(function() {
    'use strict';

    angular
        .module('edistradadhluiApp', [
            'ngStorage',
            'tmh.dynamicLocale',
            'pascalprecht.translate',
            'ngResource',
            'ngCookies',
            'ngAria',
            'ngAnimate',
            'ngCacheBuster',
            'ngFileUpload',
            'ngFileSaver',
            'ui.bootstrap',
            'ui.bootstrap.datetimepicker',
            'ui.router',
            'ngMaterial',
            'uuid',
            'ngLoadingSpinner'
        ])
        .run(run);

    run.$inject = ['EntityService', '$rootScope', 'stateHandler', 'translationHandler', 'Principal', 'DEBUG_INFO_ENABLED', 'VERSION', '$translate', '$location'];

    function run(EntityService, $rootScope, stateHandler, translationHandler, Principal, DEBUG_INFO_ENABLED, VERSION, $translate, $location) {
        var url = $location.absUrl();
        if(url.includes('billing.dhlparcel.be')) {
            EntityService.setUrlDomain('BE');
        } else if(url.includes('billing.dhlparcel.nl')) {
            EntityService.setUrlDomain('NL');
        } else {
            EntityService.setUrlDomain('EC');
        }

        stateHandler.initialize();
        translationHandler.initialize();
        $rootScope.Principal = Principal;
        $rootScope.DEBUG_INFO_ENABLED = DEBUG_INFO_ENABLED;
        $rootScope.VERSION = VERSION;
        angular.element(window).on("resize", function() {
            $rootScope.$apply();
        });

        $rootScope.$translate = $translate;
        $rootScope.$conditionalTranslate = function(condition, phrase) {
            if (condition)
                return $translate.instant(phrase);
            else return "";
        };

        //        PDFViewerApplication.isViewerEmbedded = true; //This prevents PDF.js to change view title
        //        PDFViewerApplication.postMessageTransfers = false; //This prevents PDF.js to log unnecesarry things
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .controller('UsersController', UsersController);

    UsersController.$inject = ['$rootScope', '$scope', '$state', '$stateParams', '$translate', '$uibModal', 'UsersService', 'UtilService', 'AlertService', 'API_URL'];

    function UsersController($rootScope, $scope, $state, $stateParams, $translate, $uibModal, UsersService, UtilService, AlertService, API_URL) {
        var vm = this;
        vm.translate = $translate.instant;

        /*Declare variables*/
        vm.filter = {
            data: {
                size: 25,
                page: 0,
                email: "",
                clientNumber: "",
                clientName: ""
            },
            clear: function() {
                vm.filter.data.email = "";
                vm.filter.data.clientNumber = "";
                vm.filter.data.clientName = "";
            },
            save: function() {
                if (vm.data && vm.data.page)
                    vm.filter.data.page = vm.data.page.number;
                $state.transitionTo($state.current, vm.filter.data, {
                    location: true,
                    inherit: true,
                    notify: false
                });
            },
            read: function() {
                angular.copy($stateParams, vm.filter.data);
            }
        };

        vm.data = null;

        /*Declare functions*/
        //Controller init
        vm.init = function() {
            vm.filter.read();
            if (UtilService.isFilled(vm.filter.data))
                vm.list.current();
        };

        //Getting users
        vm.list = {
            //List users
            current: function() {
                vm.filter.data.page = 0;
                UsersService.listWithParams(vm.filter.data)
                    .then(vm.list.then);
            },
            //Go to the first page
            first: function() {
                UtilService.get(vm.data, 'first', null, null)
                    .then(vm.list.then);
            },
            //Go to the previous page
            previous: function() {
                UtilService.get(vm.data, 'prev', null, null)
                    .then(vm.list.then);
            },
            //Go to the next page
            next: function() {
                UtilService.get(vm.data, 'next', null, null)
                    .then(vm.list.then);
            },
            //Go to the last page
            last: function() {
                UtilService.get(vm.data, 'last', null, null)
                    .then(vm.list.then);
            },
            then: function(response) {
                
                //add 'BENELUXUI' to url if missing 
                if(response.data._links['first'])
                    response.data._links['first'].href = fixURL(response.data._links['first'].href);
                if(response.data._links['self'])
                    response.data._links['self'].href = fixURL(response.data._links['self'].href);
                if(response.data._links['next'])
                    response.data._links['next'].href = fixURL(response.data._links['next'].href);
                if(response.data._links['prev'])
                    response.data._links['prev'].href = fixURL(response.data._links['prev'].href);
                if(response.data._links['last'])
                    response.data._links['last'].href = fixURL(response.data._links['last'].href);

                //Set data to controller data
                vm.data = response.data;
                if (response.data._embedded == null) {
                    AlertService.error($translate.instant('users.users.noUsersFound'));
                } else {
                    AlertService.clear();
                }
                //Write state to URL
                vm.filter.save();
            }
        };

        function fixURL(url) {
            if( url != null && !(url.indexOf('BENELUXUI') !== -1) && (url.indexOf('dev') !== -1 )) {
                return url.replace('edistrada2', 'BENELUXUI/edistrada2');
            }else {
                return url;
            }
        }

        //Managing user
        vm.user = {
            form: function() {
                var newUserModal = $uibModal.open({
                    templateUrl: 'app/views/users/newUser/newUser.html',
                    controller: 'NewUserController',
                    controllerAs: 'vm',
                    size: 'md'
                });

                newUserModal.result.then(function(newUser) {
                    UsersService.create(newUser)
                        .then(function() {
                            vm.list.current();
                            AlertService.success($translate.instant("users.newUser.userCreated"));
                        })
                        .catch(function() {
                            AlertService.error($translate.instant("error.occurred"));
                        });
                });
            }
        };

        //Navigating
        vm.nav = {
            user: function(user) {
                $state.go('user', user);
            }
        };

        //Generating report
        vm.report = {
            form: function() {
                var reportModal = $uibModal.open({
                    templateUrl: 'app/views/users/report/userReport.html',
                    controller: 'UserReportController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        filter: angular.copy(vm.filter.data)
                    }
                });

                reportModal.result.then(function(result) {});
            }
        };

        //Init controller
        vm.init();

        //Position fix-table
        var fixed = $('#fixed'),
            underFixed = $('#under-fixed');
        $scope.$watch(
            function() {
                return fixed.outerHeight();
            },
            function(newValue) {
                underFixed.css('padding-top', newValue);
            });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('usersPanel', {
                parent: 'application',
                url: '/usersPanel',
                views: {
                    'content@application': {
                        templateUrl: 'app/views/users/usersPanel.html'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                    	$translatePartialLoader.addPart('documents');
                    	$translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('users');
                        return $translate.refresh();
                    }]
                },
                redirectTo: 'users',
            })
            .state('users', {
                parent: 'usersPanel',
                url: '/users?size&page&email&clientNumber&clientName',
                params: {
                    size: '25',
                    page: '0',
                    email: null,
                    clientNumber: null,
                    clientName: null
                },
                data: {
                    pageTitle: 'global.menu.users'
                },
                views: {
                    'innerContent@usersPanel': {
                        templateUrl: 'app/views/users/users/users.html',
                        controller: 'UsersController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                    	$translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('users');
                        return $translate.refresh();
                    }]
                }
            })
            .state('user', {
                parent: 'usersPanel',
                url: '/user?email',
                params: {
                    email: null
                },
                data: {
                    pageTitle: 'global.menu.user'
                },
                views: {
                    'innerContent@usersPanel': {
                        templateUrl: 'app/views/users/user/user.html',
                        controller: 'UserController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                    	$translatePartialLoader.addPart('global');
                        $translatePartialLoader.addPart('users');
                        return $translate.refresh();
                    }]
                }
            });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .controller('UserController', UserController);

    UserController.$inject = ['API_URL', '$rootScope', '$state', '$stateParams', '$translate', '$uibModal', 'UsersService', 'RolesService', 'UtilService', 'Blob', 'AlertService', 'Principal'];

    function UserController(API_URL, $rootScope, $state, $stateParams, $translate, $uibModal, UsersService, RolesService, UtilService, Blob, AlertService, Principal) {
        var vm = this;
        vm.translate = $translate.instant;

        /*Declare variables*/
        vm.filter = {
            data: {
                size: 10,
                page: 0,
                email: "",
                clientNumber: "",
                clientName: ""
            },
            clear: function() {
                vm.filter.data.email = "";
                vm.filter.data.clientNumber = "";
                vm.filter.data.clientName = "";
            },
            save: function() {
                $state.transitionTo($state.current, vm.filter.data, {
                    location: true,
                    inherit: true,
                    notify: false
                });
            },
            read: function() {
                angular.copy($stateParams, vm.filter.data);
            }
        };

        vm.data = {};
        vm.rolesChangeError = null;
        vm.rolesChangeSuccess = null;

        /*Declare functions*/
        //Controller init
        vm.init = function() {
            vm.filter.read();
            if (UtilService.isFilled(vm.filter.data)) {
                vm.user.get();
                vm.roles.getAll();
            } else
                $state.go('users');
        };

        function fixURL(url) {
            console.log('fixing url = ' + url);
            if($rootScope.API_URL === API_URL.BE) {
                url = url.replace('https://billing.dhlparcel.nl', 'https://billing.dhlparcel.be');
            } else {
                url = url.replace('https://billing.dhlparcel.be', 'https://billing.dhlparcel.nl');
            }
            console.log('fixed url: ' + url);
            return url;
        }

        //Managing user
        vm.user = {
            get: function() {
                UsersService.get(vm.filter.data.email)
                    //If successful
                    .then(vm.user.then)
                    //If there were errors
                    .catch(function(response) {})
                    .finally(function(response) {});
            },
            then: function(response) {

                if(response.data._links['clients'])
                    response.data._links['clients'].href = fixURL(response.data._links['clients'].href);
                if(response.data._links['roles'])
                    response.data._links['roles'].href = fixURL(response.data._links['roles'].href);
                if(response.data._links['self'])
                    response.data._links['self'].href = fixURL(response.data._links['self'].href);
                if(response.data._links['beUser'])
                    response.data._links['beUser'].href = fixURL(response.data._links['beUser'].href);

                //Set data to controller data
                vm.data.user = response.data;

                vm.user.getClients();
                vm.user.getUserRoles();
                vm.user.getUserDates();
                //vm.user.getFirstActivationDate();
                //vm.user.getLastActivityDate();
                vm.user.getLastFailedLoginDate();
                vm.user.getLastSuccessfulLoginDate();


                //Write state to URL
                vm.filter.save();
            },
            getClients: function() {
                UtilService.get /*his clients*/ (vm.data.user, 'clients', null, null)
                    .then(function(response) {
                        var param = Principal.getCurrentEntityLowerCase()+'Clients';
                        if(response.data != null && response.data._embedded != null && response.data._embedded[param] != null) { //undefined included in check due to != used
                            vm.data.user.clients = response.data._embedded[param]; //Set clients to user
                        }
                    });
            },
            getUserRoles: function() {
                if (Principal.hasSystemAccess()) {
                    UtilService.get /*his roles*/ (vm.data.user, 'roles', null, null)
                        .then(function(response) {
                            response.data._embedded.ediRoles.forEach(function(userRole) {
                                if (vm.data.roles) {
                                    vm.data.roles.forEach(function(role) {
                                        if (userRole.roleName == role.roleName)
                                            role.active = true;
                                    });
                                }
                            });
                        });
                }
            },
            getUserDates: function() {
                UsersService.getUserDates(vm.data.user.ediUserId)
                    .then(function(response) {
                        vm.data.user.firstActivationDate = response.data.firstActivationDate;
                        vm.data.user.lastActivityDate = response.data.lastActivity;
                    });
            },
            getFirstActivationDate: function() {
                UsersService.getFirstActivationDate(vm.data.user.ediUserId)
                    .then(function(response) {
                        vm.data.user.firstActivationDate = response.data;
                    });
            },
            getLastActivityDate: function() {
                UsersService.getLastActivityDate(vm.data.user.ediUserId)
                    .then(function(response) {
                        vm.data.user.lastActivityDate = response.data;
                    });
            },
            getLastFailedLoginDate: function() {
                UsersService.getLastFailedLoginDate(vm.data.user.ediUserId)
                    .then(function(response) {
                        vm.data.user.lastFailedLoginDate = response.data;
                    });
            },
            getLastSuccessfulLoginDate: function() {
                UsersService.getLastSuccessfulLoginDate(vm.data.user.ediUserId)
                    .then(function(response) {
                        vm.data.user.lastSuccessfulLoginDate = response.data;
                    });
            },
            clients: function() {
                var reportModal = $uibModal.open({
                    templateUrl: 'app/views/users/user/clients/userClients.html',
                    controller: 'UserClientsController',
                    controllerAs: 'vm',
                    size: 'lg',
                    resolve: {
                        filter: {
                            email: vm.data.user.email,
                            ediUserId: vm.data.user.ediUserId
                        }
                    }
                });

                reportModal.result.then(function(result) {
                    AlertService.clear();
                    result.response
                        .then(function(response) {
                            var alertData = {
                                email: response.config.params.email,
                                clientNumber: response.config.params.clientNumber
                            };
                            if (result.type === 'add') {
                                AlertService.success("users.user.clients.successfullyAssigned", alertData);
                            } else if (result.type === 'removeOne'){
                                AlertService.success("users.user.clients.successfullyRemoved", alertData);
                            } else {
                                AlertService.success("users.user.clients.successfullyRemovedAll", {clientNumber: result.clientNumber});
                            }
                            vm.user.get();
                        })
                        .catch(function(response) {
                            if (result.type === 'add' && response.status === 409) {
                                AlertService.warning("users.user.clients.alreadyAssigned", {
                                    email: response.config.params.email,
                                    clientNumber: response.config.params.clientNumber
                                });
                            } else {
                                AlertService.error($translate.instant("users.errors.occurred"));
                            }
                        });
                });
            },
            unlock: function() {
                UsersService.unlock(vm.data.user.ediUserId)
                    .then(function(response) {
                        AlertService.success($translate.instant("users.user.userUnlocked"));
                        vm.data.user.locked = false;
                    })
                    .catch(function(response) {
                        AlertService.error($translate.instant("users.errors.occurred"));
                    });
            },
            lock: function() {
                UsersService.lock(vm.data.user.ediUserId)
                    .then(function(response) {
                        AlertService.success($translate.instant("users.user.userLocked"));
                        vm.data.user.locked = true;
                    })
                    .catch(function(response) {
                        AlertService.error($translate.instant("users.errors.occurred"));
                    });
            },

            resetPassword: function() {
                UsersService.resetPassword(vm.data.user.ediUserId)
                    .then(function(response) {
                        AlertService.success($translate.instant("users.user.passResetSent"));
                    })
                    .catch(function(response) {
                        AlertService.error($translate.instant("users.errors.occurred"));
                    });
            },
            toggleActivation: function() {
                if (vm.data.user.activated)
                    vm.user.deactivate();
                else
                    vm.user.activate();
            },
            activate: function() {
                UsersService.activate(vm.data.user.ediUserId)
                    .then(function(response) {
                        AlertService.success($translate.instant("users.user.userActivated"));
                        vm.data.user.activated = true;
                    })
                    .catch(function(response) {
                        AlertService.error($translate.instant("users.errors.occurred"));
                    });
            },
            deactivate: function() {
                UsersService.deactivate(vm.data.user.ediUserId)
                    .then(function(response) {
                        AlertService.success($translate.instant("users.user.userDeactivated"));
                        vm.data.user.activated = false;
                    })
                    .catch(function(response) {
                        AlertService.error($translate.instant("users.errors.occurred"));
                    });
            },
            delete: function() {
                UsersService.delete(vm.data.user.ediUserId)
                    .then(function(response) {
                        $state.go("users");
                        setTimeout(function() {
                            AlertService.success($translate.instant("users.user.userDeleted").replace("(0)", vm.data.user.email));
                        }, 1000);
                    })
                    .catch(function(response) {
                        AlertService.error($translate.instant("users.errors.occurred"));
                    });
            },
            isLocked: function() {
                return UsersService.isLocked(vm.data.user.ediUserId)
                    .then(function(response) {
                        vm.data.user.locked = response.data;
                        return response.data;
                    });
            }
        };

        vm.roles = {
            getAll: function() {
                RolesService.list()
                    .then(function(response) {
                        vm.data.roles = response.data._embedded.ediRoles;
                    });
            },
            change: function() {
                var roles = [];
                vm.data.roles.forEach(function(role) {
                    if (role.active)
                        roles.push(role.roleName);
                });
                UsersService.changeRoles(vm.data.user.ediUserId, roles)
                    .then(function(response) {
                        vm.rolesChangeError = null;
                        vm.rolesChangeSuccess = true;
                    }).catch(function(response) {
                        vm.rolesChangeError = true;
                        vm.rolesChangeSuccess = null;
                    });
            }
        };

        //Navigating
        vm.nav = {
            users: function() {
                $state.go('users');
            },
            client: function(client) {
                $state.go('client', client);
            }
        };

        //Init controller
        vm.init();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .controller('UserClientsController', UserClientsController);

    UserClientsController.$inject = ['$uibModalInstance', '$translate', 'filter', 'UsersService', 'ClientsService'];

    function UserClientsController($uibModalInstance, $translate, filter, UsersService, ClientsService) {
        var vm = this;
        vm.translate = $translate.instant;

        vm.data = {
            userId: filter.ediUserId,
            email: filter.email,
            clientNumber: "",
            clientName: null
        };

        vm.clients = {
            timeout: null,
            lookup: function() {
                clearTimeout(vm.clients.timeout);
                vm.clients.timeout = setTimeout(function() {
                    vm.data.clientName = null;
                    ClientsService.findByClientNumber(vm.data.clientNumber)
                        .then(function(response) {
                            vm.data.clientName = response.data.clientName;
                        })
                        .catch(function(response) {
                            vm.data.clientName = null;
                        });
                }, 500);
            },
            addClient: function() {
                var result = {
                    response: UsersService.addClient(vm.data.userId, vm.data.email, vm.data.clientNumber),
                    type:'add'
                };
                $uibModalInstance.close(result);
            },
            removeClient: function() {
                var result = {
                    response: UsersService.removeClient(vm.data.userId, vm.data.email, vm.data.clientNumber),
                    type: 'removeOne'
                };
                $uibModalInstance.close(result);
            },
            removeAllClients: function() {
                var result = {
                    response : UsersService.removeAllClients(vm.data.userId, vm.data.email),
                    type: 'removeAll',
                    clientNumber: vm.data.clientNumber
                };
                $uibModalInstance.close(result);
            }
        };

        vm.modal = {
            cancel: function() {
                $uibModalInstance.dismiss('cancel');
            }
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .controller('UserReportController', UserReportController);

    UserReportController.$inject = ['$uibModalInstance', '$translate', 'UsersService', 'UtilService'];

    function UserReportController($uibModalInstance, $translate, UsersService, UtilService) {
        var vm = this;
        vm.translate = $translate.instant;
        vm.filter = {};
        vm.modal = {
            generate: function() {
                $uibModalInstance.close(vm.data);
            },
            getGenerateURL: function(){
                var filterToSend = angular.copy(vm.filter);
                if (vm.active == 0)
//                    UsersService.usersReport(vm.filter)
//                    .then(function(response) {
//                        var date = new Date();
//                        FileSaver.saveAs(new Blob([response.data], { type: "text/csv" }),
//                            $translate.instant("users.report.listPrefix") + (date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate()) + ".xlsx");
//                    });
                    return UsersService.getUsersReportURL(filterToSend);
                else {

                    if (UtilService.isFilled(vm.filter.activityDateFrom))
                        filterToSend.activityDateFrom = new Date(vm.filter.activityDateFrom);

                    if (UtilService.isFilled(vm.filter.activityDateTo)) {
                        var activityDateTo = new Date(vm.filter.activityDateTo);
                        activityDateTo.setHours(23);
                        activityDateTo.setMinutes(59);
                        activityDateTo.setSeconds(59);
                        filterToSend.activityDateTo = activityDateTo;
                    }

                    if (UtilService.isFilled(vm.filter.activityUserTypes))
                        filterToSend.activityUserTypes = vm.filter.activityUserTypes.split(",");

                    if (UtilService.isFilled(vm.filter.activityOperators))
                        filterToSend.activityOperators = vm.filter.activityOperators.split(",");

                    if (UtilService.isFilled(vm.filter.activityUserEmails))
                        filterToSend.activityUserEmails = vm.filter.activityUserEmails.split(",");

                    if (UtilService.isFilled(vm.filter.activityClientNames))
                        filterToSend.activityClientNames = vm.filter.activityClientNames.split(",");

                    if (UtilService.isFilled(vm.filter.activityClientNumbers))
                        filterToSend.activityClientNumbers = vm.filter.activityClientNumbers.split(",");

                    if (UtilService.isFilled(vm.filter.activityDocumentNumbers))
                        filterToSend.activityDocumentNumbers = vm.filter.activityDocumentNumbers.split(",");

                    if (UtilService.isFilled(vm.filter.useArchiveUsers))
                        filterToSend.useArchiveUsers = vm.filter.useArchiveUsers;

//                    UsersService.activityReport(vm.filter)
//                        .then(function(response) {
//                            var date = new Date();
//                            FileSaver.saveAs(new Blob([response.data], { type: "text/csv" }),
//                                $translate.instant("users.report.activitiesPrefix") + (date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate()) + ".xlsx");
//                        });
                    return UsersService.getActivityReportURL(filterToSend);
                }
            },
            cancel: function() {
                $uibModalInstance.dismiss('cancel');
            }
        };

        setTimeout(function() {
            $('#actionTypeMultiselect').multiselect({
                includeSelectAllOption: true,
                dropUp: true,
                buttonText: function(options, select) {
                    if (options.length === 11) {
                        return $translate.instant("users.report.actions.all");
                    } else if (options.length === 0) {
                        return $translate.instant("users.report.actions.choose");
                    } else if (options.length % 10 === 1) {
                        return $translate.instant("users.report.actions.chosen") + options.length + $translate.instant("users.report.actions.1action");
                    } else if (options.length % 10 > 1 && options.length % 10 < 5) {
                        return $translate.instant("users.report.actions.chosen") + options.length + $translate.instant("users.report.actions.2actions");
                    } else if (options.length % 10 > 4) {
                        return $translate.instant("users.report.actions.chosen") + options.length + $translate.instant("users.report.actions.5actions");
                    }
                },
                selectAllText: $translate.instant("users.report.selectAll")
            });
        }, 1);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .controller('NewUserController', NewUserController);

    NewUserController.$inject = ['$uibModalInstance', '$translate', 'AlertService', 'UsersService'];

    function NewUserController($uibModalInstance, $translate, AlertService, UsersService) {
        var vm = this;
        vm.exists = null;

        vm.data = {
            email: null,
            password: null
        };

        vm.modal = {
            timeout: null,
            lookup: function() {
                if(vm.data.email != null) {
                    vm.exists = null;
                    clearTimeout(vm.modal.timeout);
                    vm.modal.timeout = setTimeout(function() {
                        UsersService.isEmailUniqueOtherSN(vm.data.email)
                            .then(function(response) {
                                if(response.data.unique === true) {
                                    vm.exists = false;
                                    AlertService.clear();
                                } else {
                                    vm.exists = true;
                                    AlertService.warning($translate.instant("users.newUser.existsInOtherSN"));
                                }
                            })
                            .catch(function(response) {
                                AlertService.error($translate.instant("users.errors.occurred"));
                            });
                    }, 500);
                }
            },
            add: function() {
                UsersService.isEmailUnique(vm.data.email)
                    .then(function(response){
                        if(!vm.exists) {
                            UsersService.checkNewUsersPasswordValid(vm.data.password)
                                .then(function(response){
                                    $uibModalInstance.close(vm.data);
                                })
                                .catch(function(response){
                                    var passwordChangeErrorText;
                                    switch (response.data.message) {
                                        case 1:
                                            passwordChangeErrorText = $translate.instant("users.newUser.error1");
                                            break;
                                        case 4:
                                            passwordChangeErrorText = $translate.instant("users.newUser.error4");
                                            break;
                                        case 5:
                                            passwordChangeErrorText = $translate.instant("users.newUser.error5");
                                            break;
                                        default:
                                            passwordChangeErrorText = $translate.instant("error.occurred");
                                    }
                                    AlertService.error(passwordChangeErrorText);
                                });
                        } else {
                            $uibModalInstance.close(vm.data);
                        }
                    })
                    .catch(function(response){
                        AlertService.error($translate.instant("users.newUser.exists"));
                    });
            },
            cancel: function() {
                $uibModalInstance.dismiss('cancel');
            }
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .controller('SystemSettingsModalController', SystemSettingsModalController);

    SystemSettingsModalController.$inject = ['$uibModalInstance'];

    function SystemSettingsModalController($uibModalInstance) {
        var vm = this;

        vm.modal = {
            go: function() {
                $uibModalInstance.close(true);
            },
            cancel: function() {
                $uibModalInstance.close(false);
            }
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('system-settings', {
            parent: 'application',
            url: '/system-settings',
            data: {
                pageTitle: 'global.menu.system-settings'
            },
            views: {
                'content@application': {
                    templateUrl: 'app/views/system-settings/system-settings.html',
                    controller: 'SystemSettingsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                	$translatePartialLoader.addPart('global');
                	$translatePartialLoader.addPart('system-settings');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function () {
    "use strict";

    angular
        .module("edistradadhluiApp")
        .controller("SystemSettingsController", SystemSettingsController);

    SystemSettingsController.$inject = [
        "API_URL",
        "$scope",
        "$translate",
        "ConstantsService",
        "Upload",
        "$rootScope",
        "MailTemplatesService",
        "$uibModal",
        "FileSaver",
        "Blob",
        "UtilService",
        "filterFilter",
        "ClientsService",
        "Principal",
    ];

    function SystemSettingsController(
        API_URL,
        $scope,
        $translate,
        ConstantsService,
        Upload,
        $rootScope,
        MailTemplatesService,
        $uibModal,
        FileSaver,
        Blob,
        UtilService,
        filterFilter,
        ClientsService,
        Principal
    ) {
        var vm = this;
        vm.translate = $translate.instant;

        vm.ActivityTypes = [
            {
                name: "ACCOUNT_OPENED",
                text: function () {
                    return $translate.instant(
                        "systemSettings.templateType.open"
                    );
                },
            },
            {
                name: "EMAIL_ADDED",
                text: function () {
                    return $translate.instant(
                        "systemSettings.templateType.emailAdded"
                    );
                },
            },
            {
                name: "REGISTRATION_FAIL",
                text: function () {
                    return $translate.instant(
                        "systemSettings.templateType.invalidRegistration"
                    );
                },
            },
            {
                name: "PASSWORD_CHANGE",
                text: function () {
                    return $translate.instant(
                        "systemSettings.templateType.reset"
                    );
                },
            },
            {
                name: "INVOICE_WITH_LINK",
                text: function () {
                    return $translate.instant(
                        "systemSettings.templateType.invoiceLink"
                    );
                },
            },
            {
                name: "INVOICE_WITH_PDF",
                text: function () {
                    return $translate.instant(
                        "systemSettings.templateType.invoicePdf"
                    );
                },
            },
            {
                name: "INVOICE_WITH_CSV",
                text: function () {
                    return $translate.instant(
                        "systemSettings.templateType.invoiceCsv"
                    );
                },
            },
            {
                name: "INVOICE_WITH_LINK_AND_XLSX",
                text: function () {
                    return $translate.instant(
                        "systemSettings.templateType.invoiceLinkAndXlsx"
                    );
                },
            },
            {
                name: "INVOICE_WITH_PDF_AND_XLSX",
                text: function () {
                    return $translate.instant(
                        "systemSettings.templateType.invoicePdfAndXlsx"
                    );
                },
            },
            {
                name: "INVOICE_WITH_PDF_AND_CSV",
                text: function () {
                    return $translate.instant(
                        "systemSettings.templateType.invoicePdfAndCsv"
                    );
                },
            },
            // {
            //     name: 'CORRECTION_INVOICE',
            //     text: function() {
            //         return $translate.instant('systemSettings.templateType.correctingInvoice');
            //     }
            // },
            {
                name: "INVOICE_TOO_LARGE",
                text: function () {
                    return $translate.instant(
                        "systemSettings.templateType.tooBig"
                    );
                },
            },
        ];

        vm.languages = [
            {
                name: "nl",
                text: function () {
                    return $translate.instant(
                        "systemSettings.templateLanguage.nl"
                    );
                },
            },
            {
                name: "fr",
                text: function () {
                    return $translate.instant(
                        "systemSettings.templateLanguage.fr"
                    );
                },
            },
            {
                name: "en",
                text: function () {
                    return $translate.instant(
                        "systemSettings.templateLanguage.en"
                    );
                },
            },
            {
                name: "de",
                text: function () {
                    return $translate.instant(
                        "systemSettings.templateLanguage.de"
                    );
                },
            },
        ];

        vm.ifContinue = true;
        vm.dhlTemplatesData;
        vm.dhlTemplates = [];
        vm.dhlTitles = [];
        vm.dhlTitlesData = [];
        vm.dhlEmailTempaltes = null;
        vm.dhlClientEmailTempaltesIds = null;
        vm.templatesToSend = [];
        vm.clientId = null;
        vm.dhlClient = null;
        vm.addingEmailTemplateErrorText = null;
        vm.addingEmailTemplateSuccessText = null;
        vm.getDataErrorText = null;
        vm.clientErrorText = null;
        vm.clientSuccessText = null;
        vm.htmlTooltip = false;
        vm.chooseOrDrop = chooseOrDrop;

        vm.clientTemplates = {
            templatesNL: {
                ACCOUNT_OPENED: {
                    name: null,
                    template_id: null,
                },
                EMAIL_ADDED: {
                    name: null,
                    template_id: null,
                },
                REGISTRATION_FAIL: {
                    name: null,
                    template_id: null,
                },
                PASSWORD_CHANGE: {
                    name: null,
                    template_id: null,
                },
                INVOICE_WITH_LINK: {
                    name: null,
                    template_id: null,
                },
                INVOICE_WITH_PDF: {
                    name: null,
                    template_id: null,
                },
                INVOICE_WITH_LINK_AND_XLSX: {
                    name: null,
                    template_id: null,
                },
                INVOICE_WITH_PDF_AND_XLSX: {
                    name: null,
                    template_id: null,
                },
                INVOICE_WITH_PDF_AND_CSV: {
                    name: null,
                    template_id: null,
                },
                // CORRECTION_INVOICE: {
                //     name: null,
                //     template_id: null
                // },
                INVOICE_TOO_LARGE: {
                    name: null,
                    template_id: null,
                },
            },
            titlesNL: {
                ACCOUNT_OPENED: {
                    name: null,
                    template_id: null,
                },
                EMAIL_ADDED: {
                    name: null,
                    template_id: null,
                },
                REGISTRATION_FAIL: {
                    name: null,
                    template_id: null,
                },
                PASSWORD_CHANGE: {
                    name: null,
                    template_id: null,
                },
                INVOICE_WITH_LINK: {
                    name: null,
                    template_id: null,
                },
                INVOICE_WITH_PDF: {
                    name: null,
                    template_id: null,
                },
                INVOICE_WITH_LINK_AND_XLSX: {
                    name: null,
                    template_id: null,
                },
                INVOICE_WITH_PDF_AND_XLSX: {
                    name: null,
                    template_id: null,
                },
                INVOICE_WITH_PDF_AND_CSV: {
                    name: null,
                    template_id: null,
                },
                // CORRECTION_INVOICE: {
                //     name: null,
                //     template_id: null
                // },
                INVOICE_TOO_LARGE: {
                    name: null,
                    template_id: null,
                },
            },
            templatesEN: {
                ACCOUNT_OPENED: {
                    name: null,
                    template_id: null,
                },
                EMAIL_ADDED: {
                    name: null,
                    template_id: null,
                },
                REGISTRATION_FAIL: {
                    name: null,
                    template_id: null,
                },
                PASSWORD_CHANGE: {
                    name: null,
                    template_id: null,
                },
                INVOICE_WITH_LINK: {
                    name: null,
                    template_id: null,
                },
                INVOICE_WITH_PDF: {
                    name: null,
                    template_id: null,
                },
                INVOICE_WITH_LINK_AND_XLSX: {
                    name: null,
                    template_id: null,
                },
                INVOICE_WITH_PDF_AND_XLSX: {
                    name: null,
                    template_id: null,
                },
                INVOICE_WITH_PDF_AND_CSV: {
                    name: null,
                    template_id: null,
                },
                // CORRECTION_INVOICE: {
                //     name: null,
                //     template_id: null
                // },
                INVOICE_TOO_LARGE: {
                    name: null,
                    template_id: null,
                },
            },
            titlesEN: {
                ACCOUNT_OPENED: {
                    name: null,
                    template_id: null,
                },
                EMAIL_ADDED: {
                    name: null,
                    template_id: null,
                },
                REGISTRATION_FAIL: {
                    name: null,
                    template_id: null,
                },
                PASSWORD_CHANGE: {
                    name: null,
                    template_id: null,
                },
                INVOICE_WITH_LINK: {
                    name: null,
                    template_id: null,
                },
                INVOICE_WITH_PDF: {
                    name: null,
                    template_id: null,
                },
                INVOICE_WITH_LINK_AND_XLSX: {
                    name: null,
                    template_id: null,
                },
                INVOICE_WITH_PDF_AND_XLSX: {
                    name: null,
                    template_id: null,
                },
                INVOICE_WITH_PDF_AND_CSV: {
                    name: null,
                    template_id: null,
                },
                // CORRECTION_INVOICE: {
                //     name: null,
                //     template_id: null
                // },
                INVOICE_TOO_LARGE: {
                    name: null,
                    template_id: null,
                },
            },
            templatesFR: {
                ACCOUNT_OPENED: {
                    name: null,
                    template_id: null,
                },
                EMAIL_ADDED: {
                    name: null,
                    template_id: null,
                },
                REGISTRATION_FAIL: {
                    name: null,
                    template_id: null,
                },
                PASSWORD_CHANGE: {
                    name: null,
                    template_id: null,
                },
                INVOICE_WITH_LINK: {
                    name: null,
                    template_id: null,
                },
                INVOICE_WITH_PDF: {
                    name: null,
                    template_id: null,
                },
                INVOICE_WITH_LINK_AND_XLSX: {
                    name: null,
                    template_id: null,
                },
                INVOICE_WITH_PDF_AND_XLSX: {
                    name: null,
                    template_id: null,
                },
                INVOICE_WITH_PDF_AND_CSV: {
                    name: null,
                    template_id: null,
                },
                // CORRECTION_INVOICE: {
                //     name: null,
                //     template_id: null
                // },
                INVOICE_TOO_LARGE: {
                    name: null,
                    template_id: null,
                },
            },
            titlesFR: {
                ACCOUNT_OPENED: {
                    name: null,
                    template_id: null,
                },
                EMAIL_ADDED: {
                    name: null,
                    template_id: null,
                },
                REGISTRATION_FAIL: {
                    name: null,
                    template_id: null,
                },
                PASSWORD_CHANGE: {
                    name: null,
                    template_id: null,
                },
                INVOICE_WITH_LINK: {
                    name: null,
                    template_id: null,
                },
                INVOICE_WITH_PDF: {
                    name: null,
                    template_id: null,
                },
                INVOICE_WITH_LINK_AND_XLSX: {
                    name: null,
                    template_id: null,
                },
                INVOICE_WITH_PDF_AND_XLSX: {
                    name: null,
                    template_id: null,
                },
                INVOICE_WITH_PDF_AND_CSV: {
                    name: null,
                    template_id: null,
                },
                // CORRECTION_INVOICE: {
                //     name: null,
                //     template_id: null
                // },
                INVOICE_TOO_LARGE: {
                    name: null,
                    template_id: null,
                },
            },
            templatesDE: {
                ACCOUNT_OPENED: {
                    name: null,
                    template_id: null,
                },
                EMAIL_ADDED: {
                    name: null,
                    template_id: null,
                },
                REGISTRATION_FAIL: {
                    name: null,
                    template_id: null,
                },
                PASSWORD_CHANGE: {
                    name: null,
                    template_id: null,
                },
                INVOICE_WITH_LINK: {
                    name: null,
                    template_id: null,
                },
                INVOICE_WITH_PDF: {
                    name: null,
                    template_id: null,
                },
                INVOICE_WITH_LINK_AND_XLSX: {
                    name: null,
                    template_id: null,
                },
                INVOICE_WITH_PDF_AND_XLSX: {
                    name: null,
                    template_id: null,
                },
                INVOICE_WITH_PDF_AND_CSV: {
                    name: null,
                    template_id: null,
                },
                // CORRECTION_INVOICE: {
                //     name: null,
                //     template_id: null
                // },
                INVOICE_TOO_LARGE: {
                    name: null,
                    template_id: null,
                },
            },
            titlesDE: {
                ACCOUNT_OPENED: {
                    name: null,
                    template_id: null,
                },
                EMAIL_ADDED: {
                    name: null,
                    template_id: null,
                },
                REGISTRATION_FAIL: {
                    name: null,
                    template_id: null,
                },
                PASSWORD_CHANGE: {
                    name: null,
                    template_id: null,
                },
                INVOICE_WITH_LINK: {
                    name: null,
                    template_id: null,
                },
                INVOICE_WITH_PDF: {
                    name: null,
                    template_id: null,
                },
                INVOICE_WITH_LINK_AND_XLSX: {
                    name: null,
                    template_id: null,
                },
                INVOICE_WITH_PDF_AND_XLSX: {
                    name: null,
                    template_id: null,
                },
                INVOICE_WITH_PDF_AND_CSV: {
                    name: null,
                    template_id: null,
                },
                // CORRECTION_INVOICE: {
                //     name: null,
                //     template_id: null
                // },
                INVOICE_TOO_LARGE: {
                    name: null,
                    template_id: null,
                },
            },
        };

        vm.upload = upload;
        vm.submit = submit;
        vm.chectUniqueNameAndType = chectUniqueNameAndType;
        vm.getTitleTemplates = getTitleTemplates;
        vm.getContentTemplates = getContentTemplates;
        vm.download = download;
        vm.addClientNumber = addClientNumber;
        vm.addInvoiceNumber = addInvoiceNumber;
        vm.addInvoiceDate = addInvoiceDate;
        vm.addNettoValue = addNettoValue;
        vm.checkTemplateTitle = checkTemplateTitle;
        vm.addTemplateTitle = addTemplateTitle;
        vm.clearForms = clearForms;
        vm.getAllEmailTemplates = getAllEmailTemplates;
        vm.getUserTemplatesId = getUserTemplatesId;
        vm.sendNewUserTemplates = sendNewUserTemplates;
        vm.getCommonElementFromLists = getCommonElementFromLists;
        vm.getClientByNumber = getClientByNumber;
        vm.changeActionTypeToText = changeActionTypeToText;
        vm.setTooltip = setTooltip;
        vm.disableTooltip = disableTooltip;

        vm.init = function () {
            vm.interval.get();
            vm.showInterval.get();
            vm.getContentTemplates();
            vm.getTitleTemplates();
            vm.clearForms();
            vm.banner.get();
        };

        function clearForms() {
            vm.template = {
                activity: vm.ActivityTypes[0],
                name: null,
                language: vm.languages[0],
            };
            vm.title = {
                activity: vm.ActivityTypes[0],
                name: null,
                text: "",
                language: vm.languages[0],
            };
        }

        vm.interval = {
            current: null,
            new: null,
            measure: "days",
            set: function () {
                var interval = vm.interval.new;
                switch (vm.interval.measure) {
                    case "days":
                        interval *=
                            24 /*h*/ * 60 /*min*/ * 60 /*s*/ * 1000 /*ms*/;
                        break;
                    case "months":
                        interval *=
                            30 /*days*/ *
                            24 /*h*/ *
                            60 /*min*/ *
                            60 /*s*/ *
                            1000 /*ms*/;
                        break;
                    case "years":
                        interval *=
                            365 /*days*/ *
                            24 /*h*/ *
                            60 /*min*/ *
                            60 /*s*/ *
                            1000 /*ms*/;
                        break;
                }
                ConstantsService.set({
                    name: "PASSWORD_CHANGE_INTERVAL",
                    value: interval,
                }).then(function (response) {
                    vm.interval.get();
                });
            },
            get: function () {
                ConstantsService.get("PASSWORD_CHANGE_INTERVAL").then(function (
                    response
                ) {
                    var interval = response.data.value;
                    //Convert to days
                    interval =
                        interval /
                        1000 /*ms*/ /
                        60 /*s*/ /
                        60 /*min*/ /
                        24 /*h*/;
                    vm.interval.current = interval;
                });
            },
        };

        vm.banner = {
            availableEntities: ['BE', 'NL', 'EC'],
            data: {
                from: null,
                to: null,
                line1: '',
                line2: '',
                closable: false,
                entities: []
            },
            preview: {
                from: null,
                to: null,
                line1: '',
                line2: '',
                closable: false,
                entities: []
            },
            isActive: false,
            exists: false,

            resetMessages: function () {
                vm.bannerSuccessText = null;
                vm.bannerErrorText = null;
            },

            clearAlerts: function () {
                setTimeout(function () {
                    $scope.$apply(function () {
                        vm.banner.resetMessages();
                    });
                }, 5000);
            },

            toggleEntity: function(entity) {
                var list = vm.banner.data.entities;
                var index = list.indexOf(entity);
                if (index === -1) {
                    list.push(entity);
                } else {
                    list.splice(index, 1);
                }
            },

            get: function () {
                ConstantsService.getBanner().then(function (res) {
                    vm.banner.preview = res.data;
                    vm.banner.exists = true;
                    vm.banner.clearAlerts();
                }).catch(function () {
                    vm.banner.data = {
                        from: null,
                        to: null,
                        line1: '',
                        line2: '',
                        closable: false,
                        entities: []
                    };
                    vm.banner.clearAlerts();
                });
            },

            save: function () {
                vm.banner.resetMessages();
                var dto = angular.copy(vm.banner.data);
        

                //VALIDATION
                if (!dto.from || !dto.to || !dto.line1) {
                    vm.bannerErrorText = $translate.instant("systemSettings.banner.validation");
                    return;
                }
        
                if (new Date(dto.from) >= new Date(dto.to)) {
                    vm.bannerErrorText = $translate.instant("systemSettings.banner.dateRangeInvalid");
                    vm.banner.clearAlerts();
                    return;
                }

                if (!dto.entities || dto.entities.length === 0) {
                    vm.bannerErrorText = $translate.instant("systemSettings.banner.entitiesValidation");
                    return;
                }
        
                ConstantsService.saveBanner(dto).then(function () {
                    vm.bannerSuccessText = $translate.instant("systemSettings.banner.successSave");
                    vm.banner.get();
                    vm.banner.clearAlerts();
                }).catch(function () {
                    vm.bannerErrorText = $translate.instant("systemSettings.banner.errorSave");
                    vm.banner.clearAlerts();
                });
            },

            delete: function () {
                vm.banner.resetMessages();
                ConstantsService.deleteBanner().then(function () {
                    vm.bannerSuccessText = $translate.instant("systemSettings.banner.successDelete");
                    vm.banner.exists = false;
                    vm.banner.clearAlerts();
                }).catch(function () {
                    vm.bannerErrorText = $translate.instant("systemSettings.banner.errorDelete");
                    vm.banner.clearAlerts();
                });
            },

            checkIfActive: function () {
                ConstantsService.isBannerActive().then(function (res) {
                    vm.banner.isActive = res.data === true;
                });
            }
        };
        

        vm.showInterval = {
            current: null,
            new: null,
            measure: "days",
            set: function () {
                var interval = vm.showInterval.new;
                switch (vm.showInterval.measure) {
                    case "days":
                        interval *=
                            24 /*h*/ * 60 /*min*/ * 60 /*s*/ * 1000 /*ms*/;
                        break;
                    case "months":
                        interval *=
                            30 /*days*/ *
                            24 /*h*/ *
                            60 /*min*/ *
                            60 /*s*/ *
                            1000 /*ms*/;
                        break;
                    case "years":
                        interval *=
                            365 /*days*/ *
                            24 /*h*/ *
                            60 /*min*/ *
                            60 /*s*/ *
                            1000 /*ms*/;
                        break;
                }
                ConstantsService.set({
                    name: "PASSWORD_SHOW_CHANGE_INTERVAL",
                    value: interval,
                }).then(function (response) {
                    vm.showInterval.get();
                });
            },
            get: function () {
                ConstantsService.get("PASSWORD_SHOW_CHANGE_INTERVAL").then(
                    function (response) {
                        var interval = response.data.value;
                        //Convert to days
                        interval =
                            interval /
                            1000 /*ms*/ /
                            60 /*s*/ /
                            60 /*min*/ /
                            24 /*h*/;
                        vm.showInterval.current = interval;
                    }
                );
            },
        };

        function submit(file) {
            if (typeof file !== "undefined" && file) {
                vm.upload(file);
            } else {
                vm.addingEmailTemplateErrorText = $translate.instant(
                    "systemSettings.messages.choseFile"
                );
                vm.addingEmailTemplateSuccessText = null;
            }
        }

        // upload on file select or drop
        function upload(file) {
            Upload.upload({
                url: $rootScope.API_URL + "api/beneluxTemplates/upload",
                fields: {
                    name: vm.template.name,
                    type: vm.template.activity,
                    language: vm.template.language,
                },
                file: file,
            }).then(
                function (resp) {
                    vm.getContentTemplates();
                    vm.clearForms();
                    vm.addingEmailTemplateSuccessText = $translate.instant(
                        "systemSettings.messages.templateSuccess"
                    );
                    vm.addingEmailTemplateErrorText = null;
                },
                function (resp) {
                    vm.addingEmailTemplateErrorText =
                        $translate.instant("error.occurred");
                    vm.addingEmailTemplateSuccessText = null;
                }
            );
        }

        function chectUniqueNameAndType(file, size) {
            MailTemplatesService.checkUnique(
                vm.template.name,
                vm.template.activity,
                vm.template.language,
                "EMAIL_CONTENT"
            )
                .then(function (response) {
                    vm.submit(file);
                })
                .catch(function (response) {
                    if (!response.data.unique) {
                        var modalInstance = $uibModal.open({
                            animation: true,
                            ariaLabelledBy: "modal-title",
                            ariaDescribedBy: "modal-body",
                            templateUrl:
                                "app/views/system-settings/template-upload-modal/system-settings.modal.html",
                            controller: "SystemSettingsModalController",
                            controllerAs: "vm",
                            size: size,
                        });

                        modalInstance.result.then(function (go) {
                            if (go) {
                                vm.submit(file);
                            }
                        });
                    } else {
                        vm.addingEmailTemplateErrorText =
                            $translate.instant("error.occurred");
                        vm.addingEmailTemplateSuccessText = null;
                    }
                });
        }

        function getEntityTemplates(data) {
            switch (Principal.getCurrentEntity()) {
                case "BE":
                    if (data._embedded.beTemplates != null) {
                        return data._embedded.beTemplates;
                    }
                    break;
                case "NL":
                    if (data._embedded.nlTemplates != null) {
                        return data._embedded.nlTemplates;
                    }
                    break;

                case "EC":
                    if (data._embedded.ecTemplates != null) {
                        return data._embedded.ecTemplates;
                    }
                    break;
            }
        }

        function getContentTemplates() {
            MailTemplatesService.getTemplatesByType("EMAIL_CONTENT")
                .then(function (response) {
                    //add 'BENELUXUI' to url if missing
                    fixTemplatesLinks(response);

                    vm.dhlTemplatesData = response.data;
                    vm.dhlTemplates = getEntityTemplates(response.data);
                })
                .catch(function (response) {
                    vm.getDataErrorText = $translate.instant(
                        "systemSettings.dataError"
                    );
                });
        }

        function getTitleTemplates() {
            MailTemplatesService.getTemplatesByType("EMAIL_TITLE")
                .then(function (response) {
                    //add 'BENELUXUI' to url if missing
                    fixTemplatesLinks(response);

                    vm.dhlTitlesData = response.data;
                    vm.dhlTitles = getEntityTemplates(response.data);
                })
                .catch(function (response) {
                    vm.getDataErrorText = $translate.instant(
                        "systemSettings.dataError"
                    );
                });
        }

        function download(name, type, language, filename) {
            MailTemplatesService.download(name, type, language)
                .then(function (response) {
                    FileSaver.saveAs(
                        new Blob([response.data], { type: "text/html" }),
                        filename
                    );
                })
                .catch(function (response) {
                    //blad pobrania danych
                });
        }

        function addClientNumber() {
            if (vm.title.text) {
                vm.title.text = [
                    vm.title.text.slice(
                        0,
                        $("#titleArea").prop("selectionStart")
                    ),
                    "{{clientNumber}}",
                    vm.title.text.slice($("#titleArea").prop("selectionStart")),
                ].join("");
            } else {
                vm.title.text = "{{clientNumber}}";
            }
        }

        function addInvoiceNumber() {
            if (vm.title.text) {
                vm.title.text = [
                    vm.title.text.slice(
                        0,
                        $("#titleArea").prop("selectionStart")
                    ),
                    "{{invoiceNumber}}",
                    vm.title.text.slice($("#titleArea").prop("selectionStart")),
                ].join("");
            } else {
                vm.title.text = "{{invoiceNumber}}";
            }
        }

        function addInvoiceDate() {
            if (vm.title.text) {
                vm.title.text = [
                    vm.title.text.slice(
                        0,
                        $("#titleArea").prop("selectionStart")
                    ),
                    "{{invoiceDate}}",
                    vm.title.text.slice($("#titleArea").prop("selectionStart")),
                ].join("");
            } else {
                vm.title.text = "{{invoiceDate}}";
            }
        }

        function addNettoValue() {
            if (vm.title.text) {
                vm.title.text = [
                    vm.title.text.slice(
                        0,
                        $("#titleArea").prop("selectionStart")
                    ),
                    "{{nettoValue}}",
                    vm.title.text.slice($("#titleArea").prop("selectionStart")),
                ].join("");
            } else {
                vm.title.text = "{{nettoValue}}";
            }
        }

        function checkTemplateTitle(size) {
            MailTemplatesService.checkUnique(
                vm.title.name,
                vm.title.activity,
                vm.title.language,
                "EMAIL_TITLE"
            )
                .then(function (response) {
                    vm.addTemplateTitle(
                        vm.title.name,
                        vm.title.activity,
                        vm.title.text,
                        vm.title.language
                    );
                })
                .catch(function (response) {
                    if (response.data.unique == false) {
                        var modalInstance = $uibModal.open({
                            animation: true,
                            ariaLabelledBy: "modal-title",
                            ariaDescribedBy: "modal-body",
                            templateUrl:
                                "app/views/system-settings/template-upload-modal/system-settings.modal.html",
                            controller: "SystemSettingsModalController",
                            controllerAs: "vm",
                            size: size,
                        });

                        modalInstance.result.then(function (go) {
                            if (go) {
                                vm.addTemplateTitle(
                                    vm.title.name,
                                    vm.title.activity,
                                    vm.title.text,
                                    vm.title.language
                                );
                            }
                        });
                    } else {
                        vm.addingEmailTitleSuccessText = null;
                        vm.addingEmailTitleErrorText =
                            $translate.instant("error.occurred");
                    }
                });
        }

        function addTemplateTitle(name, activity, text, language) {
            MailTemplatesService.addTemplateTitle(
                name,
                activity,
                text,
                language
            )
                .then(function (response) {
                    vm.getTitleTemplates();
                    vm.clearForms();
                    vm.addingEmailTitleSuccessText = $translate.instant(
                        "systemSettings.messages.templateSuccess"
                    );
                    vm.addingEmailTitleErrorText = null;
                })
                .catch(function (response) {
                    vm.addingEmailTitleSuccessText = null;
                    vm.addingEmailTitleErrorText =
                        $translate.instant("error.occurred");
                });
        }

        function fixURL(url) {
            if ($rootScope.API_URL === API_URL.BE) {
                url = url.replace(
                    "https://billing.dhlparcel.nl",
                    "https://billing.dhlparcel.be"
                );
            } else {
                url = url.replace(
                    "https://billing.dhlparcel.be",
                    "https://billing.dhlparcel.nl"
                );
            }
            if (
                url != null &&
                !(url.indexOf("BENELUXUI") !== -1) &&
                url.indexOf("dev") !== -1
            ) {
                return url.replace("edistrada2", "BENELUXUI/edistrada2");
            } else {
                return url;
            }
        }

        function fixTemplatesLinks(response) {
            if (response.data._links["self"])
                response.data._links["self"].href = fixURL(
                    response.data._links["self"].href
                );
            if (response.data._links["first"])
                response.data._links["first"].href = fixURL(
                    response.data._links["first"].href
                );
            if (response.data._links["next"])
                response.data._links["next"].href = fixURL(
                    response.data._links["next"].href
                );
            if (response.data._links["last"])
                response.data._links["last"].href = fixURL(
                    response.data._links["last"].href
                );
            if (response.data._links["prev"])
                response.data._links["prev"].href = fixURL(
                    response.data._links["prev"].href
                );
        }

        function getClientByNumber() {
            ClientsService.findByClientNumber(vm.clientId)
                .then(function (response) {
                    //add 'BENELUXUI' to url if missing
                    if (response.data._links["self"])
                        response.data._links["self"].href = fixURL(
                            response.data._links["self"].href
                        );
                    if (response.data._links["nlClient"])
                        response.data._links["nlClient"].href = fixURL(
                            response.data._links["nlClient"].href
                        );
                    if (response.data._links["beneluxTemplates"])
                        response.data._links["beneluxTemplates"].href = fixURL(
                            response.data._links["beneluxTemplates"].href
                        );
                    if (response.data._links["ftpConfiguration"])
                        response.data._links["ftpConfiguration"].href = fixURL(
                            response.data._links["ftpConfiguration"].href
                        );
                    if (response.data._links["beneluxUsers"])
                        response.data._links["beneluxUsers"].href = fixURL(
                            response.data._links["beneluxUsers"].href
                        );

                    vm.dhlClient = response.data;
                    vm.getAllEmailTemplates();
                })
                .catch(function (response) {
                    vm.dhlClient = null;
                    if (response.status == 404) {
                        vm.clientErrorText = $translate.instant(
                            "systemSettings.messages.noClientFound"
                        );
                        vm.clientSuccessText = null;
                    } else {
                        vm.clientErrorText =
                            $translate.instant("error.occurred");
                        vm.clientSuccessText = null;
                    }
                });
        }

        function getAllEmailTemplates() {
            MailTemplatesService.getAllTemplates()
                .then(function (response) {
                    if (response.data._embedded != null) {
                        vm.dhlEmailTempaltes =
                            response.data._embedded[
                                Principal.getCurrentEntityLowerCase() +
                                    "Templates"
                            ];
                        vm.getUserTemplatesId();
                    } else {
                        vm.clientErrorText = $translate.instant(
                            "systemSettings.messages.templatesDownloadFailed"
                        );
                        vm.clientSuccessText = null;
                    }
                })
                .catch(function (response) {
                    vm.clientErrorText = $translate.instant(
                        "systemSettings.messages.templatesDownloadFailed"
                    );
                    vm.clientSuccessText = null;
                });
        }

        function getUserTemplatesId() {
            ClientsService.getClientTemplates(vm.dhlClient.ediClientId)
                .then(function (response) {
                    vm.dhlClientEmailTempaltesIds = response.data;

                    var id = vm.getCommonElementFromLists(
                        filterFilter(
                            vm.dhlEmailTempaltes,
                            {
                                type: "EMAIL_TITLE",
                                actionType: "ACCOUNT_OPENED",
                                language: "nl",
                            },
                            true
                        ),
                        vm.dhlClientEmailTempaltesIds
                    );
                    vm.clientTemplates.titlesNL.ACCOUNT_OPENED = filterFilter(
                        vm.dhlEmailTempaltes,
                        { ediTemplateId: id }
                    )[0];

                    id = vm.getCommonElementFromLists(
                        filterFilter(
                            vm.dhlEmailTempaltes,
                            {
                                type: "EMAIL_TITLE",
                                actionType: "EMAIL_ADDED",
                                language: "nl",
                            },
                            true
                        ),
                        vm.dhlClientEmailTempaltesIds
                    );
                    vm.clientTemplates.titlesNL.EMAIL_ADDED = filterFilter(
                        vm.dhlEmailTempaltes,
                        { ediTemplateId: id }
                    )[0];

                    id = vm.getCommonElementFromLists(
                        filterFilter(
                            vm.dhlEmailTempaltes,
                            {
                                type: "EMAIL_TITLE",
                                actionType: "REGISTRATION_FAIL",
                                language: "nl",
                            },
                            true
                        ),
                        vm.dhlClientEmailTempaltesIds
                    );
                    vm.clientTemplates.titlesNL.REGISTRATION_FAIL =
                        filterFilter(vm.dhlEmailTempaltes, {
                            ediTemplateId: id,
                        })[0];

                    id = vm.getCommonElementFromLists(
                        filterFilter(
                            vm.dhlEmailTempaltes,
                            {
                                type: "EMAIL_TITLE",
                                actionType: "PASSWORD_CHANGE",
                                language: "nl",
                            },
                            true
                        ),
                        vm.dhlClientEmailTempaltesIds
                    );
                    vm.clientTemplates.titlesNL.PASSWORD_CHANGE = filterFilter(
                        vm.dhlEmailTempaltes,
                        { ediTemplateId: id }
                    )[0];

                    id = vm.getCommonElementFromLists(
                        filterFilter(
                            vm.dhlEmailTempaltes,
                            {
                                type: "EMAIL_TITLE",
                                actionType: "INVOICE_WITH_LINK",
                                language: "nl",
                            },
                            true
                        ),
                        vm.dhlClientEmailTempaltesIds
                    );
                    vm.clientTemplates.titlesNL.INVOICE_WITH_LINK =
                        filterFilter(vm.dhlEmailTempaltes, {
                            ediTemplateId: id,
                        })[0];

                    id = vm.getCommonElementFromLists(
                        filterFilter(
                            vm.dhlEmailTempaltes,
                            {
                                type: "EMAIL_TITLE",
                                actionType: "INVOICE_WITH_PDF",
                                language: "nl",
                            },
                            true
                        ),
                        vm.dhlClientEmailTempaltesIds
                    );
                    vm.clientTemplates.titlesNL.INVOICE_WITH_PDF = filterFilter(
                        vm.dhlEmailTempaltes,
                        { ediTemplateId: id }
                    )[0];

                    id = vm.getCommonElementFromLists(
                        filterFilter(
                            vm.dhlEmailTempaltes,
                            {
                                type: "EMAIL_TITLE",
                                actionType: "INVOICE_WITH_LINK_AND_XLSX",
                                language: "nl",
                            },
                            true
                        ),
                        vm.dhlClientEmailTempaltesIds
                    );
                    vm.clientTemplates.titlesNL.INVOICE_WITH_LINK_AND_XLSX =
                        filterFilter(vm.dhlEmailTempaltes, {
                            ediTemplateId: id,
                        })[0];

                    id = vm.getCommonElementFromLists(
                        filterFilter(
                            vm.dhlEmailTempaltes,
                            {
                                type: "EMAIL_TITLE",
                                actionType: "INVOICE_WITH_PDF_AND_XLSX",
                                language: "nl",
                            },
                            true
                        ),
                        vm.dhlClientEmailTempaltesIds
                    );
                    vm.clientTemplates.titlesNL.INVOICE_WITH_PDF_AND_XLSX =
                        filterFilter(vm.dhlEmailTempaltes, {
                            ediTemplateId: id,
                        })[0];

                    id = vm.getCommonElementFromLists(
                        filterFilter(
                            vm.dhlEmailTempaltes,
                            {
                                type: "EMAIL_TITLE",
                                actionType: "INVOICE_WITH_PDF_AND_CSV",
                                language: "nl",
                            },
                            true
                        ),
                        vm.dhlClientEmailTempaltesIds
                    );
                    vm.clientTemplates.titlesNL.INVOICE_WITH_PDF_AND_CSV =
                        filterFilter(vm.dhlEmailTempaltes, {
                            ediTemplateId: id,
                        })[0];

                    // id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_TITLE', actionType: 'CORRECTION_INVOICE', language: 'nl' }, true), vm.dhlClientEmailTempaltesIds);
                    // vm.clientTemplates.titlesNL.CORRECTION_INVOICE = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(
                        filterFilter(
                            vm.dhlEmailTempaltes,
                            {
                                type: "EMAIL_TITLE",
                                actionType: "INVOICE_TOO_LARGE",
                                language: "nl",
                            },
                            true
                        ),
                        vm.dhlClientEmailTempaltesIds
                    );
                    vm.clientTemplates.titlesNL.INVOICE_TOO_LARGE =
                        filterFilter(vm.dhlEmailTempaltes, {
                            ediTemplateId: id,
                        })[0];

                    id = vm.getCommonElementFromLists(
                        filterFilter(
                            vm.dhlEmailTempaltes,
                            {
                                type: "EMAIL_CONTENT",
                                actionType: "ACCOUNT_OPENED",
                                language: "nl",
                            },
                            true
                        ),
                        vm.dhlClientEmailTempaltesIds
                    );
                    vm.clientTemplates.templatesNL.ACCOUNT_OPENED =
                        filterFilter(vm.dhlEmailTempaltes, {
                            ediTemplateId: id,
                        })[0];

                    id = vm.getCommonElementFromLists(
                        filterFilter(
                            vm.dhlEmailTempaltes,
                            {
                                type: "EMAIL_CONTENT",
                                actionType: "EMAIL_ADDED",
                                language: "nl",
                            },
                            true
                        ),
                        vm.dhlClientEmailTempaltesIds
                    );
                    vm.clientTemplates.templatesNL.EMAIL_ADDED = filterFilter(
                        vm.dhlEmailTempaltes,
                        { ediTemplateId: id }
                    )[0];

                    id = vm.getCommonElementFromLists(
                        filterFilter(
                            vm.dhlEmailTempaltes,
                            {
                                type: "EMAIL_CONTENT",
                                actionType: "REGISTRATION_FAIL",
                                language: "nl",
                            },
                            true
                        ),
                        vm.dhlClientEmailTempaltesIds
                    );
                    vm.clientTemplates.templatesNL.REGISTRATION_FAIL =
                        filterFilter(vm.dhlEmailTempaltes, {
                            ediTemplateId: id,
                        })[0];

                    id = vm.getCommonElementFromLists(
                        filterFilter(
                            vm.dhlEmailTempaltes,
                            {
                                type: "EMAIL_CONTENT",
                                actionType: "PASSWORD_CHANGE",
                                language: "nl",
                            },
                            true
                        ),
                        vm.dhlClientEmailTempaltesIds
                    );
                    vm.clientTemplates.templatesNL.PASSWORD_CHANGE =
                        filterFilter(vm.dhlEmailTempaltes, {
                            ediTemplateId: id,
                        })[0];

                    id = vm.getCommonElementFromLists(
                        filterFilter(
                            vm.dhlEmailTempaltes,
                            {
                                type: "EMAIL_CONTENT",
                                actionType: "INVOICE_WITH_LINK",
                                language: "nl",
                            },
                            true
                        ),
                        vm.dhlClientEmailTempaltesIds
                    );
                    vm.clientTemplates.templatesNL.INVOICE_WITH_LINK =
                        filterFilter(vm.dhlEmailTempaltes, {
                            ediTemplateId: id,
                        })[0];

                    id = vm.getCommonElementFromLists(
                        filterFilter(
                            vm.dhlEmailTempaltes,
                            {
                                type: "EMAIL_CONTENT",
                                actionType: "INVOICE_WITH_PDF",
                                language: "nl",
                            },
                            true
                        ),
                        vm.dhlClientEmailTempaltesIds
                    );
                    vm.clientTemplates.templatesNL.INVOICE_WITH_PDF =
                        filterFilter(vm.dhlEmailTempaltes, {
                            ediTemplateId: id,
                        })[0];

                    id = vm.getCommonElementFromLists(
                        filterFilter(
                            vm.dhlEmailTempaltes,
                            {
                                type: "EMAIL_CONTENT",
                                actionType: "INVOICE_WITH_LINK_AND_XLSX",
                                language: "nl",
                            },
                            true
                        ),
                        vm.dhlClientEmailTempaltesIds
                    );
                    vm.clientTemplates.templatesNL.INVOICE_WITH_LINK_AND_XLSX =
                        filterFilter(vm.dhlEmailTempaltes, {
                            ediTemplateId: id,
                        })[0];

                    id = vm.getCommonElementFromLists(
                        filterFilter(
                            vm.dhlEmailTempaltes,
                            {
                                type: "EMAIL_CONTENT",
                                actionType: "INVOICE_WITH_PDF_AND_XLSX",
                                language: "nl",
                            },
                            true
                        ),
                        vm.dhlClientEmailTempaltesIds
                    );
                    vm.clientTemplates.templatesNL.INVOICE_WITH_PDF_AND_XLSX =
                        filterFilter(vm.dhlEmailTempaltes, {
                            ediTemplateId: id,
                        })[0];

                    id = vm.getCommonElementFromLists(
                        filterFilter(
                            vm.dhlEmailTempaltes,
                            {
                                type: "EMAIL_CONTENT",
                                actionType: "INVOICE_WITH_PDF_AND_CSV",
                                language: "nl",
                            },
                            true
                        ),
                        vm.dhlClientEmailTempaltesIds
                    );
                    vm.clientTemplates.templatesNL.INVOICE_WITH_PDF_AND_CSV =
                        filterFilter(vm.dhlEmailTempaltes, {
                            ediTemplateId: id,
                        })[0];

                    // id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_CONTENT', actionType: 'CORRECTION_INVOICE', language: 'nl' }, true), vm.dhlClientEmailTempaltesIds);
                    // vm.clientTemplates.templatesNL.CORRECTION_INVOICE = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(
                        filterFilter(
                            vm.dhlEmailTempaltes,
                            {
                                type: "EMAIL_CONTENT",
                                actionType: "INVOICE_TOO_LARGE",
                                language: "nl",
                            },
                            true
                        ),
                        vm.dhlClientEmailTempaltesIds
                    );
                    vm.clientTemplates.templatesNL.INVOICE_TOO_LARGE =
                        filterFilter(vm.dhlEmailTempaltes, {
                            ediTemplateId: id,
                        })[0];

                    id = vm.getCommonElementFromLists(
                        filterFilter(
                            vm.dhlEmailTempaltes,
                            {
                                type: "EMAIL_TITLE",
                                actionType: "ACCOUNT_OPENED",
                                language: "en",
                            },
                            true
                        ),
                        vm.dhlClientEmailTempaltesIds
                    );
                    vm.clientTemplates.titlesEN.ACCOUNT_OPENED = filterFilter(
                        vm.dhlEmailTempaltes,
                        { ediTemplateId: id }
                    )[0];

                    id = vm.getCommonElementFromLists(
                        filterFilter(
                            vm.dhlEmailTempaltes,
                            {
                                type: "EMAIL_TITLE",
                                actionType: "EMAIL_ADDED",
                                language: "en",
                            },
                            true
                        ),
                        vm.dhlClientEmailTempaltesIds
                    );
                    vm.clientTemplates.titlesEN.EMAIL_ADDED = filterFilter(
                        vm.dhlEmailTempaltes,
                        { ediTemplateId: id }
                    )[0];

                    id = vm.getCommonElementFromLists(
                        filterFilter(
                            vm.dhlEmailTempaltes,
                            {
                                type: "EMAIL_TITLE",
                                actionType: "REGISTRATION_FAIL",
                                language: "en",
                            },
                            true
                        ),
                        vm.dhlClientEmailTempaltesIds
                    );
                    vm.clientTemplates.titlesEN.REGISTRATION_FAIL =
                        filterFilter(vm.dhlEmailTempaltes, {
                            ediTemplateId: id,
                        })[0];

                    id = vm.getCommonElementFromLists(
                        filterFilter(
                            vm.dhlEmailTempaltes,
                            {
                                type: "EMAIL_TITLE",
                                actionType: "PASSWORD_CHANGE",
                                language: "en",
                            },
                            true
                        ),
                        vm.dhlClientEmailTempaltesIds
                    );
                    vm.clientTemplates.titlesEN.PASSWORD_CHANGE = filterFilter(
                        vm.dhlEmailTempaltes,
                        { ediTemplateId: id }
                    )[0];

                    id = vm.getCommonElementFromLists(
                        filterFilter(
                            vm.dhlEmailTempaltes,
                            {
                                type: "EMAIL_TITLE",
                                actionType: "INVOICE_WITH_LINK",
                                language: "en",
                            },
                            true
                        ),
                        vm.dhlClientEmailTempaltesIds
                    );
                    vm.clientTemplates.titlesEN.INVOICE_WITH_LINK =
                        filterFilter(vm.dhlEmailTempaltes, {
                            ediTemplateId: id,
                        })[0];

                    id = vm.getCommonElementFromLists(
                        filterFilter(
                            vm.dhlEmailTempaltes,
                            {
                                type: "EMAIL_TITLE",
                                actionType: "INVOICE_WITH_PDF",
                                language: "en",
                            },
                            true
                        ),
                        vm.dhlClientEmailTempaltesIds
                    );
                    vm.clientTemplates.titlesEN.INVOICE_WITH_PDF = filterFilter(
                        vm.dhlEmailTempaltes,
                        { ediTemplateId: id }
                    )[0];

                    id = vm.getCommonElementFromLists(
                        filterFilter(
                            vm.dhlEmailTempaltes,
                            {
                                type: "EMAIL_TITLE",
                                actionType: "INVOICE_WITH_LINK_AND_XLSX",
                                language: "en",
                            },
                            true
                        ),
                        vm.dhlClientEmailTempaltesIds
                    );
                    vm.clientTemplates.titlesEN.INVOICE_WITH_LINK_AND_XLSX =
                        filterFilter(vm.dhlEmailTempaltes, {
                            ediTemplateId: id,
                        })[0];

                    id = vm.getCommonElementFromLists(
                        filterFilter(
                            vm.dhlEmailTempaltes,
                            {
                                type: "EMAIL_TITLE",
                                actionType: "INVOICE_WITH_PDF_AND_XLSX",
                                language: "en",
                            },
                            true
                        ),
                        vm.dhlClientEmailTempaltesIds
                    );
                    vm.clientTemplates.titlesEN.INVOICE_WITH_PDF_AND_XLSX =
                        filterFilter(vm.dhlEmailTempaltes, {
                            ediTemplateId: id,
                        })[0];

                    id = vm.getCommonElementFromLists(
                        filterFilter(
                            vm.dhlEmailTempaltes,
                            {
                                type: "EMAIL_TITLE",
                                actionType: "INVOICE_WITH_PDF_AND_CSV",
                                language: "en",
                            },
                            true
                        ),
                        vm.dhlClientEmailTempaltesIds
                    );
                    vm.clientTemplates.titlesEN.INVOICE_WITH_PDF_AND_CSV =
                        filterFilter(vm.dhlEmailTempaltes, {
                            ediTemplateId: id,
                        })[0];

                    // id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_TITLE', actionType: 'CORRECTION_INVOICE', language: 'en' }, true), vm.dhlClientEmailTempaltesIds);
                    // vm.clientTemplates.titlesEN.CORRECTION_INVOICE = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(
                        filterFilter(
                            vm.dhlEmailTempaltes,
                            {
                                type: "EMAIL_TITLE",
                                actionType: "INVOICE_TOO_LARGE",
                                language: "en",
                            },
                            true
                        ),
                        vm.dhlClientEmailTempaltesIds
                    );
                    vm.clientTemplates.titlesEN.INVOICE_TOO_LARGE =
                        filterFilter(vm.dhlEmailTempaltes, {
                            ediTemplateId: id,
                        })[0];

                    id = vm.getCommonElementFromLists(
                        filterFilter(
                            vm.dhlEmailTempaltes,
                            {
                                type: "EMAIL_CONTENT",
                                actionType: "ACCOUNT_OPENED",
                                language: "en",
                            },
                            true
                        ),
                        vm.dhlClientEmailTempaltesIds
                    );
                    vm.clientTemplates.templatesEN.ACCOUNT_OPENED =
                        filterFilter(vm.dhlEmailTempaltes, {
                            ediTemplateId: id,
                        })[0];

                    id = vm.getCommonElementFromLists(
                        filterFilter(
                            vm.dhlEmailTempaltes,
                            {
                                type: "EMAIL_CONTENT",
                                actionType: "EMAIL_ADDED",
                                language: "en",
                            },
                            true
                        ),
                        vm.dhlClientEmailTempaltesIds
                    );
                    vm.clientTemplates.templatesEN.EMAIL_ADDED = filterFilter(
                        vm.dhlEmailTempaltes,
                        { ediTemplateId: id }
                    )[0];

                    id = vm.getCommonElementFromLists(
                        filterFilter(
                            vm.dhlEmailTempaltes,
                            {
                                type: "EMAIL_CONTENT",
                                actionType: "REGISTRATION_FAIL",
                                language: "en",
                            },
                            true
                        ),
                        vm.dhlClientEmailTempaltesIds
                    );
                    vm.clientTemplates.templatesEN.REGISTRATION_FAIL =
                        filterFilter(vm.dhlEmailTempaltes, {
                            ediTemplateId: id,
                        })[0];

                    id = vm.getCommonElementFromLists(
                        filterFilter(
                            vm.dhlEmailTempaltes,
                            {
                                type: "EMAIL_CONTENT",
                                actionType: "PASSWORD_CHANGE",
                                language: "en",
                            },
                            true
                        ),
                        vm.dhlClientEmailTempaltesIds
                    );
                    vm.clientTemplates.templatesEN.PASSWORD_CHANGE =
                        filterFilter(vm.dhlEmailTempaltes, {
                            ediTemplateId: id,
                        })[0];

                    id = vm.getCommonElementFromLists(
                        filterFilter(
                            vm.dhlEmailTempaltes,
                            {
                                type: "EMAIL_CONTENT",
                                actionType: "INVOICE_WITH_LINK",
                                language: "en",
                            },
                            true
                        ),
                        vm.dhlClientEmailTempaltesIds
                    );
                    vm.clientTemplates.templatesEN.INVOICE_WITH_LINK =
                        filterFilter(vm.dhlEmailTempaltes, {
                            ediTemplateId: id,
                        })[0];

                    id = vm.getCommonElementFromLists(
                        filterFilter(
                            vm.dhlEmailTempaltes,
                            {
                                type: "EMAIL_CONTENT",
                                actionType: "INVOICE_WITH_PDF",
                                language: "en",
                            },
                            true
                        ),
                        vm.dhlClientEmailTempaltesIds
                    );
                    vm.clientTemplates.templatesEN.INVOICE_WITH_PDF =
                        filterFilter(vm.dhlEmailTempaltes, {
                            ediTemplateId: id,
                        })[0];

                    id = vm.getCommonElementFromLists(
                        filterFilter(
                            vm.dhlEmailTempaltes,
                            {
                                type: "EMAIL_CONTENT",
                                actionType: "INVOICE_WITH_LINK_AND_XLSX",
                                language: "en",
                            },
                            true
                        ),
                        vm.dhlClientEmailTempaltesIds
                    );
                    vm.clientTemplates.templatesEN.INVOICE_WITH_LINK_AND_XLSX =
                        filterFilter(vm.dhlEmailTempaltes, {
                            ediTemplateId: id,
                        })[0];

                    id = vm.getCommonElementFromLists(
                        filterFilter(
                            vm.dhlEmailTempaltes,
                            {
                                type: "EMAIL_CONTENT",
                                actionType: "INVOICE_WITH_PDF_AND_XLSX",
                                language: "en",
                            },
                            true
                        ),
                        vm.dhlClientEmailTempaltesIds
                    );
                    vm.clientTemplates.templatesEN.INVOICE_WITH_PDF_AND_XLSX =
                        filterFilter(vm.dhlEmailTempaltes, {
                            ediTemplateId: id,
                        })[0];

                    id = vm.getCommonElementFromLists(
                        filterFilter(
                            vm.dhlEmailTempaltes,
                            {
                                type: "EMAIL_CONTENT",
                                actionType: "INVOICE_WITH_PDF_AND_CSV",
                                language: "en",
                            },
                            true
                        ),
                        vm.dhlClientEmailTempaltesIds
                    );
                    vm.clientTemplates.templatesEN.INVOICE_WITH_PDF_AND_CSV =
                        filterFilter(vm.dhlEmailTempaltes, {
                            ediTemplateId: id,
                        })[0];

                    // id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_CONTENT', actionType: 'CORRECTION_INVOICE', language: 'en' }, true), vm.dhlClientEmailTempaltesIds);
                    // vm.clientTemplates.templatesEN.CORRECTION_INVOICE = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(
                        filterFilter(
                            vm.dhlEmailTempaltes,
                            {
                                type: "EMAIL_CONTENT",
                                actionType: "INVOICE_TOO_LARGE",
                                language: "en",
                            },
                            true
                        ),
                        vm.dhlClientEmailTempaltesIds
                    );
                    vm.clientTemplates.templatesEN.INVOICE_TOO_LARGE =
                        filterFilter(vm.dhlEmailTempaltes, {
                            ediTemplateId: id,
                        })[0];

                    id = vm.getCommonElementFromLists(
                        filterFilter(
                            vm.dhlEmailTempaltes,
                            {
                                type: "EMAIL_TITLE",
                                actionType: "ACCOUNT_OPENED",
                                language: "fr",
                            },
                            true
                        ),
                        vm.dhlClientEmailTempaltesIds
                    );
                    vm.clientTemplates.titlesFR.ACCOUNT_OPENED = filterFilter(
                        vm.dhlEmailTempaltes,
                        { ediTemplateId: id }
                    )[0];

                    id = vm.getCommonElementFromLists(
                        filterFilter(
                            vm.dhlEmailTempaltes,
                            {
                                type: "EMAIL_TITLE",
                                actionType: "EMAIL_ADDED",
                                language: "fr",
                            },
                            true
                        ),
                        vm.dhlClientEmailTempaltesIds
                    );
                    vm.clientTemplates.titlesFR.EMAIL_ADDED = filterFilter(
                        vm.dhlEmailTempaltes,
                        { ediTemplateId: id }
                    )[0];

                    id = vm.getCommonElementFromLists(
                        filterFilter(
                            vm.dhlEmailTempaltes,
                            {
                                type: "EMAIL_TITLE",
                                actionType: "REGISTRATION_FAIL",
                                language: "fr",
                            },
                            true
                        ),
                        vm.dhlClientEmailTempaltesIds
                    );
                    vm.clientTemplates.titlesFR.REGISTRATION_FAIL =
                        filterFilter(vm.dhlEmailTempaltes, {
                            ediTemplateId: id,
                        })[0];

                    id = vm.getCommonElementFromLists(
                        filterFilter(
                            vm.dhlEmailTempaltes,
                            {
                                type: "EMAIL_TITLE",
                                actionType: "PASSWORD_CHANGE",
                                language: "fr",
                            },
                            true
                        ),
                        vm.dhlClientEmailTempaltesIds
                    );
                    vm.clientTemplates.titlesFR.PASSWORD_CHANGE = filterFilter(
                        vm.dhlEmailTempaltes,
                        { ediTemplateId: id }
                    )[0];

                    id = vm.getCommonElementFromLists(
                        filterFilter(
                            vm.dhlEmailTempaltes,
                            {
                                type: "EMAIL_TITLE",
                                actionType: "INVOICE_WITH_LINK",
                                language: "fr",
                            },
                            true
                        ),
                        vm.dhlClientEmailTempaltesIds
                    );
                    vm.clientTemplates.titlesFR.INVOICE_WITH_LINK =
                        filterFilter(vm.dhlEmailTempaltes, {
                            ediTemplateId: id,
                        })[0];

                    id = vm.getCommonElementFromLists(
                        filterFilter(
                            vm.dhlEmailTempaltes,
                            {
                                type: "EMAIL_TITLE",
                                actionType: "INVOICE_WITH_PDF",
                                language: "fr",
                            },
                            true
                        ),
                        vm.dhlClientEmailTempaltesIds
                    );
                    vm.clientTemplates.titlesFR.INVOICE_WITH_PDF = filterFilter(
                        vm.dhlEmailTempaltes,
                        { ediTemplateId: id }
                    )[0];

                    id = vm.getCommonElementFromLists(
                        filterFilter(
                            vm.dhlEmailTempaltes,
                            {
                                type: "EMAIL_TITLE",
                                actionType: "INVOICE_WITH_LINK_AND_XLSX",
                                language: "fr",
                            },
                            true
                        ),
                        vm.dhlClientEmailTempaltesIds
                    );
                    vm.clientTemplates.titlesFR.INVOICE_WITH_LINK_AND_XLSX =
                        filterFilter(vm.dhlEmailTempaltes, {
                            ediTemplateId: id,
                        })[0];

                    id = vm.getCommonElementFromLists(
                        filterFilter(
                            vm.dhlEmailTempaltes,
                            {
                                type: "EMAIL_TITLE",
                                actionType: "INVOICE_WITH_PDF_AND_XLSX",
                                language: "fr",
                            },
                            true
                        ),
                        vm.dhlClientEmailTempaltesIds
                    );
                    vm.clientTemplates.titlesFR.INVOICE_WITH_PDF_AND_XLSX =
                        filterFilter(vm.dhlEmailTempaltes, {
                            ediTemplateId: id,
                        })[0];

                    id = vm.getCommonElementFromLists(
                        filterFilter(
                            vm.dhlEmailTempaltes,
                            {
                                type: "EMAIL_TITLE",
                                actionType: "INVOICE_WITH_PDF_AND_CSV",
                                language: "fr",
                            },
                            true
                        ),
                        vm.dhlClientEmailTempaltesIds
                    );
                    vm.clientTemplates.titlesFR.INVOICE_WITH_PDF_AND_CSV =
                        filterFilter(vm.dhlEmailTempaltes, {
                            ediTemplateId: id,
                        })[0];

                    // id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_TITLE', actionType: 'CORRECTION_INVOICE', language: 'fr' }, true), vm.dhlClientEmailTempaltesIds);
                    // vm.clientTemplates.titlesFR.CORRECTION_INVOICE = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(
                        filterFilter(
                            vm.dhlEmailTempaltes,
                            {
                                type: "EMAIL_TITLE",
                                actionType: "INVOICE_TOO_LARGE",
                                language: "fr",
                            },
                            true
                        ),
                        vm.dhlClientEmailTempaltesIds
                    );
                    vm.clientTemplates.titlesFR.INVOICE_TOO_LARGE =
                        filterFilter(vm.dhlEmailTempaltes, {
                            ediTemplateId: id,
                        })[0];

                    id = vm.getCommonElementFromLists(
                        filterFilter(
                            vm.dhlEmailTempaltes,
                            {
                                type: "EMAIL_CONTENT",
                                actionType: "ACCOUNT_OPENED",
                                language: "fr",
                            },
                            true
                        ),
                        vm.dhlClientEmailTempaltesIds
                    );
                    vm.clientTemplates.templatesFR.ACCOUNT_OPENED =
                        filterFilter(vm.dhlEmailTempaltes, {
                            ediTemplateId: id,
                        })[0];

                    id = vm.getCommonElementFromLists(
                        filterFilter(
                            vm.dhlEmailTempaltes,
                            {
                                type: "EMAIL_CONTENT",
                                actionType: "EMAIL_ADDED",
                                language: "fr",
                            },
                            true
                        ),
                        vm.dhlClientEmailTempaltesIds
                    );
                    vm.clientTemplates.templatesFR.EMAIL_ADDED = filterFilter(
                        vm.dhlEmailTempaltes,
                        { ediTemplateId: id }
                    )[0];

                    id = vm.getCommonElementFromLists(
                        filterFilter(
                            vm.dhlEmailTempaltes,
                            {
                                type: "EMAIL_CONTENT",
                                actionType: "REGISTRATION_FAIL",
                                language: "fr",
                            },
                            true
                        ),
                        vm.dhlClientEmailTempaltesIds
                    );
                    vm.clientTemplates.templatesFR.REGISTRATION_FAIL =
                        filterFilter(vm.dhlEmailTempaltes, {
                            ediTemplateId: id,
                        })[0];

                    id = vm.getCommonElementFromLists(
                        filterFilter(
                            vm.dhlEmailTempaltes,
                            {
                                type: "EMAIL_CONTENT",
                                actionType: "PASSWORD_CHANGE",
                                language: "fr",
                            },
                            true
                        ),
                        vm.dhlClientEmailTempaltesIds
                    );
                    vm.clientTemplates.templatesFR.PASSWORD_CHANGE =
                        filterFilter(vm.dhlEmailTempaltes, {
                            ediTemplateId: id,
                        })[0];

                    id = vm.getCommonElementFromLists(
                        filterFilter(
                            vm.dhlEmailTempaltes,
                            {
                                type: "EMAIL_CONTENT",
                                actionType: "INVOICE_WITH_LINK",
                                language: "fr",
                            },
                            true
                        ),
                        vm.dhlClientEmailTempaltesIds
                    );
                    vm.clientTemplates.templatesFR.INVOICE_WITH_LINK =
                        filterFilter(vm.dhlEmailTempaltes, {
                            ediTemplateId: id,
                        })[0];

                    id = vm.getCommonElementFromLists(
                        filterFilter(
                            vm.dhlEmailTempaltes,
                            {
                                type: "EMAIL_CONTENT",
                                actionType: "INVOICE_WITH_PDF",
                                language: "fr",
                            },
                            true
                        ),
                        vm.dhlClientEmailTempaltesIds
                    );
                    vm.clientTemplates.templatesFR.INVOICE_WITH_PDF =
                        filterFilter(vm.dhlEmailTempaltes, {
                            ediTemplateId: id,
                        })[0];

                    id = vm.getCommonElementFromLists(
                        filterFilter(
                            vm.dhlEmailTempaltes,
                            {
                                type: "EMAIL_CONTENT",
                                actionType: "INVOICE_WITH_LINK_AND_XLSX",
                                language: "fr",
                            },
                            true
                        ),
                        vm.dhlClientEmailTempaltesIds
                    );
                    vm.clientTemplates.templatesFR.INVOICE_WITH_LINK_AND_XLSX =
                        filterFilter(vm.dhlEmailTempaltes, {
                            ediTemplateId: id,
                        })[0];

                    id = vm.getCommonElementFromLists(
                        filterFilter(
                            vm.dhlEmailTempaltes,
                            {
                                type: "EMAIL_CONTENT",
                                actionType: "INVOICE_WITH_PDF_AND_XLSX",
                                language: "fr",
                            },
                            true
                        ),
                        vm.dhlClientEmailTempaltesIds
                    );
                    vm.clientTemplates.templatesFR.INVOICE_WITH_PDF_AND_XLSX =
                        filterFilter(vm.dhlEmailTempaltes, {
                            ediTemplateId: id,
                        })[0];

                    id = vm.getCommonElementFromLists(
                        filterFilter(
                            vm.dhlEmailTempaltes,
                            {
                                type: "EMAIL_CONTENT",
                                actionType: "INVOICE_WITH_PDF_AND_CSV",
                                language: "fr",
                            },
                            true
                        ),
                        vm.dhlClientEmailTempaltesIds
                    );
                    vm.clientTemplates.templatesFR.INVOICE_WITH_PDF_AND_CSV =
                        filterFilter(vm.dhlEmailTempaltes, {
                            ediTemplateId: id,
                        })[0];

                    // id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_CONTENT', actionType: 'CORRECTION_INVOICE', language: 'fr' }, true), vm.dhlClientEmailTempaltesIds);
                    // vm.clientTemplates.templatesFR.CORRECTION_INVOICE = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(
                        filterFilter(
                            vm.dhlEmailTempaltes,
                            {
                                type: "EMAIL_CONTENT",
                                actionType: "INVOICE_TOO_LARGE",
                                language: "fr",
                            },
                            true
                        ),
                        vm.dhlClientEmailTempaltesIds
                    );
                    vm.clientTemplates.templatesFR.INVOICE_TOO_LARGE =
                        filterFilter(vm.dhlEmailTempaltes, {
                            ediTemplateId: id,
                        })[0];

                    id = vm.getCommonElementFromLists(
                        filterFilter(
                            vm.dhlEmailTempaltes,
                            {
                                type: "EMAIL_TITLE",
                                actionType: "ACCOUNT_OPENED",
                                language: "de",
                            },
                            true
                        ),
                        vm.dhlClientEmailTempaltesIds
                    );
                    vm.clientTemplates.titlesDE.ACCOUNT_OPENED = filterFilter(
                        vm.dhlEmailTempaltes,
                        { ediTemplateId: id }
                    )[0];

                    id = vm.getCommonElementFromLists(
                        filterFilter(
                            vm.dhlEmailTempaltes,
                            {
                                type: "EMAIL_TITLE",
                                actionType: "EMAIL_ADDED",
                                language: "de",
                            },
                            true
                        ),
                        vm.dhlClientEmailTempaltesIds
                    );
                    vm.clientTemplates.titlesDE.EMAIL_ADDED = filterFilter(
                        vm.dhlEmailTempaltes,
                        { ediTemplateId: id }
                    )[0];

                    id = vm.getCommonElementFromLists(
                        filterFilter(
                            vm.dhlEmailTempaltes,
                            {
                                type: "EMAIL_TITLE",
                                actionType: "REGISTRATION_FAIL",
                                language: "de",
                            },
                            true
                        ),
                        vm.dhlClientEmailTempaltesIds
                    );
                    vm.clientTemplates.titlesDE.REGISTRATION_FAIL =
                        filterFilter(vm.dhlEmailTempaltes, {
                            ediTemplateId: id,
                        })[0];

                    id = vm.getCommonElementFromLists(
                        filterFilter(
                            vm.dhlEmailTempaltes,
                            {
                                type: "EMAIL_TITLE",
                                actionType: "PASSWORD_CHANGE",
                                language: "de",
                            },
                            true
                        ),
                        vm.dhlClientEmailTempaltesIds
                    );
                    vm.clientTemplates.titlesDE.PASSWORD_CHANGE = filterFilter(
                        vm.dhlEmailTempaltes,
                        { ediTemplateId: id }
                    )[0];

                    id = vm.getCommonElementFromLists(
                        filterFilter(
                            vm.dhlEmailTempaltes,
                            {
                                type: "EMAIL_TITLE",
                                actionType: "INVOICE_WITH_LINK",
                                language: "de",
                            },
                            true
                        ),
                        vm.dhlClientEmailTempaltesIds
                    );
                    vm.clientTemplates.titlesDE.INVOICE_WITH_LINK =
                        filterFilter(vm.dhlEmailTempaltes, {
                            ediTemplateId: id,
                        })[0];

                    id = vm.getCommonElementFromLists(
                        filterFilter(
                            vm.dhlEmailTempaltes,
                            {
                                type: "EMAIL_TITLE",
                                actionType: "INVOICE_WITH_PDF",
                                language: "de",
                            },
                            true
                        ),
                        vm.dhlClientEmailTempaltesIds
                    );
                    vm.clientTemplates.titlesDE.INVOICE_WITH_PDF = filterFilter(
                        vm.dhlEmailTempaltes,
                        { ediTemplateId: id }
                    )[0];

                    id = vm.getCommonElementFromLists(
                        filterFilter(
                            vm.dhlEmailTempaltes,
                            {
                                type: "EMAIL_TITLE",
                                actionType: "INVOICE_WITH_LINK_AND_XLSX",
                                language: "de",
                            },
                            true
                        ),
                        vm.dhlClientEmailTempaltesIds
                    );
                    vm.clientTemplates.titlesDE.INVOICE_WITH_LINK_AND_XLSX =
                        filterFilter(vm.dhlEmailTempaltes, {
                            ediTemplateId: id,
                        })[0];

                    id = vm.getCommonElementFromLists(
                        filterFilter(
                            vm.dhlEmailTempaltes,
                            {
                                type: "EMAIL_TITLE",
                                actionType: "INVOICE_WITH_PDF_AND_XLSX",
                                language: "de",
                            },
                            true
                        ),
                        vm.dhlClientEmailTempaltesIds
                    );
                    vm.clientTemplates.titlesDE.INVOICE_WITH_PDF_AND_XLSX =
                        filterFilter(vm.dhlEmailTempaltes, {
                            ediTemplateId: id,
                        })[0];

                    id = vm.getCommonElementFromLists(
                        filterFilter(
                            vm.dhlEmailTempaltes,
                            {
                                type: "EMAIL_TITLE",
                                actionType: "INVOICE_WITH_PDF_AND_CSV",
                                language: "de",
                            },
                            true
                        ),
                        vm.dhlClientEmailTempaltesIds
                    );
                    vm.clientTemplates.titlesDE.INVOICE_WITH_PDF_AND_CSV =
                        filterFilter(vm.dhlEmailTempaltes, {
                            ediTemplateId: id,
                        })[0];

                    // id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_TITLE', actionType: 'CORRECTION_INVOICE', language: 'de' }, true), vm.dhlClientEmailTempaltesIds);
                    // vm.clientTemplates.titlesDE.CORRECTION_INVOICE = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(
                        filterFilter(
                            vm.dhlEmailTempaltes,
                            {
                                type: "EMAIL_TITLE",
                                actionType: "INVOICE_TOO_LARGE",
                                language: "de",
                            },
                            true
                        ),
                        vm.dhlClientEmailTempaltesIds
                    );
                    vm.clientTemplates.titlesDE.INVOICE_TOO_LARGE =
                        filterFilter(vm.dhlEmailTempaltes, {
                            ediTemplateId: id,
                        })[0];

                    id = vm.getCommonElementFromLists(
                        filterFilter(
                            vm.dhlEmailTempaltes,
                            {
                                type: "EMAIL_CONTENT",
                                actionType: "ACCOUNT_OPENED",
                                language: "de",
                            },
                            true
                        ),
                        vm.dhlClientEmailTempaltesIds
                    );
                    vm.clientTemplates.templatesDE.ACCOUNT_OPENED =
                        filterFilter(vm.dhlEmailTempaltes, {
                            ediTemplateId: id,
                        })[0];

                    id = vm.getCommonElementFromLists(
                        filterFilter(
                            vm.dhlEmailTempaltes,
                            {
                                type: "EMAIL_CONTENT",
                                actionType: "EMAIL_ADDED",
                                language: "de",
                            },
                            true
                        ),
                        vm.dhlClientEmailTempaltesIds
                    );
                    vm.clientTemplates.templatesDE.EMAIL_ADDED = filterFilter(
                        vm.dhlEmailTempaltes,
                        { ediTemplateId: id }
                    )[0];

                    id = vm.getCommonElementFromLists(
                        filterFilter(
                            vm.dhlEmailTempaltes,
                            {
                                type: "EMAIL_CONTENT",
                                actionType: "REGISTRATION_FAIL",
                                language: "de",
                            },
                            true
                        ),
                        vm.dhlClientEmailTempaltesIds
                    );
                    vm.clientTemplates.templatesDE.REGISTRATION_FAIL =
                        filterFilter(vm.dhlEmailTempaltes, {
                            ediTemplateId: id,
                        })[0];

                    id = vm.getCommonElementFromLists(
                        filterFilter(
                            vm.dhlEmailTempaltes,
                            {
                                type: "EMAIL_CONTENT",
                                actionType: "PASSWORD_CHANGE",
                                language: "de",
                            },
                            true
                        ),
                        vm.dhlClientEmailTempaltesIds
                    );
                    vm.clientTemplates.templatesDE.PASSWORD_CHANGE =
                        filterFilter(vm.dhlEmailTempaltes, {
                            ediTemplateId: id,
                        })[0];

                    id = vm.getCommonElementFromLists(
                        filterFilter(
                            vm.dhlEmailTempaltes,
                            {
                                type: "EMAIL_CONTENT",
                                actionType: "INVOICE_WITH_LINK",
                                language: "de",
                            },
                            true
                        ),
                        vm.dhlClientEmailTempaltesIds
                    );
                    vm.clientTemplates.templatesDE.INVOICE_WITH_LINK =
                        filterFilter(vm.dhlEmailTempaltes, {
                            ediTemplateId: id,
                        })[0];

                    id = vm.getCommonElementFromLists(
                        filterFilter(
                            vm.dhlEmailTempaltes,
                            {
                                type: "EMAIL_CONTENT",
                                actionType: "INVOICE_WITH_PDF",
                                language: "de",
                            },
                            true
                        ),
                        vm.dhlClientEmailTempaltesIds
                    );
                    vm.clientTemplates.templatesDE.INVOICE_WITH_PDF =
                        filterFilter(vm.dhlEmailTempaltes, {
                            ediTemplateId: id,
                        })[0];

                    id = vm.getCommonElementFromLists(
                        filterFilter(
                            vm.dhlEmailTempaltes,
                            {
                                type: "EMAIL_CONTENT",
                                actionType: "INVOICE_WITH_LINK_AND_XLSX",
                                language: "de",
                            },
                            true
                        ),
                        vm.dhlClientEmailTempaltesIds
                    );
                    vm.clientTemplates.templatesDE.INVOICE_WITH_LINK_AND_XLSX =
                        filterFilter(vm.dhlEmailTempaltes, {
                            ediTemplateId: id,
                        })[0];

                    id = vm.getCommonElementFromLists(
                        filterFilter(
                            vm.dhlEmailTempaltes,
                            {
                                type: "EMAIL_CONTENT",
                                actionType: "INVOICE_WITH_PDF_AND_XLSX",
                                language: "de",
                            },
                            true
                        ),
                        vm.dhlClientEmailTempaltesIds
                    );
                    vm.clientTemplates.templatesDE.INVOICE_WITH_PDF_AND_XLSX =
                        filterFilter(vm.dhlEmailTempaltes, {
                            ediTemplateId: id,
                        })[0];

                    id = vm.getCommonElementFromLists(
                        filterFilter(
                            vm.dhlEmailTempaltes,
                            {
                                type: "EMAIL_CONTENT",
                                actionType: "INVOICE_WITH_PDF_AND_CSV",
                                language: "de",
                            },
                            true
                        ),
                        vm.dhlClientEmailTempaltesIds
                    );
                    vm.clientTemplates.templatesDE.INVOICE_WITH_PDF_AND_CSV =
                        filterFilter(vm.dhlEmailTempaltes, {
                            ediTemplateId: id,
                        })[0];

                    // id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_CONTENT', actionType: 'CORRECTION_INVOICE', language: 'de' }, true), vm.dhlClientEmailTempaltesIds);
                    // vm.clientTemplates.templatesDE.CORRECTION_INVOICE = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(
                        filterFilter(
                            vm.dhlEmailTempaltes,
                            {
                                type: "EMAIL_CONTENT",
                                actionType: "INVOICE_TOO_LARGE",
                                language: "de",
                            },
                            true
                        ),
                        vm.dhlClientEmailTempaltesIds
                    );
                    vm.clientTemplates.templatesDE.INVOICE_TOO_LARGE =
                        filterFilter(vm.dhlEmailTempaltes, {
                            ediTemplateId: id,
                        })[0];
                })
                .catch(function (response) {
                    vm.clientErrorText = $translate.instant(
                        "systemSettings.messages.templatesDownloadFailed"
                    );
                    vm.clientSuccessText = null;
                });
        }

        function getCommonElementFromLists(list1, list2) {
            var id;
            angular.forEach(list1, function (value, key) {
                if (list2.indexOf(value.ediTemplateId) > -1) {
                    id = value.ediTemplateId;
                }
            });
            return id;
        }

        //client + listofid
        function sendNewUserTemplates() {
            vm.templatesToSend = [];

            vm.templatesToSend.push(
                vm.clientTemplates.titlesNL.ACCOUNT_OPENED.ediTemplateId
            );
            vm.templatesToSend.push(
                vm.clientTemplates.titlesNL.EMAIL_ADDED.ediTemplateId
            );
            vm.templatesToSend.push(
                vm.clientTemplates.titlesNL.REGISTRATION_FAIL.ediTemplateId
            );
            vm.templatesToSend.push(
                vm.clientTemplates.titlesNL.PASSWORD_CHANGE.ediTemplateId
            );
            vm.templatesToSend.push(
                vm.clientTemplates.titlesNL.INVOICE_WITH_LINK.ediTemplateId
            );
            vm.templatesToSend.push(
                vm.clientTemplates.titlesNL.INVOICE_WITH_PDF.ediTemplateId
            );
            vm.templatesToSend.push(
                vm.clientTemplates.titlesNL.INVOICE_WITH_LINK_AND_XLSX
                    .ediTemplateId
            );
            vm.templatesToSend.push(
                vm.clientTemplates.titlesNL.INVOICE_WITH_PDF_AND_XLSX
                    .ediTemplateId
            );
            vm.templatesToSend.push(
                vm.clientTemplates.titlesNL.INVOICE_WITH_PDF_AND_CSV
                    .ediTemplateId
            );
            // vm.templatesToSend.push(vm.clientTemplates.titlesNL.CORRECTION_INVOICE.ediTemplateId);
            vm.templatesToSend.push(
                vm.clientTemplates.titlesNL.INVOICE_TOO_LARGE.ediTemplateId
            );

            vm.templatesToSend.push(
                vm.clientTemplates.templatesNL.ACCOUNT_OPENED.ediTemplateId
            );
            vm.templatesToSend.push(
                vm.clientTemplates.templatesNL.EMAIL_ADDED.ediTemplateId
            );
            vm.templatesToSend.push(
                vm.clientTemplates.templatesNL.REGISTRATION_FAIL.ediTemplateId
            );
            vm.templatesToSend.push(
                vm.clientTemplates.templatesNL.PASSWORD_CHANGE.ediTemplateId
            );
            vm.templatesToSend.push(
                vm.clientTemplates.templatesNL.INVOICE_WITH_LINK.ediTemplateId
            );
            vm.templatesToSend.push(
                vm.clientTemplates.templatesNL.INVOICE_WITH_PDF.ediTemplateId
            );
            vm.templatesToSend.push(
                vm.clientTemplates.templatesNL.INVOICE_WITH_LINK_AND_XLSX
                    .ediTemplateId
            );
            vm.templatesToSend.push(
                vm.clientTemplates.templatesNL.INVOICE_WITH_PDF_AND_XLSX
                    .ediTemplateId
            );
            vm.templatesToSend.push(
                vm.clientTemplates.templatesNL.INVOICE_WITH_PDF_AND_CSV
                    .ediTemplateId
            );
            // vm.templatesToSend.push(vm.clientTemplates.templatesNL.CORRECTION_INVOICE.ediTemplateId);
            vm.templatesToSend.push(
                vm.clientTemplates.templatesNL.INVOICE_TOO_LARGE.ediTemplateId
            );

            vm.templatesToSend.push(
                vm.clientTemplates.titlesEN.ACCOUNT_OPENED.ediTemplateId
            );
            vm.templatesToSend.push(
                vm.clientTemplates.titlesEN.EMAIL_ADDED.ediTemplateId
            );
            vm.templatesToSend.push(
                vm.clientTemplates.titlesEN.REGISTRATION_FAIL.ediTemplateId
            );
            vm.templatesToSend.push(
                vm.clientTemplates.titlesEN.PASSWORD_CHANGE.ediTemplateId
            );
            vm.templatesToSend.push(
                vm.clientTemplates.titlesEN.INVOICE_WITH_LINK.ediTemplateId
            );
            vm.templatesToSend.push(
                vm.clientTemplates.titlesEN.INVOICE_WITH_PDF.ediTemplateId
            );
            vm.templatesToSend.push(
                vm.clientTemplates.titlesEN.INVOICE_WITH_LINK_AND_XLSX
                    .ediTemplateId
            );
            vm.templatesToSend.push(
                vm.clientTemplates.titlesEN.INVOICE_WITH_PDF_AND_XLSX
                    .ediTemplateId
            );
            vm.templatesToSend.push(
                vm.clientTemplates.titlesEN.INVOICE_WITH_PDF_AND_CSV
                    .ediTemplateId
            );
            // vm.templatesToSend.push(vm.clientTemplates.titlesEN.CORRECTION_INVOICE.ediTemplateId);
            vm.templatesToSend.push(
                vm.clientTemplates.titlesEN.INVOICE_TOO_LARGE.ediTemplateId
            );

            vm.templatesToSend.push(
                vm.clientTemplates.templatesEN.ACCOUNT_OPENED.ediTemplateId
            );
            vm.templatesToSend.push(
                vm.clientTemplates.templatesEN.EMAIL_ADDED.ediTemplateId
            );
            vm.templatesToSend.push(
                vm.clientTemplates.templatesEN.REGISTRATION_FAIL.ediTemplateId
            );
            vm.templatesToSend.push(
                vm.clientTemplates.templatesEN.PASSWORD_CHANGE.ediTemplateId
            );
            vm.templatesToSend.push(
                vm.clientTemplates.templatesEN.INVOICE_WITH_LINK.ediTemplateId
            );
            vm.templatesToSend.push(
                vm.clientTemplates.templatesEN.INVOICE_WITH_PDF.ediTemplateId
            );
            vm.templatesToSend.push(
                vm.clientTemplates.templatesEN.INVOICE_WITH_LINK_AND_XLSX
                    .ediTemplateId
            );
            vm.templatesToSend.push(
                vm.clientTemplates.templatesEN.INVOICE_WITH_PDF_AND_XLSX
                    .ediTemplateId
            );
            vm.templatesToSend.push(
                vm.clientTemplates.templatesEN.INVOICE_WITH_PDF_AND_CSV
                    .ediTemplateId
            );
            // vm.templatesToSend.push(vm.clientTemplates.templatesEN.CORRECTION_INVOICE.ediTemplateId);
            vm.templatesToSend.push(
                vm.clientTemplates.templatesEN.INVOICE_TOO_LARGE.ediTemplateId
            );

            vm.templatesToSend.push(
                vm.clientTemplates.titlesFR.ACCOUNT_OPENED.ediTemplateId
            );
            vm.templatesToSend.push(
                vm.clientTemplates.titlesFR.EMAIL_ADDED.ediTemplateId
            );
            vm.templatesToSend.push(
                vm.clientTemplates.titlesFR.REGISTRATION_FAIL.ediTemplateId
            );
            vm.templatesToSend.push(
                vm.clientTemplates.titlesFR.PASSWORD_CHANGE.ediTemplateId
            );
            vm.templatesToSend.push(
                vm.clientTemplates.titlesFR.INVOICE_WITH_LINK.ediTemplateId
            );
            vm.templatesToSend.push(
                vm.clientTemplates.titlesFR.INVOICE_WITH_PDF.ediTemplateId
            );
            vm.templatesToSend.push(
                vm.clientTemplates.titlesFR.INVOICE_WITH_LINK_AND_XLSX
                    .ediTemplateId
            );
            vm.templatesToSend.push(
                vm.clientTemplates.titlesFR.INVOICE_WITH_PDF_AND_XLSX
                    .ediTemplateId
            );
            vm.templatesToSend.push(
                vm.clientTemplates.titlesFR.INVOICE_WITH_PDF_AND_CSV
                    .ediTemplateId
            );
            // vm.templatesToSend.push(vm.clientTemplates.titlesFR.CORRECTION_INVOICE.ediTemplateId);
            vm.templatesToSend.push(
                vm.clientTemplates.titlesFR.INVOICE_TOO_LARGE.ediTemplateId
            );

            vm.templatesToSend.push(
                vm.clientTemplates.templatesFR.ACCOUNT_OPENED.ediTemplateId
            );
            vm.templatesToSend.push(
                vm.clientTemplates.templatesFR.EMAIL_ADDED.ediTemplateId
            );
            vm.templatesToSend.push(
                vm.clientTemplates.templatesFR.REGISTRATION_FAIL.ediTemplateId
            );
            vm.templatesToSend.push(
                vm.clientTemplates.templatesFR.PASSWORD_CHANGE.ediTemplateId
            );
            vm.templatesToSend.push(
                vm.clientTemplates.templatesFR.INVOICE_WITH_LINK.ediTemplateId
            );
            vm.templatesToSend.push(
                vm.clientTemplates.templatesFR.INVOICE_WITH_PDF.ediTemplateId
            );
            vm.templatesToSend.push(
                vm.clientTemplates.templatesFR.INVOICE_WITH_LINK_AND_XLSX
                    .ediTemplateId
            );
            vm.templatesToSend.push(
                vm.clientTemplates.templatesFR.INVOICE_WITH_PDF_AND_XLSX
                    .ediTemplateId
            );
            vm.templatesToSend.push(
                vm.clientTemplates.templatesFR.INVOICE_WITH_PDF_AND_CSV
                    .ediTemplateId
            );
            // vm.templatesToSend.push(vm.clientTemplates.templatesFR.CORRECTION_INVOICE.ediTemplateId);
            vm.templatesToSend.push(
                vm.clientTemplates.templatesFR.INVOICE_TOO_LARGE.ediTemplateId
            );

            vm.templatesToSend.push(
                vm.clientTemplates.titlesDE.ACCOUNT_OPENED.ediTemplateId
            );
            vm.templatesToSend.push(
                vm.clientTemplates.titlesDE.EMAIL_ADDED.ediTemplateId
            );
            vm.templatesToSend.push(
                vm.clientTemplates.titlesDE.REGISTRATION_FAIL.ediTemplateId
            );
            vm.templatesToSend.push(
                vm.clientTemplates.titlesDE.PASSWORD_CHANGE.ediTemplateId
            );
            vm.templatesToSend.push(
                vm.clientTemplates.titlesDE.INVOICE_WITH_LINK.ediTemplateId
            );
            vm.templatesToSend.push(
                vm.clientTemplates.titlesDE.INVOICE_WITH_PDF.ediTemplateId
            );
            vm.templatesToSend.push(
                vm.clientTemplates.titlesDE.INVOICE_WITH_LINK_AND_XLSX
                    .ediTemplateId
            );
            vm.templatesToSend.push(
                vm.clientTemplates.titlesDE.INVOICE_WITH_PDF_AND_XLSX
                    .ediTemplateId
            );
            vm.templatesToSend.push(
                vm.clientTemplates.titlesDE.INVOICE_WITH_PDF_AND_CSV
                    .ediTemplateId
            );
            // vm.templatesToSend.push(vm.clientTemplates.titlesDE.CORRECTION_INVOICE.ediTemplateId);
            vm.templatesToSend.push(
                vm.clientTemplates.titlesDE.INVOICE_TOO_LARGE.ediTemplateId
            );

            vm.templatesToSend.push(
                vm.clientTemplates.templatesDE.ACCOUNT_OPENED.ediTemplateId
            );
            vm.templatesToSend.push(
                vm.clientTemplates.templatesDE.EMAIL_ADDED.ediTemplateId
            );
            vm.templatesToSend.push(
                vm.clientTemplates.templatesDE.REGISTRATION_FAIL.ediTemplateId
            );
            vm.templatesToSend.push(
                vm.clientTemplates.templatesDE.PASSWORD_CHANGE.ediTemplateId
            );
            vm.templatesToSend.push(
                vm.clientTemplates.templatesDE.INVOICE_WITH_LINK.ediTemplateId
            );
            vm.templatesToSend.push(
                vm.clientTemplates.templatesDE.INVOICE_WITH_PDF.ediTemplateId
            );
            vm.templatesToSend.push(
                vm.clientTemplates.templatesDE.INVOICE_WITH_LINK_AND_XLSX
                    .ediTemplateId
            );
            vm.templatesToSend.push(
                vm.clientTemplates.templatesDE.INVOICE_WITH_PDF_AND_XLSX
                    .ediTemplateId
            );
            vm.templatesToSend.push(
                vm.clientTemplates.templatesDE.INVOICE_WITH_PDF_AND_CSV
                    .ediTemplateId
            );
            // vm.templatesToSend.push(vm.clientTemplates.templatesDE.CORRECTION_INVOICE.ediTemplateId);
            vm.templatesToSend.push(
                vm.clientTemplates.templatesDE.INVOICE_TOO_LARGE.ediTemplateId
            );

            ClientsService.postClientTemplates(
                vm.dhlClient.ediClientId,
                vm.templatesToSend
            )
                .then(function (response) {
                    vm.clientErrorText = null;
                    vm.clientSuccessText = $translate.instant(
                        "systemSettings.messages.templatesEditSuccess"
                    );
                })
                .catch(function (response) {
                    vm.clientErrorText = $translate.instant(
                        "systemSettings.messages.templatesEditFail"
                    );
                    vm.clientSuccessText = null;
                });
        }

        function changeActionTypeToText(actionType) {
            return filterFilter(
                vm.ActivityTypes,
                { name: actionType },
                true
            )[0].text();
        }

        vm.listTemplates = {
            first: function () {
                UtilService.get(vm.dhlTemplatesData, "first", null, null).then(
                    vm.listTemplates.then
                );
            },
            previous: function () {
                UtilService.get(vm.dhlTemplatesData, "prev", null, null).then(
                    vm.listTemplates.then
                );
            },
            next: function () {
                UtilService.get(vm.dhlTemplatesData, "next", null, null).then(
                    vm.listTemplates.then
                );
            },
            last: function () {
                UtilService.get(vm.dhlTemplatesData, "last", null, null).then(
                    vm.listTemplates.then
                );
            },
            then: function (response) {
                //add 'BENELUXUI' to url if missing
                fixTemplatesLinks(response);
                vm.dhlTemplatesData = response.data;
                vm.dhlTemplates = getEntityTemplates(response.data);
            },
        };
        vm.listTitles = {
            first: function () {
                UtilService.get(vm.dhlTitlesData, "first", null, null).then(
                    vm.listTitles.then
                );
            },
            previous: function () {
                UtilService.get(vm.dhlTitlesData, "prev", null, null).then(
                    vm.listTitles.then
                );
            },
            next: function () {
                UtilService.get(vm.dhlTitlesData, "next", null, null).then(
                    vm.listTitles.then
                );
            },
            last: function () {
                UtilService.get(vm.dhlTitlesData, "last", null, null).then(
                    vm.listTitles.then
                );
            },
            then: function (response) {
                //add 'BENELUXUI' to url if missing
                fixTemplatesLinks(response);
                vm.dhlTitlesData = response.data;
                vm.dhlTitles = getEntityTemplates(response.data);
            },
        };

        function setTooltip() {
            vm.htmlTooltip = true;
        }

        function disableTooltip() {
            vm.htmlTooltip = false;
        }

        function chooseOrDrop() {
            return $translate.instant("systemSettings.chooseOrDrop");
        }

        $scope.$watch(
            function () {
                var element = angular.element(
                    document.querySelector(".html-input")
                );
                return element.attr("class");
            },
            function (newValue) {
                if (newValue && newValue.indexOf("ng-invalid-pattern") !== -1) {
                    vm.htmlTooltip = true;
                } else if (!newValue || newValue.indexOf("ng-valid") !== -1) {
                    vm.htmlTooltip = false;
                }
            }
        );

        vm.init();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('settings', {
            parent: 'application',
            url: '/settings',
            data: {
                pageTitle: 'global.menu.settings'
            },
            views: {
                'content@application': {
                    templateUrl: 'app/views/settings/settings.html',
                    controller: 'SettingsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('settings');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .controller('SettingsController', SettingsController);

    SettingsController.$inject = ['$sce', '$scope', '$state', '$stateParams', 'User', 'Principal', 'JhiLanguageService', 'PasswordResetInit', '$filter', 'UsersService', 'AlertService', '$translate'];

    function SettingsController($sce, $scope, $state, $stateParams, User, Principal, JhiLanguageService, PasswordResetInit, $filter, UsersService, AlertService, $translate) {
        var vm = this;

        //Declare variables
        vm.filter = null;
        vm.data = {
            user: {
                user: {
                    passwordExpireDate: null,
                    accountLanguage: null,
                    language: 'Polski'
                },
                lastLoginFailure: null,
                onePageDocumentShown: true
            }
        };
        vm.language = "Polski";
        vm.language1 = null;
        vm.passwordChangeSuccessText = null;
        vm.passwordChangeErrorText = null;
        vm.languageChangeSuccessText = null;
        vm.languageChangeErrorText = null;
        vm.getUserErrorText = null;
        vm.lastLoginFail = null;
        //TODO for now needs refresh to function
        vm.safePassword = $sce.trustAsHtml($translate.instant('settings.toolTips.safePassword'));
        vm.documentSettingChangeErrorText = null;
        vm.documentSettingChangeSuccessText = null;
        vm.userId = null;
        vm.none = $translate.instant('settings.none');
        //Declare functions
        vm.init = init;
        vm.setLanguage = setLanguage;
        vm.getUser = getUser;
        vm.resetPassword = resetPassword;
        vm.changeDocumentSetting = changeDocumentSetting;
        vm.clientNav = clientNav;
        vm.passwordTooltip = passwordTooltip;

        function passwordTooltip() {
            return $sce.trustAsHtml($translate.instant('settings.toolTips.safePassword'));
        };


        //Init functions
        function init() {
            if (Principal.isAuthenticated()) {
                vm.userId = Principal.getProperty('userId');
                vm.getUser();
            }
        }

        function setLanguage() {
            vm.language1 = $filter('findKeyFromLanguage')(vm.language);
            vm.data.user.user.accountLanguage = vm.language1;


            UsersService.postChanges(vm.data.user.user.ediUserId, vm.data.user.user.accountLanguage).then(function(response) {
                vm.languageChangeSuccessText = $translate.instant('settings.toolTips.languageChangeSuccess');
                vm.languageChangeErrorText = null;
            }).catch(function(response) {
                vm.languageChangeSuccessText = null;
                vm.languageChangeErrorText = $translate.instant('error.occurred');
            });
        }

        function getUser() {
            if (Principal.isAuthenticated()) {
                UsersService.getDetails(Principal.getProperty('userId')).then(function(response) {
                    vm.data.user = response.data;
                    vm.language = $filter('findLanguageFromKey')($filter('lowercase')(response.data.user.accountLanguage));
                }).catch(function(response) {
                    vm.data = {
                        user: {
                            user: {
                                passwordExpireDate: null,
                                accountLanguage: null,
                                language: 'Polski'
                            },
                            lastLoginFailure: null,
                            onePageDocumentShown: true
                        }
                    };
                    vm.getUserErrorText = $translate.instant('error.occurred');
                });
            } else {
                vm.data = {
                    user: {
                        user: {
                            passwordExpireDate: null,
                            accountLanguage: null,
                            language: 'Polski'
                        }
                    },
                    lastLoginFailure: null,
                    onePageDocumentShown: true
                };
                vm.getUserErrorText = $translate.instant('error.occurred');
            }
        }

        function resetPassword(user) {
            if (Principal.isAuthenticated()) {
                PasswordResetInit.resetPassword(vm.data.user.user.ediUserId, user).then(function(response) {
                    vm.passwordChangeSuccessText = $translate.instant('settings.toolTips.passwordChangeSuccess');
                    vm.passwordChangeErrorText = null;
                }).catch(function(response) {
                    vm.passwordChangeSuccessText = null;
                    switch (response.data.message) {
                        case 1:
                            vm.passwordChangeErrorText = $translate.instant('settings.toolTips.noFieldsEmpty');
                            break;
                        case 2:
                            vm.passwordChangeErrorText = $translate.instant('settings.toolTips.invalidCurrentPassword');
                            break;
                        case 3:
                            vm.passwordChangeErrorText = $translate.instant('global.messages.error.dontmatch')
                            break;
                        case 4:
                            vm.passwordChangeErrorText = $translate.instant('settings.messages.error.minlength');
                            break;
                        case 5:
                            vm.passwordChangeErrorText = $translate.instant('settings.toolTips.passwordValidationDescription');
                            break;
                        case 6:
                            vm.passwordChangeErrorText = $translate.instant('settings.toolTips.passwordNoRepeat');
                            break;
                        default:
                            vm.passwordChangeErrorText = $translate.instant('error.occurred');
                    }
                });
            } else {
                vm.passwordChangeErrorText = $translate.instant('error.relog');
            }
        }

        function changeDocumentSetting(documentSetting) {
            if (documentSetting != null && vm.data.user.user.ediUserId != null) {
                UsersService.setOnePagePdf(vm.data.user.user.ediUserId, documentSetting).then(function(response) {
                    vm.documentSettingChangeSuccessText = $translate.instant('settings.toolTips.changeSuccessful');
                    vm.documentSettingChangeErrorText = null;
                }).catch(function(response) {
                    vm.documentSettingChangeSuccessText = null;
                    vm.documentSettingChangeErrorText = $translate.instant('error.occurred');
                });
            } else {
                vm.documentSettingChangeSuccessText = null;
                vm.documentSettingChangeErrorText = $translate.instant('error.occurred');
            }

        }

        function clientNav(client) {
            $state.go('client', client);
        }


        //Init controller
        vm.init();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('roles', {
            parent: 'application',
            url: '/roles',
            data: {
                pageTitle: 'global.menu.roles'
            },
            views: {
                'content@application': {
                    templateUrl: 'app/views/roles/roles.html',
                    controller: 'RolesController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('roles');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .controller('RolesController', RolesController);

    RolesController.$inject = ['$uibModal', 'RolesService', 'AlertService','$translate'];

    function RolesController($uibModal, RolesService, AlertService, $translate) {
        var vm = this;

        vm.roles = [];

        vm.init = init;
        vm.goToAddRole = goToAddRole;
        vm.goToEditRole = goToEditRole;

        function goToAddRole() {
            var newUserModal = $uibModal.open({
                templateUrl: 'app/views/roles/addRole.html',
                controller: 'AddRoleController',
                controllerAs: 'vm',
                size: 'md'
            });
            newUserModal.result.then(function(response) {
                if (response.result === 'added') {
                    delete response.result;
                    vm.init();
                } else if (response.result === 'warn') {
                    delete response.result;
                    vm.init();
                    AlertService.error($translate.instant("roles.assignError"));
                } else if (response.result === 'error') {
                    delete response.result;
                    AlertService.error($translate.instant("roles.addingError"));
                }
            });
        }

        function goToEditRole(event, index, role) {
            var newUserModal2 = $uibModal.open({
                templateUrl: 'app/views/roles/editRole.html',
                controller: 'EditRoleController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    passRole: role
                }
            });

            newUserModal2.result.then(function(response) {
                if (response.result === 'updated' || response.result === 'deleted') {
                    delete response.result;
                    vm.init();
                } else if (response.result === 'error') {
                    delete response.result;
                    AlertService.error($translate.instant("roles.updateError"));
                }
            });
        }

        function init() {
            RolesService.getRoles()
                .then(function(response) {
                    vm.roles = response.data._embedded.ediRoles;
                })
                .catch(function(response) {
                    AlertService.error($translate.instant("roles.getError"));
                });
        }
        
        vm.init();
    }
})();
;
(function() {
    'use strict';

    angular
		.module('edistradadhluiApp')
		.controller('EditRoleController', EditRoleController);

    EditRoleController.$inject = ['$uibModalInstance', 'RolesService', 'passRole', 'AlertService', '$translate'];

    function EditRoleController($uibModalInstance, RolesService, passRole, AlertService, $translate) {
        var vm = this;

        vm.allPermissions = [];
        vm.newRole = {
            ediRoleId:passRole.ediRoleId,
            description:passRole.description,
            roleName:passRole.roleName,
            sourceName:'DHL',
            allPermissions: []
        };

        vm.data = {
            email: null,
            password: null
        };

        vm.init = init;
        vm.toggleSelection = toggleSelection;
        vm.matchPermissions = matchPermissions;

        vm.modal = {
            update: function() {
                RolesService.updateRole(vm.newRole.ediRoleId, vm.newRole)
                    .then(function(response){
                        vm.newRole.result = "updated";
                        $uibModalInstance.close(vm.newRole);
                    })
                    .catch(function(response){
                        vm.newRole.result = "error";
                        $uibModalInstance.close(vm.newRole);
                    });
            },
            delete: function(){
                RolesService.deleteRole(passRole.ediRoleId)
                .then(function(response){
                    vm.newRole.result = 'deleted';
                    $uibModalInstance.close(vm.newRole);
                })
                .catch(function(response){
                    vm.newRole.result = 'error';
                    $uibModalInstance.close(vm.newRole);
                });
            },
            cancel: function() {
                $uibModalInstance.dismiss('cancel');
            }
        };

        function init(){
            RolesService.getPermissions()
                .then(function(response) {
                    vm.allPermissions = response.data._embedded.ediPermissions;
                    RolesService.getPermissionsByRoleId(passRole.ediRoleId)
                    .then(function(response) {
                        for(var i=0; i<response.data._embedded.ediPermissions.length; i++){
                            vm.newRole.allPermissions.push(response.data._embedded.ediPermissions[i].ediPermissionId);
                        }
                        vm.matchPermissions(vm.allPermissions, vm.newRole.allPermissions);
                    })
                    .catch(function(response) {
                        AlertService.error($translate.instant("roles.getPermissionsError"));
                    });
                })
                .catch(function(response) {
                    AlertService.error($translate.instant("roles.getPermissionsError"));
                });
        }

        function matchPermissions(allPermissions, rolePermissions){
            var i;
            var j;
            for (i = 0; i <  allPermissions.length; i++) {
                vm.allPermissions[i].checked = false;
                for (j = 0; j <  rolePermissions.length; j++){
                    if(allPermissions[i].ediPermissionId == rolePermissions[j]){
                        vm.allPermissions[i].checked = true;
                    }
                }
            }
        }

        function toggleSelection(event,index,permission){
            if (event.target.checked){
                vm.newRole.allPermissions.push(permission.ediPermissionId);
            }
            else{
                var i;
                for (i = 0; i <  vm.newRole.allPermissions.length; ++i) {
                    if( vm.newRole.allPermissions[i] ==  vm.allPermissions[index].ediPermissionId)
                        vm.newRole.allPermissions.splice(i, 1);
                }
            }
        }

        vm.init();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .controller('AddRoleController', AddRoleController);

    AddRoleController.$inject = ['$uibModalInstance','RolesService', 'uuid4', '$translate', 'AlertService'];

    function AddRoleController($uibModalInstance, RolesService, uuid4, $translate, AlertService) {
        var vm = this;

        vm.allPermissions = [];
        vm.newRole = {
            description:null,
            name:null,
            sourceName:'DHL',
            allPermissions: []
        };

        //Declare functions
        vm.init = init;
        vm.toggleSelection = toggleSelection;

        //Functions implementations
        vm.modal = {
            add: function() {
                vm.newRole.ediRoleId = uuid4.generate();
                RolesService.createRole(vm.newRole)
                    .then(function(response){
                        RolesService.updateRole(vm.newRole.ediRoleId, vm.newRole)
                            .then(function(response){
                                vm.newRole.result = "added";
                                $uibModalInstance.close(vm.newRole);
                            })
                            .catch(function(response){
                                vm.newRole.result = "warn";
                                $uibModalInstance.close(vm.newRole);
                            });
                    })
                    .catch(function(response){
                        vm.newRole.result = "error";
                        $uibModalInstance.close(vm.newRole);
                    });
            },
            cancel: function() {
                $uibModalInstance.dismiss('cancel');
            }
        };

        function init(){
            RolesService.getPermissions()
                .then(function(response) {
                    vm.allPermissions = response.data._embedded.ediPermissions;
                })
                .catch(function(response) {
                    AlertService.error($translate.instant("roles.getPermissionsError"));
                });
        }

        function toggleSelection(event,index,permission){
            if(event.target.checked){
                vm.newRole.allPermissions.push(permission.ediPermissionId);
            }
            else{
                var i;
                for (i = 0; i <  vm.newRole.permissions.length; ++i) {
                    if( vm.newRole.permissions[i] ==  vm.allPermissions[index].ediPermissionId)
                        vm.newRole.permissions.splice(i, 1);
                }
            }
        }

        vm.init();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('register_end', {
            parent: 'site',
            url: '/register_end',
            data: {
                pageTitle: 'global.menu.register_end'
            },
            views: {
                'content@': {
                    templateUrl: 'app/views/register/register_end.html',
                    controller: 'RegisterEndController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('register');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .controller('RegisterEndController', RegisterEndController);

    RegisterEndController.$inject = ['$scope', '$state', '$stateParams', 'UsersService', '$animate', 'uuid4', '$sce','$translate', 'UtilService', '$rootScope', '$translate'];

    function RegisterEndController($scope, $state, $stateParams, UsersService, $animate, uuid4, $sce, $translate, UtilService, $rootScope) {
        var vm = this;
        vm.translate = $translate.instant;

        //Declare variables
        vm.filter = null;
        vm.data = null;
        vm.data = {
            uuid: null,
            email: null,
            nip: null,
            invoiceNr: null,
            totalAmount: null,
            clientCode: null
        };
        vm.uuid = null;
        vm.patternMinLength = null;
        vm.patternMaxLength = null;
        vm.pattern = null;

        vm.getUrl = getUrl;

        //Declare functions
        vm.init = init;

        //Init functions
        function init() {
            vm.data.uuid = uuid4.generate();
        }

        function getUrl(translation) {
            return $translate.instant("registerEnd." + translation + "." + $rootScope.API_DOMAIN);
        }

        //Init controller
        vm.init();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('register', {
            parent: 'site',
            url: '/register',
            data: {
                pageTitle: 'global.menu.register'
            },
            views: {
                'content@': {
                    templateUrl: 'app/views/register/register.html',
                    controller: 'RegisterController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('register');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .controller('RegisterController', RegisterController);

    RegisterController.$inject = ['$scope', '$state', '$stateParams', 'UsersService', '$animate', 'uuid4', '$sce', '$translate', 'UtilService', '$rootScope', 'API_URL'];

    function RegisterController($scope, $state, $stateParams, UsersService, $animate, uuid4, $sce, $translate, UtilService, $rootScope, API_URL) {
        var vm = this;
        vm.translate = $translate.instant;
        $scope.invoiceNumberTooltip = $sce.trustAsHtml($translate.instant('register.invoiceNumberTooltip'));
        $scope.entities = [{party: 'IPVN', sourceName: 'NL', name: $translate.instant('global.legalentities.NL')},
                           {party: 'IPVB', sourceName: 'BE', name: $translate.instant('global.legalentities.BE')},
                           {party: 'IPSN', sourceName: 'EC', name: $translate.instant('global.legalentities.EC')}];
        $scope.entity = $scope.entities[0].sourceName;

        //Declare variables
        vm.filter = null;
        vm.data = null;
        vm.data = {
            uuid: null,
            email: null,
            nip: null,
            invoiceNr: null,
            totalAmount: null,
            clientCode: null
        };
        vm.uuid = null;
        vm.patternMinLength = null;
        vm.patternMaxLength = null;
        vm.pattern = null;

        //Declare functions
        vm.init = init;
        vm.getNIPPattern = getNIPPattern;
        vm.getInvoiceAcceptanceLink = getInvoiceAcceptanceLink;
        vm.send = send;
        vm.invalid = invalid;

        //Init functions
        function init() {
            getNIPPattern();
            vm.data.uuid = uuid4.generate();
        }

        function getNIPPattern() {
            // var NIP = UtilService.getNIPPattern($scope.entity); //if dependent on source name (legal entity)
            var NIP = UtilService.getNIPPattern();
            vm.patternMinLength = NIP.minlength;
            vm.patternMaxLength = NIP.maxlength;
            vm.pattern = new RegExp(NIP.regex);
        }

        function getInvoiceAcceptanceLink() {
            if ($rootScope.API_URL === API_URL.BE) {
                return 'https://www.dhl.com/be-nl/home.html';
            } else return 'https://www.dhl.com/nl-nl/home.html';
        }

        function send() {
            vm.registerErrorText = null;

            var registerData = {
                uuid: vm.data.uuid,
                email: vm.data.email,
                nip: vm.data.nip,
                invoiceNumber: vm.data.invoiceNr,
                grossAmount: parseFloat(vm.data.totalAmount.replace(',', '.')),
                clientCode: vm.data.clientCode,
                sourceName: $scope.entity
            };
            UsersService.createNewUser(registerData).then(function(response) {
                $state.go('register_end');
            }).catch(function(response) {
            });
        }

        function invalid() {
            vm.registerErrorText=$translate.instant("register.registerErrorText");
            if($( "#dhlEmail" ).hasClass( "ng-invalid" ))
                $( "#dhlEmailLabel" ).addClass("red");
            else
                $( "#dhlEmailLabel" ).removeClass("red");

            if($( "#dhlNip" ).hasClass( "ng-invalid" ))
                $( "#dhlNipLabel" ).addClass("red");
            else
                $( "#dhlNipLabel" ).removeClass("red");

            if($( "#dhlInvoice" ).hasClass( "ng-invalid" ))
                $( "#dhlInvoicedhlLabel" ).addClass("red");
            else
                $( "#dhlInvoicedhlLabel" ).removeClass("red");

            if($( "#dhlGrossAmount" ).hasClass( "ng-invalid" ))
                $( "#dhlGrossAmountLabel" ).addClass("red");
            else
                $( "#dhlGrossAmountLabel" ).removeClass("red");

            if($( "#dhlClientCode" ).hasClass( "ng-invalid" ))
                $( "#dhlClientCodeLabel" ).addClass("red");
            else
                $( "#dhlClientCodeLabel" ).removeClass("red");
        }

        function getUrl(translation) {
            return "Some test email just for testing controller";
            // return $translate.instant("registerEnd." + translation + "." + $rootScope.API_DOMAIN);
        }

        //Init controller
        vm.init();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .controller('RejectionController', RejectionController);

    RejectionController.$inject = ['$uibModalInstance'];

    function RejectionController($uibModalInstance) {
        var vm = this;

        vm.reason = null;

        vm.modal = {
            go: function(reason) {
                var tmp = {
                    'action': true,
                    'text': reason
                };
                $uibModalInstance.close(tmp);
            },
            cancel: function() {
                var tmp = {
                    'action': false,
                    'text': null
                };
                $uibModalInstance.close(tmp);
            }
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('pending-cases', {
            parent: 'application',
            url: '/pending-cases',
            data: {
                pageTitle: 'global.menu.pending-cases'
            },
            views: {
                'content@application': {
                    templateUrl: 'app/views/pending-cases/pending-cases.html',
                    controller: 'PendingCasesController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('pending-cases');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .controller('PendingCasesController', PendingCasesController);

    PendingCasesController.$inject = ['PendingCasesService', 'AlertService', '$uibModal', 'UtilService', 'DocumentsService', '$translate'];

    function PendingCasesController(PendingCasesService, AlertService, $uibModal, UtilService, DocumentsService, $translate) {
        var vm = this;

        //Declare variables
        vm.usersToBeUpdated = [];
        vm.documentsWithoutClientToBeUpdated = [];
        vm.documentsOfDebtorsToBeUpdated = [];
        vm.users = [];
        vm.documentsWithoutClient = [];
        vm.documentsOfDebtors = [];
        vm.checkAllUsersButton = true;
        vm.checkAllDocumentsWithoutClientButton = true;
        vm.checkAllDocumentsOfDebtorsButton = true;

        //Declare functions
        vm.init = init;
        vm.checkAllDocumentsWithoutClient = checkAllDocumentsWithoutClient;
        vm.checkAllDocumentsOfDebtors = checkAllDocumentsOfDebtors;
        vm.checkAllUsers = checkAllUsers;
        vm.denyDocumentsWithoutClient = denyDocumentsWithoutClient;
        vm.denyDocumentsOfDebtors = denyDocumentsOfDebtors;
        vm.acceptDocumentsWithoutClient = acceptDocumentsWithoutClient;
        vm.acceptDocumentsOfDebtors = acceptDocumentsOfDebtors;
        vm.denyUsers = denyUsers;
        vm.acceptUsers = acceptUsers;
        vm.usersCheckboxClick = usersCheckboxClick;
        vm.documentsWithoutClientCheckboxClick = documentsWithoutClientCheckboxClick;
        vm.documentsOfDebtorsCheckboxClick = documentsOfDebtorsCheckboxClick;
        vm.checkOrUncheckText = checkOrUncheckText;
        vm.getNameByClientNumber = getNameByClientNumber;
        vm.downloadPDF = downloadPDF;

        function checkOrUncheckText(condition) {
            return condition ? $translate.instant("pendingCases.pendingCases.selectAll") : $translate.instant("pendingCases.pendingCases.clearAll");
        }

        // add or remove user form usersToBeUpdated table
        function usersCheckboxClick(event, index) {
            event.stopPropagation();
            if (event.target.checked) {
                vm.usersToBeUpdated.push(index);
            } else {
                var i;
                for (i = 0; i < vm.usersToBeUpdated.length; ++i) {
                    if (vm.usersToBeUpdated[i] === index) {
                        vm.usersToBeUpdated.splice(i, 1);
                    }
                }
            }
        }

        // add or remove document form documentsWithoutClientToBeUpdated table
        function documentsWithoutClientCheckboxClick(event, index) {
            event.stopPropagation();
            if (event.target.checked) {
                vm.documentsWithoutClientToBeUpdated.push(vm.documentsWithoutClient[index].transactionId);
            } else {
                var i;
                for (i = 0; i < vm.documentsWithoutClientToBeUpdated.length; ++i) {
                    if (vm.documentsWithoutClientToBeUpdated[i] === vm.documentsWithoutClient[index].transactionId) {
                        vm.documentsWithoutClientToBeUpdated.splice(i, 1);
                    }
                }
            }
        }

        // add or remove document form documentsOfDebtorsToBeUpdated table
        function documentsOfDebtorsCheckboxClick(event, index) {
            event.stopPropagation();
            if (event.target.checked) {
                vm.documentsOfDebtorsToBeUpdated.push(vm.documentsOfDebtors[index].transactionId);
            } else {
                var i;
                for (i = 0; i < vm.documentsOfDebtorsToBeUpdated.length; ++i) {
                    if (vm.documentsOfDebtorsToBeUpdated[i] === vm.documentsOfDebtors[index].transactionId) {
                        vm.documentsOfDebtorsToBeUpdated.splice(i, 1);
                    }
                }
            }
        }

        function acceptUsers() {
            if (vm.usersToBeUpdated.length !== 0) { //if there is at least one selected user
                var usersList = [];

                var proceed = true;
                angular.forEach(vm.usersToBeUpdated, function(index) { //vm.users array indexes stored in vm.usersToBeUpdated
                    var user = vm.users[index];
                    if (!UtilService.isFilled(user.clientName) || !UtilService.isFilled(user.sapNumber)) {
                        AlertService.error($translate.instant("pendingCases.pendingCases.someRegistrationFailed"));
                        proceed = false; //do not proceed with accepting, client data input is missing
                    } else {
                        usersList.push({
                            'userId': user.userId,
                            'ipAddress': user.ipAddress,
                            'email': user.email,
                            'nip': user.nip,
                            'invoiceNumber': user.invoiceNumber,
                            'invoiceValue': user.invoiceValue,
                            'sapNumber': user.sapNumber + "", //convert to string
                            'clientName': user.clientName,
                            'payerNumber': user.payerNumber
                        });
                    }
                });

                if (proceed) {
                    PendingCasesService.usersAccepted(usersList)
                        .then(function(response) {
                            if (response.data.failed != null && Object.keys(response.data.failed).length > 0) {
                                var existingUsers = "";
                                var otherMsg = "";
                                for (var key in response.data.failed) {
                                    if (response.data.failed.hasOwnProperty(key)) {
                                        var message = response.data.failed[key].message;
                                        if (message == "pending.user.exist") {
                                            existingUsers += " " + response.data.failed[key].atrList[0];
                                        } else {
                                            otherMsg += "\n" + message;
                                        }
                                    }
                                }
                                var errors = "";
                                if (existingUsers !== "") {
                                    errors = $translate.instant("pendingCases.pendingCases.userExists") + existingUsers;
                                }
                                if (otherMsg !== "") {
                                    errors += otherMsg;
                                }

                                if (errors !== "") {
                                    AlertService.error(errors);
                                } else {
                                    AlertService.error($translate.instant("pendingCases.pendingCases.failedAcceptSomeUsers"));
                                }
                            } else {
                                AlertService.success($translate.instant("pendingCases.pendingCases.successAcceptMarkedUsers"));
                            }
                        })
                        .catch(function(response) {
                            AlertService.error($translate.instant("pendingCases.pendingCases.failedAcceptMarkedUsers"));
                        })
                        .finally(function(response) {
                            getUsers();
                        });
                }
            }
        }

        function denyUsers(size) {
            if (vm.usersToBeUpdated.length !== 0) { //if there is at least one selected user
                var modalInstance = $uibModal.open({
                    animation: true,
                    ariaLabelledBy: 'modal-title',
                    ariaDescribedBy: 'modal-body',
                    templateUrl: 'app/views/pending-cases/rejection-modal/rejection.modal.html',
                    controller: 'RejectionController',
                    controllerAs: 'vm',
                    size: size
                });

                modalInstance.result.then(function(go) {
                    if (go.action) {
                        var usersList = [];

                        angular.forEach(vm.usersToBeUpdated, function(index) { //vm.users array indexes stored in vm.usersToBeUpdated
                            usersList.push({
                                'userId': vm.users[index].userId,
                                'rejectReason': go.text
                            });
                        });

                        PendingCasesService.usersDenied(usersList)
                            .then(function(response) {
                                if (response.data.failed == null || Object.keys(response.data.failed).length === 0) {
                                    AlertService.success($translate.instant("pendingCases.pendingCases.successDeniedMarkedUsers"));
                                } else {
                                    AlertService.error($translate.instant("pendingCases.pendingCases.failedDenySomeUsers"));
                                }
                            })
                            .catch(function(response) {
                                AlertService.error($translate.instant("pendingCases.pendingCases.failedDenyMarkedUsers"));
                            })
                            .finally(function(response) {
                                getUsers();
                            });
                    }
                });
            }
        }

        function acceptDocumentsWithoutClient() {
            if(vm.documentsWithoutClientToBeUpdated.length !== 0) {
                PendingCasesService.documentsWithoutClientAccepted(vm.documentsWithoutClientToBeUpdated)
                    .then(function(response) {
                        if (response.data.failed != null && Object.keys(response.data.failed).length !== 0) {
                            var noClientDocs = "";
                            for (var key in response.data.failed) {
                                if (response.data.failed.hasOwnProperty(key)) {
                                    noClientDocs += " " + response.data.failed[key].message.split(" ").splice(-1);
                                } else {
                                    AlertService.error($translate.instant("pendingCases.pendingCases.failedAcceptMarkedInvoices"));
                                }
                            }
                            if (noClientDocs !== "") {
                                var message = $translate.instant("pendingCases.pendingCases.missingClients");
                                AlertService.error(message + noClientDocs);
                            }
                        } else {
                            AlertService.success($translate.instant("pendingCases.pendingCases.acceptedInvoices"));
                        }
                    })
                    .catch(function(response) {
                        AlertService.error($translate.instant("pendingCases.pendingCases.failedAcceptMarkedInvoices"));
                    })
                    .finally(function(response) {
                        getDocumentsWithoutClient();
                    });
            }
        }

        function denyDocumentsWithoutClient() {
            if(vm.documentsWithoutClientToBeUpdated.length !== 0) {
                PendingCasesService.documentsWithoutClientDenied(vm.documentsWithoutClientToBeUpdated)
                    .then(function(response) {
                        if (response.data.failed == null || Object.keys(response.data.failed).length === 0) {
                            AlertService.success($translate.instant("pendingCases.pendingCases.successDenyMarkedInvoices"));
                        } else {
                            AlertService.error($translate.instant("pendingCases.pendingCases.failedDenySomeInvoices"));
                        }
                    })
                    .catch(function(response) {
                        AlertService.error($translate.instant("pendingCases.pendingCases.failedDenyMarkedInvoices"));
                    })
                    .finally(function(response) {
                        getDocumentsWithoutClient();
                    });
            }
        }

        function acceptDocumentsOfDebtors() {
            if(vm.documentsOfDebtorsToBeUpdated.length !== 0) {
                PendingCasesService.documentsOfDebtorsAccepted(vm.documentsOfDebtorsToBeUpdated)
                    .then(function(response) {
                        if (response.data.failed != null && Object.keys(response.data.failed).length !== 0) {
                            AlertService.error($translate.instant("pendingCases.pendingCases.failedAcceptMarkedInvoices"));
                        } else {
                            AlertService.success($translate.instant("pendingCases.pendingCases.acceptedInvoices"));
                        }
                    })
                    .catch(function(response) {
                        AlertService.error($translate.instant("pendingCases.pendingCases.failedAcceptMarkedInvoices"));
                    })
                    .finally(function(response) {
                        getDocumentsOfDebtors();
                    });
            }
        }

        function denyDocumentsOfDebtors() {
            if(vm.documentsOfDebtorsToBeUpdated.length !== 0) {
                PendingCasesService.documentsOfDebtorsDenied(vm.documentsOfDebtorsToBeUpdated)
                    .then(function(response) {
                        if (response.data.failed == null || Object.keys(response.data.failed).length === 0) {
                            AlertService.success($translate.instant("pendingCases.pendingCases.successDenyMarkedInvoices"));
                        } else {
                            AlertService.error($translate.instant("pendingCases.pendingCases.failedDenySomeInvoices"));
                        }
                    })
                    .catch(function(response) {
                        AlertService.error($translate.instant("pendingCases.pendingCases.failedDenyMarkedInvoices"));
                    })
                    .finally(function(response) {
                        getDocumentsOfDebtors();
                    });
            }
        }

        function checkAllUsers() {
            vm.usersToBeUpdated = []; //reset selection
            if(vm.checkAllUsersButton) { //select all
                setUserCheckboxes(true); 
                fillSelectedUsersArray();
            } else {
                setUserCheckboxes(false);
            }
            vm.checkAllUsersButton = !vm.checkAllUsersButton;
        }

        function setUserCheckboxes(checked){
            var i;
            for (i = 0; i < vm.users.length; ++i) {
                vm.users[i].selected = checked;
            }
        }
        
        function fillSelectedUsersArray(){
            var i;
            for (i = 0; i < vm.users.length; ++i) {
                vm.usersToBeUpdated.push(i);
            }
        }

        function checkAllDocumentsWithoutClient() {
            vm.documentsWithoutClientToBeUpdated = []; //reset selection
            if(vm.checkAllDocumentsWithoutClientButton) {
                selectAllDocs(vm.documentsWithoutClient, vm.documentsWithoutClientToBeUpdated);
            } else {
                clearAllDocs(vm.documentsWithoutClient);
            }
            vm.checkAllDocumentsWithoutClientButton = !vm.checkAllDocumentsWithoutClientButton;
        }

        function checkAllDocumentsOfDebtors() {
            vm.documentsOfDebtorsToBeUpdated = []; //reset selection
            if(vm.checkAllDocumentsOfDebtorsButton) {
                selectAllDocs(vm.documentsOfDebtors, vm.documentsOfDebtorsToBeUpdated);
            } else {
                clearAllDocs(vm.documentsOfDebtors);
            }
            vm.checkAllDocumentsOfDebtorsButton = !vm.checkAllDocumentsOfDebtorsButton;
        }

        function selectAllDocs(sourceArray, selectedArray){
            angular.forEach(sourceArray, function(item) {
                item.selected = true;
                selectedArray.push(item.transactionId);
            });
        }

        function clearAllDocs(sourceArray){
            angular.forEach(sourceArray, function(item) {
                item.selected = false;
            });
        }

        function getNameByClientNumber(event, index, clientNumber) {
            if (clientNumber != null && (clientNumber + "").length === 8) {
                PendingCasesService.getNameByClientNumber(clientNumber + "")
                    .then(function(response) {
                        if(response.data != null) {
                            vm.users[index].clientName = response.data.name;
                        }
                    })
                    .catch(function(response) {
                        AlertService.error($translate.instant("pendingCases.pendingCases.clientNotFound") + clientNumber);
                    });
            }
        }

        function getDocumentsWithoutClient() {
            PendingCasesService.getDocumentsWithoutClient()
                .then(function(response) {
                    vm.documentsWithoutClient = response.data;
                })
                .catch(function(response) {
                    AlertService.error($translate.instant("pendingCases.pendingCases.getDocumentsFail"));
                }).finally(function(response) {
                    vm.documentsWithoutClientToBeUpdated = []; //reset selection
                    vm.checkAllDocumentsWithoutClientButton = true;
                });
        }

        function getDocumentsOfDebtors() {
            PendingCasesService.getDocumentsOfDebtors()
                .then(function(response) {
                    vm.documentsOfDebtors = response.data;
                })
                .catch(function(response) {
                    AlertService.error($translate.instant("pendingCases.pendingCases.getDocumentsOfDebtorsFail"));
                }).finally(function(response) {
                    vm.documentsOfDebtorsToBeUpdated = []; //reset selection
                    vm.checkAllDocumentsOfDebtorsButton = true;
                });
        }

        function getUsers() {
            PendingCasesService.getUsers()
                .then(function(response) {
                    angular.forEach(response.data, function(item) {
                        item.sapNumber = parseInt(item.sapNumber);
                    });
                    vm.users = response.data;
                })
                .catch(function(response) {
                    AlertService.error($translate.instant("pendingCases.pendingCases.getUsersFail"));
                }).finally(function(response) {
                    vm.usersToBeUpdated = []; //reset selection
                    vm.checkAllUsersButton = true;
                });
        }

        function downloadPDF(ediDocId) {
            //            PendingCasesService.getDocument(ediDocId)
            //                .then(function(response) {
            //                    var date = new Date();
            //                    FileSaver.saveAs(new Blob([response.data], { type: "application/pdf" }),
            //                        "Document_" + (date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate()) + ".pdf");
            //                    if (Object.keys(response.data.failed).length != 0) {
            //                        AlertService.error('Nie udało się pobrać dokumentu.');
            //                    }
            //                    vm.getCorrections();
            //                })
            //                .catch(function(response) {
            //                    AlertService.error('Nie udało się pobrać dokumentu.');
            //                    vm.getCorrections();
            //                })
            //                .finally(function(response) {
            //                    //vm.getCorrections();
            //                });

            var url = DocumentsService.getPdfURL(ediDocId, null, null);
            window.open(url, '_blank');
        }

        function init() {
            getDocumentsWithoutClient();
            getDocumentsOfDebtors();
            getUsers();
        }

        //Init controller
        vm.init();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('pdfView', {
            parent: 'application',
            url: '/documents/:uuid/view',
            data: {
                pageTitle: 'global.menu.pdfView'

            },
            views: {
                'content@application': {
                    templateUrl: 'app/views/pdfView/pdfView.html',
                    controller: 'PdfViewController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('pdfView');
                    return $translate.refresh();
                }],
                uuid: ['$stateParams', function($stateParams){
                    return $stateParams.uuid;
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .controller('PdfViewController', PdfViewController);

    PdfViewController.$inject = ['$scope', '$state', '$stateParams', 'DocumentsService', 'UsersService', 'Principal', 'AlertService', "$sce", "PdfViewService", 'Blob', '$compile', 'tmhDynamicLocale', '$translate', '$http'];

    function PdfViewController($scope, $state, $stateParams, DocumentsService, UsersService, Principal, AlertService, $sce, PdfViewService, Blob, $compile, tmhDynamicLocale, $translate, $http) {
        var vm = this;
        vm.translate = $translate.instant;
        vm.userOnePdfPage = null;
        vm.documentNumber = null;
        vm.init = init;
        vm.getDownloadFullPdfURL = getDownloadFullPdfURL;
        vm.getDownloadXlsxURL = getDownloadXlsxURL;
        vm.getDownloadCsvURL = getDownloadCsvURL;
        vm.getDownloadXmlURL = getDownloadXmlURL;
        vm.goToDisputeForm = goToDisputeForm;
        vm.downloadError = null;
        vm.pdfUrl = DocumentsService.getPdfURL($stateParams.uuid, false, false);
        vm.pdfViewer = './external/pdf-view/web/viewer.html?file=' + vm.pdfUrl + '#locale=' + tmhDynamicLocale.get();
        vm.isExcelAvailable = false;
        vm.isCSVAvailable = false;
        vm.isXMLAvailable = false;

        $('[data-toggle="popover"]').popover({
            container: 'body',
            title: vm.translate('pdfView.submitDispute.title'),
            html: true,
            sanitize: false,
            content: function () {
                return '<div id="popover-content"><button class="close" aria-label="Close"><span aria-hidden="true">&times;</span></button><iframe iframe-set-dimensions-onload name="disputeForm" src="./app/views/pdfView/disputeForm/disputeForm.html" style="border:none; height:100%; width:100%" onload="adjustPopover(&quot;popover&quot;, this);"></iframe></div>';
            }
        });
        // Remove any existing click event handlers on the element with data-toggle="popover"
        $('[data-toggle="popover"]').off('click');
		// Attach a click event handler to manually trigger the popover
		$('[data-toggle="popover"]').on('click', function (e) {
			e.stopPropagation(); // Prevent double click issue
			$(this).popover('toggle');
		});
        $(document).on("click", ".popover .close" , function(){
            $(this).parents(".popover").popover('hide');
        });

        function init() {
            if ($stateParams.uuid == null) {
                $state.go('404');
            }


            if (Principal.isAuthenticated()) {
                PdfViewService.getInvoiceStylesheet($stateParams.uuid).then(function(response) {
                    vm.userOnePdfPage = response.data.stylesheet;
                    vm.documentNumber = response.data.number;
                }).catch(function(response) {
                    $state.go('404');
                });
            }

            //Check whether Excel file is ready for download
            DocumentsService.isAvailable($stateParams.uuid, "XLSX")
            .then(function(response){
                vm.isExcelAvailable = response.data;
            });

            //TODO implement backend
            DocumentsService.isAvailable($stateParams.uuid, "CSV")
            .then(function(response){
                vm.isCSVAvailable = response.data;
            });

            //TODO TJ
            DocumentsService.isAvailable($stateParams.uuid, "XML")
            .then(function(response){
                vm.isXMLAvailable = response.data;
            });
        }

        function getDownloadFullPdfURL(forceFullPDF) {
            return DocumentsService.getPdfURL($stateParams.uuid, true, forceFullPDF);
        }

        function getDownloadXlsxURL() {
            return DocumentsService.getInvoiceXlsxURL($stateParams.uuid);
        }

        function getDownloadCsvURL() {
            return DocumentsService.getInvoiceCsvURL($stateParams.uuid);
        }

        function getDownloadXmlURL() {
            return DocumentsService.getInvoiceXmlURL($stateParams.uuid);
        }

        function goToDisputeForm() {
            var url = $state.href('disputeForm', { uuid: $stateParams.uuid });
            window.open(url, 'disputeForm');
        }

        //Init controller
        vm.init();

        /*
            The piece of code below shows AngularJS Loading Spinner until PDF document is not loaded. It's a workaround, beacause IFrame does not allow to capture its internal events outside.
            In order to show the spinner, we have to have at least one pending HTTP request - that's why empty object is inserted into the $http.pendingRequests array.
            When PDF document is loaded - the faked request is removed.
        */
        var loadingRequestPlaceholder = { notice: "Do not remove this object. It resides here to show AngularJS Loading Spinner. It will be removed automatically. Author: DD" };
        $http.pendingRequests.push(loadingRequestPlaceholder);

        var PDFWrapper = document.getElementById('PDFWrapper');
        PDFWrapper.onload = function() {
            $(this.contentDocument.getElementById('viewer')).one('DOMSubtreeModified', removeRequest);
        };
        $scope.$on("$destroy", function() {
            removeRequest();
        });

        function removeRequest(event) {
            var index = $http.pendingRequests.indexOf(loadingRequestPlaceholder);
            if (index !== -1) $http.pendingRequests.splice(index, 1);
            if (event)
                $scope.$apply();
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('disputeForm', {
            parent: 'pdfView',
            url: '/disputeForm',
            views: {
                'content@application': {
                    templateUrl: 'app/views/pdfView/disputeForm/disputeForm.html',
                    controller: 'DisputeFormController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('pdfView');
                    return $translate.refresh();
                }],
                uuid: ['$stateParams', function($stateParams) {
                    return $stateParams.uuid;
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .controller('DisputeFormController', DisputeFormController);

    DisputeFormController.$inject = [ '$scope', '$state', '$stateParams', '$location', 'Principal', 'DocumentsService', '$translate'];

    function DisputeFormController($scope, $state, $stateParams, $location, Principal, DocumentsService, $translate) {
        var vm = this;
        vm.translate = $translate.instant;

        // Declare variables
        vm.data = {
            name: null,
            email: null,
            retypeEmail: null,
            accountNumber: null,
            invoiceNumber: null,
            commentEntries: []
        }
        vm.originalEmail = null;
        vm.emailChanged = false;
        vm.disputeFormSuccessText = null;
        vm.disputeFormErrorText = null;

        // Declare functions
        vm.init = init;
        vm.downloadInitialFormData = downloadInitialFormData;
        vm.setInitialFormData = setInitialFormData;
        vm.submit = submit;
        vm.toggleRetypeEmailField = toggleRetypeEmailField;
        vm.addCommentField = addCommentField;
        vm.addFileText = addFileText;

        // Init functions
        function init() {
            if (!Principal.isAuthenticated()) {
                $state.go('accessdenied').then(function() {
                    $state.go('login');
                });
            }
            if ($stateParams.uuid == null) {
                $state.go('documents');
            }
            downloadInitialFormData();
            // Initialise first comment entry to be visible from the get-go
            vm.data.commentEntries = [{shipmentNumber: "", comment: "", attachment: null}];
        }

        function downloadInitialFormData() {
            DocumentsService.getDisputeFormData($stateParams.uuid)
                .then(function(response) {
                    vm.disputeFormErrorText = null;
                    setInitialFormData(response.data);
                    vm.originalEmail = vm.data.email;
                })
                .catch(function(response) {
                    vm.disputeFormSuccessText = null;
                    vm.disputeFormErrorText = vm.translate('pdfView.submitDispute.downloadError');
                });
        }

        function setInitialFormData(data) {
            vm.data.name = data.name;
            vm.data.email = data.email;
            vm.data.accountNumber = data.accountNumber;
            vm.data.invoiceNumber = data.invoiceNumber;
        }

        function submit() {
            DocumentsService.submitDispute(vm.data)
                .then(function(response) {
                    vm.disputeFormSuccessText = vm.translate('pdfView.submitDispute.success');
                    vm.disputeFormErrorText = null;
                    document.getElementById("button").disabled = true;
                }).catch(function(response) {
                    vm.disputeFormSuccessText = null;
                    vm.disputeFormErrorText = vm.translate('pdfView.submitDispute.error');
                });
        }

        function toggleRetypeEmailField() {
            vm.emailChanged = vm.data.email !== vm.originalEmail ? true : false;
        }

        function addCommentField() {
            vm.data.commentEntries.push({
                shipmentNumber: "",
                comment: "",
                attachment: null
            });
        }

        function addFileText($event) {
            var inputFile = $event.target
            var label = inputFile.previousElementSibling
            inputFile.addEventListener("change", function(){
                if (inputFile.files.length > 0) {
                    label.textContent = inputFile.files[0].name
                }else{
                    label.textContent = "No file"
                }
            });
        }

        // Init controller
        vm.init();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('password-reset-finish', {
            parent: 'application',
            url: '/user/:uuid/set-password/:link',
            data: {
                pageTitle: 'global.menu.settings'
            },
            views: {
                'content@application': {
                    templateUrl: 'app/views/password-reset-finish/password-reset-finish.html',
                    controller: 'PasswordResetFinishController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('password-reset-finish');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }],
                uuid: ['$stateParams', function($stateParams) {
                    return $stateParams.uuid;
                }],
                link: ['$stateParams', function($stateParams) {
                    return $stateParams.link;
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .controller('PasswordResetFinishController', PasswordResetFinishController);

    PasswordResetFinishController.$inject = ['$sce', '$rootScope', '$state', 'Auth', 'UsersService', '$stateParams', '$translate'];

    function PasswordResetFinishController($sce, $rootScope, $state, Auth, UsersService, $stateParams, $translate) {
        var vm = this;
        vm.data = {
            password: null,
            repassword: null
        };
        vm.passwordChangeErrorText = null;
        vm.passwordChangeSuccessText = null;
        vm.safePassword = $sce.trustAsHtml($translate.instant('password-reset-finish.toolTips.safePassword'));

        vm.changeType = 1;

        //Declare functions
        vm.init = init;
        vm.resetPassword = resetPassword;
        vm.checkPasswordResetLink = checkPasswordResetLink;
        vm.translate = $translate.instant;
        vm.passwordTooltip = passwordTooltip;
        function passwordTooltip() {
                    return $sce.trustAsHtml($translate.instant('password-reset-finish.toolTips.safePassword'));
                };
        function checkPasswordResetLink() {
            UsersService.checkPasswordResetLink($stateParams.uuid, $stateParams.link).then(function(response) {
                vm.data.acceptReset = true;

                vm.changeType = response.data.message;

            }).catch(function(response) {
                $state.go('404');
            });
        }

        function resetPassword() {
            var pass = {
                password: vm.data.password,
                repassword: vm.data.repassword
            };
            UsersService.resetOwnPassword($stateParams.uuid, $stateParams.link, pass).then(function(response) {
                vm.passwordChangeErrorText = null;
                vm.passwordChangeSuccessText = $translate.instant('password-reset-finish.messages.passwordChangeSuccess');
            }).catch(function(response) {
                vm.passwordChangeSuccessText = null;
                switch (response.data.message) {
                    case 1:
                        vm.passwordChangeErrorText = $translate.instant('password-reset-finish.messages.noFieldsEmpty');
                        break;
                    case 2:
                        vm.passwordChangeErrorText = $translate.instant('global.messages.error.dontmatch');
                        break;
                    case 3:
                        vm.passwordChangeErrorText = $translate.instant('global.messages.validate.newpassword.minlength');
                        break;
                    case 4:
                        vm.passwordChangeErrorText = $translate.instant('password-reset-finish.messages.passwordValidationDescription');
                        break;
                        /*case 5:
                            vm.data.passwordResetErrort = "Hasło musi zawierać co najmninej 3 rodzaje znaków z następujących: małe litery,"+
                            " wielkie litery, cyfry, znaki specjalne";
                            break;*/
                        /*case 6:
                            vm.data.passwordResetError = "Hasło nie może powtarzać ostatnich 12 haseł.";
                            break;*/
                    case 7:
                        vm.passwordChangeErrorText = $translate.instant('password-reset-finish.messages.passwordNoRepeat');
                        break;
                    default:
                        vm.passwordChangeErrorText = $translate.instant('global.error.occurred');
                }
            });
        }

        //Init functions
        function init() {
            vm.checkPasswordResetLink();
        }

        vm.init();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('password-reset', {
            parent: 'site',
            url: '/password-reset',
            data: {
                pageTitle: 'password-reset.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/views/password-reset/password-reset.html',
                    controller: 'PasswordResetController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('password-reset');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .controller('PasswordResetController', PasswordResetController);

    PasswordResetController.$inject = ['$rootScope', '$state', '$translate', 'Auth', 'UsersService'];

    function PasswordResetController($rootScope, $state, $translate, Auth, UsersService) {
        var vm = this;
        vm.data = {
            email: null,
            passwordResetError: null,
            passwordResetSuccess: null
        };

        //Declare functions
        vm.init = init;
        vm.resetPassword = resetPassword;
        vm.getPasswordResetSuccess = getPasswordResetSuccess;

        function resetPassword(){
            UsersService.requestResetOwnPassword(vm.data.email + '_BENELUX').then(function(response) {
                vm.data.passwordResetError = null;
                vm.data.passwordResetSuccess = $translate.instant('password-reset.after-reset.' + $rootScope.API_DOMAIN);
            }).catch(function(response){
                vm.data.passwordResetError = $translate.instant('password-reset.error');
                vm.data.passwordResetSuccess = null;
            });
        }

        function getPasswordResetSuccess() {
            return "password-reset.after-reset." + $rootScope.API_DOMAIN;
        }

        //Init functions
        function init() {
        }

        vm.init();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('password-expire', {
            parent: 'application',
            url: '/password-expire?days',
            data: {
                pageTitle: 'global.menu.password-expire'
            },
            views: {
                'content@application': {
                    templateUrl: 'app/views/password-expire/password-expire.html',
                    controller: 'PasswordExpireController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                    $translatePartialLoader.addPart('password-expire');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .controller('PasswordExpireController', PasswordExpireController);

    PasswordExpireController.$inject = ['$scope', 'Principal', '$state', '$stateParams'];

    function PasswordExpireController ($scope, Principal, $state, $stateParams) {
        var vm = this;
        vm.passwordExpireDays = $stateParams.days;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .controller('PasswordExpiredController', PasswordExpiredController);

    PasswordExpiredController.$inject = ['$uibModalInstance', 'param'];

    function PasswordExpiredController($uibModalInstance, param) {
        var vm = this;

        vm.data = {
            days: param
        };

        vm.modal = {
            ok: function() {
                $uibModalInstance.close();
            }
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('mfa', {
            parent: 'application',
            url: '/mfa',
            data: {
                pageTitle: 'mfa.title'
            },
            views: {
                'content@application': {
                    templateUrl: 'app/views/login/mfa/mfa.html',
                    controller: 'MfaController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('mfa');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .controller('MfaController', MfaController);

    MfaController.$inject = ['$rootScope', '$scope', '$state', '$timeout', 'AlertService', '$translate', '$http', 'Principal', '$uibModal', 'UsersService'];

    function MfaController($rootScope, $scope, $state, $timeout, AlertService, $translate, $http, Principal, $uibModal, UsersService) {
        var vm = this;
        vm.token = '';
        vm.mfa = mfa;
        vm.resendCode = resendCode;
        vm.isResendDisabled = false;
        vm.resendCooldown = 60;
        vm.timeoutValue = 600000

        var resendCooldownTimer;

        // Timeout for 10 minutes
        var timeoutPromise = $timeout(onTimeout, vm.timeoutValue);

        $scope.$watch('vm.token', function(newVal, oldVal) {
            if (newVal !== oldVal) {
                $timeout.cancel(timeoutPromise);
                timeoutPromise = $timeout(onTimeout, vm.timeoutValue);
            }
        });

        function onTimeout() {
            AlertService.error($translate.instant('mfa.timeout'));
            $state.go('login');
        }

        function mfa(event) {
            event.preventDefault();
            $timeout.cancel(timeoutPromise);

            $http.post($rootScope.API_URL + 'api/verify-2FA', { code: vm.token })
                .then(function(response) {
                    if (response.status === 200) {
                        Principal.identity(true).then(function() {
                                $rootScope.$broadcast('authenticationSuccess');
                                AlertService.success($translate.instant('mfa.success'));
                                $state.go('documents');
                            });
                    }
                    else {
                        AlertService.error($translate.instant('mfa.invalid'));
                    }
                }).catch(function(error) {
                if (error.status === 429) {
                    AlertService.error($translate.instant('login.attempts', { mfaTimeCooldown: error.data.time }));
                }
                else {
                    AlertService.error($translate.instant('mfa.invalid'));
                }
                });
        }

        function resendCode() {
            if (vm.isResendDisabled) return;

            $http.post($rootScope.API_URL + 'api/resend-2FA-code')
                .then(function(response) {
                    if (response.status === 200) {
                        AlertService.success($translate.instant('mfa.resendSuccess'));
                        startResendCooldown();
                    } else {
                        AlertService.error($translate.instant('mfa.resendError'));
                    }
                }).catch(function() {
                    AlertService.error($translate.instant('mfa.resendError'));
                });
        }

        function startResendCooldown() {
            vm.isResendDisabled = true;
            vm.resendCooldown = 60;

            resendCooldownTimer = $timeout(function countdown() {
                vm.resendCooldown--;
                if (vm.resendCooldown > 0) {
                    resendCooldownTimer = $timeout(countdown, 1000);
                } else {
                    vm.isResendDisabled = false;
                }
            }, 1000);
        }

        $scope.$on('$destroy', function() {
            $timeout.cancel(timeoutPromise);
            $timeout.cancel(resendCooldownTimer);
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('login', {
            parent: 'site',
            url: '/',
            data: {
                authorities: [],
                pageTitle: 'login.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/views/login/login.html',
                    controller: 'LoginController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('login');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .controller('LoginController', LoginController);

    LoginController.$inject = ['$rootScope', '$state', 'Auth', '$uibModal', '$translate', 'UsersService', 'Principal', 'AlertService'];

    function LoginController($rootScope, $state, Auth, $uibModal, $translate, UsersService, Principal, AlertService) {
        var vm = this;

        vm.login = login;
        vm.logUser = logUser;
        vm.loginreq = loginreq;
        vm.pwdreq = pwdreq;

		// Currently not used
		// AlertService.success(function(){
		//     return $translate.instant('login.migration')
		// });
        function loginreq() {
            return $translate.instant('login.loginreq');
        }

        function pwdreq() {
            return $translate.instant('login.pwdreq');
        }

        function login(event) {
            event.preventDefault();
            Auth.login({
                username: vm.username + '_BENELUX',
                password: vm.password
            }).then(function(response) {
                vm.authenticationError = false;
                 if (response.status === 206) {
                    $state.go('mfa');
                 }
                 else if (response.data.show == true) {
                    $state.go('password-expire', { days: response.data.days });
                } else {
                    if (angular.isDefined(Auth.getPreviousState())) {
                        var previousState = Auth.getPreviousState();
                        Auth.resetPreviousState();
                        $state.go(previousState.name, previousState.params);
                    } else {
                        $rootScope.$broadcast('authenticationSuccess');
                        $state.go('documents');
                    }
                }
            }).catch(function(response) {
                vm.authenticationError = true;
                switch (response.status) {
                    case 401:
                        Auth.isBlocked(vm.username)
                            .then(function(response) {
                                if (response.data.parameter1) {
                                    //account blocked due to too many failed logins
                                    AlertService.error($translate.instant('login.10times'));
                                /*
                                Alert below is revealing username existence - showed even when wrong password was given
                                Temporarly disabled until login mechanism will be refactored
                                */
                                // } else if (response.data.parameter2) {
                                    //password has expired
                                    // AlertService.error($translate.instant('login.expired'));
                                } else {
                                    //user does not exist
                                    AlertService.error($translate.instant('login.incorrect'));
                                }
                            }).catch(function(response) {
                                AlertService.error($translate.instant('login.incorrect'));
                            });
                        break;
                    case 403:
                        AlertService.error($translate.instant('login.auth'));
                        break;
                    case 404:
                        AlertService.error($translate.instant('login.notfound'));
                        break;
                    case 408:
                        AlertService.error($translate.instant('login.timeout'));
                        break;
                    case 429:
                        AlertService.error($translate.instant('login.attempts', { mfaTimeCooldown: response.data.time }));
                        break;
                    case 500:
                        AlertService.error($translate.instant('login.internal'));
                        break;
                    default:
                        AlertService.error($translate.instant('login.failure'));
                }
            });
        }

        function logUser() {
            $rootScope.$broadcast('authenticationSuccess');
            if (angular.isDefined(Auth.getPreviousState())) {
                var previousState = Auth.getPreviousState();
                Auth.resetPreviousState();
                $state.go(previousState.name, previousState.params);
            } else {
                $state.go('documents');
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('help', {
            parent: 'site',
            url: '/help',
            data: {
                pageTitle: 'global.menu.help'
            },
            views: {
                'content@': {
                    templateUrl: 'app/views/help/help.html',
                    controller: 'HelpController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('help');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .controller('HelpController', HelpController);

    HelpController.$inject = ['$scope', '$rootScope', '$state', '$stateParams', '$translate'];

    function HelpController($scope, $rootScope, $state, $stateParams, $translate) {
        var vm = this;

        //Declare variables
        vm.filter = null;
        vm.data = null;
        vm.language = function() {
            return $translate.use();
        };

        //Declare functions
        vm.init = init;
        vm.goToId = goToId;
        vm.goToTop = goToTop;
        vm.getUrl = getUrl;

        //Init functions
        function init() {}

        function goToId(event) {
            event.preventDefault();
            // 150 below is fixed header's size
            $('html, body').animate({
                scrollTop: Math.min($(document).height() - $('body').offset().top - window.innerHeight, $(event.target.attributes.href ?
                    event.target.attributes.href.value : event.target.parentElement.attributes.href.value).offset().top - 150)
            }, 1000, 'swing');
        }

        function goToTop() {
            $('html, body').animate({
                scrollTop: Math.min($(document).height() - $('body').offset().top - window.innerHeight, $('#topid').offset().top - 150)
            }, 1000, 'swing');
        }

        function getUrl(translation) {
            return $translate.instant("help." + translation + "." + $rootScope.API_DOMAIN);
        }

        //Init controller
        vm.init();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('error', {
                parent: 'application',
                url: '/error',
                views: {
                    'content@application': {
                        templateUrl: 'app/views/error/error.html'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            })
            .state('401', {
                parent: 'error',
                url: '/401',
                data: {
                    authorities: [],
                    pageTitle: 'Nie zalogowano'
                },
                views: {
                    'error@error': {
                        templateUrl: 'app/views/error/401.html'
                    }
                }
            })
            .state('403', {
                parent: 'error',
                url: '/403',
                data: {
                    authorities: [],
                    pageTitle: 'Brak dostępu'
                },
                views: {
                    'error@error': {
                        templateUrl: 'app/views/error/403.html'
                    }
                }
            })
            .state('404', {
                parent: 'error',
                url: '/404',
                data: {
                    authorities: [],
                    pageTitle: 'Podana strona nie istnieje'
                },
                views: {
                    'error@error': {
                        templateUrl: 'app/views/error/404.html'
                    }
                }
            });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .controller('resendController', resendController);

    resendController.$inject = ['$uibModalInstance'];

    function resendController($uibModalInstance) {
        var vm = this;
        vm.resendSelect = 'same';
        vm.data = {
            email: null
        };
        vm.emailValidated = false;

        vm.validateEmail = validateEmail;

        vm.modal = {
            send: function() {
                vm.result = vm.resendSelect;
                $uibModalInstance.close(vm.data);
            },
            cancel: function() {
                $uibModalInstance.dismiss('cancel');
            }
        };
        function validateEmail(value){
            vm.emailValidated = true;
            var emailArray = value.split(";");
            emailArray.forEach(function(email) {
                var re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
                if(!re.test(email)){
                    vm.emailValidated = false;
                }
            });

        }
    }
})();
;
(function () {
    "use strict";

    angular
        .module("edistradadhluiApp")
        .controller("downloadController", downloadController);

    downloadController.$inject = [
        "$uibModalInstance",
        "ediDocIds",
        "language",
        "DocumentsService",
    ];

    function downloadController(
        $uibModalInstance,
        ediDocIds,
        language,
        DocumentsService
    ) {
        var vm = this;

        vm.data = {
            downloadPDF: true,
            downloadCSV: false,
            downloadCSVConcatenate: false,
            downloadExcel: false,
            downloadExcelConcatenate: false,
            downloadXML: false,
            customCSV: false,
            ediDocIds: ediDocIds,
            availableColumns: [],
            selectedColumns: [],
            savedConfigs: [],
            selectedConfig: "base_template",
            saveName: "",
        };

        vm.getDownloadURLs = getDownloadURLs;
        vm.checkboxClick = checkboxClick;

        vm.modal = {
            download: function () {
                $uibModalInstance.close();
            },
            cancel: function () {
                $uibModalInstance.dismiss("cancel");
            },
        };

        function loadCsvSelectedTemplate(template) {
            DocumentsService.getCsvTemplate(template)
                .then(function (response) {
                    if (Array.isArray(response.data.data)) {
                        vm.data.selectedColumns = response.data.data;
                    } else {
                        console.error(
                            "getCsvTemplate Unexpected response format",
                            response.data.data
                        );
                    }
                })
                .catch(function (error) {
                    console.error("Error fetching getCsvBaseTemplate", error);
                });
        }

        function loadCsvBaseTemplate() {
            DocumentsService.getCsvTemplate("base_template")
                .then(function (response) {
                    if (Array.isArray(response.data.data)) {
                        vm.data.availableColumns = response.data.data;
                    } else {
                        console.error(
                            "getCsvTemplate Unexpected response format",
                            response.data.data
                        );
                    }
                })
                .catch(function (error) {
                    console.error("Error fetching getCsvBaseTemplate", error);
                });
        }

        function loadCsvAllTemplates() {
            DocumentsService.getCsvAllTemplates()
                .then(function (response) {
                    if (Array.isArray(response.data.data)) {
                        vm.data.savedConfigs = response.data.data;
                    } else {
                        console.error(
                            "getCsvAllTemplates Unexpected response format",
                            response.data.data
                        );
                    }
                })
                .catch(function (error) {
                    console.error("Error fetching getCsvAllTemplates", error);
                });
        }

        function checkboxClick(fivarype) {
            if (fivarype === "XML") {
                resetSelections();
                vm.data.downloadXML = true;
            } else if (fivarype === "ExcelConcatenate") {
                resetSelections();
                vm.data.downloadExcelConcatenate = true;
            } else if (fivarype === "EXCEL") {
                resetSelections();
                vm.data.downloadExcel = true;
            } else if (fivarype === "CSVConcatenate") {
                resetSelections();
                vm.data.downloadCSVConcatenate = true;
            } else if (fivarype === "CSV") {
                resetSelections();
                vm.data.downloadCSV = true;
            } else if (fivarype === "PDF") {
                resetSelections();
                vm.data.downloadPDF = true;
            } else if (fivarype === "CustomCSV") {
                resetSelections();
                loadCsvBaseTemplate();
                loadCsvAllTemplates();
                loadCsvSelectedTemplate(vm.data.selectedConfig);
                vm.data.customCSV = true;
            }
        }

        function resetSelections() {
            vm.data.downloadPDF = false;
            vm.data.downloadCSV = false;
            vm.data.downloadCSVConcatenate = false;
            vm.data.downloadExcel = false;
            vm.data.downloadExcelConcatenate = false;
            vm.data.downloadXML = false;
            vm.data.customCSV = false;
        }

        function getDownloadURLs(
            ediDocIds,
            downloadPDF,
            downloadCSV,
            downloadCSVConcatenate,
            downloadExcel,
            downloadExcelConcatenate,
            downloadXML,
            customCSV
        ) {
            if (downloadPDF) {
                return getAsPdf(ediDocIds);
            } else if (downloadCSV) {
                return getCsvs(ediDocIds);
            } else if (downloadCSVConcatenate) {
                return getCsvsConcatenate(ediDocIds);
            } else if (downloadExcel) {
                return getExcel(ediDocIds);
            } else if (downloadExcelConcatenate) {
                return getExcelConcatenate(ediDocIds);
            } else if (downloadXML) {
                return getXML(ediDocIds);
            }else if(vm.data.customCSV && vm.data.concatenated){
                return getCustomCsvContacenateURL(ediDocIds, vm.data.selectedConfig)
            }
             else if (vm.data.customCSV) {
                return getCustomCsvURL(ediDocIds, vm.data.selectedConfig);
            }
        }

        function getAsPdf(ediDocIds) {
            return ediDocIds.length > 1
                ? DocumentsService.getPdfsURL(ediDocIds, language)
                : DocumentsService.getPdfURL(ediDocIds[0], true, null);
        }

        function getCsvs(ediDocIds) {
            return ediDocIds.length > 1
                ? DocumentsService.getCsvsURL(ediDocIds, language)
                : DocumentsService.getInvoiceCsvURL(ediDocIds[0]);
        }

        function getCsvsConcatenate(ediDocIds) {
            return ediDocIds.length > 1
                ? DocumentsService.getCsvsConcatenateURL(ediDocIds, language)
                : null;
        }

        function getExcel(ediDocIds) {
            return ediDocIds.length > 1
                ? DocumentsService.getExcelURL(ediDocIds, language)
                : DocumentsService.getInvoiceXlsxURL(ediDocIds[0]);
        }

        function getExcelConcatenate(ediDocIds) {
            return ediDocIds.length > 1
                ? DocumentsService.getExcelConcatenateURL(ediDocIds, language)
                : null;
        }

        function getXML(ediDocIds) {
            return ediDocIds.length > 1
                ? DocumentsService.getXMLURL(ediDocIds, language)
                : DocumentsService.getXMLURL(ediDocIds[0]);
        }

        function getCustomCsvURL(ediDocIds, template) {
            return ediDocIds.length > 1
                ? DocumentsService.getCustomCsvURL(ediDocIds, language, template)
                : DocumentsService.getInvoiceCustomCsvURL(ediDocIds[0],template);
        }

        function getCustomCsvContacenateURL(ediDocIds, template) {
            return ediDocIds.length > 1
                ? DocumentsService.getCustomCsvsConcatenateURL(ediDocIds, language, template)
                : null;
        }

        // ----- CSV GENERATOR FUNCTIONS -----
        vm.addRow = function () {
            if (vm.data.selectedAvailable && vm.data.selectedAvailable.length) {

                vm.data.selectedAvailable.forEach(function (selectedItem) {
                    if (!vm.data.selectedColumns.includes(selectedItem)) {
                        vm.data.selectedColumns.push(selectedItem);
                    }
                });


                vm.data.selectedAvailable = [];
            }
        };

        vm.removeRow = function () {
            if (vm.data.selectedSelected && vm.data.selectedSelected.length) {

                vm.data.selectedSelected.forEach(function (selectedItem) {
                    var index = vm.data.selectedColumns.indexOf(selectedItem);
                    if (index !== -1) {
                        vm.data.selectedColumns.splice(index, 1);
                    }
                });


                vm.data.selectedSelected = [];
            }
        };

        vm.moveUp = function () {
            if (vm.data.selectedSelected && vm.data.selectedSelected.length) {

                var selectedItems = vm.data.selectedSelected.slice();

                selectedItems.forEach(function (selectedItem) {
                    var index = vm.data.selectedColumns.indexOf(selectedItem);
                    if (index > 0) {

                        var temp = vm.data.selectedColumns[index];
                        vm.data.selectedColumns[index] =
                            vm.data.selectedColumns[index - 1];
                        vm.data.selectedColumns[index - 1] = temp;
                    }
                });
            }
        };

        vm.moveDown = function () {
            if (vm.data.selectedSelected && vm.data.selectedSelected.length) {

                var selectedItems = vm.data.selectedSelected
                    .slice()
                    .sort(function (a, b) {
                        return (
                            vm.data.selectedColumns.indexOf(b) -
                            vm.data.selectedColumns.indexOf(a)
                        );
                    });

                selectedItems.forEach(function (selectedItem) {
                    var index = vm.data.selectedColumns.indexOf(selectedItem);
                    if (index < vm.data.selectedColumns.length - 1) {

                        var temp = vm.data.selectedColumns[index];
                        vm.data.selectedColumns[index] =
                            vm.data.selectedColumns[index + 1];
                        vm.data.selectedColumns[index + 1] = temp;
                    }
                });
            }
        };

        vm.sortSelectedColumns = function () {
            if (!vm.data.sortOrder || !vm.data.selectedColumns.length) {
                return;
            }

            var isAscending = vm.data.sortOrder === "Ascending";

            vm.data.selectedColumns.sort(function (a, b) {
                if (typeof a === "string" && typeof b === "string") {
                    return isAscending
                        ? a.localeCompare(b)
                        : b.localeCompare(a);
                } else {
                    return isAscending ? a - b : b - a;
                }
            });
        };

        vm.saveConfig = function () {
            var templateName = vm.data.saveName || vm.data.selectedConfig;

            if (!templateName || !vm.data.selectedColumns.length) {
                console.warn("Template name or columns missing.");
                return;
            }

            var requestBody = {
                templateName: templateName,
                columns: vm.data.selectedColumns,
            };

            console.log("Saving CSV template:", requestBody);

            if (!vm.data.saveName) {
                DocumentsService.updateCsvTemplate(
                    vm.data.selectedConfig,
                    requestBody
                );
                alert("Configuration saved!");
            } else {
                DocumentsService.setCsvTemplate(requestBody)
                    .then(function (response) {
                        if (response.status === 201) {

                            if (!vm.data.savedConfigs.includes(templateName)) {
                                vm.data.savedConfigs.push(templateName);
                            }

                            vm.data.selectedConfig = templateName;

                            vm.data.saveName = "";
                        } else {
                            console.warn(
                                "Unexpected response status:",
                                response.status
                            );
                        }
                    })
                    .catch(function (error) {

                        var errorMessage = "An error occurred while saving the template.";

                        if (error.response && error.response.data && error.response.data.message) {
                            errorMessage = error.response.data.message;
                        } else if (error.message) {
                            errorMessage = error.message; 
                        }

                        if(error.status =="409"){
                            errorMessage = "Template with this name already exists";
                        }

                        alert(errorMessage);
                        console.error(
                            "Error saving template:",
                            error.status || error
                        );
                    });
            }
        };

        vm.loadConfig = function () {
            if (!vm.data.selectedConfig) {
                console.warn("No configuration selected for loading.");
                return;
            }

            console.log("Loading configuration:", vm.data.selectedConfig);
            loadCsvSelectedTemplate(vm.data.selectedConfig);
        };

        vm.devareConfig = function () {
            if (!vm.data.selectedConfig) {
                console.warn("No configuration selected for devarion.");
                return;
            }

            var index = vm.data.savedConfigs.indexOf(vm.data.selectedConfig);
            if (index > -1) {
                vm.data.savedConfigs.splice(index, 1);
                console.log("Devared configuration:", vm.data.selectedConfig);

                vm.data.selectedConfig = vm.data.savedConfigs.length
                    ? vm.data.savedConfigs[0]
                    : null;
            } else {
                console.warn("Configuration not found in savedConfigs.");
            }
        };

        vm.deleteConfig = function () {
            DocumentsService.deleteCsvTemplate(vm.data.selectedConfig)
                .then(function () {
                    loadCsvAllTemplates();
                    vm.data.selectedConfig = "base_template";
                    loadCsvSelectedTemplate(vm.data.selectedConfig);
                })
                .catch(function (error) {
                    console.log(
                        "ERROR : " +
                            (error.message || "Unknown error")
                    );
                });
        };

        vm.done = function () {
            alert("Configuration saved!");
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('documents', {
            parent: 'application',
            url: '/documents',
            data: {
                pageTitle: 'global.menu.documents'

            },
            views: {
                'content@application': {
                    templateUrl: 'app/views/documents/documents.html',
                    controller: 'DocumentsController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('documents');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .controller('DocumentsController', DocumentsController);

    DocumentsController.$inject = ['$scope', '$state', '$uibModal', 'DocumentsService', 'Principal', 'AlertService', '$filter', '$translate', '$timeout', 'ConstantsService'];

    function DocumentsController($scope, $state, $uibModal, DocumentsService, Principal, AlertService, $filter, $translate, $timeout, ConstantsService) {
        var vm = this;

        vm.Principal = Principal;

        //Declare variables
        vm.tempIssueDateFrom = null;
        vm.tempIssueDateTo = null;
        vm.tempDueDate = null;
        vm.translate = $translate.instant;

        vm.window = $(window);
        vm.table = $("#fixtable[fix-table]");
        vm.topSpacer = $('#topSpacer').find("td");
        vm.bottomSpacer = $('#bottomSpacer').find("td");
        vm.topIndex = 0;
        vm.height = 31;
        vm.limit = Math.max(Math.ceil(vm.window.height() / vm.height) + 10, 50);

        vm.window.resize(function() {
            vm.height = vm.table.find("td").eq(2).outerHeight();
            vm.limit = Math.ceil(vm.window.height() / vm.height) + 10;
            vm.window.trigger("scroll");
        });

        var windowScrollTimeout;
        vm.window.scroll(function() {
            $timeout.cancel(windowScrollTimeout);

            windowScrollTimeout = $timeout(function() {
                var numberOfRows = Math.floor((vm.window.scrollTop() - vm.table.offset().top) / vm.height);
                vm.topIndex = Math.max(0, numberOfRows % 2 !== 0 ? numberOfRows + 1 : numberOfRows);
            }, 20);
        });

        $scope.$watchGroup(["vm.topIndex", "vm.height"], resizePlaceholders);

        $scope.$watchCollection("vm.invoices", resizePlaceholders);

        function resizePlaceholders() {
            vm.topSpacer.height(vm.topIndex * vm.height);
            vm.bottomSpacer.height(vm.invoices.length < vm.limit ? 0 : (vm.invoices.length - vm.limit - vm.topIndex) * vm.height);
        }

        vm.banner = {
            isActive: false,
            isVisible: false,
            line1: '',
            line2: '',
            closable: false
        };
        vm.columnHeaders = [{
            name: "clientNumber",
            enabled: true,
            label: "documents.document.customer"
        }, {
            name: "payerNumber",
            enabled: true,
            label: "documents.document.payer"
        }, {
            name: "dateOpen",
            enabled: Principal.hasUserRead(),
            label: "documents.document.open"
        }, {
            name: "documentType",
            enabled: true,
            label: "documents.document.docType"
        }, {
            name: "documentNumber",
            enabled: true,
            label: "documents.document.docNumber"
        }, {
            name: "dateIssue",
            enabled: true,
            label: "documents.document.issueDate"
        }, {
            name: "dateSent",
            enabled: true,
            label: "documents.document.shippingDate"
        }, {
            name: "dueDate",
            enabled: true,
            label: "documents.document.dateOfPayment"
        }, {
            name: "currency",
            enabled: true,
            label: "documents.document.currency"
        }, {
            name: "totalNetto",
            enabled: true,
            label: "documents.document.netAmount"
        }, {
            name: "totalVat",
            enabled: true,
            label: "documents.document.vatAmount"
        }, {
            name: "totalGross",
            enabled: true,
            label: "documents.document.grossAmount"
        }];

        vm.selectedColumns = [];

        $scope.onClose = function() {
            var footerSum = 1;
            var totalVisible = 1;
            vm.columnHeaders.forEach(function(element, index) {
                if (vm.selectedColumns.indexOf(element) !== -1) {
                    vm.columns[element.name] = true;
                    totalVisible++;
                    if (element.name.indexOf("total") === -1)
                        footerSum++;
                } else vm.columns[element.name] = false;
            });
            vm.columns.footerSum = footerSum;
            vm.columns.totalVisible = totalVisible;
            vm.columns.footer = totalVisible - footerSum > 0;

            DocumentsService.setUserColumnConf(Principal.getProperty('userId'), vm.columns);
        };

        vm.filter = {
            clientNo: null,
            // payerNo: null,
            clientName: null,
            documentNoFrom: null,
            documentNoTo: null,
            // waybillNo: null,
            issueDateFrom: null,
            issueDateTo: null,
            amountBruttoFrom: null,
            amountBruttoTo: null,
            dueDate: null,
            limit: 1000
        };

        vm.columns = {
            clientNumber: true,
            payerNumber: true,
            dateOpen: Principal.hasUserRead(),
            documentType: true,
            documentNumber: true,
            dateIssue: true,
            dateSent: true,
            dueDate: true,
            totalNetto: true,
            totalVat: true,
            currency: true,
            totalGross: true,
            footer: true,
            footerSum: Principal.hasUserRead() ? 10 : 9,
            totalVisible: Principal.hasUserRead() ? 13 : 12
        };

        vm.ediDocIds = [];
        vm.invoices = [];
        vm.resultParameters = {};
        vm.sortType = 'dateIssue';
        vm.sortReverse = false;
        vm.sort = '';
        vm.sortBy = sortBy;
        vm.sumTotalNetto = 0;
        vm.sumTotalBrutto = 0;
        vm.sumTotalVat = 0;
        vm.allChecked = false;
        vm.showCarretOnOpenColumn = false;

        //Declare functions
        vm.init = init;
        vm.list = list;
        vm.checkboxClick = checkboxClick;
        vm.goToPDF = goToPDF;
        vm.getPDFs = getPDFs;
        vm.resend = resend;
        vm.retransfer = retransfer;
        //        vm.getXlsx = getXlsx;
        vm.showAlertAfterDocumentSend = showAlertAfterDocumentSend;
        vm.getAllDocumentNumbersAsString = getAllDocumentNumbersAsString;
        vm.getDocumentNumber = getDocumentNumber;
        vm.calculateSums = calculateSums;
        vm.checkAllDocs = checkAllDocs;
        vm.resetSearch = resetSearch;
        vm.parseClientPayerNumberToInt = parseClientPayerNumberToInt;
        vm.getUserColumnConf = getUserColumnConf;
        vm.filterInvoiceType = filterInvoiceType;
        vm.filterDateOpen = filterDateOpen;
        vm.reformatDate = reformatDate;
        vm.comparator = comparator;
        vm.checkShowColumnOpen = checkShowColumnOpen;
        vm.reformatDates = reformatDates;
        vm.getXlsxURL = getXlsxURL;
        // vm.formatClientNumber = formatClientNumber;

        function goToPDF(ediDoc) {
            var url = $state.href('pdfView', { uuid: ediDoc });
            window.open(url, '_blank');
        }

        function resetSearch() {
            vm.filter.clientNo = null;
            // vm.filter.payerNo = null;
            vm.filter.clientName = null;
            vm.filter.documentNoFrom = null;
            vm.filter.documentNoTo = null;
            // vm.filter.waybillNo = null;
            vm.filter.issueDateFrom = null;
            vm.filter.issueDateTo = null;
            vm.filter.amountBruttoFrom = null;
            vm.filter.amountBruttoTo = null;
            vm.filter.dueDate = null;
            vm.tempIssueDateFrom = null;
            vm.tempIssueDateTo = null;
            vm.tempDueDate = null;
        }

        function checkShowColumnOpen() {
            vm.showCarretOnOpenColumn = angular.equals(['openStatus', 'dateOpen'], vm.sortType);
        }

        function comparator(value1, value2) {
            if (value1.value == value2.value)
                return 0;
            else {
                return value1.value < value2.value ? 1 : -1;
            }
        }

        function resend() {

            AlertService.clear();

            var newUserModal = $uibModal.open({
                templateUrl: 'app/views/documents/resend.html',
                controller: 'resendController',
                controllerAs: 'vm',
                size: 'md'
            });

            newUserModal.result.then(function( /*result*/ response) {
                if (response.email == null /*'same'*/ ) {
                    delete response.result;
                    DocumentsService.resendEmailForAllDocuments(vm.ediDocIds)
                        .then(function(response) {
                            showAlertAfterDocumentSend(response);
                            list(vm.filter);
                        }).catch(function(response) {
                            AlertService.error($translate.instant("documents.messages.notificationFail"));
                        });
                } else {
                    delete response.result;
                    var emailArray = response.email.split(";");

                    DocumentsService.resendEmailOnNewAdresses(vm.ediDocIds, emailArray)
                        .then(function(response) {
                            showAlertAfterDocumentSend(response);
                            list(vm.filter);
                        }).catch(function(response) {
                            AlertService.error($translate.instant("documents.messages.notificationFail"));
                        });
                }
            });
        }

        function retransfer() {

            AlertService.clear();

            DocumentsService.retransferDocumentsToSmtp(vm.ediDocIds)
            .then(function(response) {
                showAlertAfterStmpTransfer(response);
                list(vm.filter);
            }).catch(function(response) {
                AlertService.error($translate.instant("documents.messages.documentsFail"));
            });
        }

        function showAlertAfterStmpTransfer(response) {
            if (response.data != null) {
                if (response.data.failed !== null && Object.keys(response.data.failed).length > 0) {
                    var totalMessage = "";
                    for (var key in response.data.failed) {
                        if (response.data.failed.hasOwnProperty(key)) {
                            var message = response.data.failed[key].message;
                            totalMessage = totalMessage + "[" + key + "] " + message + " ";
                        } else {
                            totalMessage += $translate.instant('documents.message.documentsFail') + " ";
                        }
                    }
                    AlertService.error(totalMessage);
                }
                    if (response.data.success !== null && response.data.success.length > 0 && response.data.failed !== null && Object.keys(response.data.failed).length > 0) {
                        AlertService.success($translate.instant('documents.messages.documentsSentFor') + response.data.success.length + (response.data.success.length > 1 ? $translate.instant('documents.messages.documents') : $translate.instant('documents.messages.document')) + getAllDocumentNumbersAsString(response.data.success));
                    } else if (response.data.success !== null && response.data.success.length > 0) {
                        AlertService.success($translate.instant('documents.messages.actionTransferAgain'));
                    } else if ((response.data.failed == null || Object.keys(response.data.failed).length === 0) && (response.data.success == null || Object.keys(response.data.success).length === 0)) {
                        AlertService.error($translate.instant('documents.messages.documentsFail'));
                }
            }
        }

        function showAlertAfterDocumentSend(response) {
            if (response.data != null) {
                if (response.data.failed !== null && Object.keys(response.data.failed).length > 0) {
                    for (var key in response.data.failed) {
                        if (response.data.failed.hasOwnProperty(key)) {
                            var message = response.data.failed[key].message;
                            if (message == "document.client.not.found") {
                                AlertService.error($translate.instant("documents.messages.clientNotFound").replace("(0)", response.data.failed[key].atrList[0]).replace("(1)", response.data.failed[key].atrList[1]));
                            } else {
                                AlertService.error(message);
                            }
                        } else {
                            AlertService.error($translate.instant('documents.message.notificationFail'));
                        }
                    }
                }

                if (response.data.success !== null && response.data.success.length > 0 && response.data.failed !== null && Object.keys(response.data.failed).length > 0) {
                    AlertService.success($translate.instant('documents.messages.notificationsSentFor') + response.data.success.length + (response.data.success.length > 1 ? $translate.instant('documents.messages.documents') : $translate.instant('documents.messages.document')) + getAllDocumentNumbersAsString(response.data.success));
                } else if (response.data.success !== null && response.data.success.length > 0) {
                    AlertService.success($translate.instant('documents.messages.notificationsSent'));
                } else if ((response.data.failed == null || Object.keys(response.data.failed).length === 0) && (response.data.success == null || Object.keys(response.data.success).length === 0)) {
                    AlertService.error($translate.instant('documents.messages.notificationFail'));
                }
            }
        }

        function getAllDocumentNumbersAsString(ids) {
            var msg = '';
            var tmp;
            for (var id in ids) {
                msg += ((tmp = getDocumentNumber(ids[id])) !== null ? (tmp + '; ') : '');
            }
            return msg;
        }

        function getDocumentNumber(ediDocId) {
            for (var invoice in vm.invoices) {
                if (ediDocId == vm.invoices[invoice].entityId) {
                    return vm.invoices[invoice].documentNumber;
                }
            }
            return null;
        }

        function checkboxClick(event, index, ediDocId) {
            event.stopPropagation();
            if (event.target.checked) {
                vm.ediDocIds.push(ediDocId);
            } else {
                var i;
                for (i = 0; i < vm.ediDocIds.length; ++i) {
                    if (vm.ediDocIds[i] == ediDocId)
                        vm.ediDocIds.splice(i, 1);
                }
            }
        }

        function checkAllDocs(event) {
            event.stopPropagation();
            if (vm.allChecked) {
                vm.ediDocIds = [];
                angular.forEach(vm.invoices, function(item) {
                    item.selected = false;
                });
                vm.allChecked = false;
            } else {
                vm.ediDocIds = [];
                angular.forEach(vm.invoices, function(item) {
                    item.selected = true;
                    vm.ediDocIds.push(item.entityId);
                });
                vm.allChecked = true;
            }
        }

        function getPDFs() {
            if(vm.ediDocIds.length==0 || vm.ediDocIds.length>=100){
                alert(document.getElementById("tooMany").textContent);
            }else{
                var language = angular.element('#lang').controller().getLanguage();
                $uibModal.open({
                templateUrl: 'app/views/documents/download.html',
                controller: 'downloadController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    ediDocIds: function() {
                        return vm.ediDocIds;
                    },
                    language: function() {
                        return language;
                    }
                }
                });
            }

            //not used cause no waybills are added to Benelux pdfs, but code might be useful in future
            /*var newModal = $uibModal.open({
                templateUrl: 'app/views/documents/download.html',
                controller: 'downloadController',
                controllerAs: 'vm',
                size: 'md',
                resolve: {
                    ediDocIds: function() {
                        return vm.ediDocIds
                    },
                    language: function() {
                        return language
                    }
                }
            });*/
        }

        function getXlsxURL() {
            var listFilter = angular.copy(vm.filter);
            listFilter.sortBy = String(vm.sortType);
            listFilter.reverse = vm.sortReverse;
            listFilter.columnsFromJson = vm.columns;
            reformatDates();
            return DocumentsService.getXlsxURL(listFilter);
        }

        function init() {
            getUserColumnConf();

            if(!vm.Principal.hasAllDocumentsAccess())
                list(vm.filter);

            calculateSums();

            loadBanner(); 
        }

        function loadBanner() {
            ConstantsService.isBannerActive().then(function (res) {
                if (!res.data) return;
        
                ConstantsService.getBanner().then(function (res) {
                    var banner = res.data;
        
                    if (!banner || !banner.entities) return;
        
                    var isForThisEntity = banner.entities.includes(Principal.getCurrentEntity());

                    if (isForThisEntity) {
                        vm.banner = {
                            isActive: true,
                            line1: banner.line1,
                            line2: banner.line2,
                            closable: banner.closable,
                            isVisible: true
                        };
                    }
                });
            });
        }

        function list(filter) {
            reformatDates();
            vm.ediDocIds = [];
            var listFilter = angular.copy(vm.filter);
            listFilter.sortBy = String(vm.sortType);
            listFilter.reverse = vm.sortReverse;
            listFilter.columnsFromJson = null;
            DocumentsService.list(listFilter)
                //If successful
                .then(function(response) {
                    //Set data to controller data
                    var nullData = true;
                    if (response.data._embedded != null) {
                        switch (Principal.getCurrentEntity()) {
                            case 'BE':
                                if(response.data._embedded.beInvoices != null) {
                                    vm.invoices = response.data._embedded.beInvoices;
                                    nullData = false;
                                }
                                break;
                            case 'NL':
                                if(response.data._embedded.nlInvoices != null) {
                                    vm.invoices = response.data._embedded.nlInvoices;
                                    nullData = false;
                                }
                                break;
                            case 'EC':
                                if(response.data._embedded.ecInvoices != null) {
                                    vm.invoices = response.data._embedded.ecInvoices;
                                    nullData = false;
                                }
                                break;
                        }
                        if(!nullData) {
                            vm.resultParameters = response.headers();

                            if(vm.resultParameters.upper_date_bound)
                                vm.tempIssueDateTo = new Date(parseInt(vm.resultParameters.upper_date_bound));
                            if(vm.resultParameters.lower_date_bound)
                                vm.tempIssueDateFrom = new Date(parseInt(vm.resultParameters.lower_date_bound));
                            // AlertService.clear();
                        }
                    }
                    if(nullData) {
                        AlertService.error($translate.instant('documents.search.notFound'));
                        vm.invoices = [];
                    }
                })
                .finally(function(response) {
                    calculateSums();
                    // parseClientPayerNumberToInt();
                });
        }

        function calculateSums() {
            vm.sumTotalNetto = 0.00;
            vm.sumTotalBrutto = 0.00;
            vm.sumTotalVat = 0.00;
            angular.forEach(vm.invoices, function(invoice) {
                if (invoice.totalNetto != null) {
                    vm.sumTotalNetto += parseFloat(invoice.totalNetto);
                }
                if (invoice.totalGross != null) {
                    vm.sumTotalBrutto += parseFloat(invoice.totalGross);
                }
                if (invoice.totalVat != null) {
                    vm.sumTotalVat += parseFloat(invoice.totalVat);
                }
            });
            vm.sumTotalNetto = vm.sumTotalNetto.toFixed(2);
            vm.sumTotalBrutto = vm.sumTotalBrutto.toFixed(2);
            vm.sumTotalVat = vm.sumTotalVat.toFixed(2);
        }

        function parseClientPayerNumberToInt() {
            angular.forEach(vm.invoices, function(invoice) {
                invoice.clientNumber = parseInt(invoice.clientNumber);
                invoice.payerNumber = parseInt(invoice.payerNumber);
            });
        }

        function getUserColumnConf() {
            DocumentsService.getUserColumnConf(Principal.getProperty('userId'))
                //If successful
                .then(function(response) {
                    for (var property in response.data)
                        vm.columns[property] = JSON.parse(response.data[property]);

                    if (!vm.columns.footerSum)
                        vm.columns.footerSum = Principal.hasUserRead() ? 10 : 9;
                    if (!vm.columns.totalVisible)
                        vm.columns.totalVisible = Principal.hasUserRead() ? 13 : 12;

                    vm.columns.dateOpen = Principal.hasUserRead() ? vm.columns.dateOpen : false;

                    for (var column in vm.columns)
                        if (vm.columns[column] === true)
                            for (var columnHeader in vm.columnHeaders)
                                if (vm.columnHeaders[columnHeader].name === column)
                                    vm.selectedColumns.push(vm.columnHeaders[columnHeader]);
                });
        }

        function reformatDates() {
            if (vm.tempIssueDateFrom != null)
                vm.filter.issueDateFrom = reformatDate(vm.tempIssueDateFrom);
            if (vm.tempIssueDateTo != null)
                vm.filter.issueDateTo = reformatDate(vm.tempIssueDateTo);
            if (vm.tempDueDate != null)
                vm.filter.dueDate = reformatDate(vm.tempDueDate);
        }

        function reformatDate(date) {
            var result = '';


            result += date.getYear() + 1900;
            result += '-';

            result += date.getMonth() + 1;
            result += '-';
            result += date.getDate();
            return result;
        }

        function filterInvoiceType(type) {
            switch ($filter('uppercase')(type)) {
                case 'INVOICE':
                    return $translate.instant('documents.document.invoice');
                // case 'CORRECTION':
                    // return $translate.instant('documents.document.correctingInvoice');
                default:
                    return type;
            }
        }

        function filterDateOpen(status, date) {
            if (date == null) {
                if (status != null) {
                    return status;
                } else {
                    return $translate.instant('documents.document.notOpened');
                }
            } else {
                return date.substring(0, date.indexOf('T'));
            }
        }

        function sortBy(column, reverse){
            vm.sortType = column;
            vm.sortReverse = reverse;
            vm.checkShowColumnOpen();
            vm.list(vm.filter);
        }

        // function formatClientNumber(numberStr) {
        //     return ('00000000' + numberStr).slice(-8);
        // }

        //Init controller
        vm.init();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider.state('contact', {
            parent: 'site',
            url: '/contact',
            data: {
                pageTitle: 'global.menu.contact'
            },
            views: {
                'content@': {
                    templateUrl: 'app/views/contact/contact.html',
                    controller: 'ContactController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('contact');
                    return $translate.refresh();
                }]
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .controller('ContactController', ContactController);

    ContactController.$inject = ['$rootScope', '$translate'];

    function ContactController($rootScope, $translate) {
        var vm = this;

        vm.filter = null;
        vm.data = null;
        vm.language = function() {
            return $translate.use();
        };

        vm.getTranslation = getTranslation;
        vm.getUrl = getUrl;

        function getTranslation(translation) {
            return $translate.instant("contact." + translation);
        }

        function getUrl(translation) {
            return $translate.instant("contact." + translation + "." + $rootScope.API_DOMAIN);
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .controller('NewClientController', NewClientController);

    NewClientController.$inject = ['$uibModalInstance', '$scope', 'UsersService', 'uuid4', 'ClientsService', '$translate', 'Principal', 'UtilService'];

    function NewClientController($uibModalInstance, $scope, UsersService, UUID, ClientsService, $translate, Principal, UtilService) {
        var vm = this;
        vm.linkXlsx = $translate.instant("clients.newClient.linkXlsx");
        vm.pdfXlsx = $translate.instant("clients.newClient.pdfXlsx");
        vm.pdfCsv = $translate.instant("clients.newClient.pdfCsv");
        vm.newClientEInvoiceYes = $translate.instant("clients.newClient.yes");
        vm.newClientEInvoiceNo = $translate.instant("clients.newClient.no");

        vm.patternMinLength = null;
        vm.patternMaxLength = null;
        vm.pattern = null;
        getNIPPattern();

        vm.data = {
            ediClientId: UUID.generate(),
            clientNumber: "",
            payerNumber: "",
            clientName: "",
            users: [],
            clients: "",
            eInvoiceAgreement: "true",
            portalLang: "EN",
            docSending: "LINK",
            // correctingDocSending: "LINK",
            nip: "",
            contactPerson: "",
            phoneNumber: "",
            notes: "",
            duplicateEmailError: null
        };

        function getNIPPattern() {
            // var NIP = UtilService.getNIPPattern(Principal.getCurrentEntity());
            var NIP = UtilService.getNIPPattern();
            vm.patternMinLength = NIP.minlength;
            vm.patternMaxLength = NIP.maxlength;
            vm.pattern = new RegExp(NIP.regex);
        }

        vm.user = {
            getByEmail: function(email) {
                return UsersService.getEmailsLike({ email: email })
                    .then(function(response) {
                        return response.data._embedded.ediUsers.map(function(user) {
                            return user.email;
                        });
                    });
            },
            add: function() {
                if (vm.data.users.map(function(user) {
                    return user.email;
                }).indexOf(vm.data.user) === -1) {
                    if (angular.isDefined(vm.data.user) && vm.data.user != "" && vm.data.user != null) {
                        vm.data.users.push({ email: vm.data.user });
                        vm.data.user = "";
                    }
                } else {
                    vm.data.duplicateEmailError = $translate.instant("clients.client.duplicateEmail");
                }
            },
            delete: function() {
                var index = vm.data.users.map(function(user) {
                    return user.email;
                }).indexOf(vm.data.user);

                if (index !== -1) {
                    vm.data.users.splice(index, 1);
                    vm.data.user = "";
                }
            }
        };

        $scope.$watch('vm.data.nip', function() {
            vm.data.nip = vm.data.nip.replace(/\D/g, '');
        });

        $scope.$watch('vm.data.payerNumber', function() {
            vm.data.payerNumber = vm.data.payerNumber.replace(/\D/g, '');
        });

        $scope.$watch('vm.data.clientNumber', function() {
            vm.data.clientNumber = vm.data.clientNumber.replace(/\D/g, '');
        });

        //Define a watch for user list select
        $scope.$watch('vm.selection', function(newValue) {
            if (newValue != null)
                vm.data.user = newValue[0].email;
        });

        vm.modal = {
            clientCheck: function() {
                if ((vm.data.clientNumber + '').length === 8) {
                    ClientsService.findByClientNumber(vm.data.clientNumber).then(function(response) {
                        if (response.data != null) {
                            vm.data.clients = vm.data.clientNumber;
                        } else {
                            vm.data.clients = '';
                        }

                    }).catch(function(response) {
                        vm.data.clients = '';
                    });
                } else {
                    vm.data.clients = '';
                }
            },
            add: function() {
                vm.data.nip = vm.data.nip.replace(/\D/g, '');
                $uibModalInstance.close(vm.data);
            },
            cancel: function() {
                $uibModalInstance.dismiss('cancel');
            }
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .controller('ClientsController', ClientsController);

    ClientsController.$inject = ['$scope', '$state', '$stateParams', 'ClientsService', 'UtilService', 'Upload', '$rootScope', '$uibModal', 'AlertService', '$translate', 'Principal', 'API_URL'];

    function ClientsController($scope, $state, $stateParams, ClientsService, UtilService, Upload, $rootScope, $uibModal, AlertService, $translate, Principal, API_URL) {
        var vm = this;
        vm.clientsList = [];

        /*Declare variables*/
        vm.filter = {
            data: {
                size: 10,
                page: 0,
                email: "",
                clientNumber: "",
                clientName: ""
            },
            clear: function() {
                vm.filter.data.email = "";
                vm.filter.data.clientNumber = "";
                vm.filter.data.clientName = "";
            },
            save: function() {
                if (vm.data && vm.data.page)
                    vm.filter.data.page = vm.data.page.number;
                $state.transitionTo($state.current, vm.filter.data, {
                    location: true,
                    inherit: true,
                    notify: false
                });
            },
            read: function() {
                angular.copy($stateParams, vm.filter.data);
            }
        };
        vm.data = null;
        vm.actions = [];
        vm.wrongFile = function() {
            return $translate.instant("clients.clients.wrongFile");
        },
        vm.required = function() {
            return $translate.instant("clients.clients.required");
        },
        vm.notFound = function() {
            return $translate.instant("clients.clients.notFound");
        },
        vm.notFoundClient = function() {
            return $translate.instant("clients.clients.notFoundClient");
        },
        vm.wrong = function() {
            return $translate.instant("clients.clients.wrong");
        },
        vm.multipleAdd = function() {
            return $translate.instant("clients.clients.multipleAdd");
        },
        vm.clientExists = function() {
            return $translate.instant("clients.clients.clientExists");
        },
        vm.multiple = function() {
            return $translate.instant("clients.clients.multiple");
        },
        vm.yesOrNo = function(variable) {
            return variable ? $translate.instant("clients.newClient.yes") : $translate.instant("clients.newClient.no");

        },
        vm.yesOrNoeInvoiceAgreement = function() {
            // return entry.client.eInvoiceAgreement ? $translate.instant("clients.newClient.yes"):$translate.instant("clients.newClient.no");
        },
            /*Declare functions*/
            //Controller init
        vm.init = function() {
            vm.filter.read();
            if (UtilService.isFilled(vm.filter.data))
                vm.client.current();
        };

        //Navigating
        vm.nav = {
            client: function(client) {
                $state.go('client', client);
            }
        };

        //Getting clients
        vm.client = {
            //List clients
            current: function() {
                vm.filter.data.page = 0;

                ClientsService.listWithParams(vm.filter.data)
                    .then(vm.client.then);
            },
            //Go to the first page
            first: function() {
                UtilService.get(vm.data, 'first', null, null)
                    .then(vm.client.then);
            },
            //Go to the previous page
            previous: function() {
                UtilService.get(vm.data, 'prev', null, null)
                    .then(vm.client.then);
            },
            //Go to the next page
            next: function() {
                UtilService.get(vm.data, 'next', null, null)
                    .then(vm.client.then);
            },
            //Go to the last page
            last: function() {
                UtilService.get(vm.data, 'last', null, null)
                    .then(vm.client.then);
            },
            then: function(response) {

                //add 'BENELUXUI' to url if missing 
                if(response.data._links['first'])
                    response.data._links['first'].href = fixURL(response.data._links['first'].href);
                if(response.data._links['self'])
                    response.data._links['self'].href = fixURL(response.data._links['self'].href);
                if(response.data._links['next'])
                    response.data._links['next'].href = fixURL(response.data._links['next'].href);
                if(response.data._links['prev'])
                    response.data._links['prev'].href = fixURL(response.data._links['prev'].href);
                if(response.data._links['last'])
                    response.data._links['last'].href = fixURL(response.data._links['last'].href);

                //Set data to controller data
                vm.data = response.data;
                var nullData = true;
                if (response.data._embedded != null) {
                    switch (Principal.getCurrentEntity()) {
                        case 'BE':
                            if(response.data._embedded.beClientPortalEntryResources != null) {
                                vm.clientsList = response.data._embedded.beClientPortalEntryResources;
                                nullData = false;
                            }
                            break;
                        case 'NL':
                            if(response.data._embedded.nlClientPortalEntryResources != null) {
                                vm.clientsList = response.data._embedded.nlClientPortalEntryResources;
                                nullData = false;
                            }
                            break;
                        case 'EC':
                            if(response.data._embedded.ecClientPortalEntryResources != null) {
                                vm.clientsList = response.data._embedded.ecClientPortalEntryResources;
                                nullData = false;
                            }
                            break;
                    }
                }
                if(nullData) {
                    AlertService.error($translate.instant("clients.clients.clientNotFound"));
                } else {
                    AlertService.clear();
                }
                //Write state to URL
                vm.filter.save();
            },
            new: function() {
                var newClientModal = $uibModal.open({
                    templateUrl: 'app/views/clients/newClient/newClient.html',
                    controller: 'NewClientController',
                    controllerAs: 'vm',
                    size: 'lg'
                });

                newClientModal.result.then(function(newClient) {
                    ClientsService.create(newClient).then(function(response) {
                        vm.client.current();
                        AlertService.success($translate.instant("clients.clients.clientCreated"));
                    }).catch(function(response) {
                        AlertService.error($translate.instant("clients.clients.errorAdding"));
                    });
                });
            }
        };

        function fixURL(url) {
            if($rootScope.API_URL === API_URL.BE) {
                url = url.replace('https://billing.dhlparcel.nl', 'https://billing.dhlparcel.be');
            } else {
                url = url.replace('https://billing.dhlparcel.be', 'https://billing.dhlparcel.nl');
            }
            if( url != null && !(url.indexOf('BENELUXUI') !== -1) && (url.indexOf('dev') !== -1)) {
                return url.replace('edistrada2', 'BENELUXUI/edistrada2');
            } else {
                return url;
            }
        }

        vm.management = {
            file: null,
            progress: 0,
            status: '',
            message: '',
            errors: [],
            done: false,
            parse: function() {
                if (vm.management.file) {
                    vm.management.progress = 1;
                    vm.management.status = 'info';
                    vm.management.message = $translate.instant("clients.clients.sending");
                    vm.management.errors = [];
                    vm.management.done = false;
                    vm.actions = [];
                    Upload.http({
                        url: $rootScope.API_URL + 'api/beneluxClients/manage/parse',
                        data: vm.management.file,
                        headers: {
                            "Content-Type": "application/octet-stream"
                        }
                    }).then(function(response) {
                        vm.management.done = true;
                        vm.management.status = 'success';
                        vm.management.message = $translate.instant("clients.clients.finished");
                        response.data.forEach(function(action) {
                            vm.actions.push(action);
                        });
                    }, function(response) {
                        vm.management.done = true;
                        vm.management.status = 'danger';
                        vm.management.message = $translate.instant("clients.clients.errorInFile");
                        vm.management.errors = response.data;
                    },
                    function(event) {
                        vm.management.progress = Math.min(100, parseInt(100.0 *
                            event.loaded / event.total));
                        if (vm.management.progress == 100) {
                            vm.management.status = null;
                            vm.management.message = $translate.instant("clients.clients.processing");
                        }
                    });
                }
            },
            cancel: function() {
                vm.management.progress = 0;
                vm.management.status = '';
                vm.management.message = '';
                vm.management.done = false;
                vm.actions = [];
            },
            succeed: function() {
                vm.management.cancel();
                vm.management.status = 'succeeded';
            },
            fail: function() {
                vm.management.cancel();
                vm.management.status = 'failed';
            },
            manage: function() {
                ClientsService.manage(vm.actions)
                    .then(function(response) {
                        if (response.data == null || response.data.length === 0) {
                            vm.management.succeed();
                        } else {
                            vm.actions = [];
                            vm.management.status = 'danger';
                            vm.management.message = $translate.instant("clients.clients.notSaved");
                            AlertService.error($translate.instant("clients.clients.notCreatedInfo"));
                            response.data.forEach(function(action) {
                                vm.actions.push(action);
                            });
                        }
                    })
                    .catch(function(response) {
                        vm.management.fail();
                    });
            }
        };

        //Define a watch for file upload
        $scope.$watch('vm.management.file', function() {
            vm.management.parse();
        });

        //Init controller
        vm.init();

        //Position fix-table
        var fixed = $('#fixed'),
            underFixed = $('#under-fixed');
        $scope.$watch(
            function() {
                return fixed.outerHeight();
            },
            function(newValue) {
                underFixed.css('padding-top', newValue);
            });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('clientsPanel', {
                parent: 'application',
                url: '/clientsPanel',
                views: {
                    'content@application': {
                        templateUrl: 'app/views/clients/clientsPanel.html'
                    }
                },
                redirectTo: 'clients',
            })
            .state('clients', {
                parent: 'clientsPanel',
                url: '/clients?size&page&email&clientNumber&clientName',
                params: {
                    size: '25',
                    page: '0',
                    email: null,
                    clientNumber: null,
                    clientName: null
                },
                data: {
                    pageTitle: 'global.menu.clients'
                },
                views: {
                    'innerContent@clientsPanel': {
                        templateUrl: 'app/views/clients/clients/clients.html',
                        controller: 'ClientsController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('clients');
                        return $translate.refresh();
                    }]
                }
            }).state('client', {
                parent: 'clientsPanel',
                url: '/client?clientNumber',
                params: {
                    clientNumber: null
                },
                data: {
                    pageTitle: 'global.menu.client'
                },
                views: {
                    'innerContent@clientsPanel': {
                        templateUrl: 'app/views/clients/client/client.html',
                        controller: 'ClientController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('clients');
                        return $translate.refresh();
                    }]
                }
            });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .controller('ClientController', ClientController);

    ClientController.$inject = ['$scope', '$state', '$stateParams', 'UsersService','DocumentsService', 'ClientsService', 'UtilService', 'MailTemplatesService', 'filterFilter', 'Principal', 'AlertService', '$translate'];

    function ClientController($scope, $state, $stateParams, UsersService, DocumentsService, ClientsService, UtilService, MailTemplatesService, filterFilter, Principal, AlertService, $translate) {
        var vm = this;

        var defaultFileTypes = {
            CSV: false,
            XML: false,
            PDF: false
        };

        /*Declare variables*/
        vm.filter = {
            data: {
                clientNumber: ""
            },
            clear: function() {
                vm.filter.data.clientNumber = "";
            },
            save: function() {
                $state.transitionTo($state.current, vm.filter.data, {
                    location: true,
                    inherit: true,
                    notify: false
                });
            },
            read: function() {
                angular.copy($stateParams, vm.filter.data);
            }
        };

        vm.ActivityTypes = [{
            name: 'ACCOUNT_OPENED',
            text: function() {
                return $translate.instant("clients.client.accountOpen");
            }
        }, {
            name: 'EMAIL_ADDED',
            text: function() {
                return $translate.instant("clients.client.emailAdded");
            }
        }, {
            name: 'REGISTRATION_FAIL',
            text: function() {
                return $translate.instant("clients.client.registrationFail");
            }
        }, {
            name: 'PASSWORD_CHANGE',
            text: function() {
                return $translate.instant("clients.client.passwordChange");
            }
        }, {
            name: 'INVOICE_WITH_LINK',
            text: function() {
                return $translate.instant("clients.client.invoiceWithLink");
            }
        }, {
            name: 'INVOICE_WITH_PDF',
            text: function() {
                return $translate.instant("clients.client.invoiceWithPdf");
            }
        }, {
            name: 'INVOICE_WITH_CSV',
            text: function() {
                return $translate.instant('clients.client.invoiceWithCsv');
            }
        }, {
            name: 'INVOICE_WITH_LINK_AND_XLSX',
            text: function() {
                return $translate.instant("clients.client.invoiceWithLinkXlsx");
            }
        }, {
            name: 'INVOICE_WITH_PDF_AND_XLSX',
            text: function() {
                return $translate.instant("clients.client.invoiceWithPdfXlsx");
            }
        }, {
            name: 'INVOICE_WITH_PDF_AND_CSV',
            text: function() {
                return $translate.instant("clients.client.invoiceWithPdfCsv");
            }
        }, {
            name: 'INVOICE_WITH_CUSTOMIZED_CSV',
            text: function() {
                return $translate.instant("clients.client.invoiceWithCustCsv");
                }
        }, {
            name: 'INVOICE_WITH_CUSTOMIZED_PDF_AND_CSV',
            text: function() {
                return $translate.instant("clients.client.invoiceWithCustPdfCsv");
                }
        },
            // {
        //     name: 'CORRECTION_INVOICE',
        //     text: function() {
        //         return $translate.instant("clients.client.correctionsInvoice")
        //     }
        // },
        {
            name: 'INVOICE_TOO_LARGE',
            text: function() {
                return $translate.instant("clients.client.invoiceTooLarge");
            }
        }];

        vm.clientTemplates = {
            templatesNL: {
                ACCOUNT_OPENED: {
                    name: null,
                    template_id: null
                },
                EMAIL_ADDED: {
                    name: null,
                    template_id: null
                },
                REGISTRATION_FAIL: {
                    name: null,
                    template_id: null
                },
                PASSWORD_CHANGE: {
                    name: null,
                    template_id: null
                },
                INVOICE_WITH_LINK: {
                    name: null,
                    template_id: null
                },
                INVOICE_WITH_PDF: {
                    name: null,
                    template_id: null
                },
                INVOICE_WITH_LINK_AND_XLSX: {
                    name: null,
                    template_id: null
                },
                INVOICE_WITH_PDF_AND_XLSX: {
                    name: null,
                    template_id: null
                },
                INVOICE_WITH_PDF_AND_CSV: {
                    name: null,
                    template_id: null
                },
                INVOICE_WITH_CUSTOMIZED_CSV: {
                    name: null,
                    template_id: null
                },
                INVOICE_WITH_CUSTOMIZED_PDF_AND_CSV: {
                    name: null,
                    template_id: null
                },

                // CORRECTION_INVOICE: {
                //     name: null,
                //     template_id: null
                // },
                INVOICE_TOO_LARGE: {
                    name: null,
                    template_id: null
                }
            },
            titlesNL: {
                ACCOUNT_OPENED: {
                    name: null,
                    template_id: null
                },
                EMAIL_ADDED: {
                    name: null,
                    template_id: null
                },
                REGISTRATION_FAIL: {
                    name: null,
                    template_id: null
                },
                PASSWORD_CHANGE: {
                    name: null,
                    template_id: null
                },
                INVOICE_WITH_LINK: {
                    name: null,
                    template_id: null
                },
                INVOICE_WITH_PDF: {
                    name: null,
                    template_id: null
                },
                INVOICE_WITH_LINK_AND_XLSX: {
                    name: null,
                    template_id: null
                },
                INVOICE_WITH_PDF_AND_XLSX: {
                    name: null,
                    template_id: null
                },
                INVOICE_WITH_PDF_AND_CSV: {
                    name: null,
                    template_id: null
                },
                INVOICE_WITH_CUSTOMIZED_CSV: {
                    name: null,
                    template_id: null
                },
                INVOICE_WITH_CUSTOMIZED_PDF_AND_CSV: {
                    name: null,
                    template_id: null
                },
                // CORRECTION_INVOICE: {
                //     name: null,
                //     template_id: null
                // },
                INVOICE_TOO_LARGE: {
                    name: null,
                    template_id: null
                }
            },
            templatesEN: {
                ACCOUNT_OPENED: {
                    name: null,
                    template_id: null
                },
                EMAIL_ADDED: {
                    name: null,
                    template_id: null
                },
                REGISTRATION_FAIL: {
                    name: null,
                    template_id: null
                },
                PASSWORD_CHANGE: {
                    name: null,
                    template_id: null
                },
                INVOICE_WITH_LINK: {
                    name: null,
                    template_id: null
                },
                INVOICE_WITH_PDF: {
                    name: null,
                    template_id: null
                },
                INVOICE_WITH_LINK_AND_XLSX: {
                    name: null,
                    template_id: null
                },
                INVOICE_WITH_PDF_AND_XLSX: {
                    name: null,
                    template_id: null
                },
                INVOICE_WITH_PDF_AND_CSV: {
                    name: null,
                    template_id: null
                },
                INVOICE_WITH_CUSTOMIZED_CSV: {
                    name: null,
                    template_id: null
                },
                INVOICE_WITH_CUSTOMIZED_PDF_AND_CSV: {
                    name: null,
                    template_id: null
                },
                // CORRECTION_INVOICE: {
                //     name: null,
                //     template_id: null
                // },
                INVOICE_TOO_LARGE: {
                    name: null,
                    template_id: null
                }
            },
            titlesEN: {
                ACCOUNT_OPENED: {
                    name: null,
                    template_id: null
                },
                EMAIL_ADDED: {
                    name: null,
                    template_id: null
                },
                REGISTRATION_FAIL: {
                    name: null,
                    template_id: null
                },
                PASSWORD_CHANGE: {
                    name: null,
                    template_id: null
                },
                INVOICE_WITH_LINK: {
                    name: null,
                    template_id: null
                },
                INVOICE_WITH_PDF: {
                    name: null,
                    template_id: null
                },
                INVOICE_WITH_LINK_AND_XLSX: {
                    name: null,
                    template_id: null
                },
                INVOICE_WITH_PDF_AND_XLSX: {
                    name: null,
                    template_id: null
                },
                INVOICE_WITH_PDF_AND_CSV: {
                    name: null,
                    template_id: null
                },
                INVOICE_WITH_CUSTOMIZED_CSV: {
                    name: null,
                    template_id: null
                },
                INVOICE_WITH_CUSTOMIZED_PDF_AND_CSV: {
                    name: null,
                    template_id: null
                },
                // CORRECTION_INVOICE: {
                //     name: null,
                //     template_id: null
                // },
                INVOICE_TOO_LARGE: {
                    name: null,
                    template_id: null
                }
            },
            templatesFR: {
                ACCOUNT_OPENED: {
                    name: null,
                    template_id: null
                },
                EMAIL_ADDED: {
                    name: null,
                    template_id: null
                },
                REGISTRATION_FAIL: {
                    name: null,
                    template_id: null
                },
                PASSWORD_CHANGE: {
                    name: null,
                    template_id: null
                },
                INVOICE_WITH_LINK: {
                    name: null,
                    template_id: null
                },
                INVOICE_WITH_PDF: {
                    name: null,
                    template_id: null
                },
                INVOICE_WITH_LINK_AND_XLSX: {
                    name: null,
                    template_id: null
                },
                INVOICE_WITH_PDF_AND_XLSX: {
                    name: null,
                    template_id: null
                },
                INVOICE_WITH_PDF_AND_CSV: {
                    name: null,
                    template_id: null
                },
                INVOICE_WITH_CUSTOMIZED_CSV: {
                    name: null,
                    template_id: null
                },
                INVOICE_WITH_CUSTOMIZED_PDF_AND_CSV: {
                    name: null,
                    template_id: null
                },
                // CORRECTION_INVOICE: {
                //     name: null,
                //     template_id: null
                // },
                INVOICE_TOO_LARGE: {
                    name: null,
                    template_id: null
                }
            },
            titlesFR: {
                ACCOUNT_OPENED: {
                    name: null,
                    template_id: null
                },
                EMAIL_ADDED: {
                    name: null,
                    template_id: null
                },
                REGISTRATION_FAIL: {
                    name: null,
                    template_id: null
                },
                PASSWORD_CHANGE: {
                    name: null,
                    template_id: null
                },
                INVOICE_WITH_LINK: {
                    name: null,
                    template_id: null
                },
                INVOICE_WITH_PDF: {
                    name: null,
                    template_id: null
                },
                INVOICE_WITH_LINK_AND_XLSX: {
                    name: null,
                    template_id: null
                },
                INVOICE_WITH_PDF_AND_XLSX: {
                    name: null,
                    template_id: null
                },
                INVOICE_WITH_PDF_AND_CSV: {
                    name: null,
                    template_id: null
                },
                INVOICE_WITH_CUSTOMIZED_CSV: {
                    name: null,
                    template_id: null
                },
                INVOICE_WITH_CUSTOMIZED_PDF_AND_CSV: {
                    name: null,
                    template_id: null
                },
                // CORRECTION_INVOICE: {
                //     name: null,
                //     template_id: null
                // },
                INVOICE_TOO_LARGE: {
                    name: null,
                    template_id: null
                }
            },
            templatesDE: {
                ACCOUNT_OPENED: {
                    name: null,
                    template_id: null
                },
                EMAIL_ADDED: {
                    name: null,
                    template_id: null
                },
                REGISTRATION_FAIL: {
                    name: null,
                    template_id: null
                },
                PASSWORD_CHANGE: {
                    name: null,
                    template_id: null
                },
                INVOICE_WITH_LINK: {
                    name: null,
                    template_id: null
                },
                INVOICE_WITH_PDF: {
                    name: null,
                    template_id: null
                },
                INVOICE_WITH_LINK_AND_XLSX: {
                    name: null,
                    template_id: null
                },
                INVOICE_WITH_PDF_AND_XLSX: {
                    name: null,
                    template_id: null
                },
                INVOICE_WITH_PDF_AND_CSV: {
                    name: null,
                    template_id: null
                },
                INVOICE_WITH_CUSTOMIZED_CSV: {
                    name: null,
                    template_id: null
                },
                INVOICE_WITH_CUSTOMIZED_PDF_AND_CSV: {
                    name: null,
                    template_id: null
                },
                // CORRECTION_INVOICE: {
                //     name: null,
                //     template_id: null
                // },
                INVOICE_TOO_LARGE: {
                    name: null,
                    template_id: null
                }
            },
            titlesDE: {
                ACCOUNT_OPENED: {
                    name: null,
                    template_id: null
                },
                EMAIL_ADDED: {
                    name: null,
                    template_id: null
                },
                REGISTRATION_FAIL: {
                    name: null,
                    template_id: null
                },
                PASSWORD_CHANGE: {
                    name: null,
                    template_id: null
                },
                INVOICE_WITH_LINK: {
                    name: null,
                    template_id: null
                },
                INVOICE_WITH_PDF: {
                    name: null,
                    template_id: null
                },
                INVOICE_WITH_LINK_AND_XLSX: {
                    name: null,
                    template_id: null
                },
                INVOICE_WITH_PDF_AND_XLSX: {
                    name: null,
                    template_id: null
                },
                INVOICE_WITH_PDF_AND_CSV: {
                    name: null,
                    template_id: null
                },
                INVOICE_WITH_CUSTOMIZED_CSV: {
                    name: null,
                    template_id: null
                },
                INVOICE_WITH_CUSTOMIZED_PDF_AND_CSV: {
                    name: null,
                    template_id: null
                },
                // CORRECTION_INVOICE: {
                //     name: null,
                //     template_id: null
                // },
                INVOICE_TOO_LARGE: {
                    name: null,
                    template_id: null
                }
            }
        };

        vm.dhlEmailTempaltes = null;
        vm.dhlClientEmailTempaltesIds = null;
        vm.templatesToSend = [];
        vm.onHoldCheckboxShow = false;
        vm.onHoldCheckboxEditable = false;

        vm.data = {
            client: null,
            user: null,
            savedConfigs: [],
            users: []
        };

        /*Declare functions*/
        vm.getAllEmailTemplates = getAllEmailTemplates;
        vm.getUserTemplatesId = getUserTemplatesId;
        vm.sendNewUserTemplates = sendNewUserTemplates;
        vm.getCommonElementFromLists = getCommonElementFromLists;


        //Controller init
        vm.init = function() {
            vm.filter.read();
            if (UtilService.isFilled(vm.filter.data)) {
                if (Principal.hasClientRead()) {
                    vm.onHoldCheckboxShow = true;
                    vm.onHoldCheckboxEditable = Principal.hasClientWrite();
                }
                vm.client.get();
            } else
                $state.go('clients');
        };

        function fixURL(url) {
            if( url != null && !(url.indexOf('BENELUXUI') !== -1) && (url.indexOf('dev') !== -1) ) {
                return url.replace('edistrada2', 'BENELUXUI/edistrada2');
            }else {
                return url;
            }
        }

        //Managing client
        vm.client = {
            get: function() {
                ClientsService.findByClientNumber(vm.filter.data.clientNumber)
                    //If successful
                    .then(vm.client.then)
                    //If there were errors
                    .catch(function(response) {
                        $state.go('clients');
                    })
                    .finally(function(response) {});
            },
            then: function(response) {

                //add 'BENELUXUI' to url if missing
                if(response.data._links['self'])
                    response.data._links['self'].href = fixURL(response.data._links['self'].href);
                if(response.data._links['nlClient'])
                    response.data._links['nlClient'].href = fixURL(response.data._links['nlClient'].href);
                if(response.data._links['beneluxTemplates'])
                    response.data._links['beneluxTemplates'].href = fixURL(response.data._links['beneluxTemplates'].href);
                if(response.data._links['ftpConfiguration'])
                    response.data._links['ftpConfiguration'].href = fixURL(response.data._links['ftpConfiguration'].href);
                if(response.data._links['beneluxUsers'])
                    response.data._links['beneluxUsers'].href = fixURL(response.data._links['beneluxUsers'].href);

                //Set data to controller data
                vm.data.client = response.data;

                if(vm.data.client.ftpConfiguration) {
                    //Remove password hash from ftpConnection
                    vm.data.client.ftpConfiguration.password = null;

                    //Basic values of ftpConnection
                    vm.data.client.ftpConfiguration.fileTypesArray = Object.assign({}, defaultFileTypes);

                    //Split ftpConnection file types into array
                    if(vm.data.client.ftpConfiguration.fileTypes) {
                        var fileTypes = vm.data.client.ftpConfiguration.fileTypes.split(",");

                        for(var i = 0; i < fileTypes.length; i++) {
                            if(fileTypes[i] in defaultFileTypes)
                                vm.data.client.ftpConfiguration.fileTypesArray[fileTypes[i]] = true;
                        }
                    }

                    vm.data.client.isFtpActive = true;
                } else {
                    vm.data.client.ftpConfiguration = {
                        fileTypesArray: Object.assign({}, defaultFileTypes)
                    };
                }

                //Get his users
                vm.client.getUsers();

                //Write state to URL
                vm.filter.save();

                //Get his templates
                vm.getAllEmailTemplates();
            },
            getUsers: function() {
                UtilService.get /*his users*/ (vm.data.client, 'beneluxUsers', null, null)
                    .then(function(response) {
                        //Set users to client
                        if(response.data._embedded != undefined)
                            vm.data.client.users = response.data._embedded[Principal.getCurrentEntityLowerCase()+'Users'];
                        else
                            vm.data.client.users = [];
                    })
                    .catch(function(response) {
                        vm.data.client.users = [];
                    });
            },
            cancel: function() {
                vm.client.get();
            },
            update: function() {
                clientServiceExecutor(
                    ClientsService.update,
                    vm.data.client,
                    $translate.instant("clients.client.changesSaved"),
                    $translate.instant("clients.client.saveFailed"),
                    vm.data.client.isFtpActive
                );
            },
            updateFtpConfig: function() {
                if(vm.data.client.ftpConfiguration.fileTypesArray) {
                    vm.data.client.ftpConfiguration.fileTypes = arrayToString(vm.data.client.ftpConfiguration.fileTypesArray);
                }

                clientServiceExecutor(
                    ClientsService.updateFtpConfig,
                    vm.data.client,
                    $translate.instant("clients.client.ftpConfigurationUpdateSuccess"),
                    $translate.instant("clients.client.ftpConfigurationUpdateFailure"),
                    true
                );
            },
            deleteFtpConfig: function() {
                clientServiceExecutor(
                    ClientsService.deleteFtpConfig,
                    vm.data.client,
                    $translate.instant("clients.client.ftpConfigurationDeleteSuccess"),
                    $translate.instant("clients.client.ftpConfigurationDeleteFailure"),
                    false
                );
            }
        };

        function clientServiceExecutor(indexFunction, data, successAlert, errorAlert, isFtpActive) {
            indexFunction(data)
                .then(function(response) {
                    AlertService.success(successAlert);
                    vm.data.client.isFtpActive = isFtpActive
                }).catch(function(response) {
                    AlertService.error(errorAlert);
                })
        }

        function loadCsvAllTemplates() {
            DocumentsService.getCsvAllTemplates()
                .then(function (response) {
                    if (Array.isArray(response.data.data)) {
                        vm.data.savedConfigs = response.data.data;
                    } else {
                        console.error(
                            "getCsvAllTemplates Unexpected response format",
                            response.data.data
                        );
                    }
                })
                .catch(function (error) {
                    console.error("Error fetching getCsvAllTemplates", error);
                });
        }

        function arrayToString(array) {
            var keys = [];

            for (var key in array) {
                if (array.hasOwnProperty(key) && array[key]) {
                    keys.push(key);
                }
            }

            return keys.join(",");
        }

        vm.user = {
            getByEmail: function(email) {
                if(Principal.hasUserRead()){
                    return UsersService.getEmailsLike({ email: email.toLowerCase() })
                        .then(function(response) {
                            if (!response.data._embedded) {
                                return "";
                            }
                            return response.data._embedded.ediUsers.map(function(user) {
                                return user.email;
                            });
                        });
                }
            },
            add: function() {
                if (typeof vm.data.client.users !== 'undefined') {
                    if (vm.data.client.users.map(function(user) {
                        return user.email;
                    }).indexOf(vm.data.user) == -1) {
                        if (angular.isDefined(vm.data.user) && vm.data.user != "" && vm.data.user != null) {
                            if (/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(vm.data.user)) {
                                vm.data.client.users.push({ email: vm.data.user });
                                vm.data.user = "";
                            } else {
                                AlertService.error($translate.instant("clients.client.invalidEmail"));
                            }
                        }
                    } else {
                        AlertService.error($translate.instant("clients.client.duplicateEmail"));
                    }
                } else {
                    if (angular.isDefined(vm.data.user) && vm.data.user != "" && vm.data.user != null) {
                        if (/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(vm.data.user)) {
                            vm.data.client.users = [{ email: vm.data.user }];
                            vm.data.user = "";
                        } else {
                            AlertService.error($translate.instant("clients.client.invalidEmail"));
                        }
                    }
                }

            },
            delete: function() {
                var index = vm.data.client.users.map(function(user) {
                    return user.email;
                }).indexOf(vm.data.user);

                if (index != -1) {
                    vm.data.client.users.splice(index, 1);
                    vm.data.user = "";
                }
            }
        };

        $scope.$watch(
            function () {
                return vm.data.client.docSending;
            },
            function (newValue, oldValue) {
                if (
                    newValue === "CUSTOMIZED_CSV" ||
                    newValue === "CUSTOMIZED_PDF_CSV"
                ) {
                    loadCsvAllTemplates();
                }
            }
        );

        //Define a watch for user list select
        $scope.$watch('vm.selection', function(newValue) {
            if (!(newValue == undefined) && newValue.length != 0) {
                vm.data.user = newValue[0].email;
            }
        });

        $scope.$watch('vm.data.client.nip', function() {
            if (vm.data.client && UtilService.isFilled(vm.data.client.nip))
                vm.data.client.nip = vm.data.client.nip.replace(/\W/g, '');
        });

        //Navigating
        vm.nav = {
            clients: function() {
                $state.go('clients');
            },
            user: function(user) {
                $state.go('user', user);
            }
        };

        function getAllEmailTemplates() {
            if (Principal.hasTemplateAccess()) {
                MailTemplatesService.getAllTemplates().then(function(response) {
                    if (response.data._embedded != null) {
                        vm.dhlEmailTempaltes = response.data._embedded[Principal.getCurrentEntityLowerCase()+'Templates'];
                        vm.getUserTemplatesId();
                    } else {
                        vm.clientErrorText = $translate.instant('clients.client.templatesDownloadFailed');
                        vm.clientSuccessText = null;
                    }
                }).catch(function(response) {
                    vm.clientErrorText = $translate.instant("clients.client.templatesDownloadFailed");
                    vm.clientSuccessText = null;
                });
            }
        }

        function getUserTemplatesId() {
            if (Principal.hasTemplateAccess()) {
                ClientsService.getClientTemplates(vm.data.client.ediClientId).then(function(response) {
                    vm.dhlClientEmailTempaltesIds = response.data;

                    var id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_TITLE', actionType: 'ACCOUNT_OPENED', language: 'nl' }, true), vm.dhlClientEmailTempaltesIds);
                    vm.clientTemplates.titlesNL.ACCOUNT_OPENED = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_TITLE', actionType: 'EMAIL_ADDED', language: 'nl' }, true), vm.dhlClientEmailTempaltesIds);
                    vm.clientTemplates.titlesNL.EMAIL_ADDED = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_TITLE', actionType: 'REGISTRATION_FAIL', language: 'nl' }, true), vm.dhlClientEmailTempaltesIds);
                    vm.clientTemplates.titlesNL.REGISTRATION_FAIL = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_TITLE', actionType: 'PASSWORD_CHANGE', language: 'nl' }, true), vm.dhlClientEmailTempaltesIds);
                    vm.clientTemplates.titlesNL.PASSWORD_CHANGE = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_TITLE', actionType: 'INVOICE_WITH_LINK', language: 'nl' }, true), vm.dhlClientEmailTempaltesIds);
                    vm.clientTemplates.titlesNL.INVOICE_WITH_LINK = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_TITLE', actionType: 'INVOICE_WITH_PDF', language: 'nl' }, true), vm.dhlClientEmailTempaltesIds);
                    vm.clientTemplates.titlesNL.INVOICE_WITH_PDF = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_TITLE', actionType: 'INVOICE_WITH_LINK_AND_XLSX', language: 'nl' }, true), vm.dhlClientEmailTempaltesIds);
                    vm.clientTemplates.titlesNL.INVOICE_WITH_LINK_AND_XLSX = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_TITLE', actionType: 'INVOICE_WITH_PDF_AND_XLSX', language: 'nl' }, true), vm.dhlClientEmailTempaltesIds);
                    vm.clientTemplates.titlesNL.INVOICE_WITH_PDF_AND_XLSX = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_TITLE', actionType: 'INVOICE_WITH_PDF_AND_CSV', language: 'nl' }, true), vm.dhlClientEmailTempaltesIds);
                    vm.clientTemplates.titlesNL.INVOICE_WITH_PDF_AND_CSV = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_TITLE', actionType: 'INVOICE_WITH_CUSTOMIZED_CSV', language: 'nl' }, true), vm.dhlClientEmailTempaltesIds);
                    vm.clientTemplates.titlesNL.INVOICE_WITH_CUSTOMIZED_CSV = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_TITLE', actionType: 'INVOICE_WITH_CUSTOMIZED_PDF_AND_CSV', language: 'nl' }, true), vm.dhlClientEmailTempaltesIds);
                    vm.clientTemplates.titlesNL.INVOICE_WITH_CUSTOMIZED_PDF_AND_CSV = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    // id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_TITLE', actionType: 'CORRECTION_INVOICE', language: 'nl' }, true), vm.dhlClientEmailTempaltesIds);
                    // vm.clientTemplates.titlesNL.CORRECTION_INVOICE = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_TITLE', actionType: 'INVOICE_TOO_LARGE', language: 'nl' }, true), vm.dhlClientEmailTempaltesIds);
                    vm.clientTemplates.titlesNL.INVOICE_TOO_LARGE = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];




                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_CONTENT', actionType: 'ACCOUNT_OPENED', language: 'nl' }, true), vm.dhlClientEmailTempaltesIds);
                    vm.clientTemplates.templatesNL.ACCOUNT_OPENED = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_CONTENT', actionType: 'EMAIL_ADDED', language: 'nl' }, true), vm.dhlClientEmailTempaltesIds);
                    vm.clientTemplates.templatesNL.EMAIL_ADDED = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_CONTENT', actionType: 'REGISTRATION_FAIL', language: 'nl' }, true), vm.dhlClientEmailTempaltesIds);
                    vm.clientTemplates.templatesNL.REGISTRATION_FAIL = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_CONTENT', actionType: 'PASSWORD_CHANGE', language: 'nl' }, true), vm.dhlClientEmailTempaltesIds);
                    vm.clientTemplates.templatesNL.PASSWORD_CHANGE = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_CONTENT', actionType: 'INVOICE_WITH_LINK', language: 'nl' }, true), vm.dhlClientEmailTempaltesIds);
                    vm.clientTemplates.templatesNL.INVOICE_WITH_LINK = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_CONTENT', actionType: 'INVOICE_WITH_PDF', language: 'nl' }, true), vm.dhlClientEmailTempaltesIds);
                    vm.clientTemplates.templatesNL.INVOICE_WITH_PDF = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_CONTENT', actionType: 'INVOICE_WITH_LINK_AND_XLSX', language: 'nl' }, true), vm.dhlClientEmailTempaltesIds);
                    vm.clientTemplates.templatesNL.INVOICE_WITH_LINK_AND_XLSX = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_CONTENT', actionType: 'INVOICE_WITH_PDF_AND_XLSX', language: 'nl' }, true), vm.dhlClientEmailTempaltesIds);
                    vm.clientTemplates.templatesNL.INVOICE_WITH_PDF_AND_XLSX = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_CONTENT', actionType: 'INVOICE_WITH_PDF_AND_CSV', language: 'nl' }, true), vm.dhlClientEmailTempaltesIds);
                    vm.clientTemplates.templatesNL.INVOICE_WITH_PDF_AND_CSV = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_CONTENT', actionType: 'INVOICE_WITH_CUSTOMIZED_CSV', language: 'nl' }, true), vm.dhlClientEmailTempaltesIds);
                    vm.clientTemplates.templatesNL.INVOICE_WITH_CUSTOMIZED_CSV = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_CONTENT', actionType: 'INVOICE_WITH_CUSTOMIZED_PDF_AND_CSV', language: 'nl' }, true), vm.dhlClientEmailTempaltesIds);
                    vm.clientTemplates.templatesNL.INVOICE_WITH_CUSTOMIZED_PDF_AND_CSV = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    // id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_CONTENT', actionType: 'CORRECTION_INVOICE', language: 'nl' }, true), vm.dhlClientEmailTempaltesIds);
                    // vm.clientTemplates.templatesNL.CORRECTION_INVOICE = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_CONTENT', actionType: 'INVOICE_TOO_LARGE', language: 'nl' }, true), vm.dhlClientEmailTempaltesIds);
                    vm.clientTemplates.templatesNL.INVOICE_TOO_LARGE = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];




                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_TITLE', actionType: 'ACCOUNT_OPENED', language: 'en' }, true), vm.dhlClientEmailTempaltesIds);
                    vm.clientTemplates.titlesEN.ACCOUNT_OPENED = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_TITLE', actionType: 'EMAIL_ADDED', language: 'en' }, true), vm.dhlClientEmailTempaltesIds);
                    vm.clientTemplates.titlesEN.EMAIL_ADDED = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_TITLE', actionType: 'REGISTRATION_FAIL', language: 'en' }, true), vm.dhlClientEmailTempaltesIds);
                    vm.clientTemplates.titlesEN.REGISTRATION_FAIL = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_TITLE', actionType: 'PASSWORD_CHANGE', language: 'en' }, true), vm.dhlClientEmailTempaltesIds);
                    vm.clientTemplates.titlesEN.PASSWORD_CHANGE = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_TITLE', actionType: 'INVOICE_WITH_LINK', language: 'en' }, true), vm.dhlClientEmailTempaltesIds);
                    vm.clientTemplates.titlesEN.INVOICE_WITH_LINK = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_TITLE', actionType: 'INVOICE_WITH_PDF', language: 'en' }, true), vm.dhlClientEmailTempaltesIds);
                    vm.clientTemplates.titlesEN.INVOICE_WITH_PDF = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_TITLE', actionType: 'INVOICE_WITH_LINK_AND_XLSX', language: 'en' }, true), vm.dhlClientEmailTempaltesIds);
                    vm.clientTemplates.titlesEN.INVOICE_WITH_LINK_AND_XLSX = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_TITLE', actionType: 'INVOICE_WITH_PDF_AND_XLSX', language: 'en' }, true), vm.dhlClientEmailTempaltesIds);
                    vm.clientTemplates.titlesEN.INVOICE_WITH_PDF_AND_XLSX = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_TITLE', actionType: 'INVOICE_WITH_PDF_AND_CSV', language: 'en' }, true), vm.dhlClientEmailTempaltesIds);
                    vm.clientTemplates.titlesEN.INVOICE_WITH_PDF_AND_CSV = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_TITLE', actionType: 'INVOICE_WITH_CUSTOMIZED_CSV', language: 'en' }, true), vm.dhlClientEmailTempaltesIds);
                    vm.clientTemplates.titlesEN.INVOICE_WITH_CUSTOMIZED_CSV = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_TITLE', actionType: 'INVOICE_WITH_CUSTOMIZED_PDF_AND_CSV', language: 'en' }, true), vm.dhlClientEmailTempaltesIds);
                    vm.clientTemplates.titlesEN.INVOICE_WITH_CUSTOMIZED_PDF_AND_CSV = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    // id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_TITLE', actionType: 'CORRECTION_INVOICE', language: 'en' }, true), vm.dhlClientEmailTempaltesIds);
                    // vm.clientTemplates.titlesEN.CORRECTION_INVOICE = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_TITLE', actionType: 'INVOICE_TOO_LARGE', language: 'en' }, true), vm.dhlClientEmailTempaltesIds);
                    vm.clientTemplates.titlesEN.INVOICE_TOO_LARGE = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];




                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_CONTENT', actionType: 'ACCOUNT_OPENED', language: 'en' }, true), vm.dhlClientEmailTempaltesIds);
                    vm.clientTemplates.templatesEN.ACCOUNT_OPENED = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_CONTENT', actionType: 'EMAIL_ADDED', language: 'en' }, true), vm.dhlClientEmailTempaltesIds);
                    vm.clientTemplates.templatesEN.EMAIL_ADDED = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_CONTENT', actionType: 'REGISTRATION_FAIL', language: 'en' }, true), vm.dhlClientEmailTempaltesIds);
                    vm.clientTemplates.templatesEN.REGISTRATION_FAIL = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_CONTENT', actionType: 'PASSWORD_CHANGE', language: 'en' }, true), vm.dhlClientEmailTempaltesIds);
                    vm.clientTemplates.templatesEN.PASSWORD_CHANGE = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_CONTENT', actionType: 'INVOICE_WITH_LINK', language: 'en' }, true), vm.dhlClientEmailTempaltesIds);
                    vm.clientTemplates.templatesEN.INVOICE_WITH_LINK = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_CONTENT', actionType: 'INVOICE_WITH_PDF', language: 'en' }, true), vm.dhlClientEmailTempaltesIds);
                    vm.clientTemplates.templatesEN.INVOICE_WITH_PDF = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_CONTENT', actionType: 'INVOICE_WITH_LINK_AND_XLSX', language: 'en' }, true), vm.dhlClientEmailTempaltesIds);
                    vm.clientTemplates.templatesEN.INVOICE_WITH_LINK_AND_XLSX = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_CONTENT', actionType: 'INVOICE_WITH_PDF_AND_XLSX', language: 'en' }, true), vm.dhlClientEmailTempaltesIds);
                    vm.clientTemplates.templatesEN.INVOICE_WITH_PDF_AND_XLSX = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_CONTENT', actionType: 'INVOICE_WITH_PDF_AND_CSV', language: 'en' }, true), vm.dhlClientEmailTempaltesIds);
                    vm.clientTemplates.templatesEN.INVOICE_WITH_PDF_AND_CSV = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_CONTENT', actionType: 'INVOICE_WITH_CUSTOMIZED_CSV', language: 'en' }, true), vm.dhlClientEmailTempaltesIds);
                    vm.clientTemplates.templatesEN.INVOICE_WITH_CUSTOMIZED_CSV = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_CONTENT', actionType: 'INVOICE_WITH_CUSTOMIZED_PDF_AND_CSV', language: 'en' }, true), vm.dhlClientEmailTempaltesIds);
                    vm.clientTemplates.templatesEN.INVOICE_WITH_CUSTOMIZED_PDF_AND_CSV = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    // id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_CONTENT', actionType: 'CORRECTION_INVOICE', language: 'en' }, true), vm.dhlClientEmailTempaltesIds);
                    // vm.clientTemplates.templatesEN.CORRECTION_INVOICE = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_CONTENT', actionType: 'INVOICE_TOO_LARGE', language: 'en' }, true), vm.dhlClientEmailTempaltesIds);
                    vm.clientTemplates.templatesEN.INVOICE_TOO_LARGE = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];


                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_TITLE', actionType: 'ACCOUNT_OPENED', language: 'fr' }, true), vm.dhlClientEmailTempaltesIds);
                    vm.clientTemplates.titlesFR.ACCOUNT_OPENED = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_TITLE', actionType: 'EMAIL_ADDED', language: 'fr' }, true), vm.dhlClientEmailTempaltesIds);
                    vm.clientTemplates.titlesFR.EMAIL_ADDED = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_TITLE', actionType: 'REGISTRATION_FAIL', language: 'fr' }, true), vm.dhlClientEmailTempaltesIds);
                    vm.clientTemplates.titlesFR.REGISTRATION_FAIL = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_TITLE', actionType: 'PASSWORD_CHANGE', language: 'fr' }, true), vm.dhlClientEmailTempaltesIds);
                    vm.clientTemplates.titlesFR.PASSWORD_CHANGE = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_TITLE', actionType: 'INVOICE_WITH_LINK', language: 'fr' }, true), vm.dhlClientEmailTempaltesIds);
                    vm.clientTemplates.titlesFR.INVOICE_WITH_LINK = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_TITLE', actionType: 'INVOICE_WITH_PDF', language: 'fr' }, true), vm.dhlClientEmailTempaltesIds);
                    vm.clientTemplates.titlesFR.INVOICE_WITH_PDF = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_TITLE', actionType: 'INVOICE_WITH_LINK_AND_XLSX', language: 'fr' }, true), vm.dhlClientEmailTempaltesIds);
                    vm.clientTemplates.titlesFR.INVOICE_WITH_LINK_AND_XLSX = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_TITLE', actionType: 'INVOICE_WITH_PDF_AND_XLSX', language: 'fr' }, true), vm.dhlClientEmailTempaltesIds);
                    vm.clientTemplates.titlesFR.INVOICE_WITH_PDF_AND_XLSX = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_TITLE', actionType: 'INVOICE_WITH_PDF_AND_CSV', language: 'fr' }, true), vm.dhlClientEmailTempaltesIds);
                    vm.clientTemplates.titlesFR.INVOICE_WITH_PDF_AND_CSV = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_TITLE', actionType: 'INVOICE_WITH_CUSTOMIZED_CSV', language: 'fr' }, true), vm.dhlClientEmailTempaltesIds);
                    vm.clientTemplates.titlesFR.INVOICE_WITH_CUSTOMIZED_CSV = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_TITLE', actionType: 'INVOICE_WITH_CUSTOMIZED_PDF_AND_CSV', language: 'fr' }, true), vm.dhlClientEmailTempaltesIds);
                    vm.clientTemplates.titlesFR.INVOICE_WITH_CUSTOMIZED_PDF_AND_CSV = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    // id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_TITLE', actionType: 'CORRECTION_INVOICE', language: 'fr' }, true), vm.dhlClientEmailTempaltesIds);
                    // vm.clientTemplates.titlesFR.CORRECTION_INVOICE = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_TITLE', actionType: 'INVOICE_TOO_LARGE', language: 'fr' }, true), vm.dhlClientEmailTempaltesIds);
                    vm.clientTemplates.titlesFR.INVOICE_TOO_LARGE = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];




                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_CONTENT', actionType: 'ACCOUNT_OPENED', language: 'fr' }, true), vm.dhlClientEmailTempaltesIds);
                    vm.clientTemplates.templatesFR.ACCOUNT_OPENED = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_CONTENT', actionType: 'EMAIL_ADDED', language: 'fr' }, true), vm.dhlClientEmailTempaltesIds);
                    vm.clientTemplates.templatesFR.EMAIL_ADDED = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_CONTENT', actionType: 'REGISTRATION_FAIL', language: 'fr' }, true), vm.dhlClientEmailTempaltesIds);
                    vm.clientTemplates.templatesFR.REGISTRATION_FAIL = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_CONTENT', actionType: 'PASSWORD_CHANGE', language: 'fr' }, true), vm.dhlClientEmailTempaltesIds);
                    vm.clientTemplates.templatesFR.PASSWORD_CHANGE = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_CONTENT', actionType: 'INVOICE_WITH_LINK', language: 'fr' }, true), vm.dhlClientEmailTempaltesIds);
                    vm.clientTemplates.templatesFR.INVOICE_WITH_LINK = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_CONTENT', actionType: 'INVOICE_WITH_PDF', language: 'fr' }, true), vm.dhlClientEmailTempaltesIds);
                    vm.clientTemplates.templatesFR.INVOICE_WITH_PDF = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_CONTENT', actionType: 'INVOICE_WITH_LINK_AND_XLSX', language: 'fr' }, true), vm.dhlClientEmailTempaltesIds);
                    vm.clientTemplates.templatesFR.INVOICE_WITH_LINK_AND_XLSX = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_CONTENT', actionType: 'INVOICE_WITH_PDF_AND_XLSX', language: 'fr' }, true), vm.dhlClientEmailTempaltesIds);
                    vm.clientTemplates.templatesFR.INVOICE_WITH_PDF_AND_XLSX = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_CONTENT', actionType: 'INVOICE_WITH_PDF_AND_CSV', language: 'fr' }, true), vm.dhlClientEmailTempaltesIds);
                    vm.clientTemplates.templatesFR.INVOICE_WITH_PDF_AND_CSV = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_CONTENT', actionType: 'INVOICE_WITH_CUSTOMIZED_CSV', language: 'fr' }, true), vm.dhlClientEmailTempaltesIds);
                    vm.clientTemplates.templatesFR.INVOICE_WITH_CUSTOMIZED_CSV = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_CONTENT', actionType: 'INVOICE_WITH_CUSTOMIZED_PDF_AND_CSV', language: 'fr' }, true), vm.dhlClientEmailTempaltesIds);
                    vm.clientTemplates.templatesFR.INVOICE_WITH_CUSTOMIZED_PDF_AND_CSV = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    // id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_CONTENT', actionType: 'CORRECTION_INVOICE', language: 'fr' }, true), vm.dhlClientEmailTempaltesIds);
                    // vm.clientTemplates.templatesFR.CORRECTION_INVOICE = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_CONTENT', actionType: 'INVOICE_TOO_LARGE', language: 'fr' }, true), vm.dhlClientEmailTempaltesIds);
                    vm.clientTemplates.templatesFR.INVOICE_TOO_LARGE = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];




                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_TITLE', actionType: 'ACCOUNT_OPENED', language: 'de' }, true), vm.dhlClientEmailTempaltesIds);
                    vm.clientTemplates.titlesDE.ACCOUNT_OPENED = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_TITLE', actionType: 'EMAIL_ADDED', language: 'de' }, true), vm.dhlClientEmailTempaltesIds);
                    vm.clientTemplates.titlesDE.EMAIL_ADDED = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_TITLE', actionType: 'REGISTRATION_FAIL', language: 'de' }, true), vm.dhlClientEmailTempaltesIds);
                    vm.clientTemplates.titlesDE.REGISTRATION_FAIL = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_TITLE', actionType: 'PASSWORD_CHANGE', language: 'de' }, true), vm.dhlClientEmailTempaltesIds);
                    vm.clientTemplates.titlesDE.PASSWORD_CHANGE = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_TITLE', actionType: 'INVOICE_WITH_LINK', language: 'de' }, true), vm.dhlClientEmailTempaltesIds);
                    vm.clientTemplates.titlesDE.INVOICE_WITH_LINK = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_TITLE', actionType: 'INVOICE_WITH_PDF', language: 'de' }, true), vm.dhlClientEmailTempaltesIds);
                    vm.clientTemplates.titlesDE.INVOICE_WITH_PDF = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_TITLE', actionType: 'INVOICE_WITH_LINK_AND_XLSX', language: 'de' }, true), vm.dhlClientEmailTempaltesIds);
                    vm.clientTemplates.titlesDE.INVOICE_WITH_LINK_AND_XLSX = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_TITLE', actionType: 'INVOICE_WITH_PDF_AND_XLSX', language: 'de' }, true), vm.dhlClientEmailTempaltesIds);
                    vm.clientTemplates.titlesDE.INVOICE_WITH_PDF_AND_XLSX = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_TITLE', actionType: 'INVOICE_WITH_PDF_AND_CSV', language: 'de' }, true), vm.dhlClientEmailTempaltesIds);
                    vm.clientTemplates.titlesDE.INVOICE_WITH_PDF_AND_CSV = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_TITLE', actionType: 'INVOICE_WITH_CUSTOMIZED_CSV', language: 'de' }, true), vm.dhlClientEmailTempaltesIds);
                    vm.clientTemplates.titlesDE.INVOICE_WITH_CUSTOMIZED_CSV = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_TITLE', actionType: 'INVOICE_WITH_CUSTOMIZED_PDF_AND_CSV', language: 'de' }, true), vm.dhlClientEmailTempaltesIds);
                    vm.clientTemplates.titlesDE.INVOICE_WITH_CUSTOMIZED_PDF_AND_CSV = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    // id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_TITLE', actionType: 'CORRECTION_INVOICE', language: 'de' }, true), vm.dhlClientEmailTempaltesIds);
                    // vm.clientTemplates.titlesDE.CORRECTION_INVOICE = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_TITLE', actionType: 'INVOICE_TOO_LARGE', language: 'de' }, true), vm.dhlClientEmailTempaltesIds);
                    vm.clientTemplates.titlesDE.INVOICE_TOO_LARGE = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];




                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_CONTENT', actionType: 'ACCOUNT_OPENED', language: 'de' }, true), vm.dhlClientEmailTempaltesIds);
                    vm.clientTemplates.templatesDE.ACCOUNT_OPENED = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_CONTENT', actionType: 'EMAIL_ADDED', language: 'de' }, true), vm.dhlClientEmailTempaltesIds);
                    vm.clientTemplates.templatesDE.EMAIL_ADDED = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_CONTENT', actionType: 'REGISTRATION_FAIL', language: 'de' }, true), vm.dhlClientEmailTempaltesIds);
                    vm.clientTemplates.templatesDE.REGISTRATION_FAIL = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_CONTENT', actionType: 'PASSWORD_CHANGE', language: 'de' }, true), vm.dhlClientEmailTempaltesIds);
                    vm.clientTemplates.templatesDE.PASSWORD_CHANGE = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_CONTENT', actionType: 'INVOICE_WITH_LINK', language: 'de' }, true), vm.dhlClientEmailTempaltesIds);
                    vm.clientTemplates.templatesDE.INVOICE_WITH_LINK = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_CONTENT', actionType: 'INVOICE_WITH_PDF', language: 'de' }, true), vm.dhlClientEmailTempaltesIds);
                    vm.clientTemplates.templatesDE.INVOICE_WITH_PDF = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_CONTENT', actionType: 'INVOICE_WITH_LINK_AND_XLSX', language: 'de' }, true), vm.dhlClientEmailTempaltesIds);
                    vm.clientTemplates.templatesDE.INVOICE_WITH_LINK_AND_XLSX = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_CONTENT', actionType: 'INVOICE_WITH_PDF_AND_XLSX', language: 'de' }, true), vm.dhlClientEmailTempaltesIds);
                    vm.clientTemplates.templatesDE.INVOICE_WITH_PDF_AND_XLSX = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_CONTENT', actionType: 'INVOICE_WITH_PDF_AND_CSV', language: 'de' }, true), vm.dhlClientEmailTempaltesIds);
                    vm.clientTemplates.templatesDE.INVOICE_WITH_PDF_AND_CSV = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_CONTENT', actionType: 'INVOICE_WITH_CUSTOMIZED_CSV', language: 'de' }, true), vm.dhlClientEmailTempaltesIds);
                    vm.clientTemplates.templatesDE.INVOICE_WITH_CUSTOMIZED_CSV = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_CONTENT', actionType: 'INVOICE_WITH_CUSTOMIZED_PDF_AND_CSV', language: 'de' }, true), vm.dhlClientEmailTempaltesIds);
                    vm.clientTemplates.templatesDE.INVOICE_WITH_CUSTOMIZED_PDF_AND_CSV = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    // id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_CONTENT', actionType: 'CORRECTION_INVOICE', language: 'de' }, true), vm.dhlClientEmailTempaltesIds);
                    // vm.clientTemplates.templatesDE.CORRECTION_INVOICE = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                    id = vm.getCommonElementFromLists(filterFilter(vm.dhlEmailTempaltes, { type: 'EMAIL_CONTENT', actionType: 'INVOICE_TOO_LARGE', language: 'de' }, true), vm.dhlClientEmailTempaltesIds);
                    vm.clientTemplates.templatesDE.INVOICE_TOO_LARGE = (filterFilter(vm.dhlEmailTempaltes, { ediTemplateId: id }))[0];

                }).catch(function(response) {
                    vm.clientErrorText = $translate.instant("clients.client.templatesDownloadFailed");
                    vm.clientSuccessText = null;
                });
            }
        }

        function getCommonElementFromLists(list1, list2) {
            var id;
            angular.forEach(list1, function(value, key) {
                if (list2.indexOf(value.ediTemplateId) > -1) {
                    id = value.ediTemplateId;
                }
            });
            return id;
        }

        //client + listofid
        function sendNewUserTemplates() {
            if (Principal.hasTemplateAccess()) {
                vm.templatesToSend = [];

                vm.templatesToSend.push(vm.clientTemplates.titlesNL.ACCOUNT_OPENED.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.titlesNL.EMAIL_ADDED.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.titlesNL.REGISTRATION_FAIL.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.titlesNL.PASSWORD_CHANGE.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.titlesNL.INVOICE_WITH_LINK.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.titlesNL.INVOICE_WITH_PDF.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.titlesNL.INVOICE_WITH_LINK_AND_XLSX.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.titlesNL.INVOICE_WITH_PDF_AND_XLSX.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.titlesNL.INVOICE_WITH_PDF_AND_CSV.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.titlesNL.INVOICE_WITH_CUSTOMIZED_CSV.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.titlesNL.INVOICE_WITH_CUSTOMIZED_PDF_AND_CSV.ediTemplateId);
                // vm.templatesToSend.push(vm.clientTemplates.titlesNL.CORRECTION_INVOICE.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.titlesNL.INVOICE_TOO_LARGE.ediTemplateId);

                vm.templatesToSend.push(vm.clientTemplates.templatesNL.ACCOUNT_OPENED.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.templatesNL.EMAIL_ADDED.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.templatesNL.REGISTRATION_FAIL.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.templatesNL.PASSWORD_CHANGE.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.templatesNL.INVOICE_WITH_LINK.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.templatesNL.INVOICE_WITH_PDF.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.templatesNL.INVOICE_WITH_LINK_AND_XLSX.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.templatesNL.INVOICE_WITH_PDF_AND_XLSX.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.templatesNL.INVOICE_WITH_PDF_AND_CSV.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.templatesNL.INVOICE_WITH_CUSTOMIZED_CSV.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.templatesNL.INVOICE_WITH_CUSTOMIZED_PDF_AND_CSV.ediTemplateId);
                // vm.templatesToSend.push(vm.clientTemplates.templatesNL.CORRECTION_INVOICE.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.templatesNL.INVOICE_TOO_LARGE.ediTemplateId);

                vm.templatesToSend.push(vm.clientTemplates.titlesEN.ACCOUNT_OPENED.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.titlesEN.EMAIL_ADDED.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.titlesEN.REGISTRATION_FAIL.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.titlesEN.PASSWORD_CHANGE.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.titlesEN.INVOICE_WITH_LINK.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.titlesEN.INVOICE_WITH_PDF.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.titlesEN.INVOICE_WITH_LINK_AND_XLSX.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.titlesEN.INVOICE_WITH_PDF_AND_XLSX.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.titlesEN.INVOICE_WITH_PDF_AND_CSV.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.titlesEN.INVOICE_WITH_CUSTOMIZED_CSV.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.titlesEN.INVOICE_WITH_CUSTOMIZED_PDF_AND_CSV.ediTemplateId);
                // vm.templatesToSend.push(vm.clientTemplates.titlesEN.CORRECTION_INVOICE.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.titlesEN.INVOICE_TOO_LARGE.ediTemplateId);

                vm.templatesToSend.push(vm.clientTemplates.templatesEN.ACCOUNT_OPENED.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.templatesEN.EMAIL_ADDED.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.templatesEN.REGISTRATION_FAIL.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.templatesEN.PASSWORD_CHANGE.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.templatesEN.INVOICE_WITH_LINK.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.templatesEN.INVOICE_WITH_PDF.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.templatesEN.INVOICE_WITH_LINK_AND_XLSX.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.templatesEN.INVOICE_WITH_PDF_AND_XLSX.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.templatesEN.INVOICE_WITH_PDF_AND_CSV.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.templatesEN.INVOICE_WITH_CUSTOMIZED_CSV.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.templatesEN.INVOICE_WITH_CUSTOMIZED_PDF_AND_CSV.ediTemplateId);
                // vm.templatesToSend.push(vm.clientTemplates.templatesEN.CORRECTION_INVOICE.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.templatesEN.INVOICE_TOO_LARGE.ediTemplateId);

                vm.templatesToSend.push(vm.clientTemplates.titlesFR.ACCOUNT_OPENED.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.titlesFR.EMAIL_ADDED.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.titlesFR.REGISTRATION_FAIL.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.titlesFR.PASSWORD_CHANGE.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.titlesFR.INVOICE_WITH_LINK.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.titlesFR.INVOICE_WITH_PDF.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.titlesFR.INVOICE_WITH_LINK_AND_XLSX.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.titlesFR.INVOICE_WITH_PDF_AND_XLSX.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.titlesFR.INVOICE_WITH_PDF_AND_CSV.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.titlesFR.INVOICE_WITH_CUSTOMIZED_CSV.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.titlesFR.INVOICE_WITH_CUSTOMIZED_PDF_AND_CSV.ediTemplateId);
                // vm.templatesToSend.push(vm.clientTemplates.titlesFR.CORRECTION_INVOICE.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.titlesFR.INVOICE_TOO_LARGE.ediTemplateId);

                vm.templatesToSend.push(vm.clientTemplates.templatesFR.ACCOUNT_OPENED.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.templatesFR.EMAIL_ADDED.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.templatesFR.REGISTRATION_FAIL.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.templatesFR.PASSWORD_CHANGE.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.templatesFR.INVOICE_WITH_LINK.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.templatesFR.INVOICE_WITH_PDF.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.templatesFR.INVOICE_WITH_LINK_AND_XLSX.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.templatesFR.INVOICE_WITH_PDF_AND_XLSX.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.templatesFR.INVOICE_WITH_PDF_AND_CSV.ediTemplateId);
                // vm.templatesToSend.push(vm.clientTemplates.templatesFR.CORRECTION_INVOICE.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.templatesFR.INVOICE_TOO_LARGE.ediTemplateId);

                vm.templatesToSend.push(vm.clientTemplates.titlesDE.ACCOUNT_OPENED.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.titlesDE.EMAIL_ADDED.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.titlesDE.REGISTRATION_FAIL.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.titlesDE.PASSWORD_CHANGE.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.titlesDE.INVOICE_WITH_LINK.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.titlesDE.INVOICE_WITH_PDF.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.titlesDE.INVOICE_WITH_LINK_AND_XLSX.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.titlesDE.INVOICE_WITH_PDF_AND_XLSX.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.titlesDE.INVOICE_WITH_PDF_AND_CSV.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.titlesDE.INVOICE_WITH_CUSTOMIZED_CSV.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.titlesDE.INVOICE_WITH_CUSTOMIZED_PDF_AND_CSV.ediTemplateId);
                // vm.templatesToSend.push(vm.clientTemplates.titlesDE.CORRECTION_INVOICE.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.titlesDE.INVOICE_TOO_LARGE.ediTemplateId);

                vm.templatesToSend.push(vm.clientTemplates.templatesDE.ACCOUNT_OPENED.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.templatesDE.EMAIL_ADDED.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.templatesDE.REGISTRATION_FAIL.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.templatesDE.PASSWORD_CHANGE.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.templatesDE.INVOICE_WITH_LINK.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.templatesDE.INVOICE_WITH_PDF.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.templatesDE.INVOICE_WITH_LINK_AND_XLSX.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.templatesDE.INVOICE_WITH_PDF_AND_XLSX.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.templatesDE.INVOICE_WITH_PDF_AND_CSV.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.templatesDE.INVOICE_WITH_CUSTOMIZED_CSV.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.templatesDE.INVOICE_WITH_CUSTOMIZED_PDF_AND_CSV.ediTemplateId);
                // vm.templatesToSend.push(vm.clientTemplates.templatesDE.CORRECTION_INVOICE.ediTemplateId);
                vm.templatesToSend.push(vm.clientTemplates.templatesDE.INVOICE_TOO_LARGE.ediTemplateId);

                ClientsService.postClientTemplates(vm.data.client.ediClientId, vm.templatesToSend).then(function(response) {
                    vm.clientErrorText = null;
                    vm.clientSuccessText = $translate.instant("clients.client.templatesEditSuccess");
                }).catch(function(response) {
                    vm.clientErrorText = $translate.instant("clients.client.templatesEditFail");
                    vm.clientSuccessText = null;
                });
            }
        }

        //Init controller
        vm.init();
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .factory('UtilService', UtilService);

    UtilService.$inject = ['$http'];

    function UtilService($http) {
        var Srvc = {
            get: get,
            getNIPPattern: getNIPPattern,
            isFilled: isFilled,
            nullsToEmptyStrings: nullsToEmptyStrings,
            emptyStringsToNulls: emptyStringsToNulls,
            starsToPercents: starsToPercents
        };

        return Srvc;

        function get(from, what, filter, data) {
            return $http({
                method: 'GET',
                url: removeCacheBuster(from._links[what].href),
                params: filter,
                data: data
            });
        }

        function getNIPPattern()/*(legalEntity)*/ {
            // if(legalEntity === 'BE') {
            //     return {maxlength: 15, regex: "^(BE)?(\\s)?[0-9]{4}\\.?[0-9]{3}\\.?[0-9]{3}$" };
            // } else {
            //     return {maxlength: 14, regex: "^[a-zA-Z0-9]{14}$" };
            // }
            return {minlength: 9, maxlength: 13, regex: "^[0-9]*$" };
        }

        function removeCacheBuster(url) {
            var tempUrl = url.replace(new RegExp('&amp;', 'g'), '&');
            var cacheBusterIndex = tempUrl.indexOf("cacheBuster");
            if (cacheBusterIndex != -1) {
                var nextAmpersandIndex = tempUrl.indexOf("&", cacheBusterIndex);

                if (nextAmpersandIndex != -1)
                    tempUrl = tempUrl.substr(0, cacheBusterIndex) + tempUrl.substr(nextAmpersandIndex, tempUrl.length);
                else
                    tempUrl = tempUrl.substr(0, cacheBusterIndex);
            }
            return tempUrl;
        }

        function isFilled(object) {
            if (object != null && object !== '' && object === object)
                return true;
            if (typeof object === 'object') {
                for (var param in object) {
                    if (isFilled(object[param]))
                        return true;
                }
            }
            return false;
        }

        function nullsToEmptyStrings(filter) {
            var requestFilter = angular.copy(filter);

            for (var fieldIndex in requestFilter) {
                if (requestFilter[fieldIndex] == null) {
                    requestFilter[fieldIndex] = "";
                }
            }
            return requestFilter;
        }

        function emptyStringsToNulls(filter) {
            var requestFilter = angular.copy(filter);

            for (var fieldIndex in requestFilter) {
                if (requestFilter[fieldIndex] == "") {
                    requestFilter[fieldIndex] = null;
                }
            }
            return requestFilter;
        }

        function starsToPercents(filter) {
            var requestFilter = angular.copy(filter);

            for (var fieldIndex in requestFilter) {
                if (typeof requestFilter[fieldIndex] == "string")
                    requestFilter[fieldIndex] = requestFilter[fieldIndex].replace(/\*/g, '%');
                else if (requestFilter[fieldIndex] instanceof Array)
                    for (var element in requestFilter[fieldIndex])
                        requestFilter[fieldIndex][element] = requestFilter[fieldIndex][element].replace(/\*/g, '%');
            }
            return requestFilter;
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .factory('User', User);

    User.$inject = ['$resource'];

    function User ($resource) {
        var service = $resource('api/users/:login', {}, {
            'query': {method: 'GET', isArray: true},
            'get': {
                method: 'GET',
                transformResponse: function (data) {
                    data = angular.fromJson(data);
                    return data;
                }
            },
            'save': { method:'POST' },
            'update': { method:'PUT' },
            'delete':{ method:'DELETE'}
        });

        return service;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .factory('ProfileService', ProfileService);

    ProfileService.$inject = ['$q', '$http'];

    function ProfileService($q, $http) {

        var dataPromise;

        var service = {
            getProfileInfo : getProfileInfo
        };

        return service;

        function getProfileInfo() {
            if (angular.isUndefined(dataPromise)) {
                dataPromise = $http.get('api/profile-info').then(function(result) {
                    if (result.data.activeProfiles) {
                        var response = {};
                        response.activeProfiles = result.data.activeProfiles;
                        response.ribbonEnv = result.data.ribbonEnv;
                        response.inProduction = result.data.activeProfiles.indexOf("prod") !== -1;
                        response.swaggerDisabled = result.data.activeProfiles.indexOf("no-swagger") !== -1;
                        return response;
                    }
                });
            }
            return dataPromise;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .directive('pageRibbon', pageRibbon);

    pageRibbon.$inject = ['ProfileService', '$rootScope', '$translate'];

    function pageRibbon(ProfileService, $rootScope, $translate) {
        var directive = {
            replace : true,
            restrict : 'AE',
            template : '<div class="ribbon hidden"><a href="" translate="global.ribbon.{{ribbonEnv}}">{{ribbonEnv}}</a></div>',
            link : linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            ProfileService.getProfileInfo().then(function(response) {
                if (response.ribbonEnv) {
                    scope.ribbonEnv = response.ribbonEnv;
                    element.addClass(response.ribbonEnv);
                    element.removeClass('hidden');
                }
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .factory('UsersService', UsersService);

    UsersService.$inject = ['$rootScope', '$http', 'UtilService', 'GenerateURL', 'Principal'];

    function UsersService($rootScope, $http, UtilService, GenerateURL, Principal) {
        var usersService = {
            activate: activate,
            activityReport: activityReport,
            addClient: addClient,
            changeRoles: changeRoles,
            checkNewUsersPasswordValid: checkNewUsersPasswordValid,
            checkPasswordExpireDays: checkPasswordExpireDays,
            checkPasswordResetLink: checkPasswordResetLink,
            create: create,
            createNewUser: createNewUser,
            deactivate: deactivate,
            delete: deleteUser,
            findByEmail: findByEmail,
            get: get,
            getDetails: getDetails,
            getEmailsLike: getEmailsLike,
            getUserDates: getUserDates,
            getFirstActivationDate: getFirstActivationDate,
            getLastActivityDate: getLastActivityDate,
            getLastFailedLoginDate: getLastFailedLoginDate,
            getLastFailLoginDate: getLastFailLoginDate,
            getLastSuccessfulLoginDate: getLastSuccessfulLoginDate,
            getOnePagePdfConfiguration: getOnePagePdfConfiguration,
            isEmailUnique: isEmailUnique,
            isEmailUniqueOtherSN: isEmailUniqueOtherSN,
            list: list,
            listWithParams: listWithParams,
            isLocked: isLocked,
            postChanges: postChanges,
            getLanguage: getLanguage,
            removeAllClients: removeAllClients,
            removeClient: removeClient,
            requestResetOwnPassword: requestResetOwnPassword,
            resetOwnPassword: resetOwnPassword,
            resetPassword: resetPassword,
            setOnePagePdf: setOnePagePdf,
            unlock: unlock,
            lock: lock,
            usersReport: usersReport,
            getActivityReportURL: getActivityReportURL,
            getUsersReportURL: getUsersReportURL
        };

        return usersService;

        function get(email) {
            return $http({
                method: 'GET',
                url: $rootScope.API_URL + 'api/beneluxUsers/search/getByEmailContainingIgnoreCase',
                params: { email: email.toLowerCase() }
            });
        }

        function list(filter) {
            return $http({
                method: 'GET',
                url: $rootScope.API_URL + 'api/beneluxUsers',
                params: UtilService.nullsToEmptyStrings(filter)
            });
        }

        function listWithParams(filter) {
            return $http({
                method: 'GET',
                url: $rootScope.API_URL + 'api/beneluxUsers/find' + Principal.getCurrentEntityCamelCase() + 'Users',
                params: UtilService.starsToPercents(UtilService.nullsToEmptyStrings(filter))
            });
        }

        function getEmailsLike(email) {
            return $http({
                method: 'GET',
                url: $rootScope.API_URL + 'api/beneluxUsers/search/findByEmailContainingIgnoreCase',
                params: UtilService.starsToPercents(UtilService.nullsToEmptyStrings(email))
            });
        }

        function create(user) {
            return $http({
                method: 'PUT',
                url: $rootScope.API_URL + 'api/beneluxUsers/create',
                data: user
            });
        }

        function deleteUser(UUID) {
            return $http({
                method: 'POST',
                url: $rootScope.API_URL + 'api/beneluxUsers/' + UUID + '/delete'
            });
        }

        function unlock(id) {
            return $http({
                method: 'POST',
                url: $rootScope.API_URL + 'api/beneluxUsers/' + id + '/unlock'
            });
        }

        function lock(id) {
            return $http({
                method: 'POST',
                url: $rootScope.API_URL + 'api/beneluxUsers/' + id + '/lock'
            });
        }

        function resetPassword(id) {
            return $http({
                method: 'POST',
                url: $rootScope.API_URL + 'api/beneluxUsers/' + id + '/resetPassword'
            });
        }

        function activate(id) {
            return $http({
                method: 'POST',
                url: $rootScope.API_URL + 'api/beneluxUsers/' + id + '/activate'
            });
        }

        function deactivate(id) {
            return $http({
                method: 'POST',
                url: $rootScope.API_URL + 'api/beneluxUsers/' + id + '/deactivate'
            });
        }

        function changeRoles(id, roles) {
            return $http({
                method: 'POST',
                url: $rootScope.API_URL + 'api/beneluxUsers/' + id + '/roles/change',
                data: { 'roleNames': roles }
            });
        }

        function usersReport(filter) {
            return $http({
                method: 'GET',
                url: $rootScope.API_URL + 'api/beneluxUsers/reports/users',
                params: UtilService.starsToPercents(UtilService.nullsToEmptyStrings(filter)),
                responseType: 'arraybuffer'
            });
        }

        function activityReport(filter) {
            return $http({
                method: 'GET',
                url: $rootScope.API_URL + 'api/beneluxUsers/reports/activity',
                params: UtilService.starsToPercents(UtilService.nullsToEmptyStrings(filter)),
                responseType: 'arraybuffer'
            });
        }

        function addClient(userId, email, clientNumber) {
            return $http({
                method: 'POST',
                url: $rootScope.API_URL + 'api/beneluxUsers/' + userId + '/clients/add',
                params: { email: email, clientNumber: clientNumber }
            });
        }

        function removeClient(userId, email, clientNumber) {
            return $http({
                method: 'DELETE',
                url: $rootScope.API_URL + 'api/beneluxUsers/' + userId + '/clients/remove',
                params: { email: email, clientNumber: clientNumber }
            });
        }

        function removeAllClients(userId, email) {
            return $http({
                method: 'DELETE',
                url: $rootScope.API_URL + 'api/beneluxUsers/' + userId + '/clients/removeAll',
                params: { email: email }
            })
        }

        function findByEmail(email) {
            return $http({
                method: 'GET',
                url: $rootScope.API_URL + 'api/beneluxUsers/byEmail/' + email.toLowerCase()
            });
        }

        function postChanges(userId, language) {
            return $http({
                method: 'POST',
                url: $rootScope.API_URL + 'api/beneluxUsers/' + userId + '/editLanguage',
                params: { language: language }
            });
        }

        function getLanguage(userId) {
            return $http({
                method: 'GET',
                url: $rootScope.API_URL + 'api/beneluxUsers/' + userId + '/language'
            });
        }

        function getLastFailLoginDate(name) {
            return $http({
                method: 'GET',
                url: $rootScope.API_URL + 'api/ediPartyUsersByName/' + name
            });
        }

        function setOnePagePdf(userId, onePagePdf) {
            return $http({
                method: 'POST',
                url: $rootScope.API_URL + 'api/beneluxUsers/' + userId + '/PdfPagesShow/edit',
                params: { onePagePdf: onePagePdf }
            });
        }

        function getOnePagePdfConfiguration(userId) {
            return $http({
                method: 'GET',
                url: $rootScope.API_URL + 'api/beneluxUsers/' + userId + '/getUserOnePagePdfConfiguration'
            });
        }

        function createNewUser(registerData) {
            return $http({
                method: 'POST',
                url: $rootScope.API_URL + 'api/beneluxUsers/registerRequest',
                data: registerData
            });
        }

        //checks uniqueness of email (user existence) in current source name
        function isEmailUnique(email) {
            return $http({
                method: 'GET',
                url: $rootScope.API_URL + 'api/beneluxUsers/isUniqueEmail',
                params: { email: email.toLowerCase() }
            });
        }

        //checks uniqueness of email (user existence) in other source names (all except current)
        function isEmailUniqueOtherSN(email) {
            return $http({
                method: 'GET',
                url: $rootScope.API_URL + 'api/beneluxUsers/isEmailUniqueOtherSN',
                params: { email: email.toLowerCase() }
            });
        }

        function getDetails(uuid) {
            return $http({
                method: 'GET',
                url: $rootScope.API_URL + 'api/beneluxUsers/' + uuid + '/getFullDetails'
                    //params: { id: uuid }
            });
        }

        function getUserDates(uuid) {
            return $http({
                method: 'GET',
                url: $rootScope.API_URL + 'api/beneluxUsers/' + uuid + '/dates'
            });
        }

        function getFirstActivationDate(uuid) {
            return $http({
                method: 'GET',
                url: $rootScope.API_URL + 'api/beneluxUsers/' + uuid + '/firstActivationDate',
                //params: { id: uuid }
            });
        }

        function getLastActivityDate(uuid) {
            return $http({
                method: 'GET',
                url: $rootScope.API_URL + 'api/beneluxUsers/' + uuid + '/lastActivityDate',
                //params: { id: uuid }
            });
        }

        function getLastFailedLoginDate(uuid) {
            return $http({
                method: 'GET',
                url: $rootScope.API_URL + 'api/beneluxUsers/' + uuid + '/lastFailedLoginDate',
                //params: { id: uuid }
            });
        }

        function getLastSuccessfulLoginDate(uuid) {
            return $http({
                method: 'GET',
                url: $rootScope.API_URL + 'api/beneluxUsers/' + uuid + '/lastSuccessfulLoginDate',
                params: { id: uuid }
            });
        }

        function requestResetOwnPassword(email) {
            return $http({
                method: 'GET',
                url: $rootScope.API_URL + 'api/beneluxUsers/requestResetOwnPasswordRequest',
                params: { email: email.toLowerCase() }
            });
        }

        function checkPasswordExpireDays(uuid) {
            return $http({
                method: 'GET',
                url: $rootScope.API_URL + 'api/beneluxUsers/' + uuid + '/checkPasswordExpireDays'
            });
        }

        function checkNewUsersPasswordValid(password) {
            return $http({
                method: 'POST',
                url: $rootScope.API_URL + 'api/beneluxUsers/isPasswordValid',
                data: password
            });
        }

        function checkPasswordResetLink(uuid, link) {
            return $http({
                method: 'GET',
                url: $rootScope.API_URL + 'api/beneluxUsers/' + uuid + '/setPassword/' + link
            });
        }

        function resetOwnPassword(uuid, link, password) {
            return $http({
                method: 'POST',
                url: $rootScope.API_URL + 'api/beneluxUsers/' + uuid + '/setPassword/' + link,
                data: password
            });
        }

        function isLocked(uuid) {
            return $http({
                method: 'GET',
                url: $rootScope.API_URL + 'api/beneluxUsers/' + uuid + '/lock'
            });
        }

        function getUsersReportURL(filter) {
            var params = UtilService.starsToPercents(UtilService.nullsToEmptyStrings(filter));
            var baseURL = $rootScope.API_URL + 'api/beneluxUsers/reports/users';

            return GenerateURL.generate(baseURL, params);
        }

        function getActivityReportURL(filter) {
            var params = UtilService.starsToPercents(UtilService.nullsToEmptyStrings(filter));
            var baseURL =  $rootScope.API_URL + 'api/beneluxUsers/reports/activity';

            return GenerateURL.generate(baseURL, params);
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .factory('RolesService', RolesService);

    RolesService.$inject = ['$rootScope', '$http'];

    function RolesService($rootScope, $http) {
        var service = {
            list: list,
            getRoles: getRoles,
            getPermissions: getPermissions,
            getPermissionsByRoleId: getPermissionsByRoleId,
            createRole: createRole,
            updateRole: updateRole,
            deleteRole: deleteRole
        };

        return service;

        function list() {
            return $http({
                method: 'GET',
                url: $rootScope.API_URL + 'api/ediRoles', //TODO Change to dhlRoles
            });
        }

        function getRoles() {
            return $http({
                method: 'GET',
                url: $rootScope.API_URL + 'api/ediRoles?size=2147483647'
            });
        }

        function getPermissions() {
            return $http({
                method: 'GET',
                url: $rootScope.API_URL + 'api/ediPermissions'
            });
        }

        function getPermissionsByRoleId(roleId) {
            return $http({
                method: 'GET',
                url: $rootScope.API_URL + 'api/ediRoles/'+roleId+'/permissions'
            });
        }

        function createRole(role) {
            return $http({
                method: 'POST',
                url: $rootScope.API_URL + 'api/ediRoles',
                data: role
            });
        }

        function updateRole(roleId, role) {
            return $http({
                method: 'POST',
                url: $rootScope.API_URL + 'api/ediRoles/' + roleId + '/update',
                data: role
            });
        }

        function deleteRole(roleId) {
            return $http({
                method: 'DELETE',
                url: $rootScope.API_URL + 'api/ediRoles/' + roleId
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .factory('PendingCasesService', PendingCasesService);

    PendingCasesService.$inject = ['$rootScope', '$http'];

    function PendingCasesService ($rootScope, $http) {
        var service = {
//            getDocument : getDocument,
            getDocumentsWithoutClient: getDocumentsWithoutClient,
            getDocumentsOfDebtors: getDocumentsOfDebtors,
            getNameByClientNumber : getNameByClientNumber,
            getUsers : getUsers,
            usersAccepted : usersAccepted,
            usersDenied : usersDenied,
            documentsWithoutClientAccepted : documentsWithoutClientAccepted,
            documentsWithoutClientDenied : documentsWithoutClientDenied,
            documentsOfDebtorsAccepted: documentsOfDebtorsAccepted,
            documentsOfDebtorsDenied: documentsOfDebtorsDenied
        };

        return service;
        function getNameByClientNumber(SapNumber){
            return $http({
                method: 'GET',
                url: $rootScope.API_URL + 'api/beneluxClients/getName',
                params : {'clientNumber': SapNumber}
            });
        }
        function getDocumentsWithoutClient(){
            return $http({
                method: 'GET',
                url: $rootScope.API_URL + 'api/beneluxInvoices/clientWaitInvoices'
            });
        }
        function getDocumentsOfDebtors(){
            return $http({
                method: 'GET',
                url: $rootScope.API_URL + 'api/beneluxInvoices/onHoldInvoices'
            });
        }
        function getUsers(){
            return $http({
                method: 'GET',
                url: $rootScope.API_URL + 'api/beneluxUsers/notActive'
            });
        }
        function usersAccepted(UIDs){
            return $http({
                method: 'POST',
                url: $rootScope.API_URL + 'api/beneluxUsers/acceptAll',
                data : UIDs //byc moze nie zalapie nazwy
            });
        }
        function usersDenied(UIDs){
            return $http({
                method: 'POST',
                url: $rootScope.API_URL + 'api/beneluxUsers/rejectAll',
                data : UIDs
            });
        }
        function documentsWithoutClientAccepted(ediDocIds){
            return $http({
                method: 'POST',
                url: $rootScope.API_URL + 'api/beneluxInvoices/approveWait',
                data: ediDocIds
            });
        }
        function documentsWithoutClientDenied(ediDocIds){
            return $http({
                method: 'POST',
                url: $rootScope.API_URL + 'api/beneluxInvoices/rejectWait',
                data : ediDocIds
            });
        }
        function documentsOfDebtorsAccepted(ediDocIds){
            return $http({
                method: 'POST',
                url: $rootScope.API_URL + 'api/beneluxInvoices/approveOnHold',
                data: ediDocIds
            });
        }
        function documentsOfDebtorsDenied(ediDocIds){
            return $http({
                method: 'POST',
                url: $rootScope.API_URL + 'api/beneluxInvoices/rejectOnHold',
                data : ediDocIds
            });
        }
//        function getDocument(ediDocId){
//            return $http({
//                method: 'GET',
//                url: $rootScope.API_URL + 'api/beneluxInvoices/' + ediDocId + '/getPdf',
//                responseType: 'arraybuffer'
//            });
//        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .factory('PdfViewService', PdfViewService);

    PdfViewService.$inject = ['$rootScope', '$http'];

    function PdfViewService($rootScope, $http) {
        var service = {
            getFirstPagePdf: getFirstPagePdf,
            getInvoiceStylesheet: getInvoiceStylesheet
        };

        return service;

        function getInvoiceStylesheet(EdiDocId) {
            return $http({
                method: 'GET',
                url: $rootScope.API_URL + 'api/beneluxInvoices/' + EdiDocId + '/getInvoiceStylesheet'
            });
        }

        function getFirstPagePdf(EdiDocId) {
            return $http({
                method: 'GET',
                url: $rootScope.API_URL + 'api/beneluxInvoices/' + EdiDocId + '/getFirstPagePdf',
                responseType: 'arraybuffer'
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .factory('MailTemplatesService', MailTemplatesService);

    MailTemplatesService.$inject = ['$rootScope', '$http', 'Principal'];

    function MailTemplatesService($rootScope, $http, Principal) {
        var service = {
            checkUnique: checkUnique,
            getTemplatesByType: getTemplatesByType,
            download: download,
            addTemplateTitle: addTemplateTitle,
            getAllTemplates: getAllTemplates
        };

        return service;

        function checkUnique(name, actionType, language, type) {
            return $http({
                method: 'GET',
                url: $rootScope.API_URL + 'api/beneluxTemplates/isTemplateUnique',
                params: { 'name': name, 'actionType': actionType, 'language': language, 'type': type }
            });
        }

        function getTemplatesByType(type) {
            return $http({
                method: 'GET',
                url: $rootScope.API_URL + 'api/' + Principal.getCurrentEntityLowerCase() + 'Templates/search/findByType',
                params: { 'type': type, 'size': 10 }
            });
        }

        function download(name, actionType, language) {
            return $http({
                method: 'GET',
                url: $rootScope.API_URL + 'api/beneluxTemplates/download',
                params: { 'name': name, 'actionType': actionType, 'language': language },
                responseType: 'arraybuffer'
            });
        }

        function addTemplateTitle(name, actionType, text, language) {
            return $http({
                method: 'POST',
                url: $rootScope.API_URL + 'api/beneluxTemplates/add',
                params: { 'name': name, 'actionType': actionType, 'text': text, 'language': language, 'type': 'EMAIL_TITLE' }
            });
        }

        function getAllTemplates() {
            return $http({
                method: 'GET',
                url: $rootScope.API_URL + 'api/' + Principal.getCurrentEntityLowerCase() + 'Templates/search/findAllBy'
            });
        }

    }
})();
;
(function () {
    "use strict";

    angular
        .module("edistradadhluiApp")
        .factory("DocumentsService", DocumentsService);

    DocumentsService.$inject = [
        "$rootScope",
        "$http",
        "$httpParamSerializer",
        "UtilService",
        "GenerateURL",
    ];

    function DocumentsService(
        $rootScope,
        $http,
        $httpParamSerializer,
        UtilService,
        GenerateURL
    ) {
        var service = {
            list: list,
            getUserColumnConf: getUserColumnConf,
            setUserColumnConf: setUserColumnConf,
            getPdf: getPdf,
            getXlsx: getXlsx,
            resendEmailForAllDocuments: resendEmailForAllDocuments,
            resendEmailOnNewAdresses: resendEmailOnNewAdresses,
            retransferDocumentsToSmtp: retransferDocumentsToSmtp,
            getPdfURL: getPdfURL,
            getInvoiceXlsxURL: getInvoiceXlsxURL,
            getInvoiceCsvURL: getInvoiceCsvURL,
            getInvoiceXmlURL: getInvoiceXmlURL,
            getPdfsURL: getPdfsURL,
            getCsvsURL: getCsvsURL,
            getCsvsConcatenateURL: getCsvsConcatenateURL,
            getExcelURL: getExcelURL,
            getExcelConcatenateURL: getExcelConcatenateURL,
            getXMLURL: getXMLURL,
            getXlsxURL: getXlsxURL,
            isAvailable: isAvailable,
            submitDispute: submitDispute,
            getDisputeFormData: getDisputeFormData,
            getCsvTemplate: getCsvTemplate,
            getCsvAllTemplates: getCsvAllTemplates,
            setCsvTemplate: setCsvTemplate,
            updateCsvTemplate: updateCsvTemplate,
            deleteCsvTemplate: deleteCsvTemplate,
            getCustomCsvURL: getCustomCsvURL,
            getInvoiceCustomCsvURL: getInvoiceCustomCsvURL,
            getCustomCsvsConcatenateURL: getCustomCsvsConcatenateURL,
        };
        return service;

        function getCsvAllTemplates() {
            return $http({
                method: "GET",
                url: $rootScope.API_URL + "api/csv/templates/names",
            });
        }

        function getCsvTemplate(template) {
            return $http({
                method: "GET",
                url: $rootScope.API_URL + "api/csv/templates/name/" + template,
            });
        }

        function setCsvTemplate(body) {
            return $http({
                method: "POST",
                url: $rootScope.API_URL + "api/csv/templates/",
                data: body,
            });
        }

        function updateCsvTemplate(template, body) {
            return $http({
                method: "PUT",
                url: $rootScope.API_URL + "api/csv/templates/" + template,
                data: body,
            });
        }

        function deleteCsvTemplate(template) {
            return $http({
                method: "DELETE",
                url: $rootScope.API_URL + "api/csv/templates/name/" + template,
            });
        }

        function list(filter) {
            return $http({
                method: "POST",
                url: $rootScope.API_URL + "api/beneluxInvoices/getLimited",
                data: UtilService.starsToPercents(filter),
            });
        }

        function getUserColumnConf(UID) {
            return $http({
                method: "GET",
                url:
                    $rootScope.API_URL +
                    "api/beneluxUsers/" +
                    UID +
                    "/userConf",
            });
        }

        function setUserColumnConf(UID, columnConf) {
            return $http({
                method: "POST",
                url:
                    $rootScope.API_URL +
                    "api/beneluxUsers/" +
                    UID +
                    "/userConf",
                data: columnConf,
            });
        }

        function getPdf(EdiDocId) {
            return $http({
                method: "GET",
                url:
                    $rootScope.API_URL +
                    "api/beneluxInvoices/" +
                    EdiDocId +
                    "/pdf",
                responseType: "arraybuffer",
            });
        }

        function getXlsx(filter) {
            return $http({
                method: "POST",
                url:
                    $rootScope.API_URL +
                    "api/beneluxInvoices/getAsExcelByCustomCriteria",
                data: UtilService.starsToPercents(filter), //filter,
                responseType: "arraybuffer",
            });
        }

        function getPdfsURL(EdiDocIds, language) {
            var params = {
                ids: EdiDocIds,
                includePdf: true,
                //if waybill scans will be implemented, this param should be used and set to true when needed
                includeScan: false,
                language: language,
            };
            var serializedParams = $httpParamSerializer(params);
            var baseURL =
                $rootScope.API_URL + "api/beneluxInvoices/downloadPdfs";
            if (serializedParams.length > 0) {
                baseURL +=
                    (baseURL.indexOf("?") === -1 ? "?" : "&") +
                    serializedParams;
            }
            return baseURL;
        }

        //TODO implement backend
        function getCsvsURL(EdiDocIds, language) {
            var params = {
                ids: EdiDocIds,
                language: language,
            };
            var serializedParams = $httpParamSerializer(params);
            var baseURL =
                $rootScope.API_URL + "api/beneluxInvoices/downloadCsvs";
            if (serializedParams.length > 0) {
                baseURL +=
                    (baseURL.indexOf("?") === -1 ? "?" : "&") +
                    serializedParams;
            }
            return baseURL;
        }

        function getCustomCsvURL(EdiDocIds, language, template) {
            var params = {
                ids: EdiDocIds,
                language: language,
            };
            var serializedParams = $httpParamSerializer(params);
            var baseURL =
                $rootScope.API_URL + "api/csv/download/zip/" + template;
            if (serializedParams.length > 0) {
                baseURL +=
                    (baseURL.indexOf("?") === -1 ? "?" : "&") +
                    serializedParams;
            }
            return baseURL;
        }

        function getCsvsConcatenateURL(EdiDocIds, language) {
            var params = {
                ids: EdiDocIds,
                language: language,
            };
            var serializedParams = $httpParamSerializer(params);
            var baseURL =
                $rootScope.API_URL +
                "api/beneluxInvoices/downloadCsvsConcatenate";
            if (serializedParams.length > 0) {
                baseURL +=
                    (baseURL.indexOf("?") === -1 ? "?" : "&") +
                    serializedParams;
            }
            return baseURL;
        }

        function getCustomCsvsConcatenateURL(EdiDocIds, language, template) {
            var params = {
                ids: EdiDocIds,
                language: language,
            };
            var serializedParams = $httpParamSerializer(params);
            var baseURL =
                $rootScope.API_URL +
                "api/csv/download/concatenated-zip/" + template;
            if (serializedParams.length > 0) {
                baseURL +=
                    (baseURL.indexOf("?") === -1 ? "?" : "&") +
                    serializedParams;
            }
            return baseURL;
        }
        function getExcelURL(EdiDocIds, language) {
            var params = {
                ids: EdiDocIds,
                language: language,
            };
            var serializedParams = $httpParamSerializer(params);
            var baseURL =
                $rootScope.API_URL + "api/beneluxInvoices/downloadExcel";
            if (serializedParams.length > 0) {
                baseURL +=
                    (baseURL.indexOf("?") === -1 ? "?" : "&") +
                    serializedParams;
            }
            return baseURL;
        }
        function getExcelConcatenateURL(EdiDocIds, language) {
            var params = {
                ids: EdiDocIds,
                language: language,
            };
            var serializedParams = $httpParamSerializer(params);
            var baseURL =
                $rootScope.API_URL +
                "api/beneluxInvoices/downloadExcelConcatenate";
            if (serializedParams.length > 0) {
                baseURL +=
                    (baseURL.indexOf("?") === -1 ? "?" : "&") +
                    serializedParams;
            }
            return baseURL;
        }
        function getXMLURL(EdiDocIds, language) {
            var params = {
                ids: EdiDocIds,
                language: language,
            };
            var serializedParams = $httpParamSerializer(params);
            var baseURL =
                $rootScope.API_URL + "api/beneluxInvoices/downloadXML";
            if (serializedParams.length > 0) {
                baseURL +=
                    (baseURL.indexOf("?") === -1 ? "?" : "&") +
                    serializedParams;
            }
            return baseURL;
        }

        function resendEmailForAllDocuments(EdiDocIds) {
            return $http({
                method: "POST",
                url: $rootScope.API_URL + "api/beneluxInvoices/resendEmails",
                data: EdiDocIds,
            });
        }

        function resendEmailOnNewAdresses(EdiDocIds, Emails) {
            return $http({
                method: "POST",
                url: $rootScope.API_URL + "api/beneluxInvoices/sendNewEmails",
                data: {
                    docIds: EdiDocIds,
                    emails: Emails,
                },
            });
        }

        function retransferDocumentsToSmtp(EdiDocIds) {
            return $http({
                method: "POST",
                url:
                    $rootScope.API_URL +
                    "api/beneluxInvoices/sendDocClientsSmtp",
                data: {
                    docIds: EdiDocIds,
                },
            });
        }

        function getPdfURL(EdiDocId, download, forceFullDocument) {
            var params = {
                download: download,
                forceFullDocument: forceFullDocument,
            };
            var baseURL =
                $rootScope.API_URL + "api/beneluxInvoices/" + EdiDocId + "/pdf";
            return GenerateURL.generate(baseURL, params);
        }

        function getInvoiceXlsxURL(EdiDocId) {
            var params = {};
            var baseURL =
                $rootScope.API_URL +
                "api/beneluxInvoices/" +
                EdiDocId +
                "/xlsx";
            return GenerateURL.generate(baseURL, params);
        }

        function getInvoiceCsvURL(EdiDocId) {
            var params = {};
            var baseURL =
                $rootScope.API_URL + "api/beneluxInvoices/" + EdiDocId + "/csv";
            return GenerateURL.generate(baseURL, params);
        }

        function getInvoiceCustomCsvURL(EdiDocId, template) {
            var params = {};
            var baseURL =
                $rootScope.API_URL +
                "api/csv/template/customCsv/" +
                template +
                "/" +
                EdiDocId;
            return GenerateURL.generate(baseURL, params);
        }

        function getInvoiceXmlURL(EdiDocId) {
            var params = {};
            var baseURL =
                $rootScope.API_URL + "api/beneluxInvoices/" + EdiDocId + "/xml";
            return GenerateURL.generate(baseURL, params);
        }

        function getXlsxURL(filter) {
            var params = UtilService.starsToPercents(filter);
            var baseURL =
                $rootScope.API_URL +
                "api/beneluxInvoices/getAsExcelByCustomCriteria";
            return GenerateURL.generate(baseURL, params);
        }

        function isAvailable(uuid, type) {
            return $http({
                method: "GET",
                url: $rootScope.API_URL + "api/beneluxInvoices/isAvailable",
                params: {
                    documentId: uuid,
                    documentType: type,
                },
            });
        }

        function submitDispute(data) {
            return $http({
                method: "POST",
                url: $rootScope.API_URL + "api/beneluxInvoices/disputes/submit",
                headers: { "Content-Type": undefined },
                params: {
                    name: data.name,
                    email: data.email,
                    accountNumber: data.accountNumber,
                    invoiceNumber: data.invoiceNumber,
                },
                data: {
                    shipmentNumbers: getShipmentNumbers(data),
                    comments: getComments(data),
                    attachments: getAttachments(data),
                },
                transformRequest: function (data) {
                    var formData = new FormData();
                    formData.append(
                        "shipmentNumbers",
                        blobify(data.shipmentNumbers)
                    );
                    formData.append("comments", blobify(data.comments));

                    for (var i = 0; i < data.attachments.length; i++) {
                        var attachment = data.attachments[i];
                        if (attachment) {
                            formData.append(
                                "attachments",
                                new Blob([attachment], {
                                    type: "application/octet-stream",
                                }),
                                attachment.name
                            );
                        } else
                            formData.append(
                                "attachments",
                                new Blob([], {
                                    type: "application/octet-stream",
                                })
                            );
                    }

                    return formData;
                },
            });
        }

        function blobify(data) {
            var json = JSON.stringify(data);
            return new Blob([json], {
                type: "application/json",
            });
        }

        function getShipmentNumbers(data) {
            return getArrayOf("shipmentNumber", data);
        }
        function getComments(data) {
            return getArrayOf("comment", data);
        }
        function getAttachments(data) {
            return getArrayOf("attachment", data);
        }

        function getArrayOf(idx, data) {
            var arr = [];
            data.commentEntries.forEach(function (entry) {
                arr.push(entry[idx]);
            });
            return arr;
        }

        function getDisputeFormData(EdiDocId) {
            return $http({
                method: "GET",
                url:
                    $rootScope.API_URL +
                    "api/beneluxInvoices/" +
                    EdiDocId +
                    "/disputes",
                params: {},
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .factory('ConstantsService', ConstantsService);

    ConstantsService.$inject = ['$rootScope', '$http'];

    function ConstantsService($rootScope, $http) {
        var service = {
            set: set,
            get: get,
            saveBanner: saveBanner,
            getBanner: getBanner,
            deleteBanner: deleteBanner,
            isBannerActive: isBannerActive
        };

        return service;

        function set(interval) {
            return $http({
                method: 'POST',
                url: $rootScope.API_URL + 'api/beneluxConstants/set',
                data: interval
            });
        }

        function get(constantName) {
            return $http({
                method: 'GET',
                url: $rootScope.API_URL + 'api/beneluxConstants/search/findByName',
                params: { name: constantName }
            });
        }

        function saveBanner(bannerDto) {
            return $http({
                method: 'POST',
                url: $rootScope.API_URL + 'api/communique',
                data: bannerDto
            });
        }

        function getBanner() {
            return $http({
                method: 'GET',
                url: $rootScope.API_URL + 'api/communique'
            });
        }

        function deleteBanner() {
            return $http({
                method: 'DELETE',
                url: $rootScope.API_URL + 'api/communique'
            });
        }

        function isBannerActive() {
            return $http({
                method: 'GET',
                url: $rootScope.API_URL + 'api/communique/isActive'
            });
        }

    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .factory('ClientsService', ClientsService);

    ClientsService.$inject = ['$rootScope', '$http', 'UtilService', 'Principal'];

    function ClientsService($rootScope, $http, UtilService, Principal) {
        var service = {
            create: create,
            findByClientNumber: findByClientNumber,
            getClientTemplates: getClientTemplates,
            list: list,
            listByUserEmail: listByUserEmail,
            listWithParams: listWithParams,
            manage: manage,
            parseManagementFile: parseManagementFile,
            postClientTemplates: postClientTemplates,
            update: update,
            updateFtpConfig: updateFtpConfig,
            deleteFtpConfig: deleteFtpConfig
        };

        return service;

        function list(filter) {
            return $http({
                method: 'GET',
                url: $rootScope.API_URL + 'api/beneluxClients',
                params: filter
            });
        }

        function listWithParams(filter) {
            return $http({
                method: 'GET',
                url: $rootScope.API_URL + 'api/beneluxClients/find' + Principal.getCurrentEntityCamelCase() + 'Clients',
                params: UtilService.starsToPercents(UtilService.nullsToEmptyStrings(filter))
            });
        }

        function create(client) {
            return $http({
                method: 'POST',
                url: $rootScope.API_URL + 'api/beneluxClients/create',
                data: UtilService.emptyStringsToNulls(client)
            });
        }

        function update(client) {
            return $http({
                method: 'PUT',
                url: $rootScope.API_URL + 'api/beneluxClients/update',
                data: client
            });
        }

        function listByUserEmail(filter) {
            return $http({
                method: 'GET',
                url: $rootScope.API_URL + 'api/beneluxClients/search/findAllWithClientsByEmail',
                params: filter
            });
        }

        function findByClientNumber(clientNumber) {
            return $http({
                method: 'GET',
                url: $rootScope.API_URL + 'api/' + Principal.getCurrentEntityLowerCase() + 'Clients/search/findByClientNumber',
                params: { 'clientNumber': clientNumber }
            });
        }

        function parseManagementFile(file) {
            return $http({
                method: 'POST',
                url: $rootScope.API_URL + 'api/beneluxClients/manage/parse',
                data: file
            });
        }

        function manage(actions) {
            return $http({
                method: 'POST',
                url: $rootScope.API_URL + 'api/beneluxClients/manage',
                data: actions
            });
        }

        function getClientTemplates(ediClientId) {
            return $http({
                method: 'GET',
                url: $rootScope.API_URL + 'api/beneluxClients/' + ediClientId + '/getTemplatesId'
            });
        }

        function postClientTemplates(ediClientId, templates) {
            return $http({
                method: 'POST',
                url: $rootScope.API_URL + 'api/beneluxClients/' + ediClientId + '/postTemplates',
                data: templates
            });
        }

        function updateFtpConfig(client) {
            return $http({
                method: 'POST',
                url: $rootScope.API_URL + 'api/beneluxClients/updateFtpConfig',
                data: client
            });
        }

        function deleteFtpConfig(client) {
            return $http({
                method: 'POST',
                url: $rootScope.API_URL + 'api/beneluxClients/deleteFtpConfig',
                data: client
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .factory('Sessions', Sessions);

    Sessions.$inject = ['$resource'];

    function Sessions ($resource) {
        return $resource('api/account/sessions/:series', {}, {
            'getAll': { method: 'GET', isArray: true}
        });
    }
})();
;
(function () {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .factory('Register', Register);

    Register.$inject = ['$resource'];

    function Register ($resource) {
        return $resource('api/register', {}, {});
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .factory('Principal', Principal);

    Principal.$inject = ['$q', 'Account', '$rootScope', '$http'];

    function Principal($q, Account, $rootScope, $http) {
        var _identity,
            _authenticated = false;

        var service = {
            authenticate: authenticate,
            hasAnyAuthority: hasAnyAuthority,
            hasAuthority: hasAuthority,
            identity: identity,
            isAuthenticated: isAuthenticated,
            isIdentityResolved: isIdentityResolved,
            getProperty: getProperty,
            hasInvoiceRead: hasInvoiceRead,
            hasClientRead: hasClientRead,
            hasUserRead: hasUserRead,
            hasInvoiceWrite: hasInvoiceWrite,
            hasClientWrite: hasClientWrite,
            hasUserWrite: hasUserWrite,
            hasPortalAccess: hasPortalAccess,
            hasAllDocumentsAccess: hasAllDocumentsAccess,
            hasSystemAccess: hasSystemAccess,
            hasTemplateAccess: hasTemplateAccess,
            updateLanguage: updateLanguage,
            getLegalEntities: getLegalEntities,
            getCurrentEntity: getCurrentEntity,
            getCurrentEntityCamelCase: getCurrentEntityCamelCase,
            getCurrentEntityLowerCase: getCurrentEntityLowerCase,
            getLockedLegalEntities: getLockedLegalEntities
        };

        var currentEntity = '';

        return service;

        function authenticate(identity) {
            _identity = identity;
            _authenticated = identity !== null;
        }

        function hasAnyAuthority(authorities) {
            if (!_authenticated || !_identity || !_identity.authorities) {
                return false;
            }

            for (var i = 0; i < authorities.length; i++) {
                if (_identity.authorities.indexOf(authorities[i]) !== -1) {
                    return true;
                }
            }

            return false;
        }

        function hasAuthority(authority) {
            if (!_authenticated) {
                return $q.when(false);
            }

            return this.identity().then(function(_id) {
                return _id.authorities && _id.authorities.indexOf(authority) !== -1;
            }, function() {
                return false;
            });
        }

        function identity(force) {
            var deferred = $q.defer();

            if (force === true) {
                _identity = undefined;
            }

            // check and see if we have retrieved the identity data from the server.
            // if we have, reuse it by immediately resolving
            if (angular.isDefined(_identity)) {
                deferred.resolve(_identity);

                return deferred.promise;
            }

            // retrieve the identity data from the server, update the identity object, and then resolve.
            Account.get()
                .then(function(response) {
                    getAccountThen(response);
                })
                .catch(function(response) {
                    getAccountCatch(response);
                });

            return deferred.promise;

            function getAccountThen(account) {
                _identity = account.data;
                _authenticated = true;
                currentEntity = getProperty('currentSourceName');
                deferred.resolve(_identity);
            }

            function getAccountCatch() {
                _identity = null;
                _authenticated = false;
                currentEntity = '';
                deferred.resolve(_identity);
            }
        }

        function isAuthenticated() {
            return _authenticated;
        }

        function isIdentityResolved() {
            return angular.isDefined(_identity);
        }

        function getProperty(property) {
            if (!property) {
                return null;
            }

            if (angular.isDefined(_identity) && _identity != null) {
                return _identity[property];
            }

            return null;
        }

        function getAuthorities() {
            var authorities = getProperty('authorities');
            if (authorities == null) {
                authorities = [];
            }
            return authorities;
        }

        function getLegalEntities() {
            var entities = getProperty('sourceNames');
            if (entities == null) {
                entities = "";
            }
            return entities;
        }

        function getLockedLegalEntities() {
            var entitiesLocked = getProperty('sourceNamesLocked');
            if (entitiesLocked == null) {
                entitiesLocked = "";
            }
            return entitiesLocked;
        }

        function getCurrentEntity() {
            return currentEntity;
        }

        function getCurrentEntityCamelCase() {
            return currentEntity.charAt(0) + currentEntity.charAt(1).toLowerCase();
        }

        function getCurrentEntityLowerCase() {
            return currentEntity.toLowerCase();
        }

        function hasInvoiceRead() {
            return getAuthorities().indexOf('ROLE_INVOICE_READ@' + currentEntity) >= 0;
        }

        function hasClientRead() {
            return getAuthorities().indexOf('ROLE_CLIENT_READ@' + currentEntity) >= 0;
        }

        function hasUserRead() {
            return getAuthorities().indexOf('ROLE_USER_READ@' + currentEntity) >= 0;
        }

        function hasInvoiceWrite() {
            return getAuthorities().indexOf('ROLE_INVOICE_WRITE@' + currentEntity) >= 0;
        }

        function hasClientWrite() {
            return getAuthorities().indexOf('ROLE_CLIENT_WRITE@' + currentEntity) >= 0;
        }

        function hasUserWrite() {
            return getAuthorities().indexOf('ROLE_USER_WRITE@' + currentEntity) >= 0;
        }

        function hasPortalAccess() {
            return getAuthorities().indexOf('ROLE_PORTAL_ACCESS@' + currentEntity) >= 0;
        }

        function hasAllDocumentsAccess() {
            return getAuthorities().indexOf('ROLE_ALL_DOCUMENTS_ACCESS@' + currentEntity) >= 0;
        }

        function hasSystemAccess() {
            return getAuthorities().indexOf('ROLE_SYSTEM_ACCESS@' + currentEntity) >= 0;
        }

        function hasTemplateAccess() {
            return getAuthorities().indexOf('ROLE_TEMPLATE_ACCESS@' + currentEntity) >= 0;
        }

        function updateLanguage(language) {
            return $http({
                method: 'POST',
                url: $rootScope.API_URL + 'api/language',
                data: language
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .factory('PasswordResetInit', PasswordResetInit);

    PasswordResetInit.$inject = ['$rootScope', '$http'];

    function PasswordResetInit($rootScope, $http) {
        var service = {
            resetPassword: resetPassword
        }

        return service;

        function resetPassword(id, user){
            return $http({
                method: 'POST',
                url: $rootScope.API_URL + 'api/beneluxUsers/' + id + '/changePassword',
                data: user
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .factory('PasswordResetFinish', PasswordResetFinish);

    PasswordResetFinish.$inject = ['$resource'];

    function PasswordResetFinish($resource) {
        var service = $resource('api/account/reset_password/finish', {}, {});

        return service;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .factory('Password', Password);

    Password.$inject = ['$resource'];

    function Password($resource) {
        var service = $resource('api/account/change_password', {}, {});

        return service;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .directive('hasAuthority', hasAuthority);

    hasAuthority.$inject = ['Principal'];

    function hasAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authority = attrs.hasAuthority.replace(/\s+/g, '');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {

                    if (reset) {
                        setVisible();
                    }

                    Principal.hasAuthority(authority)
                        .then(function (result) {
                            if (result) {
                                setVisible();
                            } else {
                                setHidden();
                            }
                        });
                };

            if (authority.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .directive('hasAnyAuthority', hasAnyAuthority);

    hasAnyAuthority.$inject = ['Principal'];

    function hasAnyAuthority(Principal) {
        var directive = {
            restrict: 'A',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs) {
            var authorities = attrs.hasAnyAuthority.replace(/\s+/g, '').split(',');

            var setVisible = function () {
                    element.removeClass('hidden');
                },
                setHidden = function () {
                    element.addClass('hidden');
                },
                defineVisibility = function (reset) {
                    var result;
                    if (reset) {
                        setVisible();
                    }

                    result = Principal.hasAnyAuthority(authorities);
                    if (result) {
                        setVisible();
                    } else {
                        setHidden();
                    }
                };

            if (authorities.length > 0) {
                defineVisibility(true);

                scope.$watch(function() {
                    return Principal.isAuthenticated();
                }, function() {
                    defineVisibility(true);
                });
            }
        }
    }
})();
;
(function () {
    "use strict";

    angular.module("edistradadhluiApp").factory("EntityService", EntityService);

    EntityService.$inject = [
        "$http",
        "$rootScope",
        "$q",
        "Principal",
        "API_URL",
    ];

    function EntityService($http, $rootScope, $q, Principal, API_URL) {
        var service = {
            changeEntity: changeEntity,
            setApiUrl: setApiUrl,
            setUrlDomain: setUrlDomain,
            getVersion: getVersion,
        };

        return service;

        function changeEntity(entity) {
            var deferred = $q.defer();
            switchEntity(entity)
                .then(function (response) {
                    // setApiUrl(entity);  //for now if we are in .nl we stay in .nl, no api url change after login
                    Principal.identity(true).then(function () {
                        //update user data, current source name etc.
                        deferred.resolve(response);
                    });
                })
                .catch(function (response) {
                    deferred.reject(response);
                });
            return deferred.promise;
        }

        function setUrlDomain(entity) {
            $rootScope.API_DOMAIN = entity;
            setApiUrl(entity);
        }

        function setApiUrl(entity) {
            if (entity === "BE") {
                $rootScope.API_URL = API_URL.BE;
            } else if (entity === "NL") {
                $rootScope.API_URL = API_URL.NL;
            } else {
                $rootScope.API_URL = API_URL.EC;
            }
            console.log("Set api url = " + $rootScope.API_URL);
        }

        function switchEntity(entity) {
            return $http({
                method: "POST",
                url: $rootScope.API_URL + "api/switch",
                params: { username: entity },
            });
        }

        function getVersion() {
            return $http({
                method: "GET",
                url: $rootScope.API_URL + "api/version",
            });
        }
    }
})();
;
(function () {
    "use strict";

    angular
        .module("edistradadhluiApp")
        .factory("AuthServerProvider", AuthServerProvider);

    AuthServerProvider.$inject = [
        "$rootScope",
        "$http",
        "$localStorage",
        "Base64",
    ];

    function AuthServerProvider($rootScope, $http, $localStorage, Base64) {
        var service = {
            getToken: getToken,
            hasValidToken: hasValidToken,
            login: login,
            logout: logout,
            isBlocked: isBlocked,
        };

        return service;

        function getToken() {
            return $localStorage.authenticationToken;
        }

        function hasValidToken() {
            return !!this.getToken();
        }

        function login(credentials) {
            var base64EncodedString = Base64.encode(
                credentials.username + ":" + credentials.password
            );
            var authorizationHeader = base64EncodedString
                ? "Basic " + base64EncodedString
                : "Basic";

            return $http.post($rootScope.API_URL + "api/authenticate", "", {
                headers: {
                    Authorization: authorizationHeader,
                },
                withCredentials: true,
            });
        }

        function isBlocked(email) {
            return $http({
                method: "GET",
                url:
                    $rootScope.API_URL +
                    "api/isBlocked?email=" +
                    email +
                    "&gr=BENELUX",
                withCredentials: true,
            });
        }

        function logout() {
            return $http
                .post(
                    $rootScope.API_URL + "api/logout",
                    {},
                    {
                        withCredentials: true,
                    }
                )
                .then(function (response) {
                    delete $localStorage.authenticationToken;
                    return response;
                })
                .catch(function (error) {
                    console.error("Logout error:", error);
                });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .factory('Auth', Auth);

    Auth.$inject = ['$rootScope', '$cookies', '$state', '$sessionStorage', '$q', '$translate', 'Principal', 'AuthServerProvider', 'Account', 'Register', 'Activate', 'Password', 'PasswordResetInit', 'PasswordResetFinish'];

    function Auth ($rootScope, $cookies, $state, $sessionStorage, $q, $translate, Principal, AuthServerProvider, Account, Register, Activate, Password, PasswordResetInit, PasswordResetFinish) {
        var service = {
            activateAccount: activateAccount,
            authorize: authorize,
            changePassword: changePassword,
            createAccount: createAccount,
            getPreviousState: getPreviousState,
            login: login,
            logout: logout,
            resetPasswordFinish: resetPasswordFinish,
            resetPasswordInit: resetPasswordInit,
            resetPreviousState: resetPreviousState,
            storePreviousState: storePreviousState,
            updateAccount: updateAccount,
            isBlocked: isBlocked
        };

        return service;

        function activateAccount (key, callback) {
            var cb = callback || angular.noop;

            return Activate.get(key,
                function (response) {
                    return cb(response);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function authorize (force) {
            var authReturn = Principal.identity(force).then(authThen);

            return authReturn;

            function authThen () {
                var isAuthenticated = Principal.isAuthenticated();

                // an authenticated user can't access to login and register pages
                if (isAuthenticated && $rootScope.toState.parent === 'account' && ($rootScope.toState.name === 'login' || $rootScope.toState.name === 'register')) {
                    $state.go('documents');
                }

                // recover and clear previousState after external login redirect (e.g. oauth2)
                if (isAuthenticated && !$rootScope.fromState.name && getPreviousState()) {
                    var previousState = getPreviousState();
                    resetPreviousState();
                    $state.go(previousState.name, previousState.params);
                }

                if ($rootScope.toState.data.authorities && $rootScope.toState.data.authorities.length > 0 && !Principal.hasAnyAuthority($rootScope.toState.data.authorities)) {
                    if (isAuthenticated) {
                        // user is signed in but not authorized for desired state
                        $state.go('accessdenied');
                    }
                    else {
                        // user is not authenticated. stow the state they wanted before you
                        // send them to the login service, so you can return them when you're done
                        storePreviousState($rootScope.toState.name, $rootScope.toStateParams);

                        // now, send them to the signin state so they can log in
                        $state.go('accessdenied').then(function() {
                            $state.go('login');
                            // LoginService.open();
                        });
                    }
                }
            }
        }

        function changePassword (newPassword, callback) {
            var cb = callback || angular.noop;

            return Password.save(newPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function createAccount (account, callback) {
            var cb = callback || angular.noop;

            return Register.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    this.logout();
                    return cb(err);
                }.bind(this)).$promise;
        }

        function isBlocked (email){
            return AuthServerProvider.isBlocked(email);
        }

        function login (credentials, callback) {
            var cb = callback || angular.noop;
            var deferred = $q.defer();

            AuthServerProvider.login(credentials)
                .then(loginThen)
                .catch(function (err) {
                    this.logout();
                    deferred.reject(err);
                    return cb(err);
                }.bind(this));

            function loginThen (data) {
                Principal.identity(true).then(function(account) {
                    // After the login the language will be changed to
                    // the language selected by the user during his registration
                    if (account != null && account.langKey != null) {
                        $cookies.putObject("NG_TRANSLATE_LANG_KEY", account.langKey);
                        $translate.use(account.langKey).then(function () {
                            $translate.refresh();
                        });
                    }
                    deferred.resolve(data);
                });
                return cb();
            }

            return deferred.promise;
        }


        function logout () {
            AuthServerProvider.logout();
            Principal.authenticate(null);
        }

        function resetPasswordFinish (keyAndPassword, callback) {
            var cb = callback || angular.noop;

            return PasswordResetFinish.save(keyAndPassword, function () {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function resetPasswordInit (mail, callback) {
            var cb = callback || angular.noop;

            return PasswordResetInit.save(mail, function() {
                return cb();
            }, function (err) {
                return cb(err);
            }).$promise;
        }

        function updateAccount (account, callback) {
            var cb = callback || angular.noop;

            return Account.save(account,
                function () {
                    return cb(account);
                },
                function (err) {
                    return cb(err);
                }.bind(this)).$promise;
        }

        function getPreviousState() {
            var previousState = $sessionStorage.previousState;
            return previousState;
        }

        function resetPreviousState() {
            delete $sessionStorage.previousState;
        }

        function storePreviousState(previousStateName, previousStateParams) {
            var previousState = { "name": previousStateName, "params": previousStateParams };
            $sessionStorage.previousState = previousState;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .factory('Activate', Activate);

    Activate.$inject = ['$resource'];

    function Activate ($resource) {
        var service = $resource('api/activate', {}, {
            'get': { method: 'GET', params: {}, isArray: false}
        });

        return service;
    }
})();
;
(function () {
    "use strict";

    angular.module("edistradadhluiApp").factory("Account", Account);

    Account.$inject = ["$rootScope", "$resource", "$http"];

    function Account($rootScope, $resource, $http) {
        var service = {
            get: get,
        };

        function get() {
            return $http({
                method: "GET",
                url: $rootScope.API_URL + "api/session",
                withCredentials: true,
            });
        }

        // var apiUrl = $rootScope.API_URL;
        // console.log('Account ai url = ' + apiUrl);
        // var service = $resource(apiUrl + 'api/session', {}, {
        //     'get': {
        //         method: 'GET',
        //         params: {},
        //         isArray: false,
        //         interceptor: {
        //             response: function(response) {
        //                 // expose response
        //                 return response;
        //             }
        //         }
        //     }
        // });

        return service;
    }
})();
;
(function (window, document) {
    'use strict';

    var host = window.location.hostname;

    var domainScriptId = null;

    if (host === 'billing.dhlparcel.be') {
        domainScriptId = '019c762a-1540-7635-8fe6-c7cdcd81c551';
    } else if (host === 'billing.dhlparcel.nl') {
        domainScriptId = '019c762b-1357-7e6e-a444-d326ad1dc30b';
    } else if (host === 'dhl.nl.qas-benelux.edistrada.pl') {
        domainScriptId = '019c762a-1540-7635-8fe6-c7cdcd81c551-test'; // QAS single
    } else {
        return; // lokalnie/inne hosty: nie ładuj
    }

    // wymagane przez OneTrust
    window.OptanonWrapper = window.OptanonWrapper || function () {};

    // uniknij podwójnego ładowania
    if (document.querySelector('script[data-onetrust="true"]')) return;

    var s = document.createElement('script');
    s.src = 'https://cdn.cookielaw.org/scripttemplates/otSDKStub.js';
    s.type = 'text/javascript';
    s.charset = 'UTF-8';
    s.setAttribute('data-domain-script', domainScriptId);
    s.setAttribute('data-onetrust', 'true');

    document.head.appendChild(s);

})(window, document);
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .factory('ShellService', ShellService);

	ShellService.$inject = ['$rootScope','$http'];

    function ShellService ($rootScope, $http) {

		return {
			'logout': function(){
				return $http({
				  method: 'POST',
				  url: $rootScope.API_URL + 'api/auth/logout'
				});
			}
		};
	}
})();
;
/* eslint-disable indent */
(function() {
	'use strict';

	angular.
		module('edistradadhluiApp')
		.controller('ShellController', ShellController);

	ShellController.$inject = [ '$rootScope', '$state', 'Auth',
			'Principal', 'EntityService', 'SHELL_LOGO_HREF', 'AlertService', '$translate' ];

	function ShellController($rootScope, $state, Auth, Principal, EntityService, SHELL_LOGO_HREF, AlertService, $translate) {
		var vm = this;
		vm.state = $state;

		vm.logoHref = SHELL_LOGO_HREF;
		// Declare function
		vm.setVersion = setVersion;
		vm.toggleSidebar = toggleSidebar;
		vm.showSidebar = showSidebar;
		vm.hideSidebar = hideSidebar;
		vm.logout = logout;
		vm.identity = Principal.identity();
		vm.changeEntity = changeEntity;
		vm.currentEntity = Principal.getCurrentEntity();
		vm.getLegalEntities = getLegalEntities;
		vm.entities = Principal.getLegalEntities().split(',');
		vm.blockedEntities = Principal.getLockedLegalEntities().split(',');

		function filterEntities() {
			if(vm.blockedEntities != null && vm.blockedEntities != "" && vm.entities != null) {
				vm.blockedEntities.forEach(function(entity) {
					var index = vm.entities.indexOf(entity);
					if (index !== -1)
						vm.entities.splice(index, 1);
				});
			}
		}

		function changeEntity(entity) {
			if(entity !== vm.currentEntity) {
				EntityService.changeEntity(entity).then(function(response) {
					getLegalEntities();
					$state.reload();
					if(response.data.message !== "SUCCESS")
						AlertService.error($translate.instant("error.occurred"));
				})
				.catch(function() {
					$state.go('documents');
					AlertService.error($translate.instant("error.occurred"));
				});
			}
		}

        function setVersion() {
        var version_text = $('#version_text');
        var version = "256";
        console.log("setVersion2");
                EntityService.getVersion().then(function(response) {
                    version = $rootScope.VERSION;
                    version += " | ";
                    version += response.data.version;
                    version_text.text(version);
                })
                .catch(function(response) {
                    version ="error";
                    version_text.text(version);
                });
        }

		function getLegalEntities() {
		    setVersion();
			vm.currentEntity = Principal.getCurrentEntity();
			vm.entities = Principal.getLegalEntities().split(',');
			vm.blockedEntities = Principal.getLockedLegalEntities().split(',');
			filterEntities();
		}

		function showSidebar() {
			var toggle = $('.navbar-toggle');
			setTimeout(function() {
				toggle.addClass('toggled');
			}, 430);

			var div = '<div id="bodyClick"></div>';
			$(div).appendTo("body").click(function() {
				hideSidebar();
				var $body = angular.element(document.body);
				var $rootScope = $body.injector().get('$rootScope');
				$rootScope.$apply(function() {
					$rootScope.sidebar = false;
				});
			});

			$('html').addClass('nav-open');
		}

		function hideSidebar() {
			var toggle = $('.navbar-toggle');
			$('html').removeClass('nav-open');
			$('#bodyClick').remove();
			setTimeout(function() {
				toggle.removeClass('toggled');
			}, 400);
		}

		function toggleSidebar() {
			var navbar = $('.navbar-collapse');
			if ($rootScope.sidebar == undefined) {
				$rootScope.sidebar = true;
				navbar.css('min-height', window.screen.height);
			} else {
				$rootScope.sidebar = !$rootScope.sidebar;
			}

			if ($rootScope.sidebar == false) {
				hideSidebar();
			} else {
				showSidebar();
			}
		}

		function logout() {
			Auth.logout(); // Logout through HTTP request
			$state.go('documents'); // Go to login view
		}
	}
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('error', {
                parent: 'app',
                url: '/error',
                data: {
                    authorities: [],
                    pageTitle: 'error.title'
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/error.html'
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            })
            .state('accessdenied', {
                parent: 'app',
                url: '/accessdenied',
                data: {
                    authorities: []
                },
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/error/accessdenied.html'
                    }
                },
                resolve: {
                    mainTranslatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate,$translatePartialLoader) {
                        $translatePartialLoader.addPart('error');
                        return $translate.refresh();
                    }]
                }
            });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .filter('words', words);

    function words() {
        return wordsFilter;

        function wordsFilter(input, words) {
            if (isNaN(words)) {
                return input;
            }
            if (words <= 0) {
                return '';
            }
            if (input) {
                var inputWords = input.split(/\s+/);
                if (inputWords.length > words) {
                    input = inputWords.slice(0, words).join(' ') + '...';
                }
            }

            return input;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .filter('characters', characters);

    function characters () {
        return charactersFilter;

        function charactersFilter(input, chars, breakOnWord) {
            if (isNaN(chars)) {
                return input;
            }
            if (chars <= 0) {
                return '';
            }
            if (input && input.length > chars) {
                input = input.substring(0, chars);

                if (!breakOnWord) {
                    var lastspace = input.lastIndexOf(' ');
                    // Get last space
                    if (lastspace !== -1) {
                        input = input.substr(0, lastspace);
                    }
                } else {
                    while (input.charAt(input.length-1) === ' ') {
                        input = input.substr(0, input.length - 1);
                    }
                }
                return input + '...';
            }
            return input;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .directive('jhSortBy', jhSortBy);

    function jhSortBy() {
        var directive = {
            restrict: 'A',
            scope: false,
            require: '^jhSort',
            link: linkFunc
        };

        return directive;

        function linkFunc(scope, element, attrs, parentCtrl) {
            element.bind('click', function () {
                parentCtrl.sort(attrs.jhSortBy);
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .directive('jhSort', jhSort);

    function jhSort () {
        var directive = {
            restrict: 'A',
            scope: {
                predicate: '=jhSort',
                ascending: '=',
                callback: '&'
            },
            controller: SortController,
            controllerAs: 'vm',
            bindToController: true
        };

        return directive;
    }

    SortController.$inject = ['$scope', '$element'];

    function SortController ($scope, $element) {
        var vm = this;

        vm.applyClass = applyClass;
        vm.resetClasses = resetClasses;
        vm.sort = sort;
        vm.triggerApply = triggerApply;

        $scope.$watchGroup(['vm.predicate', 'vm.ascending'], vm.triggerApply);
        vm.triggerApply();

        function applyClass (element) {
            var thisIcon = element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt',
                remove = sortIcon + ' ' + sortDesc,
                add = sortAsc;
            if (!vm.ascending) {
                remove = sortIcon + ' ' + sortAsc;
                add = sortDesc;
            }
            vm.resetClasses();
            thisIcon.removeClass(remove);
            thisIcon.addClass(add);
        }

        function resetClasses () {
            var allThIcons = $element.find('span.glyphicon'),
                sortIcon = 'glyphicon-sort',
                sortAsc = 'glyphicon-sort-by-attributes',
                sortDesc = 'glyphicon-sort-by-attributes-alt';
            allThIcons.removeClass(sortAsc + ' ' + sortDesc);
            allThIcons.addClass(sortIcon);
        }

        function sort (field) {
            if (field !== vm.predicate) {
                vm.ascending = true;
            } else {
                vm.ascending = !vm.ascending;
            }
            vm.predicate = field;
            $scope.$apply();
            vm.callback();
        }

        function triggerApply (values)  {
            vm.resetClasses();
            if (values && values[0] !== '_score') {
                vm.applyClass($element.find('th[jh-sort-by=\'' + values[0] + '\']'));
            }
        }
    }
})();
;
(function(){
    'use strict';

    angular
        .module('edistradadhluiApp')
        .factory('ParseLinks', ParseLinks);

    function ParseLinks () {

        var service = {
            parse : parse
        };

        return service;

        function parse(header) {
            if (header.length === 0) {
                throw new Error('input must not be of zero length');
            }

            // Split parts by comma
            var parts = header.split(',');
            var links = {};
            // Parse each part into a named link
            angular.forEach(parts, function(p) {
                var section = p.split(';');
                if (section.length !== 2) {
                    throw new Error('section could not be split on ";"');
                }
                var url = section[0].replace(/<(.*)>/, '$1').trim();
                var queryString = {};
                url.replace(
                    new RegExp('([^?=&]+)(=([^&]*))?', 'g'),
                    function($0, $1, $2, $3) { queryString[$1] = $3; }
                );
                var page = queryString.page;
                if (angular.isString(page)) {
                    page = parseInt(page);
                }
                var name = section[1].replace(/rel="(.*)"/, '$1').trim();
                links[name] = page;
            });
            return links;
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .factory('PaginationUtil', PaginationUtil);

    function PaginationUtil () {

        var service = {
            parseAscending : parseAscending,
            parsePage : parsePage,
            parsePredicate : parsePredicate
        };

        return service;

        function parseAscending (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                return sort.split(',').slice(-1)[0] === 'asc';
            } else {
                // default to true if no sort defined
                return true;
            }
        }

        // query params are strings, and need to be parsed
        function parsePage (page) {
            return parseInt(page);
        }

        // sort can be in the format `id,asc` or `id`
        function parsePredicate (sort) {
            var sortArray = sort.split(',');
            if (sortArray.length > 1){
                sortArray.pop();
            }
            return sortArray.join(',');
        }
    }
})();
;
(function() {
    'use strict';

    var jhiItemCount = {
        template: '<div class="info">' +
                    'Showing {{(($ctrl.page - 1) * $ctrl.itemsPerPage) == 0 ? 1 : (($ctrl.page - 1) * $ctrl.itemsPerPage + 1)}} - ' +
                    '{{($ctrl.page * $ctrl.itemsPerPage) < $ctrl.queryCount ? ($ctrl.page * $ctrl.itemsPerPage) : $ctrl.queryCount}} ' +
                    'of {{$ctrl.queryCount}} items.' +
                '</div>',
        bindings: {
            page: '<',
            queryCount: '<total',
            itemsPerPage: '<'
        }
    };

    angular
        .module('edistradadhluiApp')
        .component('jhiItemCount', jhiItemCount);
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .directive('iframeSetDimensionsOnload', [function() {

            return {
                restrict: 'A',
                link: function(scope, element, attrs){
                    element.on('load', function(){
                        /* Set the dimensions here,
                           I think that you were trying to do something like this: */
                           var iFrameHeight = element[0].contentWindow.document.body.scrollHeight + 'px';
                           var iFrameWidth = '100%';
                           element.css('width', iFrameWidth);
                           element.css('height', iFrameHeight);
                            var Window = $(window);
                            var Document = $(document);
                            element.css('height', Document.height());
                            element.css('height', element.height() - (Document.height() - Window.height()));

//                           $(window).resize(function(){
//                                var Window = $(window),
//                                Document = $(document),
//                                PDFWrapper = $('#PDFWrapper');
//                           });

                    })
                }
            }
        }]);
})();
;
(function() {
    /*jshint bitwise: false*/
    'use strict';

    angular
        .module('edistradadhluiApp')
        .factory('GenerateURL', GenerateURL);

    GenerateURL.$inject = ['$httpParamSerializer'];

    function GenerateURL ($httpParamSerializer) {
        var service = {
            generate : generate
        };

        return service;

        function generate (baseURL, params) {
           var serializedParams = $httpParamSerializer(params);
           if (serializedParams.length > 0) {
                   baseURL += ((baseURL.indexOf('?') === -1) ? '?' : '&') + serializedParams;
           }

            return baseURL;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .factory('DateUtils', DateUtils);

    DateUtils.$inject = ['$filter'];

    function DateUtils ($filter) {

        var service = {
            convertDateTimeFromServer : convertDateTimeFromServer,
            convertLocalDateFromServer : convertLocalDateFromServer,
            convertLocalDateToServer : convertLocalDateToServer,
            dateformat : dateformat
        };

        return service;

        function convertDateTimeFromServer (date) {
            if (date) {
                return new Date(date);
            } else {
                return null;
            }
        }

        function convertLocalDateFromServer (date) {
            if (date) {
                var dateString = date.split('-');
                return new Date(dateString[0], dateString[1] - 1, dateString[2]);
            }
            return null;
        }

        function convertLocalDateToServer (date) {
            if (date) {
                return $filter('date')(date, 'yyyy-MM-dd');
            } else {
                return null;
            }
        }

        function dateformat () {
            return 'yyyy-MM-dd';
        }
    }

})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .factory('DataUtils', DataUtils);

    DataUtils.$inject = ['$window'];

    function DataUtils ($window) {

        var service = {
            abbreviate: abbreviate,
            byteSize: byteSize,
            openFile: openFile,
            toBase64: toBase64
        };

        return service;

        function abbreviate (text) {
            if (!angular.isString(text)) {
                return '';
            }
            if (text.length < 30) {
                return text;
            }
            return text ? (text.substring(0, 15) + '...' + text.slice(-10)) : '';
        }

        function byteSize (base64String) {
            if (!angular.isString(base64String)) {
                return '';
            }

            function endsWith(suffix, str) {
                return str.indexOf(suffix, str.length - suffix.length) !== -1;
            }

            function paddingSize(base64String) {
                if (endsWith('==', base64String)) {
                    return 2;
                }
                if (endsWith('=', base64String)) {
                    return 1;
                }
                return 0;
            }

            function size(base64String) {
                return base64String.length / 4 * 3 - paddingSize(base64String);
            }

            function formatAsBytes(size) {
                return size.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' bytes';
            }

            return formatAsBytes(size(base64String));
        }

        function openFile (type, data) {
            $window.open('data:' + type + ';base64,' + data, '_blank', 'height=300,width=400');
        }

        function toBase64 (file, cb) {
            var fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = function (e) {
                var base64Data = e.target.result.substr(e.target.result.indexOf('base64,') + 'base64,'.length);
                cb(base64Data);
            };
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .filter('capitalize', capitalize);

    function capitalize() {
        return capitalizeFilter;

        function capitalizeFilter (input) {

            if (typeof value === "undefined" || value === undefined || value === null) {
                return "";
            }
            input = input.toLowerCase();
            return input.substring(0, 1).toUpperCase() + input.substring(1);
        }
    }
})();
;
(function() {
    'use strict';

    /*Using this directive requires the table to be wrapped in a DIV element*/
    angular
        .module('edistradadhluiApp')
        .directive("callFunctionAfterNgRepeat", [function() {
            return {
                restrict: 'A',
                scope: false,
                link: function(scope, element, attrs) {
                    if (scope.$last){
                      window.alert("im the last!");
                    }
                }
            };
        }]);
})();
;
(function() {
    /*jshint bitwise: false*/
    'use strict';

    angular
        .module('edistradadhluiApp')
        .factory('Base64', Base64);

    function Base64 () {
        var keyStr = 'ABCDEFGHIJKLMNOP' +
            'QRSTUVWXYZabcdef' +
            'ghijklmnopqrstuv' +
            'wxyz0123456789+/' +
            '=';

        var service = {
            decode : decode,
            encode : encode
        };

        return service;

        function encode (input) {
            var output = '',
                chr1, chr2, chr3 = '',
                enc1, enc2, enc3, enc4 = '',
                i = 0;

            while (i < input.length) {
                chr1 = input.charCodeAt(i++);
                chr2 = input.charCodeAt(i++);
                chr3 = input.charCodeAt(i++);

                enc1 = chr1 >> 2;
                enc2 = ((chr1 & 3) << 4) | (chr2 >> 4);
                enc3 = ((chr2 & 15) << 2) | (chr3 >> 6);
                enc4 = chr3 & 63;

                if (isNaN(chr2)) {
                    enc3 = enc4 = 64;
                } else if (isNaN(chr3)) {
                    enc4 = 64;
                }

                output = output +
                    keyStr.charAt(enc1) +
                    keyStr.charAt(enc2) +
                    keyStr.charAt(enc3) +
                    keyStr.charAt(enc4);
                chr1 = chr2 = chr3 = '';
                enc1 = enc2 = enc3 = enc4 = '';
            }

            return output;
        }

        function decode (input) {
            var output = '',
                chr1, chr2, chr3 = '',
                enc1, enc2, enc3, enc4 = '',
                i = 0;

            // remove all characters that are not A-Z, a-z, 0-9, +, /, or =
            input = input.replace(/[^A-Za-z0-9\+\/\=]/g, '');

            while (i < input.length) {
                enc1 = keyStr.indexOf(input.charAt(i++));
                enc2 = keyStr.indexOf(input.charAt(i++));
                enc3 = keyStr.indexOf(input.charAt(i++));
                enc4 = keyStr.indexOf(input.charAt(i++));

                chr1 = (enc1 << 2) | (enc2 >> 4);
                chr2 = ((enc2 & 15) << 4) | (enc3 >> 2);
                chr3 = ((enc3 & 3) << 6) | enc4;

                output = output + String.fromCharCode(chr1);

                if (enc3 !== 64) {
                    output = output + String.fromCharCode(chr2);
                }
                if (enc4 !== 64) {
                    output = output + String.fromCharCode(chr3);
                }

                chr1 = chr2 = chr3 = '';
                enc1 = enc2 = enc3 = enc4 = '';
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .directive('principalProperty', ['Principal', function(Principal) {

			return {
				restrict: "A",
				link: function(scope, element, attrs) {
					var property  = attrs.principalProperty;
					element.text(Principal.getProperty(property));
				}
			}
		}]);
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .filter('findKeyFromLanguage', findKeyFromLanguage);

    function findKeyFromLanguage() {
        return findKeyFromLanguageFilter;

        function findKeyFromLanguageFilter(lang) {
            return {
                'Català': 'ca',
                'Český': 'cs',
                'Dansk': 'da',
                'Deutsch': 'de',
                'Ελληνικά': 'el',
                'English': 'en',
                'Español': 'es',
                'Français': 'fr',
                'Galego': 'gl',
                'Magyar': 'hu',
                'हिंदी': 'hi',
                'Italiano': 'it',
                '日本語': 'ja',
                '한국어': 'ko',
                'मराठी': 'mr',
                'Dutch': 'nl',
                'Polski': 'pl',
                'Português (Brasil)': 'pt-br',
                'Português': 'pt-pt',
                'Română': 'ro',
                'Русский': 'ru',
                'Slovenský': 'sk',
                'Svenska': 'sv',
                'தமிழ்': 'ta',
                'Türkçe': 'tr',
                '中文（简体）': 'zh-cn',
                '繁體中文': 'zh-tw'
            }[lang];
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .factory('JhiLanguageService', JhiLanguageService);

    JhiLanguageService.$inject = ['$q', '$http', '$translate', 'LANGUAGES'];

    function JhiLanguageService($q, $http, $translate, LANGUAGES) {
        var service = {
            getAll: getAll,
            getCurrent: getCurrent
        };

        return service;

        function getAll() {
            var deferred = $q.defer();
            deferred.resolve(LANGUAGES);
            return deferred.promise;
        }

        function getCurrent() {
            var deferred = $q.defer();
            var language = $translate.storage().get('NG_TRANSLATE_LANG_KEY');

            if (!language) language = "nl";

            deferred.resolve(language);

            return deferred.promise;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .filter('findLanguageFromKey', findLanguageFromKey);

    function findLanguageFromKey() {
        return findLanguageFromKeyFilter;

        function findLanguageFromKeyFilter(lang) {
            return {
                'ca': 'Català',
                'cs': 'Český',
                'da': 'Dansk',
                'de': 'Deutsch',
                'el': 'Ελληνικά',
                'en': 'English',
                'es': 'Español',
                'fr': 'Français',
                'gl': 'Galego',
                'hu': 'Magyar',
                'hi': 'हिंदी',
                'it': 'Italiano',
                'ja': '日本語',
                'ko': '한국어',
                'mr': 'मराठी',
                'nl': 'Dutch',
                'pl': 'Polski',
                'pt-br': 'Português (Brasil)',
                'pt-pt': 'Português',
                'ro': 'Română',
                'ru': 'Русский',
                'sk': 'Slovenský',
                'sv': 'Svenska',
                'ta': 'தமிழ்',
                'tr': 'Türkçe',
                'zh-cn': '中文（简体）',
                'zh-tw': '繁體中文'
            }[lang];
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .controller('JhiLanguageController', JhiLanguageController);

    JhiLanguageController.$inject = ['$translate', 'JhiLanguageService', 'tmhDynamicLocale'];

    function JhiLanguageController ($translate, JhiLanguageService, tmhDynamicLocale) {
        var vm = this;

        vm.changeLanguage = changeLanguage;
        vm.languages = null;
        vm.getLanguage = getLanguage;

        JhiLanguageService.getAll().then(function (languages) {
            vm.languages = languages;
        });

        function changeLanguage (languageKey) {
            $translate.use(languageKey);
            tmhDynamicLocale.set(languageKey);
        }

        function getLanguage(){
            return tmhDynamicLocale.get();
        }
    }
})();
;
(function () {
    'use strict';

    angular
        .module('edistradadhluiApp')

        /*
         Languages codes are ISO_639-1 codes, see http://en.wikipedia.org/wiki/List_of_ISO_639-1_codes
         They are written in English to avoid character encoding issues (not a perfect solution)
         */
        .constant('LANGUAGES', [
            'en',
            'nl',
            "fr",
            "de"
        ]
    );
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .directive('smartFloat', function() {

            return {
                require: '?ngModel',
                link: function(scope, element, attrs, ngModelCtrl) {
                    if (!ngModelCtrl) {
                        return;
                    }

                    ngModelCtrl.$parsers.push(function(val) {
                        if (angular.isUndefined(val)) {
                            val = '';
                        } else {
                        	val = val.toString();
                        }
                        var clean = val.replace(/[^0-9,.-]+/g, '');
                        if (val !== clean) {
                            ngModelCtrl.$setViewValue(clean);
                            ngModelCtrl.$render();
                        }
                        return clean;
                    });

                    element.bind('keypress', function(event) {
                        if (event.keyCode === 32) {
                            event.preventDefault();
                        }
                    });
                }
            };
        });
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .directive('pemail', [function() {

            return {
                require: 'ngModel',
                restrict: 'E',
                replace: 'true',
                template: "<input type='text' id='dhlEmail' name='dhlEmail' class='form-control register-input normal-form' "+
                "ng-model='vm.data.email' autocomplete='off' tooltip-placement='top' ng-class='registerEmail' "+
                "uib-tooltip={{dynamicTooltip}} tooltip-placement='top'/>",
                link: function(scope, element, attributes, control) {
                    // Required
                    control.$validators.required = jQuery.proxy(function(value) {
                        return (!control.$isEmpty(value));
                    }, element);

                    // Validate email
                    control.$validators.email = jQuery.proxy(function(value) {
                        return (control.$isEmpty(value) || /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value));
                    }, element);
                }
            }
        }]);
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .directive('nip', ['UtilService', 'UsersService', '$q', '$translate', '$translatePartialLoader', function(UtilService, UsersService, $q, $translate, $translatePartialLoader) {

            return {
                require: 'ngModel',
                restrict: 'E',
                replace: 'true',
                template: "<input type='text' id='dhlNip' name='dhlNip' ng-pattern='vm.pattern' maxlength='{{vm.patternMaxLength}}' minlength='{{vm.patternMinLength}}' class='form-control register-input normal-form'ng-model='vm.data.nip' uib-tooltip={{nipTooltip()}} tooltip-placement='top' required='required' ng-class='registerNip' />",
                link: function(scope, element, attributes, control) {
                    $translatePartialLoader.addPart('register');
                    $translate.refresh();
                    //Required
                    control.$validators.required = jQuery.proxy(function(value) {
                        return (!control.$isEmpty(value));
                    }, element);

                    //allow only digits
                    control.$parsers.push(function(val) {
                        if (angular.isUndefined(val)) {
                            var val = '';
                        }
                        var clean = val.replace(/[^0-9]+/g, '');
                        if (val !== clean) {
                            control.$setViewValue(clean);
                            control.$render();
                        }
                        return clean;
                    });
                    
                    //ignore space
                    $(element).bind('keypress', function(event) {
                        if (event.keyCode === 32) {
                            event.preventDefault();
                        }
                    });

                    scope.nipTooltip = function() {
                        var tooltipNip = '';
                        if (control.$error.maximum || control.$error.minimum || control.$error.validDigits)
                            tooltipNip = $translate.instant('directives.requiredNip');
                        else if (control.$error.required)
                            tooltipNip = $translate.instant('directives.requiredNip');

                        return tooltipNip;
                    };

                    $(element).on('keyup change', function(event) {
                        if ($("#dhlNip").hasClass("ng-invalid"))
                            $("#dhlNipLabel").addClass("red");
                        else
                            $("#dhlNipLabel").removeClass("red");
                    });
                }
            }
        }]);
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .directive('legalEntity', ['UtilService', 'UsersService', '$q', '$translate', '$translatePartialLoader', function(UtilService, UsersService, $q, $translate, $translatePartialLoader) {
            return {
                require: 'ngModel',
                restrict: 'E',
                replace: 'true',
                template: "<select type='text' name='dhlLegalEntity'" +
                "ng-model='entity'" +
                "ng-change='vm.getNIPPattern()'" +
                "ng-options='entity.sourceName as entity.name for entity in entities'" +
                "class='form-control register-input normal-form'" +
                "autocomplete='off' id='dhlLegalEntity'>" +
                "</select>",
                link: function(scope, element, attributes, control) {

                    $translatePartialLoader.addPart('register');
                    $translate.refresh();
                }
            };
        }]);
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .directive('invoice', ['UtilService', 'UsersService', '$q', '$translate', '$translatePartialLoader', function(UtilService, UsersService, $q, $translate, $translatePartialLoader) {

            return {
                require: 'ngModel',
                restrict: 'E',
                replace: 'true',
                template: "<input type='text' name='dhlInvoice' class='form-control register-input normal-form' autocomplete='off' id='dhlInvoice' placeholder='' required='required' ng-model='vm.data.invoiceNr' ng-maxlength='256' ng-class='registerInvoice' uib-tooltip={{invoiceTooltip()}} tooltip-placement='top' />",
                link: function(scope, element, attributes, control) {
                    $translatePartialLoader.addPart('register');
                    $translate.refresh();
                    // Only numbers
                    control.$parsers.push(function(val) {
                        if (angular.isUndefined(val)) {
                            var val = '';
                        }
                        var clean = val.replace(/[^0-9]+/g, '');
                        if (val !== clean) {
                            control.$setViewValue(clean);
                            control.$render();
                        }
                        return clean;
                    });

                    $(element).bind('keypress', function(event) {
                        if (event.keyCode === 32) {
                            event.preventDefault();
                        }
                    });

                    // Required
                    control.$validators.required = jQuery.proxy(function(value) {
                        return (!control.$isEmpty(value));
                    }, element);

                    scope.invoiceTooltip = function() {
                        var tooltipInvoice = '';
                        if (control.$error.required)
                            tooltipInvoice = $translate.instant("directives.requiredInvoice");
                        return tooltipInvoice;
                    }

                    $(element).on('keyup change ', function(event) {
                        if ($("#dhlInvoice").hasClass("ng-invalid"))
                            $("#dhlInvoicedhlLabel").addClass("red")
                        else
                            $("#dhlInvoicedhlLabel").removeClass("red")
                    });
                }
            }
        }]);
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .directive('gross', ['UtilService', 'UsersService', '$q', '$translate', '$translatePartialLoader', function(UtilService, UsersService, $q, $translate, $translatePartialLoader) {
            return {
                require: 'ngModel',
                restrict: 'E',
                replace: 'true',
                template: "<input id='dhlGrossAmount' name='dhlGrossAmount' class='form-control register-input normal-form' required='required' ng-model='vm.data.totalAmount' type='text' ng-class='registerGrossAmount' smart-float ng-pattern='/^[+-]?[0-9]+([.,][0-9]{1,2})?$/' uib-tooltip='{{grossTooltip()}}'  tooltip-placement='top' />",
                link: function(scope, element, attributes, control) {
                    $translatePartialLoader.addPart('register');
                    $translate.refresh();
                    //Only numbers
                    control.$parsers.push(function(val) {
                        if (angular.isUndefined(val)) {
                            var val = '';
                        }
                        var clean = val.replace(/[^0-9,.-]+/g, '');
                        if (val !== clean) {
                            control.$setViewValue(clean);
                            control.$render();
                        }
                        return clean;
                    });

                    $(element).bind('keypress', function(event) {
                        if (event.keyCode === 32) {
                            event.preventDefault();
                        }
                    });
                    //Required
                    control.$validators.required = jQuery.proxy(function(value) {
                        return (!control.$isEmpty(value));
                    }, element);
                    // Begins
                    control.$validators.format = jQuery.proxy(function(value) {
                        return (control.$isEmpty(value) || /^[+-]?[0-9]+([.,][0-9]{1,2})?$/.test(value));
                    }, element);

                    scope.grossTooltip = function() {
                        var tooltipGross = '';
                        if (control.$error.required)
                            tooltipGross = $translate.instant("directives.giveValidTotal");
                        else if (control.$error.format)
                            tooltipGross = $translate.instant("directives.invalidTotal");
                        return tooltipGross;
                    }

                    $(element).on('keyup change ', function(event) {
                        if ($("#dhlGrossAmount").hasClass("ng-invalid"))
                            $("#dhlGrossAmountLabel").addClass("red")
                        else
                            $("#dhlGrossAmountLabel").removeClass("red")
                    });
                }
            }
        }]);
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .directive('fileUpload', function() {
            return {
                require: 'ngModel',
                restrict: 'A',
                scope: {
                    fileUpload: '&'
                },
                link: function(scope, element, attributes, control) {
                    element.on('change', onChange);
                    scope.$on('destroy', function () {
                        element.off('change', onChange);
                    });
                    function onChange() {
                        control.$setViewValue(element[0].files[0]);
                        scope.$apply(function () {
                            scope.fileUpload();
                        });
                    }
                }
            };
        });
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .directive('email', ['UtilService', 'UsersService', '$q', '$translate', '$translatePartialLoader', function(UtilService, UsersService, $q, $translate, $translatePartialLoader) {

            return {
                require: 'ngModel',
                restrict: 'E',
                replace: 'true',
                template: "<input type='text' id='dhlEmail' name='dhlEmail' class='form-control register-input normal-form' " +
                    "ng-model='vm.data.email' autocomplete='off' tooltip-placement='top' ng-class='registerEmail' " +
                    "uib-tooltip={{emailTooltip()}} tooltip-placement='top'/>",
                link: function(scope, element, attributes, control) {
                    $translatePartialLoader.addPart('register');
                    $translate.refresh();
                    //Required
                    control.$validators.required = jQuery.proxy(function(value) {
                        return (!control.$isEmpty(value));
                    }, element);

                    //Validate maximum
                    control.$validators.max = jQuery.proxy(function(value) {
                        var maximum = 256;
                        if (UtilService.isFilled($(this).attr('data-max')))
                            maximum = $(this).attr('data-max');
                        return (control.$isEmpty(value) || (value.length <= maximum));
                    }, element);

                    //Validate email
                    control.$validators.email = jQuery.proxy(function(value) {
                        return (control.$isEmpty(value) || /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value));
                    }, element);

                    scope.emailTooltip = function() {
                        var tooltip = '';
                        if (control.$error.max)
                            tooltip += $translate.instant("directives.maxEmail1") + ($(this).attr('data-max') || 256) + $translate.instant("directives.maxEmail2");
                        if (control.$error.email)
                            tooltip += $translate.instant("directives.requiredEmail");
                        else if (control.$error.required)
                            tooltip += $translate.instant("directives.giveValidEmail");

                        return tooltip;
                    }

                    $(element).on('keyup change ', function(event) {
                        if ($("#dhlEmail").hasClass("ng-invalid"))
                            $("#dhlEmailLabel").addClass("red")
                        else
                            $("#dhlEmailLabel").removeClass("red")
                    });
                }
            }
        }]);
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .directive('demail', ['UtilService', '$translate', '$translatePartialLoader', function(UtilService, $translate, $translatePartialLoader) {

            return {
                require: 'ngModel',
                restrict: 'E',
                replace: 'true',
                template: "<input type='text' id='email' name='email' class='form-control dispute-input normal-form' " +
                    "ng-model='vm.data.email' autocomplete='off' tooltip-placement='top' " +
                    "uib-tooltip={{emailTooltip()}} tooltip-placement='top' ng-change='vm.toggleRetypeEmailField()'/>",
                link: function(scope, element, attributes, control) {
                    $translatePartialLoader.addPart('register');
                    $translate.refresh();
                    // Required
                    control.$validators.required = jQuery.proxy(function(value) {
                        return (!control.$isEmpty(value));
                    }, element);

                    // Validate maximum
                    control.$validators.max = jQuery.proxy(function(value) {
                        var maximum = 256;
                        if (UtilService.isFilled($(this).attr('data-max')))
                            maximum = $(this).attr('data-max');
                        return (control.$isEmpty(value) || (value.length <= maximum));
                    }, element);

                    // Validate email
                    control.$validators.email = jQuery.proxy(function(value) {
                        return (control.$isEmpty(value) || /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value));
                    }, element);

                    scope.emailTooltip = function() {
                        var tooltip = '';
                        if (control.$error.max)
                            tooltip += $translate.instant("directives.maxEmail1") + ($(this).attr('data-max') || 256) + $translate.instant("directives.maxEmail2");
                        if (control.$error.email)
                            tooltip += $translate.instant("directives.requiredEmail");
                        else if (control.$error.required)
                            tooltip += $translate.instant("directives.giveValidEmail");

                        return tooltip;
                    }

                    $(element).on('keyup change ', function(event) {
                        if ($("#dhlEmail").hasClass("ng-invalid"))
                            $("#dhlEmailLabel").addClass("red")
                        else
                            $("#dhlEmailLabel").removeClass("red")
                    });
                }
            }
        }]);
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .directive('client', ['UtilService', 'UsersService', '$q', '$translate', '$translatePartialLoader', function(UtilService, UsersService, $q, $translate, $translatePartialLoader) {
            return {
                require: 'ngModel',
                restrict: 'E',
                replace: 'true',
                template: "<input type='text' ng-pattern='/^[0-9]+$/' smart-float class='form-control register-input normal-form' autocomplete='off' id='dhlClientCode' uib-tooltip='{{clientTooltip()}}'' tabindex=0 ng-model='vm.data.clientCode' ng-maxlength='128'></input>",
                link: function(scope, element, attributes, control) {
                    $translatePartialLoader.addPart('register');
                    $translate.refresh();
                    //Validate minimum
                    control.$validators.minimum = jQuery.proxy(function(value) {
                        var minimum = 8;
                        if (UtilService.isFilled($(this).attr('data-min')))
                            minimum = $(this).attr('data-min');
                        return (control.$isEmpty(value) || (value.length >= minimum));
                    }, element);
                    //Validate maximum
                    control.$validators.maximum = jQuery.proxy(function(value) {
                        var maximum = 8;
                        if (UtilService.isFilled($(this).attr('data-max')))
                            maximum = $(this).attr('data-max');
                        return (control.$isEmpty(value) || (value.length <= maximum));
                    }, element);

                    control.$parsers.push(function(val) {
                        if (angular.isUndefined(val)) {
                            var val = '';
                        }
                        var clean = val.replace(/[^0-9]+/g, '');
                        if (val !== clean) {
                            control.$setViewValue(clean);
                            control.$render();
                        }
                        return clean;
                    });

                    $(element).bind('keypress', function(event) {
                        if (event.keyCode === 32) {
                            event.preventDefault();
                        }
                    });

                    scope.clientTooltip = function() {
                        return scope.$conditionalTranslate(control.$error.minimum || control.$error.maximum, "directives.giveValidClientNumber");
                    };

                    // Live validation tooltip
                    $(element).on('keyup change ', function(event) {
                        if ($("#dhlClientCode").hasClass("ng-invalid"))
                            $("#dhlClientCodeLabel").addClass("red");
                        else
                            $("#dhlClientCodeLabel").removeClass("red");
                    });
                }
            }
        }]);
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .directive('showValidation', showValidation);

    function showValidation () {
        var directive = {
            restrict: 'A',
            require: 'form',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element) {
            element.find('.form-group').each(function() {
                var $formGroup = angular.element(this);
                var $inputs = $formGroup.find('input[ng-model],textarea[ng-model],select[ng-model]');

                if ($inputs.length > 0) {
                    $inputs.each(function() {
                        var $input = angular.element(this);
                        scope.$watch(function() {
                            return $input.hasClass('ng-invalid') && $input.hasClass('ng-dirty');
                        }, function(isInvalid) {
                            $formGroup.toggleClass('has-error', isInvalid);
                        });
                    });
                }
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .constant('paginationConstants', {
            'itemsPerPage': 20
        });
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .directive('minbytes', minbytes);

    function minbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.minbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) >= attrs.minbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .directive('maxbytes', maxbytes);

    function maxbytes () {
        var directive = {
            restrict: 'A',
            require: '?ngModel',
            link: linkFunc
        };

        return directive;

        function linkFunc (scope, element, attrs, ngModel) {
            if (!ngModel) {
                return;
            }

            ngModel.$validators.maxbytes = function (modelValue) {
                return ngModel.$isEmpty(modelValue) || numberOfBytes(modelValue) <= attrs.maxbytes;
            };
        }

        function endsWith(suffix, str) {
            return str.indexOf(suffix, str.length - suffix.length) !== -1;
        }

        function paddingSize(base64String) {
            if (endsWith('==', base64String)) {
                return 2;
            }
            if (endsWith('=', base64String)) {
                return 1;
            }
            return 0;
        }

        function numberOfBytes(base64String) {
            return base64String.length / 4 * 3 - paddingSize(base64String);
        }
    }

})();
;
(function() {
    'use strict';

    /*Using this directive requires the table to be wrapped in a DIV element*/
    angular
        .module('edistradadhluiApp')
        .directive("fixTable", ['$compile', function($compile) {
            return {
                restrict: 'A',
                scope: false,
                link: function(scope, element, attrs) {
                    var table = $(element),
                        fixedHeader,
                        fixedFooter,
                        wrapper = table.closest('div');

                    fixedHeader = table.clone();
                    fixedHeader.find("tbody").remove().end() //Remove body
                        .find("tfoot").remove().end() //Remove footer
                        .addClass("alt-fixed") //Add class that fixes this element
                        .removeAttr('fix-table') //Remove this directive
                        .insertBefore(table); //Insert before table
                    $compile(fixedHeader)(scope); //Inject into AngularJS

                    fixedFooter = table.clone();
                    fixedFooter.find("tbody").remove().end() //Remove body
                        .find("thead").remove().end() //Remove footer
                        .addClass("alt-fixed") //Add class that fixes this element
                        .removeAttr('fix-table') //Remove this directive
                        .insertAfter(table); //Insert after table
                    fixedFooter.css('bottom', 0); //Fix footer at the bottom, instead of top
                    $compile(fixedFooter)(scope); //Inject into AngularJS

                    function resizeFixed() {
                        var tableOffsetLeft = table.offset().left,
                            tableCutLeft = wrapper.offset().left - tableOffsetLeft,
                            tableCutRight = table.width() - wrapper.width() - tableCutLeft,
                            tableInnerWidth = table.width() - tableCutRight;

                        resizeFixedColumns(fixedHeader, table);
                        resizeFixedColumns(fixedFooter, table);

                        function resizeFixedColumns(elementToResize, modelElement) {
                            elementToResize.css('left', tableOffsetLeft); //Move element to left, just as modelElement
                            elementToResize.css('clip', 'rect(0px ' + tableInnerWidth + 'px auto ' + tableCutLeft + 'px)'); //Clip element to not stick out of the wrapper
                            //Resize columns taking colspan attribute into consideration
                            var column = 0;
                            var elementSelector = "th";
                            elementToResize.find("th").each(resizeFixedColumn);
                            elementSelector = "tfoot td";
                            elementToResize.find("td").each(resizeFixedColumn);

                            function resizeFixedColumn(index, element) {
                                if (index == 0) column = 0;
                                var matchingColumn = modelElement.find(elementSelector).eq(column++);
                                if (!$(matchingColumn).hasClass('ng-hide')) {
                                    $(this).css("min-width", matchingColumn.outerWidth(true) + "px");
                                    $(this).css("max-width", matchingColumn.outerWidth(true) + "px");
                                } else {
                                    $(this).css("min-width", "0");
                                    $(this).css("max-width", "0");
                                }
                            }
                        }
                    }

                    function scrollFixed() {
                        try { //To avoid console errors before AngularJS initialization
                            var fixedPart = $('#fixed')[0] != undefined ? $('#fixed') : $('#shell'),
                                windowPart = $(window),
                                topPosition = fixedPart.offset().top - windowPart.scrollTop() + fixedPart.outerHeight(),
                                offsetTop = fixedPart.offset().top + fixedPart.outerHeight(),
                                offsetBottom = windowPart.scrollTop() + windowPart.outerHeight(),
                                tableOffsetTop = table.offset().top,
                                tableOffsetBottom = tableOffsetTop + table.outerHeight();

                            if ((offsetTop < tableOffsetTop || offsetTop > tableOffsetBottom) && !fixedHeader.is(":hidden")) {
                                fixedHeader.css('top', topPosition + "px");
                                fixedHeader.hide();
                            } else if (offsetTop >= tableOffsetTop && offsetTop <= tableOffsetBottom) {
                                var headerSpaceLeft = tableOffsetBottom - fixedHeader.outerHeight() - offsetTop;
                                fixedHeader.css('top', (headerSpaceLeft > 0 ? topPosition : topPosition + headerSpaceLeft) + "px");
                                fixedHeader.show();
                            }

                            if (offsetBottom < tableOffsetTop + fixedFooter.outerHeight() + fixedHeader.outerHeight() || offsetBottom > tableOffsetBottom) {
                                fixedFooter.hide();
                            } else if (offsetBottom >= tableOffsetTop && offsetBottom <= tableOffsetBottom && fixedFooter.is(":hidden")) {
                                fixedFooter.show();
                            }
                        } catch (e) {
                            if (!e instanceof TypeError)
                                throw e;
                        } finally {}
                    }

                    function adjustFixed() {
                        resizeFixed();
                        scrollFixed();
                    }

                    //This function shows changes made to footer and header
                    function move() {
                        $(window).scrollTop($(window).scrollTop() + 1);
                        $(window).scrollTop($(window).scrollTop() - 1);
                    }

                    //Timeout prevents huge lag due to massive amount of function calls
                    var handlerTimeout;
                    //React to window resize, window scroll, wrapper DIV scroll and table header DOM manipulation events
                    $(window).resize(ResizeAndScrollHandler);
                    $(window).scroll(ResizeAndScrollHandler);
                    $(table.closest('div')).scroll(ResizeAndScrollHandler);
                    $(table.find('thead')).bind("DOMSubtreeModified", DOMModificationHandler);
                    $(table).bind("DOMNodeInserted", DOMModificationHandler);

                    function ResizeAndScrollHandler() {
                        clearTimeout(handlerTimeout);
                        adjustFixed();
                    }

                    function DOMModificationHandler() {
                        clearTimeout(handlerTimeout);
                        handlerTimeout = setTimeout(function() {
                            adjustFixed();
                            move();
                        }, 100);
                    }

                    table.on('$destroy', function() {
                        $(window).unbind('resize', ResizeAndScrollHandler);
                        $(window).unbind('scroll', ResizeAndScrollHandler);
                    });
                }
            };
        }]);
})();
;
(function() {
    'use strict';

    /*Using this directive requires the table to be wrapped in a DIV element*/
    angular
        .module('edistradadhluiApp')
        .directive("dynamicHeight", ['$compile', function($compile) {
            return {
                restrict: 'A',
                scope: {
                    dhElementId: '@'
                },
                link: function(scope, element, attrs) {
                    scope.$watch(function(){ //watch any changes to our element
                        $(scope.dhElementId).css('padding-top', element[0].offsetHeight);
                    });

                    scope.$on('alert-service-event', function(evt, data) {
                        $(scope.dhElementId).css('padding-top', element[0].offsetHeight);
                    });
                }
            };
        }]);
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .directive("confirm", ['$document', '$parse','$translate','$translatePartialLoader', function($document, $parse,$translate,$translatePartialLoader) {
            return {
                restrict: 'A',
                link: function(scope, element, attrs) {
                    var buttonId, html, message, nope, title, yep;
                    $translatePartialLoader.addPart('global');
                    $translate.refresh();
                    buttonId = Math.floor(Math.random() * 10000000000);

                    attrs.buttonId = buttonId;

                    message = attrs.message || $translate.instant("confirm.areYouSure");
                    yep = attrs.yes || $translate.instant("confirm.yes");
                    nope = attrs.no || $translate.instant("confirm.no");
                    title = attrs.title || $translate.instant("confirm.confirm");

                    html = "<div id='button-" + buttonId + "' class='confirm'><span class='confirmpopover-msg'>" + message + "</span><br><div class='confirmbutton-yes btn btn-primary btn-fill btn-round'>" + yep + "</div><div class='confirmbutton-no btn btn-primary btn-round'>" + nope + "</div></div>";

                    element.popover({
                        content: html,
                        html: true,
                        trigger: "manual",
                        title: title,
                        container: 'body',
                        placement: 'top auto'
                    });

                    return element.bind('click', function(e) {
                        var dontBubble, pop;
                        dontBubble = true;

                        e.stopPropagation();

                        element.popover('show');

                        pop = $("#button-" + buttonId);

                        pop.closest(".popover").click(function(e) {
                            if (dontBubble) {
                                e.stopPropagation();
                            }
                        });

                        pop.find('.confirmbutton-yes').click(function(e) {
                            dontBubble = false;

                            var func = $parse(attrs.confirm);
                            func(scope);
                        });

                        pop.find('.confirmbutton-no').click(function(e) {
                            dontBubble = false;

                            $document.off('click.confirmbutton.' + buttonId);

                            element.popover('hide');
                        });

                        $document.on('click.confirmbutton.' + buttonId, ":not(.popover, .popover *)", function() {
                            $document.off('click.confirmbutton.' + buttonId);
                            element.popover('hide');
                        });
                    });
                }
            };
        }]);
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .directive('clickToEdit', ['$timeout', '$compile', function($timeout, $compile) {
            return {
                require: 'ngModel',
                scope: {
                    model: '=ngModel',
                    type: '@type'
                },
                replace: true,
                transclude: false,
                // includes our template
                templateUrl: 'app/components/form/clickToEdit.html',
                link: function(scope, element, attrs, model) {
                    scope.editState = false;

                    // make a local ref so we can back out changes, this only happens once and persists
                    scope.element = element;

                    if (!String.prototype.startsWith) {
                        String.prototype.startsWith = function(searchString, position) {
                            position = position || 0;
                            return this.indexOf(searchString, position) === position;
                        };
                    }

                    var input = element.find("input");
                    for (var attr in attrs.$attr) {
                        if (attrs.$attr[attr].startsWith("data-")) {
                            input.attr(attrs.$attr[attr].replace("data-", ""), element.attr(attrs.$attr[attr]));
                        }
                    };
                    input.append($compile(input)(scope));
                    if( attr == "textarea" ){
                        input.remove();
                    } else {
                        var textarea = element.find("textarea");
                        textarea.remove();
                    }

                    // apply the changes to the real model
                    scope.save = function($event) {
                        scope.toggle($event);
                    };

                    // don't apply changes
                    scope.cancel = function($event) {
                        scope.model = scope.localModel;
                        scope.toggle($event);
                    }

                    scope.edit = function($event) {
                        scope.localModel = scope.model;
                        scope.toggle($event);
                    }

                    /*
                     * toggles the editState of our field
                     */
                    scope.toggle = function($event) {
                        scope.editState = !scope.editState;

                        /*
                         * a little hackish - find the "type" by class query
                         *
                         */
                        var x1 = scope.element.find('input');


                        /*
                         * could not figure out how to focus on the text field, needed $timout
                         * http://stackoverflow.com/questions/14833326/how-to-set-focus-on-input-field-in-angularjs
                         */
                        $timeout(function($event) {
                            // focus if in edit, blur if not. some IE will leave cursor without the blur
                            if (scope.editState) {
                                x1.focus();
                                x1.select();
                            } else
                                x1.blur();
                        }, 0);
                    }
                }
            }
        }]).directive('ngEnter', function() {
            return function(scope, element, attrs) {
                element.unbind("keypress keydown");
                element.bind("keypress keydown", function(event) {
                    if (event.which === 13) {
                        scope.$apply(function() {
                            scope.$eval(attrs.ngEnter);
                        });
                        event.preventDefault();
                    } else if (event.which === 27) {
                        scope.$apply(function() {
                            scope.$eval(attrs.ngEscape);
                        });
                        event.preventDefault();
                    }
                });
            };
        });

})();
;
(function() {
    'use strict';

    var jhiAlertError = {
        template: '<div class="alerts" ng-cloak="">' +
                        '<div ng-repeat="alert in $ctrl.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
                            '<uib-alert ng-cloak="" type="{{alert.type}}" close="alert.close($ctrl.alerts)"><pre>{{ alert.msg }}</pre></uib-alert>' +
                        '</div>' +
                  '</div>',
        controller: jhiAlertErrorController
    };

    angular
        .module('edistradadhluiApp')
        .component('jhiAlertError', jhiAlertError);

    jhiAlertErrorController.$inject = ['$scope', 'AlertService', '$rootScope', '$translate'];

    function jhiAlertErrorController ($scope, AlertService, $rootScope, $translate) {
        var vm = this;

        vm.alerts = [];

        function addErrorAlert (message, key, data) {
            key = key ? key : message;
            vm.alerts.push(
                AlertService.add(
                    {
                        type: 'danger',
                        msg: key,
                        params: data,
                        timeout: 5000,
                        toast: AlertService.isToast(),
                        scoped: true
                    },
                    vm.alerts
                )
            );
        }

        var cleanHttpErrorListener = $rootScope.$on('edistradadhluiApp.httpError', function (event, httpResponse) {
            var i;
            event.stopPropagation();
            switch (httpResponse.status) {
            // connection refused, server not reachable
            case 0:
                addErrorAlert('Server not reachable','error.server.not.reachable');
                break;

            case 400:
                var errorHeader = httpResponse.headers('X-edistradadhluiApp-error');
                var entityKey = httpResponse.headers('X-edistradadhluiApp-params');
                if (errorHeader) {
                    var entityName = $translate.instant('global.menu.entities.' + entityKey);
                    addErrorAlert(errorHeader, errorHeader, {entityName: entityName});
                } else if (httpResponse.data && httpResponse.data.fieldErrors) {
                    for (i = 0; i < httpResponse.data.fieldErrors.length; i++) {
                        var fieldError = httpResponse.data.fieldErrors[i];
                        // convert 'something[14].other[4].id' to 'something[].other[].id' so translations can be written to it
                        var convertedField = fieldError.field.replace(/\[\d*\]/g, '[]');
                        var fieldName = $translate.instant('edistradadhluiApp.' + fieldError.objectName + '.' + convertedField);
                        addErrorAlert('Field ' + fieldName + ' cannot be empty', 'error.' + fieldError.message, {fieldName: fieldName});
                    }
                } else if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message, httpResponse.data.message, httpResponse.data);
                } else {
                    addErrorAlert(httpResponse.data);
                }
                break;

            case 404:
                addErrorAlert('Not found','error.url.not.found');
                break;

            default:
                if (httpResponse.data && httpResponse.data.message) {
                    addErrorAlert(httpResponse.data.message);
                } else {
                    addErrorAlert(angular.toJson(httpResponse));
                }
            }
        });

        $scope.$on('$destroy', function () {
            if(angular.isDefined(cleanHttpErrorListener) && cleanHttpErrorListener !== null){
                cleanHttpErrorListener();
                vm.alerts = [];
            }
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .provider('AlertService', AlertService);

    function AlertService() {
        this.toast = false;
        /*jshint validthis: true */
        this.$get = getService;

        this.showAsToast = function(isToast) {
            this.toast = isToast;
        };

        getService.$inject = ['$timeout', '$sce', '$translate'];

        function getService($timeout, $sce, $translate) {
            var toast = this.toast,
                alertId = 0, // unique id for each alert. Starts from 0.
                alerts = [],
                timeout = 0; // default timeout

            return {
                factory: factory,
                isToast: isToast,
                add: addAlert,
                closeAlert: closeAlert,
                closeAlertByIndex: closeAlertByIndex,
                clear: clear,
                get: get,
                success: success,
                error: error,
                info: info,
                warning: warning
            };

            function isToast() {
                return toast;
            }

            function clear() {
                alerts.length = 0;
            }

            function get() {
                return alerts;
            }

            function success(msg, params, position) {
                return this.add({
                    type: 'success',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function error(msg, params, position) {
                return this.add({
                    type: 'danger',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function warning(msg, params, position) {
                return this.add({
                    type: 'warning',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function info(msg, params, position) {
                return this.add({
                    type: 'info',
                    msg: msg,
                    params: params,
                    timeout: timeout,
                    toast: toast,
                    position: position
                });
            }

            function factory(alertOptions) {
                var alert = {
                    type: alertOptions.type,
                    msg: alertOptions.msg instanceof Function ? alertOptions.msg : $sce.trustAsHtml(alertOptions.msg),
                    id: alertOptions.alertId,
                    timeout: alertOptions.timeout,
                    toast: alertOptions.toast,
                    position: alertOptions.position ? alertOptions.position : 'top right',
                    scoped: alertOptions.scoped,
                    close: function(alerts) {
                        return closeAlert(this.id, alerts);
                    }
                };
                if (!alert.scoped) {
                    // Faster than clear() and alerts.push
                    alerts[0] = alert;
                }
                return alert;
            }

            function addAlert(alertOptions, extAlerts) {
                alertOptions.alertId = alertId++;
                var that = this;

                if (!(alertOptions.msg instanceof Function) && alertOptions.params != null) {
                    return $translate(alertOptions.msg, alertOptions.params)
                        .then(function(response) {
                            alertOptions.msg = response;
                            return doRest();
                        });
                }

                return doRest();

                function doRest() {
                    var alert = that.factory(alertOptions);
                    if (alertOptions.timeout && alertOptions.timeout > 0) {
                        $timeout(function() {
                            that.closeAlert(alertOptions.alertId, extAlerts);
                        }, alertOptions.timeout);
                    }
                    return alert;
                }
            }

            function closeAlert(id, extAlerts) {
                var thisAlerts = extAlerts ? extAlerts : alerts;
                return closeAlertByIndex(thisAlerts.map(function(e) {
                    return e.id;
                }).indexOf(id), thisAlerts);
            }

            function closeAlertByIndex(index, thisAlerts) {
                return thisAlerts.splice(index, 1);
            }
        }
    }
})();
;
(function() {
    'use strict';

    var portalAlert = {
        template: '<span class="container container-fluid" style="padding:0;" ng-show="vm.alerts.length > 0" ng-cloak="">' +
            '<div ng-repeat="alert in vm.alerts" ng-class="[alert.position, {\'toast\': alert.toast}]">' +
            '<uib-alert  type="{{alert.type}}" close="alert.close(vm.alerts); vm.onClose(alert)">{{vm.get(alert.msg)}}</uib-alert>' +
            '</div>' +
            '</span>',
        controller: portalAlertController,
        controllerAs: 'vm'
    };

    angular
        .module('edistradadhluiApp')
        .component('portalAlert', portalAlert);

    portalAlertController.$inject = ['$rootScope', '$scope', '$timeout', 'AlertService', '$sce'];

    function portalAlertController($rootScope, $scope, $timeout, AlertService, $sce) {
        var vm = this;

        vm.get = function(functionOrTranslatedString) {
            if (functionOrTranslatedString instanceof Function)
                return $sce.trustAsHtml(functionOrTranslatedString());
            else
                return functionOrTranslatedString;
        }

        vm.onClose = function(alert) {
            setTimeout(function() {
                $('#under-fixed').css('padding-top', $('#fixed').height());
                $(window).trigger('scroll');
            }, 100);

        }


        vm.alerts = AlertService.get();

        $scope.$watch('vm.alerts', function(newValue, oldValue) {
            $timeout(function() { $rootScope.$broadcast('alert-service-event'); }, 0);
        }, true);
        $scope.$on('$destroy', function() {
            vm.alerts = [];
            AlertService.clear();
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .service('HttpPendingRequestsService', HttpPendingRequestsService)
        .factory('serviceUnavailableInterceptor', serviceUnavailableInterceptor);

    serviceUnavailableInterceptor.$inject = ['$window', '$q', 'HttpPendingRequestsService'];

    function serviceUnavailableInterceptor ($window, $q, HttpPendingRequestsService) {
        var service = {
            request: handleRequest,
            responseError: handleResponseError
        };

        return service;

        function handleResponseError(response) {
            if (response.status === 404 && angular.isDefined(response.data) && response.data.rest_not_available === true) {
                HttpPendingRequestsService.cancelAll();
                $window.location.href = $window.location.origin + "/40x.htm";
                throw new Error("Backend is not available! Redirecting to mainenance page.");
            }

            if (response.config.timeout.isGloballyCancelled) {
                return $q.defer().promise;
            }
            return $q.reject(response);
        }

        function handleRequest(config) {
            config = config || {};
            if (config.timeout === undefined && !config.noCancelOnRouteChange) {
                config.timeout = HttpPendingRequestsService.newTimeout();
            }
            return config;
        }
    }

    HttpPendingRequestsService.$inject = ['$q'];

    function HttpPendingRequestsService($q) {
        var cancelPromises = [];

        function newTimeout() {
            var cancelPromise = $q.defer();
            cancelPromises.push(cancelPromise);
            return cancelPromise.promise;
        }

        function cancelAll() {
            angular.forEach(cancelPromises, function(cancelPromise) {
                cancelPromise.promise.isGloballyCancelled = true;
                cancelPromise.resolve();
            });
            cancelPromises.length = 0;
        }

        return {
            newTimeout: newTimeout,
            cancelAll: cancelAll
        };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .factory('notificationInterceptor', notificationInterceptor);

    notificationInterceptor.$inject = ['$q', 'AlertService'];

    function notificationInterceptor ($q, AlertService) {
        var service = {
            response: response
        };

        return service;

        function response (response) {
            var alertKey = response.headers('X-edistradadhluiApp-alert');
            if (angular.isString(alertKey)) {
                AlertService.success(alertKey, { param : response.headers('X-edistradadhluiApp-params')});
            }
            return response;
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .factory('errorHandlerInterceptor', errorHandlerInterceptor);

    errorHandlerInterceptor.$inject = ['$q', '$rootScope'];

    function errorHandlerInterceptor ($q, $rootScope) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError (response) {
            if (!(response.status === 401 && (response.data === '' || (response.data.path && response.data.path.indexOf('/api/account') === 0 )))) {
                $rootScope.$emit('edistradadhluiApp.httpError', response);
            }
            return $q.reject(response);
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .factory('authExpiredInterceptor', authExpiredInterceptor);


    authExpiredInterceptor.$inject = ['$rootScope', '$q', '$injector', '$document'];

    function authExpiredInterceptor($rootScope, $q, $injector, $document) {
        var service = {
            responseError: responseError
        };

        return service;

        function responseError(response) {
            // If we have an unauthorized request we redirect to the login page
            // Don't do this check on the account API to avoid infinite loop
            if (response.status === 401 && response.config.url.indexOf('api/session') === -1) {
                var Auth = $injector.get('Auth');
                var to = $rootScope.toState;
                var params = $rootScope.toStateParams;
                Auth.logout();
                if (to.name !== 'accessdenied' && to.name !== 'login') {
                    Auth.storePreviousState(to.name, params);
                }
                var state = $injector.get('$state');
                state.go('login');
            } else if (response.status === 403 && response.config.method !== 'GET' && getCSRF() === '') {
                // If the CSRF token expired, then try to get a new CSRF token and retry the old request
                var $http = $injector.get('$http');
                return $http.get($rootScope.API_URL + 'api/csrf').finally(function() {
                    return afterCSRFRenewed(response);
                });
            }
            return $q.reject(response);
        }

        function getCSRF() {
            var doc = $document[0];
            if (doc) {
                var name = 'CSRF-TOKEN=';
                var ca = doc.cookie.split(';');
                for (var i = 0; i < ca.length; i++) {
                    var c = ca[i];
                    while (c.charAt(0) === ' ') { c = c.substring(1); }

                    if (c.indexOf(name) !== -1) {
                        return c.substring(name.length, c.length);
                    }
                }
            }
            return '';
        }

        function afterCSRFRenewed(oldResponse) {
            if (getCSRF() !== '') {
                // retry the old request after the new CSRF-TOKEN is obtained
                var $http = $injector.get('$http');
                return $http(oldResponse.config);
            } else {
                // unlikely get here but reject with the old response any way and avoid infinite loop
                return $q.reject(oldResponse);
            }
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .factory('translationHandler', translationHandler);

    translationHandler.$inject = ['$rootScope', '$window', '$state', '$translate', 'Principal'];

    function translationHandler($rootScope, $window, $state, $translate, Principal) {
        return {
            initialize: initialize,
            updateTitle: updateTitle
        };

        function initialize() {
            // if the current translation changes, update the window title
            var translateChangeSuccess = $rootScope.$on('$translateChangeSuccess', function(event, change) {
                updateTitle();
                Principal.updateLanguage(change.language);
            });

            $rootScope.$on('$destroy', function() {
                if (angular.isDefined(translateChangeSuccess) && translateChangeSuccess !== null) {
                    translateChangeSuccess();
                }
            });
        }

        // update the window title using params in the following
        // precendence
        // 1. titleKey parameter
        // 2. $state.$current.data.pageTitle (current state page title)
        // 3. 'global.title'
        function updateTitle(titleKey) {
            if (!titleKey && $state.$current.data && $state.$current.data.pageTitle) {
                titleKey = $state.$current.data.pageTitle;
            }
            $translate(titleKey || 'global.title').then(function(title) {
                $window.document.title = title;
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .factory('stateHandler', stateHandler);

    stateHandler.$inject = ['$rootScope', '$state', '$sessionStorage', '$translate', 'JhiLanguageService', 'translationHandler', '$window',
        'Auth', 'Principal', 'VERSION'
    ];

    function stateHandler($rootScope, $state, $sessionStorage, $translate, JhiLanguageService, translationHandler, $window,
        Auth, Principal, VERSION) {
        return {
            initialize: initialize
        };

        function initialize() {
            $rootScope.VERSION = VERSION;

            var stateChangeStart = $rootScope.$on('$stateChangeStart', function(event, toState, toStateParams, fromState) {
                $rootScope.toState = toState;
                $rootScope.toStateParams = toStateParams;
                $rootScope.fromState = fromState;

                // Redirect to a state with an external URL (http://stackoverflow.com/a/30221248/1098564)
                if (toState.external) {
                    event.preventDefault();
                    $window.open(toState.url, '_self');
                }

                if (toState.redirectTo) {
                    event.preventDefault();
                    $state.go(toState.redirectTo, toStateParams);
                }

                if (Principal.isIdentityResolved()) {
                    Auth.authorize();
                }


                // Update the language
                JhiLanguageService.getCurrent().then(function(language) {
                    $translate.use(language);
                });

            });

            var stateChangeSuccess = $rootScope.$on('$stateChangeSuccess', function(event, toState, toParams, fromState, fromParams) {
                var titleKey = 'global.title';

                // Set the page title key to the one configured in state or use default one
                if (toState.data.pageTitle) {
                    titleKey = toState.data.pageTitle;
                }
                translationHandler.updateTitle(titleKey);
            });

            $rootScope.$on('$destroy', function() {
                if (angular.isDefined(stateChangeStart) && stateChangeStart !== null) {
                    stateChangeStart();
                }
                if (angular.isDefined(stateChangeSuccess) && stateChangeSuccess !== null) {
                    stateChangeSuccess();
                }
            });
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .config(paginationConfig);

    paginationConfig.$inject = ['uibPaginationConfig', 'paginationConstants'];

    function paginationConfig(uibPaginationConfig, paginationConstants) {
        uibPaginationConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPaginationConfig.maxSize = 5;
        uibPaginationConfig.boundaryLinks = true;
        uibPaginationConfig.firstText = '«';
        uibPaginationConfig.previousText = '‹';
        uibPaginationConfig.nextText = '›';
        uibPaginationConfig.lastText = '»';
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .config(pagerConfig);

    pagerConfig.$inject = ['uibPagerConfig', 'paginationConstants'];

    function pagerConfig(uibPagerConfig, paginationConstants) {
        uibPagerConfig.itemsPerPage = paginationConstants.itemsPerPage;
        uibPagerConfig.previousText = '«';
        uibPagerConfig.nextText = '»';
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .factory('translationStorageProvider', translationStorageProvider);

    translationStorageProvider.$inject = ['$cookies', '$log', 'LANGUAGES'];

    function translationStorageProvider($cookies, $log, LANGUAGES) {
        return {
            get: get,
            put: put
        };

        function get(name) {
            if (LANGUAGES.indexOf($cookies.getObject(name)) === -1) {
                $log.info('Resetting invalid cookie language "' + $cookies.getObject(name) + '" to prefered language "nl"');
                $cookies.putObject(name, 'nl');
            }
            return $cookies.getObject(name);
        }

        function put(name, value) {
            $cookies.putObject(name, value);
        }
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .config(translationConfig);

    translationConfig.$inject = ['$translateProvider', 'tmhDynamicLocaleProvider'];

    function translationConfig($translateProvider, tmhDynamicLocaleProvider) {
        // Initialize angular-translate
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: 'i18n/{lang}/{part}.json'
        });

        $translateProvider.preferredLanguage('nl');
        $translateProvider.useStorage('translationStorageProvider');
        $translateProvider.useSanitizeValueStrategy('escaped');
        $translateProvider.addInterpolation('$translateMessageFormatInterpolation');

        tmhDynamicLocaleProvider.localeLocationPattern('i18n/angular-locale_{{locale}}.js');
        tmhDynamicLocaleProvider.useCookieStorage();
        tmhDynamicLocaleProvider.storageKey('NG_TRANSLATE_LANG_KEY');
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .config(ngMaterialConfig);

    ngMaterialConfig.$inject = ['$mdThemingProvider', '$mdDateLocaleProvider'];

    function ngMaterialConfig($mdThemingProvider, $mdDateLocaleProvider) {
        $mdThemingProvider.theme('default')
            .primaryPalette('red')
            .accentPalette('red');

        $mdDateLocaleProvider.firstDayOfWeek = 1;
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .config(localStorageConfig);

    localStorageConfig.$inject = ['$localStorageProvider', '$sessionStorageProvider'];

    function localStorageConfig($localStorageProvider, $sessionStorageProvider) {
        $localStorageProvider.setKeyPrefix('dhl-portal-');
        $sessionStorageProvider.setKeyPrefix('dhl-portal-');
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .config(httpConfig);

    httpConfig.$inject = ['$urlRouterProvider', '$httpProvider', 'httpRequestInterceptorCacheBusterProvider', '$urlMatcherFactoryProvider'];

    function httpConfig($urlRouterProvider, $httpProvider, httpRequestInterceptorCacheBusterProvider, $urlMatcherFactoryProvider) {
        //enable CSRF
        $httpProvider.defaults.xsrfCookieName = '__Host-CSRF-TOKEN';
        $httpProvider.defaults.xsrfHeaderName = 'X-CSRF-TOKEN';

        //Cache everything except REST API requests
        httpRequestInterceptorCacheBusterProvider.setMatchlist([/.*i18n.*/,/.*api.*/], true);

        $urlRouterProvider.otherwise('/');

        // tmp solution no 'home page' currently
        $urlRouterProvider.when('', ['$state', '$match', 'Principal', function($state, $match, Principal) {
            Principal.identity().then(function(response) {
                if (response) {
                    $state.go('documents');
                } else {
                    $state.go('login');
                }
            });

        }]);
        $httpProvider.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';
        $httpProvider.defaults.headers.common['X-Frame-Options'] = 'DENY';


        $httpProvider.interceptors.push('serviceUnavailableInterceptor');
        $httpProvider.interceptors.push('errorHandlerInterceptor');
        $httpProvider.interceptors.push('authExpiredInterceptor');
        $httpProvider.interceptors.push('notificationInterceptor');

        $urlMatcherFactoryProvider.type('boolean', {
            name: 'boolean',
            decode: function(val) {
                return val === true || val === 'true';
            },
            encode: function(val) {
                return val ? 1 : 0;
            },
            equals: function(a, b) {
                return this.is(a) && a === b;
            },
            is: function(val) {
                return [true, false, 0, 1].indexOf(val) >= 0;
            },
            pattern: /bool|true|0|1/
        });
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .config(dateFormatConfig);

    dateFormatConfig.$inject = ['$mdDateLocaleProvider'];

    function dateFormatConfig($mdDateLocaleProvider) {
         $mdDateLocaleProvider.formatDate = function(date) {

            if (date!=null){
                  var day = date.getDate();
                  var monthIndex = date.getMonth();
                  var year = date.getFullYear();

                  return year + '-' + ((monthIndex + 1 < 10 ? '0':'') + (monthIndex + 1)) + '-' + ((day < 10 ? '0':'')+day)  ;
            } else {
                 return "";
            }
         };
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .config(compileServiceConfig);

    compileServiceConfig.$inject = ['$compileProvider','DEBUG_INFO_ENABLED'];

    function compileServiceConfig($compileProvider,DEBUG_INFO_ENABLED) {
        // disable debug data on prod profile to improve performance
        $compileProvider.debugInfoEnabled(DEBUG_INFO_ENABLED);

        /*
        If you wish to debug an application with this information
        then you should open up a debug console in the browser
        then call this method directly in this console:

		angular.reloadWithDebugInfo();
		*/
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .config(alertServiceConfig);

    alertServiceConfig.$inject = ['AlertServiceProvider'];

    function alertServiceConfig(AlertServiceProvider) {
        // set below to true to make alerts look like toast
        AlertServiceProvider.showAsToast(false);
    }
})();
;
(function() {
    'use strict';

    angular
        .module('edistradadhluiApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('site', {
                abstract: true,
                views: {
                    'footer@': {
                        templateUrl: 'app/layouts/footer/footer.html'
                    },
                    'shell@': {
                        templateUrl: 'app/layouts/shell/shell.html',
                        controller: 'ShellController',
                        controllerAs: 'vm'
                    }
                },
                resolve: {
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('global');
                    }]
                }

            })
            .state('application', {
                parent: 'site',
                abstract: true,
                url: '/app',
                views: {
                    'content@': {
                        templateUrl: 'app/layouts/application/application.html'
                    }
                },
                resolve: {
                    authorize: ['Auth',
                        function (Auth) {
                            return Auth.authorize();
                        }
                    ]
                }
            });
    }
})();
;
/*
This file contains declarations for not-everywhere supported JavaScript functions.
*/

if (!String.prototype.endsWith) {
    String.prototype.endsWith = function(searchString, position) {
        var subjectString = this.toString();
        if (typeof position !== 'number' || !isFinite(position) || Math.floor(position) !== position || position > subjectString.length) {
            position = subjectString.length;
        }
        position -= searchString.length;
        var lastIndex = subjectString.lastIndexOf(searchString, position);
        return lastIndex !== -1 && lastIndex === position;
    };
}

if (!Array.prototype.indexOf) {
    Array.prototype.indexOf = function(searchElement, fromIndex) {

        var k;

        // 1. Let o be the result of calling ToObject passing
        //    the this value as the argument.
        if (this == null) {
            throw new TypeError('"this" is null or not defined');
        }

        var o = Object(this);

        // 2. Let lenValue be the result of calling the Get
        //    internal method of o with the argument "length".
        // 3. Let len be ToUint32(lenValue).
        var len = o.length >>> 0;

        // 4. If len is 0, return -1.
        if (len === 0) {
            return -1;
        }

        // 5. If argument fromIndex was passed let n be
        //    ToInteger(fromIndex); else let n be 0.
        var n = +fromIndex || 0;

        if (Math.abs(n) === Infinity) {
            n = 0;
        }

        // 6. If n >= len, return -1.
        if (n >= len) {
            return -1;
        }

        // 7. If n >= 0, then Let k be n.
        // 8. Else, n<0, Let k be len - abs(n).
        //    If k is less than 0, then let k be 0.
        k = Math.max(n >= 0 ? n : len - Math.abs(n), 0);

        // 9. Repeat, while k < len
        while (k < len) {
            // a. Let Pk be ToString(k).
            //   This is implicit for LHS operands of the in operator
            // b. Let kPresent be the result of calling the
            //    HasProperty internal method of o with argument Pk.
            //   This step can be combined with c
            // c. If kPresent is true, then
            //    i.  Let elementK be the result of calling the Get
            //        internal method of o with the argument ToString(k).
            //   ii.  Let same be the result of applying the
            //        Strict Equality Comparison Algorithm to
            //        searchElement and elementK.
            //  iii.  If same is true, return k.
            if (k in o && o[k] === searchElement) {
                return k;
            }
            k++;
        }
        return -1;
    };
}
;
(function () {
    'use strict';
    // DO NOT EDIT THIS FILE, EDIT THE GULP TASK NGCONSTANT SETTINGS INSTEAD WHICH GENERATES THIS FILE
    angular
        .module('edistradadhluiApp')
        .constant('VERSION', "132.0.0-22-gc653c860")
        .constant('DEBUG_INFO_ENABLED', false)
        .constant('API_URL', {
	"BE": "https://dhl.be.qas-benelux.edistrada.pl/edistrada2/",
	"EC": "https://dhl.nl.qas-benelux.edistrada.pl/edistrada2/",
	"NL": "https://dhl.nl.qas-benelux.edistrada.pl/edistrada2/"
})
        .constant('SHELL_LOGO_HREF', "/BENELUXUI")
;
})();
;(function(){angular.module('edistradadhluiApp').run(['$templateCache', function($templateCache) {$templateCache.put('app/components/form/clickToEdit.html','<div class="templateRoot"> <div class="hover-edit-trigger"> <div class="hover-text-field" ng-show="!editState && $root.Principal.hasClientWrite()" ng-click="edit($event)" style="height: 30px">{{model}} <button class="btn" style="margin-left:15px"><i class="fa fa-pencil"></i></button> </div> <div class="hover-text-field" ng-show="!editState && !$root.Principal.hasClientWrite()">{{model}} </div> <div class="input-group" ng-show="editState && $root.Principal.hasClientWrite()"> <input class="form-control" type="text" ng-model="model" ng-enter="toggle($event)" ng-escape="cancel($event)"> <textarea class="form-control" rows="5" cols="30" ng-model="model" ng-enter="toggle($event)" ng-escape="cancel($event)" maxlength="100"></textarea> <div class="input-group-btn"> <button class="btn" ng-click="save($event)"><i class="fa fa-check"></i></button> <button class="btn" ng-click="cancel($event)"><i class="fa fa-times"></i></button> </div> </div> </div> </div> ');
$templateCache.put('app/layouts/application/application.html','<div ui-view="content"> <!-- Angular views --> </div> ');
$templateCache.put('app/layouts/error/accessdenied.html','<div ng-cloak> <div class="row"> <div class="col-md-4"> <span class="hipster img-responsive img-rounded"></span> </div> <div class="col-md-8"> <h1 translate="error.title">Error Page!</h1> <div class="alert alert-danger" translate="error.403">You are not authorized to access the page. </div> </div> </div> </div> ');
$templateCache.put('app/layouts/error/error.html','<div ng-cloak> <div class="row"> <div class="col-md-4"> <span class="hipster img-responsive img-rounded"></span> </div> <div class="col-md-8"> <h1 translate="error.title">Error page!</h1> <div ng-show="errorMessage"> <div class="alert alert-danger">{{errorMessage}} </div> </div> </div> </div> </div> ');
$templateCache.put('app/layouts/footer/footer.html','<footer> <div class="container container-fluid"> <div class="float-left"><a href="https://www.all-for-one.pl" target="_blank"><span class="copyrights">2024 All For One Poland Sp. z o.o. </span></a></div><div class="float-right tag" id="version_text" align="right"></div> </div> </footer> ');
$templateCache.put('app/layouts/shell/shell.html','<header ng-hide="vm.state.current.name === \'disputeForm\'"> <div class="top"> <div class="container container-fluid"> <a id="top-logo" href="{{vm.logoHref}}"> <img id="logo-top" src="content/images/DHL_rgb.png" alt="DHL eCommerce"> <span id="title-top" class="b">DHL eCommerce</span> </a> <div class="user-profile"> <p> <span ng-if="$root.Principal.isAuthenticated()" class="nicname">{{$root.Principal.getProperty(\'login\')}}</span> <a ng-if="$root.Principal.isAuthenticated()" href="#" ng-click="vm.logout()" class="btn btn-logout"><span translate="global.logout">Wyloguj</span> <i class="fa fa-sign-out"></i></a> </p> <span id="lang" ui-sref-active="active" uib-dropdown class="langController dropdown pointer" ng-controller="JhiLanguageController as languageVm"> <a class="dropdown-toggle" uib-dropdown-toggle href="" ng-if="languageVm.languages.length > 1"> <span> <span class="glyphicon glyphicon-flag"></span> <span class="hidden-sm" translate="global.menu.language">Language</span> <b class="caret"></b> </span> </a> <ul class="dropdown-menu" uib-dropdown-menu ng-if="languageVm.languages.length > 1"> <li active-menu="{{language}}" ng-repeat="language in languageVm.languages"> <a href="" ng-click="languageVm.changeLanguage(language);"> <img ng-src="content/images/ignore/flags/{{language}}.png" class="flag"> {{language | findLanguageFromKey}}</a> </li> </ul> </span> <span ng-if="$root.Principal.isAuthenticated()" ng-init="vm.getLegalEntities()"> <span id="entity" ui-sref-active="active" uib-dropdown ng-if="vm.entities.length > 0"> <a class="dropdown-toggle" uib-dropdown-toggle href=""> <span> <span class="glyphicon glyphicon-globe"></span> <span class="hidden-sm" translate="global.menu.entity">Legal entity</span> <img width="20px" height="15px" ng-src="content/images/ignore/flags/{{$root.Principal.getCurrentEntityLowerCase()}}.png"> <b class="caret"></b> </span> </a> <ul class="dropdown-menu" uib-dropdown-menu> <li active-menu="{{entity}}" ng-repeat="entity in vm.entities"> <a href="" ng-click="vm.changeEntity(entity);"> <img ng-src="content/images/ignore/flags/{{entity.toLowerCase()}}.png" class="flag"> <span translate="global.legalentities.{{entity}}">{{entity}}</span> </a> </li> </ul> </span> </span> </div> </div> </div> <div us-spinner="{color: \'#d40511\', radius:7, width:3, length: 5, opacity:0, trail:100, top:\'27%\'}"> </div> <nav class="navbar navbar-default navbar-dhl"> <div class="container-fluid"> <!-- Brand and toggle get grouped for better mobile display --> <div class="navbar-header"> <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#bs-example-navbar-collapse-1" aria-expanded="false"> <span class="sr-only">Toggle navigation</span> <span class="icon-bar"></span> <span class="icon-bar"></span> <span class="icon-bar"></span> </button> </div> <div class="collapse navbar-collapse" style="padding-left:0px"> <ul class="nav navbar-nav"> <li> <a translate="global.menu.documents" ng-if="$root.Principal.isAuthenticated()" ui-sref="documents" ui-sref-active="active">Faktury i noty</a> </li> <li><a translate="global.menu.users" ng-if="$root.Principal.isAuthenticated() && $root.Principal.hasUserRead() && ($root.Principal.hasSystemAccess() || $root.Principal.hasTemplateAccess())" ui-sref="users" ui-sref-active="active">U\u017Cytkownicy</a> </li> <li><a translate="global.menu.users" ng-if="$root.Principal.isAuthenticated() && $root.Principal.hasUserRead() && ! $root.Principal.hasSystemAccess() && ! $root.Principal.hasTemplateAccess()" ui-sref="users" ui-sref-active="active">U\u017Cytkownicy</a> </li> <li> <a translate="global.menu.settings" ng-if="$root.Principal.isAuthenticated()" ui-sref="settings" ui-sref-active="active">Ustawienia</a> </li><li><a translate="global.menu.clients" ng-if="$root.Principal.isAuthenticated()" ui-sref="clients" ui-sref-active="active">Klienci</a> </li><li><a translate="global.menu.roles" ng-if="$root.Principal.isAuthenticated() && $root.Principal.hasSystemAccess()" ui-sref="roles" ui-sref-active="active">Role</a> </li> <li><a translate="global.menu.pending-cases" ng-if="$root.Principal.isAuthenticated() && ($root.Principal.hasSystemAccess() || $root.Principal.hasTemplateAccess())" ui-sref="pending-cases" ui-sref-active="active">Sprawy oczekuj\u0105ce</a> </li> <li><a translate="global.menu.system-settings" ng-if="$root.Principal.isAuthenticated() && ($root.Principal.hasSystemAccess() || $root.Principal.hasTemplateAccess())" ui-sref="system-settings" ui-sref-active="active">Ustawienia systemu</a> </li> <li><a translate="global.menu.contact" ui-sref="contact" ui-sref-active="active">Kontakty DHL</a> </li> <li><a translate="global.menu.help" ui-sref="help" ui-sref-active="active">Pomoc</a> </li> </ul> </div> </div> </nav> </header> ');
$templateCache.put('app/views/clients/clientsPanel.html','<section class="container container-fluid" ui-view="innerContent"> </section> ');
$templateCache.put('app/views/contact/contact.html','<section class="container container-fluid embedded-page-padding"> <div class="contactdhl" style="display: inline-block; text-align: left"> <h2 class="b black delivery"><span translate="contact.howToContact">How can I contact DHL eCommerce??</span></h2> <div> <p class="b" style="padding-bottom: 1em"> <span translate="contact.visitHomepage">By visiting our DHL eCommerce homepage: </span> <a target="_blank" rel="noopener noreferrer" ng-href="{{vm.getUrl(\'visitHomepageLink\')}}">DHL eCommerce</a> </p> <p class="b" style="padding-bottom: 1em"> <span translate="contact.doorContact">Door contact with DHL eCommerce customer service: </span> <a target="_blank" rel="noopener noreferrer" ng-href="{{vm.getUrl(\'doorContactLink\')}}">{{vm.getTranslation(\'link\')}}</a> </p> <p class="b"> <span translate="contact.invoiceComplaint">Complaints related to invoices can be submitted via this email address: </span> <a href="mailto:{{vm.getUrl(\'invoiceComplaintEmail\')}}">{{vm.getUrl(\'invoiceComplaintEmail\')}}</a> </p> <p class="small"><span translate="contact.invoiceComplaint2">(eg rates not agreed with you, incorrect surcharges)</span></p> <p class="b"> <span translate="contact.serviceComplaint">Complaints about the quality of our services can be submitted via this link: </span> <a href="mailto:{{vm.getUrl(\'serviceComplaintLink\')}}">{{vm.getTranslation(\'link\')}}</a> </p> <p class="small"><span translate="contact.serviceComplaint2">(e.g. transport damage, late delivery)</span></p> <p class="b" style="padding-bottom: 1em"> <span translate="contact.terms">Information about the general terms and conditions: </span> <a target="_blank" rel="noopener noreferrer" ng-href="{{vm.getUrl(\'termsLink\')}}">{{vm.getTranslation(\'link\')}}</a> </p> <p class="b" style="padding-bottom: 1em"> <span translate="contact.shipment">Where\'s my shipment? </span> <a target="_blank" rel="noopener noreferrer" ng-href="{{vm.getUrl(\'shipmentLink\')}}">{{vm.getTranslation(\'link\')}}</a> </p> <p class="b" style="padding-bottom: 1em"> <span translate="contact.myDhl">Our all-in-one shipping solution </span> <a target="_blank" rel="noopener noreferrer" ng-href="{{vm.getUrl(\'myDhlLink\')}}">{{vm.getTranslation(\'myDhlName\')}}</a> </p> <p class="b" style="padding-bottom: 1em"> <span translate="contact.billingTeam">The billing team of eCommerce: </span> <a href="mailto:{{vm.getUrl(\'billingTeamEmail\')}}">{{vm.getUrl(\'billingTeamEmail\')}}</a> </p> </div> </div> </section> ');
$templateCache.put('app/views/documents/documents.html','<section class="container container-fluid"> <div id="fixed" class="container container-fluid embedded-page-padding" dynamic-height dh-element-id="#under-fixed"> <portal-alert></portal-alert> <div class="alert alert-success alert-dismissible" ng-if="vm.banner && vm.banner.isVisible"> <button type="button" class="close" ng-if="vm.banner.closable" ng-click="vm.banner.isVisible = false"> &times; </button> <strong translate="documents.banner.attention">Attention!</strong> <p class="banner-paragraph">{{vm.banner.line1}}</p> <p class="banner-paragraph">{{vm.banner.line2}}</p> </div> <form name="filterForm" class="form-inline" accept-charset="UTF-8" enctype="multipart/form-data"> <fieldset> <div class="form-group"> <label class="control-label"><span translate="documents.document.custNumber">Debiteuren nummer</span>:</label> <input class="form-control margin-bottom input-sm" type="text" id="cli_number" name="client_number" ng-model="vm.filter.clientNo" nip> </div> <!-- <div class="form-group">\n                    <label class="control-label"><span translate="documents.document.payerNumber">Numer p\u0142atnika</span>:</label>\n                    <input class="form-control margin-bottom input-sm" type="text" id="payer_number" name="payer_number" ng-model="vm.filter.payerNo" nip />\n                </div> --> <div class="form-group"> <label class="control-label"><span translate="documents.document.custName">Debiteuren naam</span>:</label> <input class="form-control margin-bottom input-sm" type="text" id="clientName" name="clientName" ng-model="vm.filter.clientName"> </div> <div class="form-group"> <label class="control-label"><span translate="documents.document.docNumber">Document nummer</span>:</label> <input class="form-control margin-bottom input-sm" type="text" id="document_number_start" name="document_number_start" ng-model="vm.filter.documentNoFrom" placeholder="{{ vm.translate(\'from\') }}" nip> </div> <div class="form-group"> <label class="control-label">&nbsp;</label> <input class="form-control margin-bottom input-sm" type="text" id="document_number_end" name="document_number_end" ng-model="vm.filter.documentNoTo" placeholder="{{ vm.translate(\'to\') }}" nip> </div> <!-- <div class="form-group">\n                    <label class="control-label" for="waybill"><span translate="documents.document.waybillNumber">Numer listu przewozowego</span>:</label>\n                    <input class="form-control margin-bottom input-sm" type="text" id="waybill" name="waybill" ng-model="vm.filter.waybillNo" nip />\n                </div> --> <div class="form-group"> <div class="form-group"> <label class="control-label"><span translate="documents.document.issueDate">Datum van uitgave</span>:</label> <div class="form-control-am-picker margin-bottom"> <md-datepicker class="datepicker" id="date_start" ng-model="vm.tempIssueDateFrom" md-placeholder="{{ vm.translate(\'from\') }}"></md-datepicker> </div> </div> <div class="form-group"> <label class="control-label"><span></span></label> <div class="form-control-am-picker margin-bottom"> <md-datepicker class="datepicker" id="date_end" name="date_end" ng-model="vm.tempIssueDateTo" md-placeholder="{{ vm.translate(\'to\') }}"></md-datepicker> </div> </div> </div> <div class="form-group"> <div class="form-group"> <label class="control-label"><span translate="documents.document.grossAmount">Gross amount</span>:</label> <input class="form-control form-control-short margin-bottom input-sm" smart-float ng-pattern="/^[-]?[0-9]+([.,][0-9]{1,2})?$/" type="number" id="amount_from" name="amount_from" placeholder="{{ vm.translate(\'from\') }}" ng-model="vm.filter.amountBruttoFrom" step="0.01"> </div> <div class="form-group"> <label class="control-label">&nbsp;</label> <input class="form-control form-control-short margin-bottom input-sm" smart-float ng-pattern="/^[-]?[0-9]+([.,][0-9]{1,2})?$/" type="number" id="amount_to" name="amount_to" placeholder="{{ vm.translate(\'to\') }}" ng-model="vm.filter.amountBruttoTo" step="0.01"> </div> </div> <div class="form-group"> <label><span translate="documents.document.dateOfPayment">Datum van betaling</span>:</label> <div class="form-control-am-picker margin-bottom"> <md-datepicker class="datepicker" md-placeholder="{{vm.translate(\'documents.document.choose\') }}" id="due_date" name="due_date" ng-model="vm.tempDueDate"></md-datepicker> </div> </div> <div class="form-group"> <label class="">&nbsp;</label> <div> <button type="submit" id="search" class="btn margin-bottom" ng-click="vm.list(vm.filter)"><span translate="documents.document.search">Zoeken</span> <i class="fa fa-search"></i> </button> </div> </div> <div class="form-group"> <label class="">&nbsp;</label> <div> <button type="reset" id="delete" class="btn margin-bottom" ng-click="vm.resetSearch()"><span translate="documents.document.clear">Maak leeg</span> <i class="fa fa-eraser"></i></button> </div> </div> </fieldset> </form> <b style="display: none" id="tooMany" translate="documents.download.tooMany"></b> <div class="actionButtons row"> <div class="col-xs-7"> <a class="btn" id="downloadButton" target="_blank" title="Download" ng-disabled=" vm.ediDocIds.length == \'0\'" ng-click="vm.getPDFs()"> <span translate="documents.document.download">Download</span> <i class="fa fa-download"></i> </a> <a target="_blank" class="btn" id="excelButton" title="Generate report" ng-href="{{vm.getXlsxURL()}}"> <span translate="documents.document.generateReport">Genereer rapport</span> <i class="fa fa-table"></i> </a> <button class="btn" ng-if="$root.Principal.hasTemplateAccess()" id="resendButton" title="Send again" type="button" ng-click="vm.resend()" ng-disabled=" vm.ediDocIds.length == \'0\'"> <span translate="documents.document.sendAgain">Opnieuw versturen</span> <i class="fa fa-envelope"></i> </button> <button class="btn" ng-if="$root.Principal.hasTemplateAccess()" id="transferButton" title="Transfer again" type="button" ng-click="vm.retransfer()" ng-disabled="vm.ediDocIds.length == \'0\'"> <span translate="documents.document.transferAgain">Opnieuw overdragen</span> <i class="fa fa-exchange"></i> </button> </div> <md-input-container class="col-xs-5"> <md-select class="btn pull-right md-no-underline" ng-model="vm.selectedColumns" ng-model-options="{trackBy: \'$value.name\'}" multiple="" md-on-close="onClose()" aria-label="Kolumny" md-selected-text="vm.translate(\'documents.document.chooseColumns\')" md-container-class="columnConfiguration"> <md-option ng-repeat="column in vm.columnHeaders" ng-value="column" ng-if="column.enabled"> <span translate="{{column.translate}}">{{column.label}}</span> </md-option> </md-select> </md-input-container> <div class="col-xs-12 text-center" ng-if="vm.resultParameters.limit" style="margin: 10px 0 5px 0"> <b translate="documents.search.last1000">Laatste 1000 documenten weergegeven. Om resterende facturen te zien graag zoekfilters verfijnen.</b> </div> <div class="col-xs-12 text-center" ng-if="vm.resultParameters.upper_date_bound || vm.resultParameters.lower_date_bound" style="margin: 10px 0 5px 0"> <b translate="documents.search.lastDate">Documenten van vorige maand weergegeven die aan de opgegeven criteria voldoen. Om resterende facturen te zien graag zoekfilters verfijnen.</b> </div> </div> </div> <div id="under-fixed"> <div style="width: 100%; overflow-x : auto"> <table id="fixtable" class="tablesorter latest" fix-table ng-show="vm.invoices.length > 0"> <thead> <tr> <th ng-click="vm.checkAllDocs($event)" ng-model="vm.allChecked"> <input type="checkbox"> </th> <th ng-show="vm.columns.clientNumber"> <a href="#" ng-click="vm.sortBy(\'clientNumber\', !vm.sortReverse)"> <span translate="documents.document.customer">Debiteur</span> <span ng-show="vm.sortType == \'clientNumber\' && vm.sortReverse" class="fa fa-caret-up"></span> <span ng-show="vm.sortType == \'clientNumber\' && !vm.sortReverse" class="fa fa-caret-down"></span> </a> </th> <th ng-show="vm.columns.payerNumber"> <a href="#" ng-click="vm.sortBy(\'payerNumber\', !vm.sortReverse)"> <span translate="documents.document.payer">Betaler</span> <span ng-show="vm.sortType == \'payerNumber\' && vm.sortReverse" class="fa fa-caret-up"></span> <span ng-show="vm.sortType == \'payerNumber\' && !vm.sortReverse" class="fa fa-caret-down"></span> </a> </th> <th ng-show="$root.Principal.hasUserRead() && vm.columns.dateOpen"> <a href="#" ng-click="vm.sortBy([\'openStatus\',\'dateOpen\'], !vm.sortReverse)"> <span translate="documents.document.open">Open</span> <span ng-show="vm.showCarretOnOpenColumn && vm.sortReverse" class="fa fa-caret-up"></span> <span ng-show="vm.showCarretOnOpenColumn && !vm.sortReverse" class="fa fa-caret-down"></span> </a> </th> <th ng-show="vm.columns.documentType"> <a href="#" ng-click="vm.sortBy(\'documentType\', !vm.sortReverse)"> <span translate="documents.document.docType">Document type</span> <span ng-show="vm.sortType == \'documentType\' && vm.sortReverse" class="fa fa-caret-up"></span> <span ng-show="vm.sortType == \'documentType\' && !vm.sortReverse" class="fa fa-caret-down"></span> </a> </th> <th ng-show="vm.columns.documentNumber"> <a href="#" ng-click="vm.sortBy(\'documentNumber\', !vm.sortReverse)"> <span translate="documents.document.docNumber">Document nummer</span> <span ng-show="vm.sortType == \'documentNumber\' && vm.sortReverse" class="fa fa-caret-up"></span> <span ng-show="vm.sortType == \'documentNumber\' && !vm.sortReverse" class="fa fa-caret-down"></span> </a> </th> <th ng-show="vm.columns.dateIssue"> <a href="#" ng-click="vm.sortBy(\'dateIssue\', !vm.sortReverse)"> <span translate="documents.document.issueDate">Datum van uitgave</span> <span ng-show="vm.sortType == \'dateIssue\' && vm.sortReverse" class="fa fa-caret-up"></span> <span ng-show="vm.sortType == \'dateIssue\' && !vm.sortReverse" class="fa fa-caret-down"></span> </a> </th> <th ng-show="vm.columns.dateSent"> <a href="#" ng-click="vm.sortBy(\'dateSent\', !vm.sortReverse)"> <span translate="documents.document.shippingDate">Verzenddatum</span> <span ng-show="vm.sortType == \'dateSent\' && vm.sortReverse" class="fa fa-caret-up"></span> <span ng-show="vm.sortType == \'dateSent\' && !vm.sortReverse" class="fa fa-caret-down"></span> </a> </th> <th ng-show="vm.columns.dueDate"> <a href="#" ng-click="vm.sortBy(\'dueDate\', !vm.sortReverse)"> <span translate="documents.document.dateOfPayment">Datum van betaling</span> <span ng-show="vm.sortType == \'dueDate\' && vm.sortReverse" class="fa fa-caret-up"></span> <span ng-show="vm.sortType == \'dueDate\' && !vm.sortReverse" class="fa fa-caret-down"></span> </a> </th> <th ng-show="vm.columns.currency"> <a href="#" ng-click="vm.sortBy(\'currency\', !vm.sortReverse)"> <span translate="documents.document.currency">Valuta</span> <span ng-show="vm.sortType == \'currency\' && vm.sortReverse" class="fa fa-caret-up"></span> <span ng-show="vm.sortType == \'currency\' && !vm.sortReverse" class="fa fa-caret-down"></span> </a> </th> <th ng-show="vm.columns.totalNetto"> <a href="#" ng-click="vm.sortBy(\'totalNetto\', !vm.sortReverse)"> <span translate="documents.document.netAmount">Netto bedrag</span> <span ng-show="vm.sortType == \'totalNetto\' && vm.sortReverse" class="fa fa-caret-up"></span> <span ng-show="vm.sortType == \'totalNetto\' && !vm.sortReverse" class="fa fa-caret-down"></span> </a> </th> <th ng-show="vm.columns.totalVat"> <a href="#" ng-click="vm.sortBy(\'totalVat\', !vm.sortReverse)"> <span translate="documents.document.vatAmount">BTW bedrag</span> <span ng-show="vm.sortType == \'totalVat\' && vm.sortReverse" class="fa fa-caret-up"></span> <span ng-show="vm.sortType == \'totalVat\' && !vm.sortReverse" class="fa fa-caret-down"></span> </a> </th> <th ng-show="vm.columns.totalGross"> <a href="#" ng-click="vm.sortBy(\'totalGross\', !vm.sortReverse)"> <span translate="documents.document.grossAmount">Gross amount</span> <span ng-show="vm.sortType == \'totalGross\' && vm.sortReverse" class="fa fa-caret-up"></span> <span ng-show="vm.sortType == \'totalGross\' && !vm.sortReverse" class="fa fa-caret-down"></span> </a> </th> </tr> </thead> <tbody> <tr id="topSpacer"> <td colspan="{{vm.columns.totalVisible}}" style="padding: 0 !important; margin: 0 !important"> </td> </tr> <tr ng-repeat="invoice in vm.invoices | limitTo:vm.limit:vm.topIndex track by invoice.entityId" ng-click="vm.goToPDF(invoice.entityId)"> <td ng-click="vm.checkboxClick($event, $index, invoice.entityId)"> <input type="checkbox" ng-model="invoice.selected"> </td> <td ng-show="vm.columns.clientNumber">{{ ::invoice.clientNumber }}</td> <td ng-show="vm.columns.payerNumber">{{ ::invoice.payerNumber }}</td> <td ng-show="$root.Principal.hasUserRead() && vm.columns.dateOpen">{{ ::vm.filterDateOpen(invoice.openStatus,invoice.dateOpen) }}</td> <td ng-show="vm.columns.documentType">{{ vm.filterInvoiceType(invoice.documentType)}}</td> <td ng-show="vm.columns.documentNumber">{{ ::invoice.documentNumber}}</td> <td ng-show="vm.columns.dateIssue">{{ ::invoice.dateIssue | date:\'yyyy-MM-dd\' }}</td> <td ng-show="vm.columns.dateSent">{{ ::invoice.dateSent | date:\'yyyy-MM-dd\' }}</td> <td ng-show="vm.columns.dueDate">{{ ::invoice.datePayment | date:\'yyyy-MM-dd\' }}</td> <td ng-show="vm.columns.currency">{{ ::invoice.currency }}</td> <td ng-show="vm.columns.totalNetto">{{ ::invoice.totalNetto | number:2}}</td> <td ng-show="vm.columns.totalVat">{{ ::invoice.totalVat | number:2 }}</td> <td ng-show="vm.columns.totalGross">{{ ::invoice.totalGross | number:2}}</td> </tr> <tr id="bottomSpacer"> <td colspan="{{vm.columns.totalVisible}}" style="padding: 0 !important; margin: 0 !important"> </td> </tr> </tbody> <tfoot> <tr> <td>&nbsp;</td> <td colspan="{{vm.columns.footer ? vm.columns.footerSum-1 : vm.columns.totalVisible-1}}" ng-show="(vm.columns.footer && vm.columns.footerSum > 1) || (!vm.columns.footer && vm.columns.totalVisible > 1)"> <span translate="documents.document.sumOfDocs" ng-show="vm.columns.footer ">The sum of the above documents</span> </td> <td ng-show="vm.columns.totalNetto"> {{vm.sumTotalNetto | number:2}} </td> <td ng-show="vm.columns.totalVat"> {{vm.sumTotalVat | number:2}} </td> <td ng-show="vm.columns.totalGross"> {{vm.sumTotalBrutto | number:2}} </td> </tr> </tfoot> </table> </div> </div> </section> ');
$templateCache.put('app/views/documents/download.html','<!-- NOT USED in Benelux, might be useful in future --> <div class="modal-header"> <h3 class="modal-title" translate="documents.download.title">Download</h3> </div> <form id="resend" class="inline inline-search" novalidate accept-charset="UTF-8"> <div class="modal-body"> <div class="container-fluid"> <div class="row"> <div style="padding: 5px"> <span translate="documents.download.download">Download</span>: </div> <div style="padding: 5px"> <input ng-click="vm.checkboxClick(\'PDF\')" type="checkbox" ng-model="vm.data.downloadPDF"> <span translate="documents.download.downloadPdf"></span> </div> <div style="padding: 5px; float: left; padding-right: 100px"> <input ng-click="vm.checkboxClick(\'CSV\')" type="checkbox" ng-model="vm.data.downloadCSV"> <span translate="documents.download.downloadCSV"></span> </div> <div style="padding: 5px"> <input ng-click="vm.checkboxClick(\'CSVConcatenate\')" type="checkbox" ng-model="vm.data.downloadCSVConcatenate"> <span translate="documents.download.concatenate"></span> </div> <div style="padding: 5px; float: left; padding-right: 90px"> <input ng-click="vm.checkboxClick(\'EXCEL\')" type="checkbox" ng-model="vm.data.downloadExcel"> <span translate="documents.download.downloadExcel"></span> </div> <div style="padding: 5px"> <input ng-click="vm.checkboxClick(\'ExcelConcatenate\')" type="checkbox" ng-model="vm.data.downloadExcelConcatenate"> <span translate="documents.download.concatenate"></span> </div> <div style="padding: 5px"> <input ng-click="vm.checkboxClick(\'XML\')" type="checkbox" ng-model="vm.data.downloadXML"> <span translate="documents.download.downloadXML"></span> </div> <div ng-if="$root.Principal.hasSystemAccess() || $root.Principal.hasTemplateAccess()" style="padding: 5px"> <input ng-click="vm.checkboxClick(\'CustomCSV\')" type="checkbox" ng-model="vm.data.customCSV"> <span translate="documents.customCSV.customCSV"></span> </div> </div> </div> </div> <div class="custom-csv" ng-show="vm.data.customCSV" ng-if="$root.Principal.hasSystemAccess() || $root.Principal.hasTemplateAccess()"> <hr> <section class="container container-fluid" ng-if="$root.Principal.hasSystemAccess() || $root.Principal.hasTemplateAccess()"> <div class="container-csv"> <div class="row"> <div class="col-md-12 text-right"> <label translate="documents.customCSV.loadPreservedConfiguration"></label> <select ng-model="vm.data.selectedConfig" ng-options="config for config in vm.data.savedConfigs track by config"></select> <button class="btn btn-warning" ng-click="vm.loadConfig()" translate="documents.customCSV.load"></button> <button class="btn btn-danger" ng-click="vm.deleteConfig()" translate="documents.customCSV.delete"></button> </div> </div> <div class="row"> <!-- Available Column Headers --> <div class="col-md-5"> <h4 translate="documents.customCSV.availableColumnHeaders"></h4> <select multiple="multiple" class="form-control" ng-model="vm.data.selectedAvailable" ng-model-options="{trackBy: \'$value\'}" size="10"> <option ng-repeat="item in vm.data.availableColumns track by $index" value="{{item}}"> {{item}} </option> </select> </div> <div class="col-md-2 text-center"> <button class="btn btn-warning" ng-click="vm.addRow()" translate="documents.customCSV.addRow"></button> <br><br> <button class="btn btn-danger" ng-click="vm.removeRow()" translate="documents.customCSV.removeRow"></button> </div> <!-- Selected Column Headers --> <div class="col-md-5"> <h4 translate="documents.customCSV.selectedColumnHeaders"></h4> <select multiple="multiple" class="form-control" ng-model="vm.data.selectedSelected" ng-model-options="{trackBy: \'$value\'}" size="10"> <option ng-repeat="item in vm.data.selectedColumns track by $index" value="{{item}}"> {{item}} </option> </select> </div> </div> <div class="row text-center mt-3"> <button class="btn btn-secondary" ng-click="vm.moveUp()" translate="documents.customCSV.moveUp"></button> <button class="btn btn-secondary" ng-click="vm.moveDown()" translate="documents.customCSV.moveDown"></button> </div> <div class="row mt-3"> <div class="col-md-6"> <label translate="documents.customCSV.concatenated"></label> <input type="checkbox" ng-model="vm.data.concatenated"> </div> <div class="col-md-6"> <label translate="documents.customCSV.sortOrder"></label> <select ng-model="vm.data.sortOrder" class="form-control" ng-change="vm.sortSelectedColumns()"> <option value="Ascending" translate="documents.customCSV.ascending"></option> <option value="Descending" translate="documents.customCSV.descending"></option> </select> </div> </div> <div class="row mt-3"> <div class="col-md-6"> <label translate="documents.customCSV.saveCurrentSelectionAs"></label> <input type="text" ng-model="vm.data.saveName" class="form-control"> </div> <div class="col-md-6 text-left"> <button class="btn" ng-click="vm.saveConfig()" style="margin-top: 15px" translate="documents.customCSV.save"></button> </div> </div> </div> </section> </div> <div class="modal-footer"> <a target="_blank" ng-click="vm.modal.download()" ng-href="{{vm.getDownloadURLs(vm.data.ediDocIds, vm.data.downloadPDF, vm.data.downloadCSV, vm.data.downloadCSVConcatenate, vm.data.downloadExcel, vm.data.downloadExcelConcatenate, vm.data.downloadXML)}}" class="btn" ng-disabled="!vm.data.downloadPDF && !vm.data.downloadCSV && !vm.data.downloadCSVConcatenate && !vm.data.downloadExcel && !vm.data.downloadExcelConcatenate && !vm.data.downloadXML && !vm.data.customCSV"> <span translate="documents.download.download">Download</span> <i class="fa fa-download"></i> </a> <button class="btn btn-warning" type="button" ng-click="vm.modal.cancel()"> <span translate="documents.download.cancel">Annuleerl</span> <i class="fa fa-times"></i> </button> </div> </form> ');
$templateCache.put('app/views/documents/resend.html','<div class="modal-header"> <h3 class="modal-title"><span translate="documents.resend.title">Documenten opnieuw verzenden</span></h3> </div> <form id="resend" class="inline inline-search" novalidate accept-charset="UTF-8"> <div class="modal-body"> <div class="container-fluid"> <div class="row"> <div style="padding:5px"><span translate="documents.resend.sendTo">Opnieuw sturen naar:</span></div> <div style="padding:5px"> <input type="radio" ng-model="vm.resendSelect" value="same"> <span translate="documents.resend.sameEmail"> Dezelfde e-mailadressen:</span> </div> <div style="padding:5px"> <input type="radio" ng-model="vm.resendSelect" value="new"> <span translate="documents.resend.newEmail"> Nieuwe e-mails voor eenmalig gebruik (bijv.user@dhl.com;user2@dhl.com)</span> </div> <fieldset> <div style="padding:5px"> <label for="newEmail"><span translate="documents.resend.email">E-mail:</span></label> <input id="newEmail" ng-disabled="vm.resendSelect == \'same\'" type="text" ng-model="vm.data.email" ng-change="vm.validateEmail(vm.data.email)"> </div> </fieldset> </div> </div> </div> <div class="modal-footer"> <button class="btn btn-primary" type="submit" ng-click="vm.modal.send()" ng-disabled="vm.resendSelect == \'new\' && vm.emailValidated ==false"> <span translate="documents.resend.send">Verzend</span> <i class="fa fa-envelope"></i> </button> <button class="btn btn-warning" type="button" ng-click="vm.modal.cancel()"> <span translate="documents.resend.cancel">Annuleer</span> <i class="fa fa-times"></i> </button> </div> </form> ');
$templateCache.put('app/views/error/401.html','<div class="row embedded-page-padding"> <div class="col-md-12"> <h2 class="no-m-top"><span translate="error.401.title"> Nie jeste\u015B zalogowany</span></h2> </div> </div> <div class="row"> <div class="col-md-12"> <h7 class="no-m-top" style="text-align: left"> <span translate="error.401.info">Twoja sesja wygas\u0142a lub zosta\u0142e\u015B wylogowany.</span> <br><b> <span translate="error.401.info2">Zaloguj si\u0119 ponownie.</span> </b></h7> </div> </div> <div class="row error-footer border-dotted-top"> <a ui-sref="login" class="btn btn-primary btn-round btn-fill"> <span translate="error.401.login">Zaloguj</span> </a> </div> ');
$templateCache.put('app/views/error/403.html','<div class="row embedded-page-padding"> <div class="col-md-8"> <h2 class="no-m-top"><span translate="error.403.title">Nie masz dost\u0119pu do tego zasobu</span></h2> </div> </div> <div class="row"> <div class="col-md-8"> <h7 class="no-m-top" style="text-align: left"> <span translate="error.403.info">Nie masz uprawnie\u0144, \u017Ceby ogl\u0105da\u0107 ten zas\xF3b.</span> </h7> </div> </div> <div class="row error-footer border-dotted-top"> <a ui-sref="login" class="btn btn-primary btn-round btn-fill"> <span translate="error.403.back">Powr\xF3t</span> </a> </div> ');
$templateCache.put('app/views/error/404.html','<section class="container container-fluid embedded-page-padding"> <h1 class="title"><span translate="error.404.title">Podana strona nie istnieje</span></h1> <errors></errors> <statements></statements> <p> <span translate="error.404.info"> Prawdopodobnie wpisa\u0142e\u015B z\u0142y adres lub klikn\u0105\u0142e\u015B w niewa\u017Cny link. </span> </p> <br> <button class="btn" ui-sref="{{$root.Principal.isAuthenticated() ? \'documents\' : \'login\'}}"> <span translate="error.404.back">Powr\xF3t</span></button> </section> ');
$templateCache.put('app/views/error/error.html','<div ui-view="error"></div> <!-- section --> ');
$templateCache.put('app/views/help/help.html','<section id="topid" class="embedded-page-padding"> <section class="container-fluid"> <section class="help section-help col-md-6 col-sm-7"> <div> <div class="container-service"> <div class="title help-faq" translate="help.faq">Frequently asked questions</div> <table class="service"> <tbody> <tr> <td class="help-bullet"> <a ng-click="vm.goToId($event)" href="#tip1"> <span translate="help.q1">What is DHL eCommerce e-Billing?</span> <span ng-click="vm.goToId($event)" class="has-icon-right">&#xe60A;</span> </a> </td> </tr> <tr> <td class="help-bullet"> <a ng-click="vm.goToId($event)" href="#tip2"> <span translate="help.q2">What are the benefits of DHL eCommerce e-Billing?</span> <span ng-click="vm.goToId($event)" class="has-icon-right">&#xe60A;</span> </a> </td> </tr> <tr> <td class="help-bullet"> <a ng-click="vm.goToId($event)" href="#tip3"> <span translate="help.q3">How do I sign up for DHL eCommerce e-Billing?</span> <span ng-click="vm.goToId($event)" class="has-icon-right">&#xe60A;</span> </a> </td> </tr> <tr> <td class="help-bullet"> <a ng-click="vm.goToId($event)" href="#tip4"> <span translate="help.q4">I forgot my password. How do I log in now?</span> <span ng-click="vm.goToId($event)" class="has-icon-right">&#xe60A;</span> </a> </td> </tr> <tr> <td class="help-bullet"> <a ng-click="vm.goToId($event)" href="#tip5"> <span translate="help.q5">How do I set a strong password?</span> <span ng-click="vm.goToId($event)" class="has-icon-right">&#xe60A;</span> </a> </td> </tr> <tr> <td class="help-bullet"> <a ng-click="vm.goToId($event)" href="#tip6"> <span translate="help.q6">How do I change my language?</span> <span ng-click="vm.goToId($event)" class="has-icon-right">&#xe60A;</span> </a> </td> </tr> <tr> <td class="help-bullet"> <a ng-click="vm.goToId($event)" href="#tip7"> <span translate="help.q7">Do I need to install additional software to start using DHL eCommerce e-Billing?</span> <span ng-click="vm.goToId($event)" class="has-icon-right">&#xe60A;</span> </a> </td> </tr> <tr> <td class="help-bullet"> <a ng-click="vm.goToId($event)" href="#tip8"> <span translate="help.q8">In which file types are the e-Billing invoices available?</span> <span ng-click="vm.goToId($event)" class="has-icon-right">&#xe60A;</span> </a> </td> </tr> <tr> <td class="help-bullet"> <a ng-click="vm.goToId($event)" href="#tip9"> <span translate="help.q9">How do I know there\u2019s a new invoice waiting for me?</span> <span ng-click="vm.goToId($event)" class="has-icon-right">&#xe60A;</span> </a> </td> </tr> <tr> <td class="help-bullet"> <a ng-click="vm.goToId($event)" href="#tip10"> <span translate="help.q10">Is an e-Billing invoice the same as a paper invoice?</span> <span ng-click="vm.goToId($event)" class="has-icon-right">&#xe60A;</span> </a> </td> </tr> <tr> <td class="help-bullet"> <a ng-click="vm.goToId($event)" href="#tip11"> <span translate="help.q11">How do I change the DHL company I am a client of?</span> <span ng-click="vm.goToId($event)" class="has-icon-right">&#xe60A;</span> </a> </td> </tr> <tr> <td class="help-bullet"> <a ng-click="vm.goToId($event)" href="#tip12"> <span translate="help.q12">Is DHL eCommerce e-Billing safe?</span> <span ng-click="vm.goToId($event)" class="has-icon-right">&#xe60A;</span> </a> </td> </tr> <tr> <td class="help-bullet"> <a ng-click="vm.goToId($event)" href="#tip13"> <span translate="help.q13">Does DHL eCommerce e-Billing meet the requirements for proper VAT administration?</span> <span ng-click="vm.goToId($event)" class="has-icon-right">&#xe60A;</span> </a> </td> </tr> <tr> <td class="help-bullet"> <a ng-click="vm.goToId($event)" href="#tip14"> <span translate="help.q14">Can DHL eCommerce e-Billing be integrated with my financial accounts?</span> <span ng-click="vm.goToId($event)" class="has-icon-right">&#xe60A;</span> </a> </td> </tr> </tbody> </table> </div> <br> </div> </section> </section> <hr id="tip1"> <section class="container container-fluid help"> <h2> <button class="btn" ng-click="vm.goToTop()"> <i class="fa fa-arrow-up fa-lg"></i> </button> <span translate="help.q1">What is DHL eCommerce e-Billing? </span> </h2> <div> <p translate="help.a1a">DHL eCommerce e-Billing is a convenient tool that allows you to receive and process your invoices digitally. It is much quicker and less error-prone. Digital invoicing not only saves you printing costs; the fact that it reduces paper consumption and lowers CO2 emissions means it is also better for the environment. Also nice: the tool is completely free.</p> </div> </section> <hr id="tip2"> <section class="container container-fluid help"> <h2> <button class="btn" ng-click="vm.goToTop()"> <i class="fa fa-arrow-up fa-lg"></i> </button> <span translate="help.q2">What are the benefits of DHL eCommerce e-Billing? </span> </h2> <div> <ul> <li class="list"> <p translate="help.a2a">You receive digital invoices in your mailbox automatically (e.g. weekly).</p> </li> <li class="list"> <p translate="help.a2b"> The chance of errors in your processing will be much smaller. </p> </li> <li class="list"> <p translate="help.a2c"> The tool displays invoices dynamically, contains a digital archive, and lets you easily search by invoice characteristics. </p> </li> <li class="list"> <p translate="help.a2d"> Invoice data can easily be downloaded in various formats, e.g. for your accounting or invoice control. This will save you a lot of time during input and processing. </p> </li> <li class="list"> <p translate="help.a2e"> Other versions are also possible for sending invoice data. This can, of course, be done via EDI (Electronic Data Interchange), but also in other ways, making it possible to process invoices interactively. </p> </li> <li class="list"> <p translate="help.a2f"> Do you have a question about an invoice? The tool allows you to contact a DHL employee directly. </p> </li> </ul> </div> </section> <hr id="tip3"> <section class="container container-fluid help"> <h2> <button class="btn" ng-click="vm.goToTop()"> <i class="fa fa-arrow-up fa-lg"></i> </button> <span translate="help.q3">How do I sign up for DHL eCommerce e-Billing?</span> </h2> <div> <p translate="help.a3a">Once you are a DHL eCommerce client, an e-Billing account is automatically created for you. From that moment on, you can log in and manage your invoices in this environment. </p> <br> <p translate="{{vm.getUrl(\'a3b\')}}">Are you already a client but don\u2019t have an active e-Billing account yet? Then fill in the registration form in the tool or send an email to parcelbilling-be@dhl.com with the following information: </p> <ul> <li class="list"> <p translate="help.a3c">your client number</p> </li> <li class="list"> <p translate="help.a3d">your VAT number</p> </li> <li class="list"> <p translate="help.a3e">the invoice number of the last invoice received</p> </li> <li class="list"> <p translate="help.a3f">at least one email address you want to use to log in and receive your invoices</p> </li> </ul> <br> <p translate="help.a3g">You will receive an email with an activation link and instructions to activate your account. This link is valid for 30 days.</p> </div> </section> <hr id="tip4"> <section class="container container-fluid help"> <h2> <button class="btn" ng-click="vm.goToTop()"> <i class="fa fa-arrow-up fa-lg"></i> </button> <span translate="help.q4">I forgot my password. How do I log in now?</span> </h2> <div> <p translate="{{vm.getUrl(\'a4a\')}}">Click \u2018Forgot password\u2019 on the login screen. You can then easily create a new password. Can\u2019t figure something out? Feel free to contact us via parcelbilling-be@dhl.com and we\u2019ll be happy to help you. </p> </div> </section> <hr id="tip5"> <section class="container container-fluid help"> <h2> <button class="btn" ng-click="vm.goToTop()"> <i class="fa fa-arrow-up fa-lg"></i> </button> <span translate="help.q5">How do I set a strong password?</span> </h2> <div> <p translate="help.a5a">Naturally, you want to secure your digital invoices. A strong password is therefore very important. The password for your DHL eCommerce e-Billing account must be different from your last 12 e-Billing passwords and comply with the following rules: </p> <ul> <li class="list"> <p translate="help.a5b">Minimum of 8 characters</p> </li> <li class="list"> <p translate="help.a5c">Not similar to your email address</p> </li> <li class="list"> <p translate="help.a5d">At least three of the following four options:</p> </li> <ul> <li class="innerlist"> <p translate="help.a5e">a lowercase letter </p> </li> <li class="innerlist"> <p translate="help.a5f">an uppercase letter </p> </li> <li class="innerlist"> <p translate="help.a5g">a number </p> </li> <li class="innerlist"> <p translate="help.a5h">a special character</p> </li> </ul> </ul> </div> </section> <hr id="tip6"> <section class="container container-fluid help"> <h2> <button class="btn" ng-click="vm.goToTop()"> <i class="fa fa-arrow-up fa-lg"></i> </button> <span translate="help.q6">How do I change my language?</span> </h2> <div> <p translate="help.a6a">You can change your language directly from the screen you are logged into (see Logging in), or by clicking the \u2018Language\u2019 button in the taskbar. A final change of your preference can be made via the \u2018My Profile\u2019 button. </p> </div> </section> <hr id="tip7"> <section class="container container-fluid help"> <h2> <button class="btn" ng-click="vm.goToTop()"> <i class="fa fa-arrow-up fa-lg"></i> </button> <span translate="help.q7">Do I need to install additional software to start using DHL eCommerce e-Billing?</span> </h2> <div> <p translate="help.a7a">No, there is no need to install additional software. You do need an internet browser. DHL eCommerce e-Billing works best in the latest versions of the most commonly used browsers (Google Chrome, Firefox, or Safari).</p> <p translate="help.a7b">Would you like to download the invoices in a PDF file? Then install (the free version of) Adobe Acrobat Reader to verify your electronic signature.</p> </div> </section> <hr id="tip8"> <section class="container container-fluid help"> <h2> <button class="btn" ng-click="vm.goToTop()"> <i class="fa fa-arrow-up fa-lg"></i> </button> <span translate="help.q8">In which file types are the e-Billing invoices available?</span> </h2> <div> <p translate="help.a8a">The invoice is available in PDF format by default. You can also download the invoices in CSV or XLSX format. </p> </div> </section> <hr id="tip9"> <section class="container container-fluid help"> <h2> <button class="btn" ng-click="vm.goToTop()"> <i class="fa fa-arrow-up fa-lg"></i> </button> <span translate="help.q9">How do I know there\u2019s a new invoice waiting for me?</span> </h2> <div> <p translate="help.a9a">As soon as DHL receives an invoice, it is automatically visible in e-Billing. By default, new invoices are also sent to the email address(es) that you provided.</p> <p translate="help.a9b">You will receive the invoices in PDF format as an attachment or the email will contain a link to the document. If you click the link, the PDF document will open and you can then print or save it. There is no need to log in to e-Billing. </p> </div> </section> <hr id="tip10"> <section class="container container-fluid help"> <h2> <button class="btn" ng-click="vm.goToTop()"> <i class="fa fa-arrow-up fa-lg"></i> </button> <span translate="help.q10">Nie pami\u0119tam has\u0142a do aplikacji. Jak je odzyska\u0107?</span> </h2> <div> <p translate="help.a10a">Yes. Since 2010, there has been a European VAT Directive (Directive 2010/45/EU), which stipulates that the electronic and paper invoices must meet the same requirements. This directive was transposed into Belgian law on 1 January 2013. All the extra requirements that used to be imposed on digital invoices have been abolished. </p> <p translate="help.a10b"> Digital and paper invoices are therefore processed in the same way. You, or the tax inspector, for example, check whether an invoice is original and unchanged. Check that the sender is correct, for example by comparing the invoice with a packing slip, price quote, order confirmation, bank statements, or other correspondence. </p> </div> </section> <hr id="tip11"> <section class="container container-fluid help"> <h2> <button class="btn" ng-click="vm.goToTop()"> <i class="fa fa-arrow-up fa-lg"></i> </button> <span translate="help.q11">How do I change the DHL company I am a client of?</span> </h2> <div> <p translate="help.a11a">In the taskbar, you can use the \u2018Legal Entity\u2019 button to choose between:</p> <ul> <li class="list"> <p translate="help.a11b">Belgium: DHL eCommerce (Belgium) N.V.</p> </li> <li class="list"> <p translate="help.a11c">eCommerce: DHL eCommerce (Services) in the Netherlands</p> </li> <li class="list"> <p translate="help.a11d">the Netherlands: DHL eCommerce (Netherlands) B.V.</p> </li> </ul> <p translate="help.a11e">Of course, you will only have access if you are an actual client of the DHL company specified.</p> </div> </section> <hr id="tip12"> <section class="container container-fluid help"> <h2> <button class="btn" ng-click="vm.goToTop()"> <i class="fa fa-arrow-up fa-lg"></i> </button> <span translate="help.q12">Is DHL eCommerce e-Billing safe?</span> </h2> <div> <p translate="help.a12a">Yes, DHL eCommerce e-Billing is safer than most traditional methods of sending and receiving invoices.</p> <p translate="help.a12b">A combination of digital signatures and advanced encryption techniques provides optimal security for your invoice data.</p> </div> </section> <hr id="tip13"> <section class="container container-fluid help"> <h2> <button class="btn" ng-click="vm.goToTop()"> <i class="fa fa-arrow-up fa-lg"></i> </button> <span translate="help.q13">Does DHL eCommerce e-Billing meet the requirements for proper VAT administration?</span> </h2> <div> <p translate="help.a13a">Yes. Our system complies with the relevant European and Dutch VAT legislation.</p> </div> </section> <hr id="tip14"> <section class="container container-fluid help"> <h2> <button class="btn" ng-click="vm.goToTop()"> <i class="fa fa-arrow-up fa-lg"></i> </button> <span translate="help.q14">Can DHL eCommerce e-Billing be integrated with my financial accounts?</span> </h2> <div> <p translate="help.a14a">Yes, our electronic invoicing system can be easily integrated into any known accounting system or ERP application. Adapted solutions also enable integration into other systems.</p> </div> </section> <hr> <br> </section> ');
$templateCache.put('app/views/login/login.html','<div id="shell" ui-view="shell" ng-cloak></div> <div class="container container-logout login-panel-padding"> <portal-alert></portal-alert> <table class="login" style="padding-top: 150px"> <tbody> <tr> <td> <section> <h1> <strong translate="login.title">Inloggen DHL eCommerce Billing</strong> </h1> <form class="form login-form" novalidate id="loginForm" name="loginForm"> <div class="form-group"> <label class="control-label" for="login"><span translate="login.login">Login (e-mail)</span></label> <br> <input ng-model="vm.username" class="login-input form-control" value="" type="text" id="login" name="username" required uib-tooltip="{{ (loginForm.username.$error.required) ? vm.loginreq() : \'\' }}"> </div> <div class="form-group login-margin"> <label class="control-label" for="password"><span translate="login.password">Wachtwoord</span></label> <input ng-model="vm.password" class="login-input form-control" type="password" id="password" name="password" autocomplete="new-password" required uib-tooltip="{{ (loginForm.password.$error.required) ? vm.pwdreq() : \'\' }}"> </div> <p class="login-margin text-align-left"> <span translate="login.forgotten1">Wachtwoord</span> <a href="" ui-sref="password-reset" translate="login.forgotten2">vergeten</a>? </p> <br> <br> <div class="text-align-left"> <button class="btn" type="submit" ng-click="loginForm.$valid ? vm.login($event) : null"> <span translate="login.login-btn">Log in</span> <i class="fa fa-sign-in"></i> </button> </div> </form> </section> </td> <td></td> <td> <section> <h1> <strong translate="login.access1">Heeft u geen toegang?</strong> </h1> <div> <a href="" ui-sref="register"><span translate="login.access2">Controleer hoe u toegang kunt krijgen.</span> <span class="has-icon">&#xe60A;</span></a> </div> </section> </td> </tr> </tbody> </table> </div> ');
$templateCache.put('app/views/password-expire/password-expire.html','<section> <section class="container container-fluid"> <h1 class="title" translate="global.menu.password-expire">Wyga\u015Bni\u0119cie has\u0142a</h1> </section> <hr id="toptip"> <section class="container-fluid"> <div> <p><span translate="password-expire.information.expire">Uw wachtwoord is verlopen in</span> {{vm.passwordExpireDays}} <span translate="password-expire.information.days">dagen</span>. <br><span translate="password-expire.information.change">Wachtwoord kan aangepast worden in</span> <a ui-sref="settings"><span class="text-underline" translate="password-expire.information.settings">Mijn profiel</span></a>.</p> </div> <div></div> <div> <a ui-sref="documents" class="btn voffset2" type="button"> <span translate="password-expire.buttons.back">Terug naar hoofdmenu</span> </a> </div> </section> </section> ');
$templateCache.put('app/views/password-reset/password-reset.html','<section class="container container-fluid"> <h1 class="title" translate="password-reset.title">Wachtwoord opnieuw instellen voor DHL eCommerce Billing</h1> <errors></errors> <statements></statements> <div ng-show="vm.data.passwordResetError!=null" class="alert ng-isolate-scope alert-danger alert-dismissible" role="alert" type="danger" close="alert.close($ctrl.alerts)"> <button ng-show="true" type="button" class="close" ng-click="vm.data.passwordResetError=null" aria-hidden="false"> <span aria-hidden="true">\xD7</span> <span class="sr-only">Close</span> </button> <div style="text-align: center"> <span class="ng-binding ng-scope" translate="password-reset.error">{{vm.data.passwordResetError}}</span> </div> </div> <div ng-show="vm.data.passwordResetSuccess!=null" class="alert ng-isolate-scope alert-success alert-dismissible" role="alert" type="success" close="alert.close($ctrl.alerts)"> <button ng-show="true" type="button" class="close" ng-click="vm.data.passwordResetSuccess=null" aria-hidden="false"> <span aria-hidden="true">\xD7</span> <span class="sr-only">Close</span> </button> <div style="text-align: center"> <span class="ng-binding ng-scope" translate="{{vm.getPasswordResetSuccess()}}"></span> </div> </div> <p translate="password-reset.desc">Om het wachtwoord opnieuw in te stellen: e-mailadres invullen dat tijdens de aanmelding is opgegeven.</p> <br> <form id="resetForm" name="resetForm" class="form-horizontal"> <div class="form-group"> <label for="dhlEmail" class="col-md-2 control-label">E-mail</label> <div class="col-md-5"> <pemail></pemail> </div> </div> <div class="form-group"> <div class="col-md-5 col-md-offset-2 text-center"> <button type="button" class="btn" ui-sref="login" translate="password-reset.return">Annuleer</button> <button type="submit" class="btn" ng-disabled="resetForm.$invalid || resetForm.$pending || vm.data.passwordResetSuccess!=null" ng-click="vm.resetPassword()" translate="password-reset.send">Verzenden</button> </div> </div> </form> </section> ');
$templateCache.put('app/views/password-reset-finish/password-reset-finish.html','<section class="container container-fluid" ng-show="vm.data.acceptReset"> <h1 class="title">{{(vm.changeType == 2) ? vm.translate(\'password-reset-finish.title.reset\') : vm.translate(\'password-reset-finish.title.activation\')}}</h1> <errors></errors> <statements></statements> <div ng-show="vm.passwordChangeErrorText!=null" class="alert ng-isolate-scope alert-danger alert-dismissible" role="alert" type="danger" close="alert.close($ctrl.alerts)"> <button ng-show="true" type="button" class="close" ng-click="vm.passwordChangeErrorText=null" aria-hidden="false"> <span aria-hidden="true">\xD7</span> <span class="sr-only">Close</span> </button> <div style="text-align: center"> <span class="ng-binding ng-scope">{{vm.passwordChangeErrorText}}</span> </div> </div> <div ng-show="vm.passwordChangeSuccessText!=null" class="alert ng-isolate-scope alert-success alert-dismissible" role="alert" type="success" close="alert.close($ctrl.alerts)"> <button ng-show="true" type="button" class="close" ng-click="vm.passwordChangeSuccessText=null" aria-hidden="false"> <span aria-hidden="true">\xD7</span> <span class="sr-only">Close</span> </button> <div style="text-align: center"> <span class="ng-binding ng-scope">{{vm.passwordChangeSuccessText}}</span> </div> </div> <p>{{(vm.changeType == 2) ? vm.translate(\'password-reset-finish.password.new\') : vm.translate(\'password-reset-finish.password.set\')}}</p> <br> <form id="resetForm" name="resetForm" class="form-horizontal"> <div class="form-group"> <label for="dhlPassword" class="col-md-2 control-label" translate="password-reset-finish.labels.password">Wachtwoord</label> <div class="col-md-5 tooltip-left"> <input type="password" class="form-control" required="required" autocomplete="off" placeholder="" tabindex="0" tooltip-placement="right" uib-tooltip-template="\'passwordTooltipTemplate.html\'" ng-model="vm.data.password" ng-maxlength="128"> </div> </div> <div class="form-group"> <label for="dhlRePassword" class="col-md-2 control-label" translate="password-reset-finish.labels.repassword">Bevestig uw wachtwoord</label> <div class="col-md-5"> <input type="password" class="form-control" required="required" autocomplete="off" placeholder="" tabindex="0" ng-model="vm.data.repassword" ng-maxlength="128"> </div> </div> <div class="form-group"> <div class="col-md-5 col-md-offset-2 text-center"> <button type="button" class="btn" ui-sref="login" translate="password-reset-finish.buttons.back">Terug naar login</button> <button type="submit" class="btn" ng-disabled="resetForm.$invalid || resetForm.$pending" ng-click="vm.resetPassword()" translate="password-reset-finish.buttons.change">Wijzig</button> </div> </div> </form> <script type="text/ng-template" id="passwordTooltipTemplate.html"> <span ng-bind-html="vm.passwordTooltip()"></span> </script> </section> ');
$templateCache.put('app/views/pdfView/pdfView.html','<portal-alert></portal-alert> <script> function adjustPopover(popover, iframe) {\n        var width = iframe.contentWindow.document.body.scrollWidth + \'px\',\n            popoverContent = $(popover).next(\'.popover-content\');\n        iframe.style.width = width;\n        popoverContent.css(\'width\', width);\n\n        var height = 3 * (iframe.contentWindow.document.body.scrollHeight) + \'px\',\n            popoverContent = $(popover).next(\'.popover-content\');\n\t\tiframe.style.height = height;\n\t\tpopoverContent.css(\'height\', height);\n    } </script> <section class="container container-fluid"> <div ng-show="vm.downloadError!=null" class="alert ng-isolate-scope alert-danger alert-dismissible" role="alert" type="danger" close="alert.close($ctrl.alerts)"> <button ng-show="true" type="button" class="close" ng-click="vm.downloadError=null" aria-hidden="false"> <span aria-hidden="true">\xD7</span> <span class="sr-only">Close</span> </button> <div style="text-align: center"><span class="ng-binding ng-scope">{{vm.downloadError}}</span></div> </div> <iframe id="PDFWrapper" iframe-set-dimensions-onload src="{{vm.pdfViewer}}"></iframe> <div class="actionButtons"> <a class="btn" target="_blank" ng-href="{{!vm.isExcelAvailable ? \'\' : vm.getDownloadXlsxURL()}}" ng-disabled="!vm.isExcelAvailable" tooltip-placement="top" uib-tooltip="{{!vm.isExcelAvailable ? vm.translate(\'pdfView.excelUnavailable\') : \'\' }}"> <span translate="pdfView.downloadX">Download XLSX</span> <i class="fa fa-file-excel-o"></i> </a> <a class="btn" target="_blank" ng-href="{{!vm.isCSVAvailable ? \'\' : vm.getDownloadCsvURL()}}" ng-disabled="!vm.isCSVAvailable" tooltip-placement="top" uib-tooltip="{{!vm.isCSVAvailable ? vm.translate(\'pdfView.csvUnavailable\') : \'\' }}"> <span translate="pdfView.downloadCSV">Download CSV</span> <i class="fa fa-file-excel-o"></i> </a> <a class="btn" target="_blank" ng-href="{{!vm.isXMLAvailable ? \'\' : vm.getDownloadXmlURL()}}" ng-disabled="!vm.isXMLAvailable" tooltip-placement="top" uib-tooltip="{{!vm.isXMLAvailable ? vm.translate(\'pdfView.xmlUnavailable\') : \'\' }}"> <span translate="pdfView.downloadXML">Download XML</span> <i class="fa fa-file-archive-o"></i> </a> <a target="_blank" ng-href="{{vm.getDownloadFullPdfURL(false)}}" class="btn btn-add btn-add-use"> <span translate="pdfView.downloadPrint">PDF - download/print</span> <i class="fa fa-file-pdf-o"></i> </a> <a target="_blank" ng-href="{{vm.getDownloadFullPdfURL(true)}}" class="btn btn-add btn-add-use" ng-if="vm.userOnePdfPage==\'B1\' || vm.userOnePdfPage==\'B2\' "> <span translate="pdfView.downloadPrintWhole">PDF - download/print het document</span> <i class="fa fa-file-pdf-o"></i> </a> <a ng-click="vm.goToDisputeForm()" tabindex="0" class="btn float-right" data-toggle="popover" data-placement="top"> <span translate="pdfView.submitDispute.submitDispute">Submit dispute</span> </a> </div> </section> ');
$templateCache.put('app/views/pending-cases/pending-cases.html','<section class="container container-fluid embedded-page-padding"> <portal-alert></portal-alert> <h1 class="title text-left ng-scope clear-margin-top"><span translate="pendingCases.pendingCases.registerUsers">User registrations</span></h1> <div class="actionButtons"> <button ng-disabled="vm.usersToBeUpdated.length === 0" class="btn align-right" id="DenyButton1" title="Deny users" type="button" ng-click="vm.denyUsers()"> <span translate="pendingCases.pendingCases.deny">Deny</span> <i class="fa fa-times"></i> </button> <button ng-disabled="vm.usersToBeUpdated.length === 0" class="btn align-right" id="AcceptButton1" title="Accept users" type="button" ng-click="vm.acceptUsers()"> <span translate="pendingCases.pendingCases.accept">Accept</span> <i class="fa fa-check"></i> </button> <button class="btn" title="Select/clear all" type="button" ng-click="vm.checkAllUsers()"> <span>{{ vm.checkOrUncheckText(vm.checkAllUsersButton) }}</span> <i class="fa fa-check-square"></i> </button> </div> <div> <div width="100%" style="overflow-y : auto"> <table id="fixtable" class="tablesorter latest" fix-table> <thead> <tr> <th></th> <th> <span translate="pendingCases.pendingCases.email">E-mail</span> </th> <th> <span translate="pendingCases.pendingCases.nip">NIP</span> </th> <th> <span translate="pendingCases.pendingCases.invoice">Faktura</span> </th> <th> <span translate="pendingCases.pendingCases.totalGross"> Kwota brutto</span> </th> <th> <span translate="pendingCases.pendingCases.sapNumber">Nr klienta</span> </th> <th> <span translate="pendingCases.pendingCases.payerSapNumber">Nr p\u0142atnika</span> </th> <th> <span translate="pendingCases.pendingCases.name">Nazwa</span> </th> </tr> </thead> <tbody> <tr ng-repeat="user in vm.users"> <td> <input type="checkbox" ng-click="vm.usersCheckboxClick($event,$index)" ng-model="vm.users[$index].selected"> </td> <td>{{ user.email}}</td> <td>{{ user.nip}}</td> <td>{{ user.invoiceNumber}}</td> <td>{{ user.invoiceValue | number:2}}</td> <td> <input type="number" ng-model="user.sapNumber" ng-change="vm.getNameByClientNumber($event,$index,user.sapNumber)" maxlength="8"> </td> <td> <input type="number" ng-model="user.payerNumber" maxlength="8"> </td> <td> <input type="text" ng-model="user.clientName"> </td> </tr> </tbody> <tfoot> <tr> <td colspan="8"></td> </tr> </tfoot> </table> </div> </div> </section> <hr> <section class="container container-fluid"> <h1 class="title text-left ng-scope"><span translate="pendingCases.pendingCases.documentsWithoutCient">Documents without client</span> </h1> <div class="actionButtons"> <button ng-disabled="vm.documentsWithoutClientToBeUpdated.length === 0" class="btn align-right" id="DenyButton2" title="Deny documents without client" type="button" ng-click="vm.denyDocumentsWithoutClient()"> <span translate="pendingCases.pendingCases.deny">Deny</span> <i class="fa fa-times"></i> </button> <button ng-disabled="vm.documentsWithoutClientToBeUpdated.length === 0" class="btn align-right" id="AcceptButton2" title="Accept documents without client" type="button" ng-click="vm.acceptDocumentsWithoutClient()"> <span translate="pendingCases.pendingCases.accept">Accept</span> <i class="fa fa-check"></i> </button> <button class="btn" title="Select/clear all" type="button" ng-click="vm.checkAllDocumentsWithoutClient()"> <span>{{ vm.checkOrUncheckText(vm.checkAllDocumentsWithoutClientButton) }}</span> <i class="fa fa-check-square"></i> </button> </div> <div> <div width="100%" style="overflow-y : auto"> <table id="fixtable3" class="tablesorter latest" fix-table> <thead> <tr> <th></th> <th> <span translate="pendingCases.pendingCases.client">Debiteur</span> </th> <th> <span translate="pendingCases.pendingCases.payer">Betaler</span> </th> <th> <span translate="pendingCases.pendingCases.document">Document</span> </th> <th> <span translate="pendingCases.pendingCases.dateIssue">Issue datum</span> </th> <th> <span translate="pendingCases.pendingCases.datePayment">Datum betaling</span> </th> <th> <span translate="pendingCases.pendingCases.totalNetto">Netto bedrag</span> </th> <th> <span translate="pendingCases.pendingCases.totalVat">BTW bedrag</span> </th> <th> <span translate="pendingCases.pendingCases.totalGross">Totaal factuurbedrag</span> </th> </tr> </thead> <tbody> <tr ng-repeat="document in vm.documentsWithoutClient" ng-click="vm.downloadPDF(document.entityId)"> <td ng-click="vm.documentsWithoutClientCheckboxClick($event,$index)"> <input type="checkbox" ng-model="vm.documentsWithoutClient[$index].selected"> </td> <td>{{ document.clientNumber}}</td> <td>{{ document.payerNumber}}</td> <td>{{ document.documentNumber}}</td> <td>{{ document.dateIssue | date:\'yyyy-MM-dd\'}}</td> <td>{{ document.datePayment | date:\'yyyy-MM-dd\'}} </td> <td>{{ document.totalNetto | number:2}} </td> <td>{{ document.totalVat | number:2}}</td> <td>{{ document.totalGross | number:2}}</td> </tr> </tbody> <tfoot> <tr> <td colspan="9"></td> </tr> </tfoot> </table> </div> </div> </section> <hr> <section class="container container-fluid"> <h1 class="title text-left ng-scope"><span translate="pendingCases.pendingCases.documentsOfDebtors">Documents of debtors on hold</span> </h1> <div class="actionButtons"> <button ng-disabled="vm.documentsOfDebtorsToBeUpdated.length === 0" class="btn align-right" id="DenyButton3" title="Deny documents of debtors" type="button" ng-click="vm.denyDocumentsOfDebtors()"> <span translate="pendingCases.pendingCases.deny">Deny</span> <i class="fa fa-times"></i> </button> <button ng-disabled="vm.documentsOfDebtorsToBeUpdated.length === 0" class="btn align-right" id="AcceptButton3" title="Accept documents of debtors" type="button" ng-click="vm.acceptDocumentsOfDebtors()"> <span translate="pendingCases.pendingCases.accept">Accept</span> <i class="fa fa-check"></i> </button> <button class="btn" title="Select/clear all" type="button" ng-click="vm.checkAllDocumentsOfDebtors()"> <span>{{ vm.checkOrUncheckText(vm.checkAllDocumentsOfDebtorsButton) }}</span> <i class="fa fa-check-square"></i> </button> </div> <div> <div width="100%" style="overflow-y : auto"> <table id="fixtable3" class="tablesorter latest" fix-table> <thead> <tr> <th></th> <th> <span translate="pendingCases.pendingCases.client">Klient</span> </th> <th> <span translate="pendingCases.pendingCases.payer">P\u0142atnik</span> </th> <th> <span translate="pendingCases.pendingCases.document"> Dokument</span> </th> <th> <span translate="pendingCases.pendingCases.dateIssue">Data wystawienia</span> </th> <th> <span translate="pendingCases.pendingCases.datePayment">Termin p\u0142atno\u015Bci</span> </th> <th> <span translate="pendingCases.pendingCases.totalNetto">Kwota netto</span> </th> <th> <span translate="pendingCases.pendingCases.totalVat">Kwota VAT</span> </th> <th> <span translate="pendingCases.pendingCases.totalGross">Kwota brutto</span> </th> </tr> </thead> <tbody> <tr ng-repeat="document in vm.documentsOfDebtors" ng-click="vm.downloadPDF(document.entityId)"> <td ng-click="vm.documentsOfDebtorsCheckboxClick($event,$index)"> <input type="checkbox" ng-model="vm.documentsOfDebtors[$index].selected"> </td> <td>{{ document.clientNumber}}</td> <td>{{ document.payerNumber}}</td> <td>{{ document.documentNumber}}</td> <td>{{ document.dateIssue | date:\'yyyy-MM-dd\'}}</td> <td>{{ document.datePayment | date:\'yyyy-MM-dd\'}} </td> <td>{{ document.totalNetto | number:2}} </td> <td>{{ document.totalVat | number:2}}</td> <td>{{ document.totalGross | number:2}}</td> </tr> </tbody> <tfoot> <tr> <td colspan="9"></td> </tr> </tfoot> </table> </div> </div> </section> ');
$templateCache.put('app/views/register/register.html','<section class="container container-fluid"> <h1 class="title"><span translate="register.title2"> Rejestracja w aplikacji eFaktura DHL eCommerce</span></h1> </section> <hr id="toptip"> <section class="container container-fluid"> <div ng-show="vm.registerErrorText!=null" class="alert ng-isolate-scope alert-danger alert-dismissible" role="alert" type="danger" close="alert.close($ctrl.alerts)"> <button ng-show="true" type="button" class="close" ng-click="vm.registerErrorText=null" aria-hidden="false"> <span aria-hidden="true">\xD7</span> <span class="sr-only">Close</span> </button> <div style="text-align: center"> <span class="ng-binding ng-scope">{{vm.registerErrorText}}</span> </div> </div> </section> <section class="register container container-fluid"> <form id="step1Form" name="step1Form" novalidate class="form-horizontal step1Form"> <div> <div clas="col-md-10"> <label class="normal-form" style="padding-bottom: 1em"><span translate="register.fillForm">Vul het formulier in om facturen te ontvangen:</span></label> </div> </div> <div class="form-group" style="display: flex; align-items: center"> <label id="dhlEmailLabel" class="col-md-2 control-label normal-form"><span translate="register.email">E-mail</span><strong class="red">*</strong></label> <div class="col-md-5"> <email></email> </div> <div class="col-md-5"></div> </div> <div class="form-group" style="display: flex; align-items: center"> <label id="dhlNipLabel" class="col-md-2 control-label normal-form"><span translate="register.nip">BTW nummer </span><strong class="red">*</strong></label> <div class="col-md-5"> <nip pattern="vm.pattern"></nip> </div> <div class="col-md-5"></div> </div> <div class="form-group" style="display: flex; align-items: center"> <label id="dhlInvoicedhlLabel" for="dhlInvoice" class="col-md-2 control-label normal-form"><span translate="register.invoiceNumber">Factuur nummer</span><strong class="red">*</strong></label> <div class="col-md-5"> <invoice></invoice> </div> <div class="col-md-5 tooltip-wide"> <a class="form-help-link normal-form" style="line-height: 40px" tooltip-placement="top" uib-tooltip="{{ vm.translate(\'register.invoiceNumberTooltip\') }}" tabindex="-1" tooltip><span translate="register.invoiceNumberLink">Waar kan ik het factuurnummer vinden?</span></a> </div> </div> <div class="form-group" style="display: flex; align-items: center"> <label id="dhlGrossAmountLabel" for="dhlGrossAmount" class="col-md-2 control-label normal-form"><span translate="register.totalGross">Totaal bruto</span><strong class="red">*</strong></label> <div class="col-md-5"> <gross></gross> </div> <div class="col-md-5 tooltip-wide"> <a class="form-help-link normal-form" style="line-height: 40px" tooltip-placement="top" uib-tooltip="{{ vm.translate(\'register.tooltipTotalGross\') }}" tabindex="-1" tooltip><span translate="register.totalGrossLink">Hoe het Totaal bruto veld invullen?</span></a> </div> </div> <div class="form-group" style="display: flex; align-items: center"> <label id="dhlClientCodeLabel" for="dhlClientCode" class="col-md-2 control-label normal-form"><span translate="register.clientNumber">Debiteuren nummer</span></label> <div class="col-md-5"> <client></client> </div> <div class="col-md-5 tooltip-wide"> <a class="form-help-link normal-form" style="line-height: 40px" tooltip-placement="top" uib-tooltip="{{ vm.translate(\'register.tooltipClientNumber\') }}" tabindex="-1" tooltip><span translate="register.clientNumberLink">Waar kan ik het debiteurennummer vinden?</span></a> </div> </div> <div class="form-group" style="display: flex; align-items: center"> <label id="dhlLegalEntityLabel" for="dhlLegalEntity" class="col-md-2 control-label normal-form"><span translate="global.menu.entity">Juridische entiteit</span></label> <span class="col-md-5"> <legal-entity></legal-entity> </span> </div> <div class="form-group" style="display: flex; align-items: center"> <div class="col-md-2 float-left"> <input name="agreement1" type="checkbox" id="agreement1" class="register-input pull-right normal-form registrationCheckbox" required="required" ng-model="vm.data.agreement1"> <label for="agreement1" class="pull-right" uib-tooltip="{{ step1Form.agreement1.$error.required ?\n\t\t\t\t\t\tvm.translate(\'register.acceptanceTooltip\') : \'\' }}" tooltip-placement="top-right"> </div> <label class="checkbox register-input col-md-7-5 normal-form" style="cursor: default"><span translate="register.invoiceAcceptanceBeforeLink" style="display: inline">Ik ga hierbij akkoord met DHL eCommerce om elektronische facturen te verzenden, in overeenstemming met de momenteel bindende btw-bepalingen en ik accepteer de voorwaarden voor het gebruik van de internetsite van DHL eCommerce.</span> <b> <a target="_blank" ng-href="{{ vm.getInvoiceAcceptanceLink() }}"> <span translate="register.invoiceAcceptanceLink">Servicevoorwaarden</span> </a> </b> <span translate="register.invoiceAcceptanceAfterLink"> van DHL eCommerce website.</span><strong class="red">*</strong> </label> </div> <div class="form-group" style="display: flex; align-items: center"> <div class="col-md-2 float-left"> <div></div> </div> <label class="checkbox register-input col-md-7-5 normal-form" style="cursor: default"> <span translate="register.rodoInfo" style="display: inline">De beheerder van uw persoonlijke gegevens is DHL eCommerce met als maatschappelijke zetel Reactorweg 25, 3542 AD Utrecht, hierna te noemen \xE2 \u20AC \u0153DHL\xE2 \u20AC. DHL gebruikt uw gegevens voor het beheer en de werking van uw account op parcelbilling.dhl.com, en om communicatie met betrekking tot het uitvoeren van diensten te beheren, in het bijzonder om financi\xEBle en factuurinformatie te verzenden. U hebt recht op toegang tot uw gegevens en het recht om ze te corrigeren of te wissen, de verwerking te beperken, het recht op gegevensoverdraagbaarheid, het recht om bezwaar te maken en het recht om een \u200B\u200Bklacht in te dienen bij Autoriteit Persoonsgegevens (AP). Voor meer informatie over hoe we uw gegevens gebruiken. klik </span> <a target="_blank" ng-href="{{ vm.translate(\'register.rodoLink\')}}"> <span translate="register.here"> hier.</span></a> </label> </div> <div> <div clas="col-md-10"> <br> <label class="normal-form" style="padding-bottom: 1em"><strong class="red">*</strong><span translate="register.required">verplicht</span></label> </div> </div> <div class="form-group"> <div class="col-md-10"> <button type="submit" class="btn float-right" ng-click="step1Form.dhlEmail.$submit;step1Form.$valid?vm.send(): vm.invalid()"><span translate="register.next">Volgende</span></button> </div> </div> </form> </section> ');
$templateCache.put('app/views/register/register_end.html',' <section class="container container-fluid"> <h1 class="title"><span translate="registerEnd.title"> Zako\u0144czenie rejestracji</span></h1> </section> <hr id="toptip"> <!-- <div class="text-primary steps">Krok 1/2</div> --> <section class="container container-fluid"> <p><span translate="registerEnd.dearClient">Geachte klant,</span></p><br> <p><span translate="registerEnd.thanks">Bedankt voor uw aanmelding in de DHL eCommerce facturatie-app.</span></p><br> <p><span translate="registerEnd.text1">Na het verifi\xEBren en accepteren van uw verzoek ontvangt u een e-mailbericht met een activatie link die wordt verzonden naar het adres dat tijdens de registratie is opgegeven. De e-mail wordt verzonden van de </span> <a href="mailto:{{vm.getUrl(\'emailAddress\')}}">{{vm.getUrl(\'emailAddress\')}}</a> <span translate="registerEnd.text2">adres. Zorg ervoor dat uw antispam filter geen informatie blokkeert die vanaf dit adres wordt verzonden. </span></p><br> <p><b><span translate="registerEnd.link">De link is 30 dagen actief.</span></b></p><br> <p><span translate="registerEnd.text3">Volg de e-mailinstructies om de functionaliteit van onze site volledig te gebruiken.</span></p><br> <p><span translate="registerEnd.regards">Met vriendelijke groet,</span><br> <span translate="registerEnd.signature">DHL eCommerce e-invoicing team</span></p> </section> ');
$templateCache.put('app/views/roles/addRole.html','<div class="modal-header" xmlns="http://www.w3.org/1999/html"> <h1 class="title text-left"><span translate="roles.addingNewRole">Voeg een nieuwe rol toe</span></h1> </div> <form id="resend" class="inline inline-search" accept-charset="UTF-8"> <div class="modal-body"> <div class="container-fluid"> <form class="form-inline"> <fieldset> <div class="form-group"> <label class="control-label" for="newName"><span translate="roles.roleName">Naam rol</span></label> <input class="form-control" id="newName" ng-model="vm.newRole.roleName" required> </div> <div class="form-group"> <label class="control-label" for="newDescription"><span translate="roles.roleDescription">Rol omschrijving</span></label> <input class="form-control" id="newDescription" ng-model="vm.newRole.description"> </div> </fieldset> </form> <div height="10px"> <h3><span translate="roles.selectPermissions">Selecteer machtigingen:</span></h3> <div ng-repeat="permission in vm.allPermissions"> <label> <input type="checkbox" value="{{permission.ediPermissionId}}" ng-checked="" ng-click="vm.toggleSelection($event,$index,permission)"> {{permission.permissionName}}  </label> </div> </div> </div> </div> <div class="modal-footer"> <button class="btn btn-primary" ng-disabled="!vm.newRole.roleName" type="submit" ng-click="vm.modal.add()"><span translate="roles.add">Toevoegen</span> <i class="fa fa-plus"></i> </button> <button class="btn btn-warning" type="button" ng-click="vm.modal.cancel()"><span translate="roles.cancel">Annuleer </span> <i class="fa fa-times"></i> </button> </div> </form> ');
$templateCache.put('app/views/roles/editRole.html','<div class="modal-header" xmlns="http://www.w3.org/1999/html"> <h1 class="title text-left"><span translate="roles.editRole">Bewerk rol</span></h1> </div> <form id="resend" class="inline inline-search" accept-charset="UTF-8"> <div class="modal-body"> <div class="container-fluid"> <div class="form-inline"> <fieldset> <div class="form-group"> <label class="control-label" for="newName"><span translate="roles.roleName">Naam rol</span></label> <input class="form-control" id="newName" ng-model="vm.newRole.roleName" readonly="readonly"> </div> <div class="form-group"> <label class="control-label" for="newDescription"><span translate="roles.roleDescription">Rol omschrijving</span></label> <input class="form-control" id="newDescription" ng-model="vm.newRole.description"> </div> </fieldset> </div> <div height="10px"> <h3><span translate="roles.selectPermissions">Selecteer machtigingen:</span></h3> <div ng-repeat="permission in vm.allPermissions"> <label> <input type="checkbox" value="{{permission.ediPermissionId}}" ng-checked="permission.checked" ng-click="vm.toggleSelection($event,$index,permission)"> {{permission.permissionName}}  </label> </div> </div> </div> </div> <div class="modal-footer"> <button class="btn btn-primary" type="submit" ng-click="vm.modal.update()"><span translate="roles.save"> Sla op </span> <i class="fa fa-floppy-o"></i> </button> <button class="btn btn-warning" type="button" ng-click="vm.modal.delete()"><span translate="roles.delete"> Verwijder </span> <i class="fa fa-trash"></i> </button> <button class="btn btn-warning" type="button" ng-click="vm.modal.cancel()"><span translate="roles.cancel"> Annuleer </span> <i class="fa fa-times"></i> </button> </div> </form> ');
$templateCache.put('app/views/roles/roles.html','<section class="container container-fluid" ng-if="$root.Principal.hasSystemAccess()"> <div id="fixed" class="container container-fluid embedded-page-padding" dynamic-height dh-element-id="#under-fixed"> <portal-alert></portal-alert> <div class="actionButtons row clear-margin-top"> <div class="col-xs-12"> <button id="AddRoleButton" title="Add role" ng-click="vm.goToAddRole()" class="btn btn-add btn-add-use"> <span translate="roles.add">Toevoegen</span> <i class="fa fa-plus-square"></i> </button> </div> </div> </div> <div id="under-fixed"> <table id="fixtable" class="tablesorter latest" fix-table> <thead> <tr> <th><span translate="roles.ordinal">Volgorde</span></th> <th> <span translate="roles.roleName">Naam rol</span> </th> <th> <span translate="roles.roleDescription">Rol omschrijving</span> </th> </tr> </thead> <tbody> <tr ng-repeat="role in vm.roles" ng-click="vm.goToEditRole($event,$index,role)"> <td>{{$index+1}}</td> <td>{{ role.roleName}}</td> <td>{{ role.description}}</td> </tr> </tbody> <tfoot> <tr> <td colspan="3"></td> </tr> </tfoot> </table> </div> </section> ');
$templateCache.put('app/views/settings/settings.html','<div ng-if="$root.Principal.isAuthenticated()"> <section class="container container-fluid"> <div ng-show="vm.getUserErrorText!=null" class="alert ng-isolate-scope alert-danger alert-dismissible" role="alert" type="danger" close="alert.close($ctrl.alerts)"> <button ng-show="true" type="button" class="close" ng-click="vm.getUserErrorText=null" aria-hidden="false"> <span aria-hidden="true">\xD7</span> <span class="sr-only">Close</span> </button> <div style="text-align: center"><span class="ng-binding ng-scope">{{vm.getUserErrorText}}</span></div> </div> </section> <section class="container container-fluid"> <h1 class="settings_header embedded-page-padding"> <span class="part-title" translate="settings.details.header">Gebruiker info</span><span class="info_header_normal"></span> </h1> <form class="block"> <fieldset> <div class="row"> <label class="col-md-6 form_inside" translate="settings.details.email">E-mail: </label> <label class="info_header_normal col-md-6 form_inside" ng-show="$root.Principal.isAuthenticated()">{{$root.Principal.getProperty(\'login\')}}</label> </div> <div class="row"> <label class="col-md-6 form_inside" translate="settings.details.loginFailed">Laatste ongeldige inlogpoging: </label> <label class="info_header_normal col-md-6 form_inside" ng-show="$root.Principal.isAuthenticated()">{{vm.data.user.lastLoginFailure | date:\'yyyy-MM-dd\'}}</label> </div> <div class="row"> <label class="col-md-6 form_inside" translate="settings.details.passwordExpiration">Vervaldatum wachtwoord: </label> <label class="info_header_normal col-md-6 form_inside" ng-show="$root.Principal.isAuthenticated()">{{vm.data.user.user.passwordExpireDate | date:\'yyyy-MM-dd\'}}</label> </div> </fieldset> </form> </section> <hr ng-if="vm.data.user.clients.length"> <section class="container container-fluid" ng-controller="SettingsController" ng-if="vm.data.user.clients.length"> <h1 class="settings_header"> <span class="part-title" translate="settings.details.customers">Codes van de klant: </span><br><br> <td> <div ng-if="vm.data.user.clients.length == 0">{{vm.none}}</div> <div ng-if="vm.data.user.clients.length > 0" ng-repeat="client in vm.data.user.clients" ng-click="vm.clientNav(client)"><a>{{client.clientNumber}}</a></div> </td> </h1> </section> <hr> <section class="container container-fluid"> <section class="container container-fluid"> <div ng-show="vm.passwordChangeErrorText!=null" class="alert ng-isolate-scope alert-danger alert-dismissible" role="alert" type="danger" close="alert.close($ctrl.alerts)"> <button ng-show="true" type="button" class="close" ng-click="vm.passwordChangeErrorText=null" aria-hidden="false"> <span aria-hidden="true">\xD7</span> <span class="sr-only" translate="entity.action.close"> Close</span> </button> <div style="text-align: center"><span class="ng-binding ng-scope">{{vm.passwordChangeErrorText}}</span></div> </div> <div ng-show="vm.passwordChangeSuccessText!=null" class="alert ng-isolate-scope alert-success alert-dismissible" role="alert" type="success" close="alert.close($ctrl.alerts)"> <button ng-show="true" type="button" class="close" ng-click="vm.passwordChangeSuccessText=null" aria-hidden="false"> <span aria-hidden="true">\xD7</span><span class="sr-only"> Close</span> </button> <div style="text-align: center"><span class="ng-binding ng-scope">{{vm.passwordChangeSuccessText}}</span></div> </div> </section> <h1 class="settings_header"> <span class="part-title" translate="settings.passform.title">Verander uw wachtwoord</span> </h1> <form id="passwordChangeForm" class="block form" ng-submit="vm.resetPassword(user)" accept-charset="UTF-8" enctype="multipart/form-data" data-parsley-validate="data-parsley-validate"> <fieldset> <div class="form-group"> <label for="passwordChangeOld" class="control-label" translate="settings.passform.password">Voer uw huidige wachtwoord in: </label> <input class="form-control" type="password" name="passwordChangeOld" id="passwordChangeOld" required="required" autocomplete="new-password" ng-model="user.passwordChangeOld"> </div> <div class="form-group tooltip-left"> <label for="passwordChangeNew" class="control-label" translate="settings.passform.passwordNew">Voer uw nieuwe wachtwoord in: </label> <input class="form-control" type="password" name="passwordChangeNew" id="passwordChangeNew" tooltip-append-to-body="true" required="required" tooltip-placement="right" uib-tooltip-template="\'passwordTooltipTemplate.html\'" tooltip-trigger="focus mouseenter" tooltip-class="tooltip-text-align-left" ng-model="user.passwordChangeNew"> </div> <div class="form-group"> <label for="rePasswordChangeNew" class="control-label" translate="settings.passform.passwordConfirm">Bevestig uw nieuwe wachtwoord: </label> <input class="form-control" type="password" name="rePasswordChangeNew" id="rePasswordChangeNew" nrequired="required" ng-model="user.rePasswordChangeNew"> </div> <button class="btn" name="submitChangePassword" type="submit" value="submitChangePassword"> <span translate="entity.action.save">Zapisz</span> <i class="fa fa-save"></i> </button> </fieldset> </form> </section> <hr> <section class="container container-fluid"> <section class="container container-fluid"> <div ng-show="vm.languageChangeErrorText!=null" class="alert ng-isolate-scope alert-danger alert-dismissible" role="alert" type="danger" close="alert.close($ctrl.alerts)"> <button ng-show="true" type="button" class="close" ng-click="vm.languageChangeErrorText=null" aria-hidden="false"> <span aria-hidden="true">\xD7</span> <span class="sr-only" translate="entity.action.close"> Close</span> </button> <div style="text-align: center"><span class="ng-binding ng-scope">{{vm.languageChangeErrorText}}</span></div> </div> <div ng-show="vm.languageChangeSuccessText!=null" class="alert ng-isolate-scope alert-success alert-dismissible" role="alert" type="success" close="alert.close($ctrl.alerts)"> <button ng-show="true" type="button" class="close" ng-click="vm.languageChangeSuccessText=null" aria-hidden="false"> <span aria-hidden="true">\xD7</span> <span class="sr-only" translate="entity.action.close"> Close</span> </button> <div style="text-align: center"><span class="ng-binding ng-scope">{{vm.languageChangeSuccessText}}</span></div> </div> </section> <h1 class="settings_header"> <span class="part-title" translate="settings.langform.title">Wijzig uw standaardtaal</span> </h1> <form id="languageChangeForm" class="langController block" ng-controller="JhiLanguageController as languageVm" ng-submit="vm.setLanguage();\n    ((vm.languageChangeErrorText)?null:(languageVm.changeLanguage(vm.language1)));\n    ((vm.languageChangeErrorText)?null:(vm.collapseNavbar()));" accept-charset="UTF-8" enctype="multipart/form-data" data-parsley-validate="data-parsley-validate"> <fieldset> <div class="form-group clear-margin-bottom" id="lang" uib-dropdown class="dropdown pointer" ng-controller="JhiLanguageController as languageVm"> <select class="form-control" chosen ng-model="vm.language"> <option ng-repeat="language in languageVm.languages">{{language | findLanguageFromKey}}</option> </select> <br> </div> <button class="btn" name="submitChangeLanguage" value="submitChangeLanguage"> <span translate="entity.action.save">Zapisz</span> <i class="fa fa-save"></i> </button> </fieldset> </form> </section> <script type="text/ng-template" id="passwordTooltipTemplate.html"> <span ng-bind-html="vm.passwordTooltip()"></span> </script> </div> ');
$templateCache.put('app/views/system-settings/system-settings.html','<div class="system-settings"> <section class="container-fluid clear-line-height embedded-page-padding" ng-if="$root.Principal.hasSystemAccess() || $root.Principal.hasTemplateAccess()"> <br> <div ng-show="vm.getDataErrorText!=null" class="alert ng-isolate-scope alert-danger alert-dismissible" role="alert" type="danger" close="alert.close($ctrl.alerts)"> <button ng-show="true" type="button" class="close" ng-click="vm.getDataErrorText=null" aria-hidden="false"> <span aria-hidden="true">\xD7</span> <span class="sr-only">Close</span> </button> <div style="text-align: center"> <span class="ng-binding ng-scope">{{vm.getDataErrorText}}</span> </div> </div> </section> <section class="container-fluid" ng-if="$root.Principal.hasSystemAccess() || $root.Principal.hasTemplateAccess()"> <h1 class="title text-left ng-scope clear-margin-top"> <span translate="systemSettings.systemSettings.header">Algemene instellingen</span> </h1> <div class="voffset3"> <h6 for="passwordChangeInterval" translate="systemSettings.systemSettings.period1"> Geldigheidsperiode wachtwoord: </h6> <form id="intervalForm" name="intervalForm" class="form-inline voffset2"> <fieldset> <div class="form-group"> <label class="control-label" ng-show="vm.interval.current"><span translate="systemSettings.systemSettings.currentPeriod">Huidige periode (in dagen) </span>: {{vm.interval.current}}</label> <div> <div class="input-group"> <input class="form-control" ng-if="$root.Principal.hasSystemAccess()" type="number" id="passwordChangeInterval" required="required" min="1" ng-model="vm.interval.new"> <span class="input-group-addon multi-input"></span> <select class="form-control" ng-if="$root.Principal.hasSystemAccess()" ng-model="vm.interval.measure"> <option value="days" translate="systemSettings.systemSettings.days"> dagen </option> <option value="months" translate="systemSettings.systemSettings.months"> maanden </option> <option value="years" translate="systemSettings.systemSettings.years"> jaren </option> </select> </div> </div> </div> <div class="form-group"> <label class="">&nbsp;</label> <div> <button ng-if="$root.Principal.hasSystemAccess()" type="submit" class="btn" ng-click="vm.interval.set()" ng-disabled="intervalForm.$invalid || intervalForm.$pending"> <span translate="systemSettings.systemSettings.set">Stel in</span> <i class="fa fa-wrench"></i> </button> </div> </div> </fieldset> </form> </div> <div class="voffset5"> <h6 for="passwordChangeInterval" translate="systemSettings.systemSettings.period2"> Periode berichtweergave v\xF3\xF3r wachtwoord is verlopen: </h6> <form id="showIntervalForm" name="showIntervalForm" class="form-inline voffset2"> <fieldset> <div class="form-group"> <label class="control-label" ng-show="vm.showInterval.current"><span translate="systemSettings.systemSettings.currentPeriod">Huidige periode (in dagen) </span>: {{vm.showInterval.current}}</label> <div> <div class="input-group"> <input class="form-control" ng-if="$root.Principal.hasSystemAccess()" type="number" id="showPasswordChangeInterval" required="required" min="1" ng-model="vm.showInterval.new"> <span class="input-group-addon multi-input"></span> <select class="form-control" ng-if="$root.Principal.hasSystemAccess()" ng-model="vm.showInterval.measure"> <option value="days" translate="systemSettings.systemSettings.days"> dagen </option> <option value="months" translate="systemSettings.systemSettings.months"> maanden </option> <option value="years" translate="systemSettings.systemSettings.years"> jaren </option> </select> </div> </div> </div> <div class="form-group"> <label class="">&nbsp;</label> <div> <button ng-if="$root.Principal.hasSystemAccess()" type="submit" class="btn" ng-click="vm.showInterval.set()" ng-disabled="showIntervalForm.$invalid || showIntervalForm.$pending"> <span translate="systemSettings.systemSettings.set">Stel in</span> <i class="fa fa-wrench"></i> </button> </div> </div> </fieldset> </form> </div> </section> <hr> <section class="container container-fluid" ng-if="$root.Principal.hasSystemAccess() || $root.Principal.hasTemplateAccess()"> <h1 class="title text-left ng-scope clear-margin-top"> <span translate="systemSettings.banner.header">Banner header</span> </h1> <div class="voffset3"> <div ng-show="vm.bannerSuccessText" class="alert alert-success"> {{vm.bannerSuccessText}} </div> <div ng-show="vm.bannerErrorText" class="alert alert-danger"> {{vm.bannerErrorText}} </div> <form name="bannerForm" novalidate class="form"> <!-- From --> <div class="form-group"> <label translate="systemSettings.banner.from"></label> <input type="datetime-local" class="form-control datetime-short" ng-model="vm.banner.data.from" required> </div> <!-- To --> <div class="form-group"> <label translate="systemSettings.banner.to"></label> <input type="datetime-local" class="form-control datetime-short" ng-model="vm.banner.data.to" required> </div> <!-- Line1 --> <div class="form-group"> <label translate="systemSettings.banner.line1"></label> <input type="text" class="form-control" ng-model="vm.banner.data.line1" required> </div> <!-- Line2 --> <div class="form-group"> <label translate="systemSettings.banner.line2"></label> <input type="text" class="form-control" ng-model="vm.banner.data.line2"> </div> <!-- Closable --> <div class="form-group"> <label> <input type="checkbox" ng-model="vm.banner.data.closable"> <span translate="systemSettings.banner.closable"></span> </label> </div> <!-- Entities --> <div class="form-group"> <label translate="systemSettings.banner.entities"></label> <div class="checkbox" ng-repeat="entity in vm.banner.availableEntities"> <label> <input type="checkbox" ng-checked="vm.banner.data.entities.indexOf(entity) !== -1" ng-click="vm.banner.toggleEntity(entity)"> {{ entity }} </label> </div> </div> <div class="form-group"> <button class="btn btn-primary" ng-click="vm.banner.save()" ng-disabled="bannerForm.$invalid"> <span translate="systemSettings.banner.save"></span> </button> <button class="btn btn-danger" ng-click="vm.banner.delete()"> <span translate="systemSettings.banner.delete"></span> </button> </div> </form> <div class="form-group" ng-if="vm.banner.exists"> <div class="alert alert-info"> <p><strong translate="systemSettings.banner.previewHeader">Active banner</strong></p> <p> <strong translate="systemSettings.banner.from">From:</strong> {{vm.banner.preview.from | date:\'yyyy-MM-dd HH:mm\'}} &nbsp; <strong translate="systemSettings.banner.to">To:</strong> {{vm.banner.preview.to | date:\'yyyy-MM-dd HH:mm\'}} </p> <p><strong translate="systemSettings.banner.content">Content:</strong></p> <p class="banner-paragraph">{{vm.banner.preview.line1}}</p> <p class="banner-paragraph">{{vm.banner.preview.line2}}</p> <p> <strong translate="systemSettings.banner.closable"></strong>: {{ vm.banner.preview.closable ? \'Yes\' : \'No\' }} </p> <p> <strong translate="systemSettings.banner.entities"></strong>: {{ vm.banner.preview.entities.join(\', \') }} </p> </div> </div> </div> </section> <hr> <section class="container container-fluid" ng-if="$root.Principal.hasSystemAccess() || $root.Principal.hasTemplateAccess()"> <div ng-show="vm.addingEmailTemplateErrorText!=null" class="alert ng-isolate-scope alert-danger alert-dismissible" role="alert" type="danger" close="alert.close($ctrl.alerts)"> <button ng-show="true" type="button" class="close" ng-click="vm.addingEmailTemplateErrorText=null" aria-hidden="false"> <span aria-hidden="true">\xD7</span> <span class="sr-only">Close</span> </button> <div style="text-align: center"> <span class="ng-binding ng-scope">{{vm.addingEmailTemplateErrorText}}</span> </div> </div> <div ng-show="vm.addingEmailTemplateSuccessText!=null" class="alert ng-isolate-scope alert-success alert-dismissible" role="alert" type="success" close="alert.close($ctrl.alerts)"> <button ng-show="true" type="button" class="close" ng-click="vm.addingEmailTemplateSuccessText=null" aria-hidden="false"> <span aria-hidden="true">\xD7</span> <span class="sr-only">Close</span> </button> <div style="text-align: center"> <span class="ng-binding ng-scope">{{vm.addingEmailTemplateSuccessText}}</span> </div> </div> <h1 class="title text-left ng-scope"> <span translate="systemSettings.addEmailTemplate.header">E-mail sjabloon toevoegen</span> </h1> <div class="voffset3"> <form name="templateUploadForm" novalidate class="form"> <div class="form-group"> <label class="control-label" for="templateId"><span translate="systemSettings.addEmailTemplate.designation">Sjabloonaanduiding</span>:</label> <input class="form-control form-control-width-auto" type="text" id="templateId" required="required" ng-model="vm.template.name"> </div> <div class="form-group"> <label class="control-label"><span translate="systemSettings.getEmailTemplate.language">Taal</span>:</label> <select class="form-control" ng-model="vm.template.language" style="width: 100%"> <option ng-repeat="language in vm.languages" value="{{language.name}}"> {{language.text()}} </option> </select> </div> <div class="form-group"> <label class="control-label"><span translate="systemSettings.addEmailTemplate.type">Sjabloontype</span>:</label> <select class="form-control" ng-model="vm.template.activity" style="width: 100%"> <option ng-repeat="activity in vm.ActivityTypes" value="{{activity.name}}"> {{activity.text()}} </option> </select> </div> <div class="form-group"> <div uib-dropdown class="dropdown pointer"></div> <div name="html-input" ngf-select ngf-drop ng-model="file" ngf-multiple="false" ngf-allow-dir="false" ngf-drag-over-class="\'dragover\'" ngf-max-size="20MB" ngf-pattern="\'.html\'" ngf-accept="text/html" ngf-drop-available="dropAvailable" class="drop-box html-input" uib-tooltip="{{vm.htmlTooltip ? \'Dodawany dokument musi mie\u0107 odpowiednie rozszerzenie (.html).\' : \'\'}}" tooltip-placement="top"> {{file.name != null ? vm.translate(\'systemSettings.chosen1\') + " " + file.name + vm.translate(\'systemSettings.chosen2\') + ". "+ vm.translate(\'systemSettings.click_to_change\') + "." : vm.chooseOrDrop()}} </div> </div> <button type="submit" class="btn pull-right" ng-disabled="templateUploadForm.$invalid || templateUploadForm.$pending" ng-click="vm.chectUniqueNameAndType(file)"> <span translate="systemSettings.addEmailTemplate.add">Voeg toe</span> <i class="fa fa-plus"></i> </button> </form> </div> </section> <hr> <section class="container container-fluid" ng-if="$root.Principal.hasSystemAccess() || $root.Principal.hasTemplateAccess()"> <h1 class="title text-left ng-scope"> <span translate="systemSettings.getEmailTemplate.header">E-mailsjabloon ophalen</span> </h1> <table class="tablesorter latest" fix-table> <thead> <tr> <th></th> <th translate="systemSettings.addEmailTemplate.designation"> Sjabloonaanduiding </th> <th translate="systemSettings.getEmailTemplate.filename"> Oorspronkelijke bestandsnaam </th> <th translate="systemSettings.addEmailTemplate.type"> Sjabloontype </th> <th translate="systemSettings.getEmailTemplate.language"> Taal </th> <th translate="systemSettings.getEmailTemplate.default"> Standaard </th> <th translate="systemSettings.getEmailTemplate.download"> Download </th> </tr> </thead> <tbody> <tr ng-repeat="template in vm.dhlTemplates"> <td> {{$index+1+vm.dhlTemplatesData.page.size*vm.dhlTemplatesData.page.number}} </td> <td>{{template.name}}</td> <td>{{template.originalName}}</td> <td>{{vm.changeActionTypeToText(template.actionType)}}</td> <td>{{template.language}}</td> <td> {{(template.defaultTemplate)? vm.translate(\'yes\') : vm.translate(\'no\')}} </td> <td style="text-align: center"> <button class="btn" ng-click="vm.download(template.name, template.actionType, template.language, template.originalName)"> <span translate="systemSettings.getEmailTemplate.download2">Download</span> <i class="fa fa-download"></i> </button> </td> </tr> </tbody> <tfoot> <tr> <td colspan="7"></td> </tr> </tfoot> </table> <div class="row" ng-if="vm.dhlTemplates.length > 0"> <br> <div class="col-sm-6 text-left"> <button class="btn" ng-disabled="!vm.dhlTemplatesData._links.first || (vm.dhlTemplatesData.page.number == 0)" ng-click="vm.listTemplates.first()"> <i class="fa fa-step-backward"></i> <span translate="systemSettings.getEmailTemplate.first">Eerste</span> </button> <button class="btn" ng-disabled="!vm.dhlTemplatesData._links.prev" ng-click="vm.listTemplates.previous()"> <i class="fa fa-chevron-left"></i> <span translate="systemSettings.getEmailTemplate.previous">Voorgaand</span> </button> </div> <div class="col-sm-6 text-right"> <button class="btn" ng-disabled="!vm.dhlTemplatesData._links.next" ng-click="vm.listTemplates.next()"> <span translate="systemSettings.getEmailTemplate.next">Volgende</span> <i class="fa fa-chevron-right"></i> </button> <button class="btn" ng-disabled="!vm.dhlTemplatesData._links.last || (vm.dhlTemplatesData.page.number >= vm.dhlTemplatesData.page.totalPages-1)" ng-click="vm.listTemplates.last()"> <span translate="systemSettings.getEmailTemplate.last">Laatste</span> <i class="fa fa-step-forward"></i> </button> </div> </div> </section> <hr> <section class="container container-fluid" ng-if="$root.Principal.hasSystemAccess() || $root.Principal.hasTemplateAccess()"> <div ng-show="vm.addingEmailTitleErrorText!=null" class="alert ng-isolate-scope alert-danger alert-dismissible" role="alert" type="danger" close="alert.close($ctrl.alerts)"> <button ng-show="true" type="button" class="close" ng-click="vm.addingEmailTitleErrorText=null" aria-hidden="false"> <span aria-hidden="true">\xD7</span> <span class="sr-only">Close</span> </button> <div style="text-align: center"> <span class="ng-binding ng-scope">{{vm.addingEmailTitleErrorText}}</span> </div> </div> <div ng-show="vm.addingEmailTitleSuccessText!=null" class="alert ng-isolate-scope alert-success alert-dismissible" role="alert" type="success" close="alert.close($ctrl.alerts)"> <button ng-show="true" type="button" class="close" ng-click="vm.addingEmailTitleSuccessText=null" aria-hidden="false"> <span aria-hidden="true">\xD7</span> <span class="sr-only">Close</span> </button> <div style="text-align: center"> <span class="ng-binding ng-scope">{{vm.addingEmailTitleSuccessText}}</span> </div> </div> <h1 class="title text-left ng-scope"> <span translate="systemSettings.addSubjectTemplate.header">Voeg een onderwerp aan sjabloon toe</span> </h1> <form name="titleUploadForm" novalidate class="form"> <div class="form-group"> <label class="control-label" for="templateName"><span translate="systemSettings.addEmailTemplate.designation">Sjabloonaanduiding</span>:</label> <input class="form-control form-control-width-auto" type="text" id="templateName" required="required" ng-model="vm.title.name"> </div> <div class="form-group"> <label class="control-label"><span translate="systemSettings.getEmailTemplate.language">Taal</span>:</label> <select class="form-control" ng-model="vm.title.language" style="width: 100%"> <option ng-repeat="language in vm.languages" value="{{language.name}}"> {{language.text()}} </option> </select> </div> <div class="form-group"> <label class="control-label"><span translate="systemSettings.addEmailTemplate.type">Sjabloontype </span>:</label> <select class="form-control" ng-model="vm.title.activity" style="width: 100%"> <option ng-repeat="activity in vm.ActivityTypes" value="{{activity.name}}"> {{activity.text()}} </option> </select> </div> <div class="form-group"> <div uib-dropdown class="dropdown pointer"></div> </div> <div class="form-group"> <label class="control-label" for="templateTitle"><span translate="systemSettings.addSubjectTemplate.content">Sjabloon inhoud</span>:</label> <textarea class="form-control" id="titleArea" style="width: 100%; min-height: 50px; resize: none" type="text" id="templateTitle" required="required" ng-model="vm.title.text"></textarea> </div> <div class="form-group"> <label class="control-label"><span translate="systemSettings.addSubjectTemplate.field">Speciaal veld toevoegen </span>:</label> <div> <button type="button" class="btn" ng-click="vm.addClientNumber()"> <span translate="systemSettings.addSubjectTemplate.customer">Debiteur #</span> <i class="fa fa-users"></i> </button> <button type="button" class="btn" ng-click="vm.addInvoiceNumber()"> <span translate="systemSettings.addSubjectTemplate.invoice">Factuur #</span> <i class="fa fa-file-text-o"></i> </button> <button type="button" class="btn" ng-click="vm.addInvoiceDate()"> <span translate="systemSettings.addSubjectTemplate.date">Factuur datum</span> <i class="fa fa-calendar"></i> </button> <button type="button" class="btn" ng-click="vm.addNettoValue()"> <span translate="systemSettings.addSubjectTemplate.net">Factuur bedrag (netto)</span> <i class="fa fa-money"></i> </button> <button type="submit" class="btn pull-right" ng-click="vm.checkTemplateTitle()"> <span translate="systemSettings.addEmailTemplate.add">Voeg toe</span> <i class="fa fa-plus"></i> </button> </div> </div> </form> </section> <hr> <section class="container container-fluid" ng-if="$root.Principal.hasSystemAccess() || $root.Principal.hasTemplateAccess()"> <h1 class="title text-left ng-scope"> <span translate="systemSettings.subjectTemplates.header">Onderwerp sjablonen </span> </h1> <table id="fixtable" class="tablesorter latest" fix-table> <thead> <tr> <th></th> <th translate="systemSettings.addEmailTemplate.designation"> Sjabloonaanduiding </th> <th translate="systemSettings.addEmailTemplate.type"> Sjabloontype </th> <th translate="systemSettings.getEmailTemplate.language"> Taal </th> <th translate="systemSettings.getEmailTemplate.default"> Standaard </th> <th translate="systemSettings.addSubjectTemplate.content"> Sjabloon inhoud </th> <!-- <th>Edycja</th> --> </tr> </thead> <tbody> <tr ng-repeat="title in vm.dhlTitles"> <td> {{$index+1+vm.dhlTitlesData.page.size*vm.dhlTitlesData.page.number}} </td> <td>{{title.name}}</td> <td>{{vm.changeActionTypeToText(title.actionType)}}</td> <td>{{title.language}}</td> <td> {{(title.defaultTemplate) ? vm.translate(\'yes\') : vm.translate(\'no\')}} </td> <td>{{title.content}}</td> </tr> </tbody> <tfoot> <tr> <td colspan="6"></td> </tr> </tfoot> </table> <div class="row" ng-if="vm.dhlTitles.length > 0"> <br> <div class="col-sm-6 text-left"> <button class="btn" ng-disabled="!vm.dhlTitlesData._links.first || (vm.dhlTitlesData.page.number == 0)" ng-click="vm.listTitles.first()"> <i class="fa fa-step-backward"></i> <span translate="systemSettings.getEmailTemplate.first">Eerste</span> </button> <button class="btn" ng-disabled="!vm.dhlTitlesData._links.prev" ng-click="vm.listTitles.previous()"> <i class="fa fa-chevron-left"></i> <span translate="systemSettings.getEmailTemplate.previous">Voorgaand</span> </button> </div> <div class="col-sm-6 text-right"> <button class="btn" ng-disabled="!vm.dhlTitlesData._links.next" ng-click="vm.listTitles.next()"> <span translate="systemSettings.getEmailTemplate.next">Volgende</span> <i class="fa fa-chevron-right"></i> </button> <button class="btn" ng-disabled="!vm.dhlTitlesData._links.last || (vm.dhlTitlesData.page.number >= vm.dhlTitlesData.page.totalPages-1)" ng-click="vm.listTitles.last()"> <span translate="systemSettings.getEmailTemplate.last">Laatste</span> <i class="fa fa-step-forward"></i> </button> </div> </div> </section> <hr> <section class="container container-fluid" ng-if="$root.Principal.hasSystemAccess() || $root.Principal.hasTemplateAccess()"> <div ng-show="vm.clientErrorText!=null" class="alert ng-isolate-scope alert-danger alert-dismissible" role="alert" type="danger" close="alert.close($ctrl.alerts)"> <button ng-show="true" type="button" class="close" ng-click="vm.clientErrorText=null" aria-hidden="false"> <span aria-hidden="true">\xD7</span> <span class="sr-only">Close</span> </button> <div style="text-align: center"> <span class="ng-binding ng-scope">{{vm.clientErrorText}}</span> </div> </div> <div ng-show="vm.clientSuccessText!=null" class="alert ng-isolate-scope alert-success alert-dismissible" role="alert" type="success" close="alert.close($ctrl.alerts)"> <button ng-show="true" type="button" class="close" ng-click="vm.clientSuccessText=null" aria-hidden="false"> <span aria-hidden="true">\xD7</span> <span class="sr-only">Close</span> </button> <div style="text-align: center"> <span class="ng-binding ng-scope">{{vm.clientSuccessText}}</span> </div> </div> <h1 class="title text-left ng-scope"> <span translate="systemSettings.assignToUser.header">Wijs sjabloon toe aan gebruiker</span> </h1> <div> <form name="findUserForm" novalidate class="form voffset3"> <div class="form-group"> <label class="control-label" for="clientId"><span translate="systemSettings.assignToUser.edit">Bewerk e-mailsjablonen voor debiteuren</span>:</label> <input class="form-control form-control-width-auto" type="text" id="clientId" required="required" ng-model="vm.clientId"> </div> <button class="btn" ng-click="vm.getClientByNumber()"> <span translate="systemSettings.assignToUser.display">Toon</span> <i class="fa fa-eye"></i> </button> </form> </div> <div style="width: 100%; overflow: auto" ng-show="vm.dhlClient && vm.clientTemplates.templatesNL.INVOICE_TOO_LARGE != null"> <table class="tablesorter latest"> <thead> <tr> <th></th> <th>{{vm.ActivityTypes[0].text()}}</th> <th>{{vm.ActivityTypes[1].text()}}</th> <th>{{vm.ActivityTypes[2].text()}}</th> <th>{{vm.ActivityTypes[3].text()}}</th> <th>{{vm.ActivityTypes[4].text()}}</th> <th>{{vm.ActivityTypes[5].text()}}</th> <th>{{vm.ActivityTypes[6].text()}}</th> <th>{{vm.ActivityTypes[7].text()}}</th> <th>{{vm.ActivityTypes[8].text()}}</th> <!-- <th>{{vm.ActivityTypes[9].text()}}</th> --> </tr> </thead> <tbody> <tr> <td translate="systemSettings.assignToUser.titleNL"> Titel [NL] </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.titlesNL.ACCOUNT_OPENED" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'ACCOUNT_OPENED\', language:\'nl\'} : true" style="width: 100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.titlesNL.EMAIL_ADDED" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'EMAIL_ADDED\', language:\'nl\'} : true" style="width: 100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.titlesNL.REGISTRATION_FAIL" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'REGISTRATION_FAIL\', language:\'nl\'} : true" style="width: 100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.titlesNL.PASSWORD_CHANGE" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'PASSWORD_CHANGE\', language:\'nl\'} : true" style="width: 100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.titlesNL.INVOICE_WITH_LINK" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'INVOICE_WITH_LINK\', language:\'nl\'} : true" style="width: 100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.titlesNL.INVOICE_WITH_PDF" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'INVOICE_WITH_PDF\', language:\'nl\'} : true" style="width: 100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.titlesNL.INVOICE_WITH_LINK_AND_XLSX" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'INVOICE_WITH_LINK_AND_XLSX\', language:\'nl\'} : true" style="width: 100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.titlesNL.INVOICE_WITH_PDF_AND_XLSX" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'INVOICE_WITH_PDF_AND_XLSX\', language:\'nl\'} : true" style="width: 100%"></select> <br> </div> </td> <!-- <td>\n                            <div uib-dropdown class="dropdown pointer" style="width:100%;">\n                                <select ng-model="vm.clientTemplates.titlesNL.CORRECTION_INVOICE" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'CORRECTION_INVOICE\', language:\'nl\'} : true" style="width:100%;"></select>\n                                <br/>\n                            </div>\n                        </td> --> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.titlesNL.INVOICE_TOO_LARGE" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'INVOICE_TOO_LARGE\', language:\'nl\'} : true" style="width: 100%"></select> <br> </div> </td> </tr> <tr> <td translate="systemSettings.assignToUser.contentNL"> Inhoud [NL] </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.templatesNL.ACCOUNT_OPENED" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'ACCOUNT_OPENED\', language:\'nl\'} : true" style="width: 100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.templatesNL.EMAIL_ADDED" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'EMAIL_ADDED\', language:\'nl\'} : true" style="width: 100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.templatesNL.REGISTRATION_FAIL" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'REGISTRATION_FAIL\', language:\'nl\'} : true" style="width: 100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.templatesNL.PASSWORD_CHANGE" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'PASSWORD_CHANGE\', language:\'nl\'} : true" style="width: 100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.templatesNL.INVOICE_WITH_LINK" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'INVOICE_WITH_LINK\', language:\'nl\'} : true" style="width: 100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.templatesNL.INVOICE_WITH_PDF" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'INVOICE_WITH_PDF\', language:\'nl\'} : true" style="width: 100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.templatesNL.INVOICE_WITH_LINK_AND_XLSX" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'INVOICE_WITH_LINK_AND_XLSX\', language:\'nl\'} : true" style="width: 100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.templatesNL.INVOICE_WITH_PDF_AND_XLSX" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'INVOICE_WITH_PDF_AND_XLSX\', language:\'nl\'} : true" style="width: 100%"></select> <br> </div> </td> <!-- <td>\n                            <div uib-dropdown class="dropdown pointer" style="width:100%;">\n                                <select ng-model="vm.clientTemplates.templatesNL.CORRECTION_INVOICE" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'CORRECTION_INVOICE\', language:\'nl\'} : true" style="width:100%;"></select>\n                                <br/>\n                            </div>\n                        </td> --> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.templatesNL.INVOICE_TOO_LARGE" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'INVOICE_TOO_LARGE\', language:\'nl\'} : true" style="width: 100%"></select> <br> </div> </td> </tr> <tr> <td translate="systemSettings.assignToUser.titleFR"> Titel [FR] </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.titlesFR.ACCOUNT_OPENED" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'ACCOUNT_OPENED\', language:\'fr\'} : true" style="width: 100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.titlesFR.EMAIL_ADDED" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'EMAIL_ADDED\', language:\'fr\'} : true" style="width: 100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.titlesFR.REGISTRATION_FAIL" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'REGISTRATION_FAIL\', language:\'fr\'} : true" style="width: 100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.titlesFR.PASSWORD_CHANGE" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'PASSWORD_CHANGE\', language:\'fr\'} : true" style="width: 100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.titlesFR.INVOICE_WITH_LINK" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'INVOICE_WITH_LINK\', language:\'fr\'} : true" style="width: 100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.titlesFR.INVOICE_WITH_PDF" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'INVOICE_WITH_PDF\', language:\'fr\'} : true" style="width: 100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.titlesFR.INVOICE_WITH_LINK_AND_XLSX" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'INVOICE_WITH_LINK_AND_XLSX\', language:\'fr\'} : true" style="width: 100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.titlesFR.INVOICE_WITH_PDF_AND_XLSX" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'INVOICE_WITH_PDF_AND_XLSX\', language:\'fr\'} : true" style="width: 100%"></select> <br> </div> </td> <!-- <td>\n                            <div uib-dropdown class="dropdown pointer" style="width:100%;">\n                                <select ng-model="vm.clientTemplates.titlesFR.CORRECTION_INVOICE" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'CORRECTION_INVOICE\', language:\'fr\'} : true" style="width:100%;"></select>\n                                <br/>\n                            </div>\n                        </td> --> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.titlesFR.INVOICE_TOO_LARGE" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'INVOICE_TOO_LARGE\', language:\'fr\'} : true" style="width: 100%"></select> <br> </div> </td> </tr> <tr> <td translate="systemSettings.assignToUser.contentFR"> Inhoud [FR] </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.templatesFR.ACCOUNT_OPENED" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'ACCOUNT_OPENED\', language:\'fr\'} : true" style="width: 100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.templatesFR.EMAIL_ADDED" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'EMAIL_ADDED\', language:\'fr\'} : true" style="width: 100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.templatesFR.REGISTRATION_FAIL" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'REGISTRATION_FAIL\', language:\'fr\'} : true" style="width: 100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.templatesFR.PASSWORD_CHANGE" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'PASSWORD_CHANGE\', language:\'fr\'} : true" style="width: 100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.templatesFR.INVOICE_WITH_LINK" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'INVOICE_WITH_LINK\', language:\'fr\'} : true" style="width: 100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.templatesFR.INVOICE_WITH_PDF" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'INVOICE_WITH_PDF\', language:\'fr\'} : true" style="width: 100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.templatesFR.INVOICE_WITH_LINK_AND_XLSX" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'INVOICE_WITH_LINK_AND_XLSX\', language:\'fr\'} : true" style="width: 100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.templatesFR.INVOICE_WITH_PDF_AND_XLSX" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'INVOICE_WITH_PDF_AND_XLSX\', language:\'fr\'} : true" style="width: 100%"></select> <br> </div> </td> <!-- <td>\n                            <div uib-dropdown class="dropdown pointer" style="width:100%;">\n                                <select ng-model="vm.clientTemplates.templatesFR.CORRECTION_INVOICE" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'CORRECTION_INVOICE\', language:\'fr\'} : true" style="width:100%;"></select>\n                                <br/>\n                            </div>\n                        </td> --> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.templatesFR.INVOICE_TOO_LARGE" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'INVOICE_TOO_LARGE\', language:\'fr\'} : true" style="width: 100%"></select> <br> </div> </td> </tr> <tr> <td translate="systemSettings.assignToUser.titleEN"> Titel [EN] </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.titlesEN.ACCOUNT_OPENED" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'ACCOUNT_OPENED\', language:\'en\'} : true" style="width: 100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.titlesEN.EMAIL_ADDED" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'EMAIL_ADDED\', language:\'en\'} : true" style="width: 100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.titlesEN.REGISTRATION_FAIL" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'REGISTRATION_FAIL\', language:\'en\'} : true" style="width: 100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.titlesEN.PASSWORD_CHANGE" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'PASSWORD_CHANGE\', language:\'en\'} : true" style="width: 100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.titlesEN.INVOICE_WITH_LINK" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'INVOICE_WITH_LINK\', language:\'en\'} : true" style="width: 100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.titlesEN.INVOICE_WITH_PDF" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'INVOICE_WITH_PDF\', language:\'en\'} : true" style="width: 100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.titlesEN.INVOICE_WITH_LINK_AND_XLSX" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'INVOICE_WITH_LINK_AND_XLSX\', language:\'en\'} : true" style="width: 100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.titlesEN.INVOICE_WITH_PDF_AND_XLSX" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'INVOICE_WITH_PDF_AND_XLSX\', language:\'en\'} : true" style="width: 100%"></select> <br> </div> </td> <!-- <td>\n                            <div uib-dropdown class="dropdown pointer" style="width:100%;">\n                                <select ng-model="vm.clientTemplates.titlesEN.CORRECTION_INVOICE" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'CORRECTION_INVOICE\', language:\'en\'} : true" style="width:100%;"></select>\n                                <br/>\n                            </div>\n                        </td> --> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.titlesEN.INVOICE_TOO_LARGE" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'INVOICE_TOO_LARGE\', language:\'en\'} : true" style="width: 100%"></select> <br> </div> </td> </tr> <tr> <td translate="systemSettings.assignToUser.contentEN"> Inhoud [EN] </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.templatesEN.ACCOUNT_OPENED" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'ACCOUNT_OPENED\', language:\'en\'} : true" style="width: 100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.templatesEN.EMAIL_ADDED" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'EMAIL_ADDED\', language:\'en\'} : true" style="width: 100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.templatesEN.REGISTRATION_FAIL" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'REGISTRATION_FAIL\', language:\'en\'} : true" style="width: 100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.templatesEN.PASSWORD_CHANGE" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'PASSWORD_CHANGE\', language:\'en\'} : true" style="width: 100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.templatesEN.INVOICE_WITH_LINK" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'INVOICE_WITH_LINK\', language:\'en\'} : true" style="width: 100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.templatesEN.INVOICE_WITH_PDF" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'INVOICE_WITH_PDF\', language:\'en\'} : true" style="width: 100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.templatesEN.INVOICE_WITH_LINK_AND_XLSX" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'INVOICE_WITH_LINK_AND_XLSX\', language:\'en\'} : true" style="width: 100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.templatesEN.INVOICE_WITH_PDF_AND_XLSX" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'INVOICE_WITH_PDF_AND_XLSX\', language:\'en\'} : true" style="width: 100%"></select> <br> </div> </td> <!-- <td>\n                            <div uib-dropdown class="dropdown pointer" style="width:100%;">\n                                <select ng-model="vm.clientTemplates.templatesEN.CORRECTION_INVOICE" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'CORRECTION_INVOICE\', language:\'en\'} : true" style="width:100%;"></select>\n                                <br/>\n                            </div>\n                        </td> --> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.templatesEN.INVOICE_TOO_LARGE" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'INVOICE_TOO_LARGE\', language:\'en\'} : true" style="width: 100%"></select> <br> </div> </td> </tr> <tr> <td translate="systemSettings.assignToUser.titleDE"> Titel [DE] </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.titlesDE.ACCOUNT_OPENED" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'ACCOUNT_OPENED\', language:\'de\'} : true" style="width: 100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.titlesDE.EMAIL_ADDED" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'EMAIL_ADDED\', language:\'de\'} : true" style="width: 100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.titlesDE.REGISTRATION_FAIL" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'REGISTRATION_FAIL\', language:\'de\'} : true" style="width: 100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.titlesDE.PASSWORD_CHANGE" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'PASSWORD_CHANGE\', language:\'de\'} : true" style="width: 100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.titlesDE.INVOICE_WITH_LINK" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'INVOICE_WITH_LINK\', language:\'de\'} : true" style="width: 100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.titlesDE.INVOICE_WITH_PDF" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'INVOICE_WITH_PDF\', language:\'de\'} : true" style="width: 100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.titlesDE.INVOICE_WITH_LINK_AND_XLSX" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'INVOICE_WITH_LINK_AND_XLSX\', language:\'de\'} : true" style="width: 100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.titlesDE.INVOICE_WITH_PDF_AND_XLSX" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'INVOICE_WITH_PDF_AND_XLSX\', language:\'de\'} : true" style="width: 100%"></select> <br> </div> </td> <!-- <td>\n                            <div uib-dropdown class="dropdown pointer" style="width:100%;">\n                                <select ng-model="vm.clientTemplates.titlesDE.CORRECTION_INVOICE" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'CORRECTION_INVOICE\', language:\'de\'} : true" style="width:100%;"></select>\n                                <br/>\n                            </div>\n                        </td> --> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.titlesDE.INVOICE_TOO_LARGE" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'INVOICE_TOO_LARGE\', language:\'de\'} : true" style="width: 100%"></select> <br> </div> </td> </tr> <tr> <td translate="systemSettings.assignToUser.contentDE"> Inhoud [DE] </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.templatesDE.ACCOUNT_OPENED" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'ACCOUNT_OPENED\', language:\'de\'} : true" style="width: 100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.templatesDE.EMAIL_ADDED" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'EMAIL_ADDED\', language:\'de\'} : true" style="width: 100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.templatesDE.REGISTRATION_FAIL" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'REGISTRATION_FAIL\', language:\'de\'} : true" style="width: 100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.templatesDE.PASSWORD_CHANGE" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'PASSWORD_CHANGE\', language:\'de\'} : true" style="width: 100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.templatesDE.INVOICE_WITH_LINK" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'INVOICE_WITH_LINK\', language:\'de\'} : true" style="width: 100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.templatesDE.INVOICE_WITH_PDF" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'INVOICE_WITH_PDF\', language:\'de\'} : true" style="width: 100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.templatesDE.INVOICE_WITH_LINK_AND_XLSX" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'INVOICE_WITH_LINK_AND_XLSX\', language:\'de\'} : true" style="width: 100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.templatesDE.INVOICE_WITH_PDF_AND_XLSX" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'INVOICE_WITH_PDF_AND_XLSX\', language:\'de\'} : true" style="width: 100%"></select> <br> </div> </td> <!-- <td>\n                            <div uib-dropdown class="dropdown pointer" style="width:100%;">\n                                <select ng-model="vm.clientTemplates.templatesDE.CORRECTION_INVOICE" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'CORRECTION_INVOICE\', language:\'de\'} : true" style="width:100%;"></select>\n                                <br/>\n                            </div>\n                        </td> --> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.templatesDE.INVOICE_TOO_LARGE" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'INVOICE_TOO_LARGE\', language:\'de\'} : true" style="width: 100%"></select> <br> </div> </td> </tr> </tbody> <tfoot> <tr> <td colspan="11"></td> </tr> </tfoot> </table> </div> <br> <button class="btn pull-right" ng-click="vm.sendNewUserTemplates()" ng-show="vm.dhlClient && vm.clientTemplates.templatesNL.INVOICE_TOO_LARGE != null" translate="systemSettings.assignToUser.send"> Verstuur </button> </section> </div> ');
$templateCache.put('app/views/users/usersPanel.html','<section class="container container-fluid" ui-view="innerContent" ng-if="$root.Principal.hasUserRead()"> </section> ');
$templateCache.put('app/views/clients/client/client.html','<div ng-if="$root.Principal.isAuthenticated()" class="embedded-page-padding"> <div class="row-fluid"> <div class="btn-enclose"> <button id="back" class="btn" ng-click="vm.nav.clients()"> <i class="fa fa-chevron-left"></i> <span translate="clients.client.back">Terug</span> </button> </div> </div> <portal-alert></portal-alert> <div class="row voffset2" style="margin-left:0; margin-right:0"> <div class="col-md-5" style="padding-left:0px;padding-bottom: 10px"> <h1 class="title text-left"><span translate="clients.client.client">Debiteur</span></h1> <form id="clientForm" name="clientForm" novalidate> <table class="tablesorter latest"> <thead> <tr> <th></th> <th></th> </tr> </thead> <tbody> <tr> <td><span translate="clients.client.clientNumber">Debiteuren nummer</span></td> <td>{{vm.data.client.clientNumber}}</td> </tr> <tr> <td><span translate="clients.client.payerNumber">Debiteuren nummer</span></td> <td> <div click-to-edit ng-model="vm.data.client.payerNumber" data-maxlength="8" data-ng-pattern="/^[0-9]{8}$/" data-required="required"></div> </td> </tr> <tr> <td><span translate="clients.client.nipNumber">BTW codenummer</span></td> <td> <div click-to-edit ng-model="vm.data.client.nip" data-maxlength="14" data-ng-pattern="/^[a-zA-Z0-9]{14}$/"></div> </td> </tr> <tr> <td><span translate="clients.client.companyName">Bedrijfsnaam </span></td> <td> <div click-to-edit ng-model="vm.data.client.clientName" data-maxlength="50"></div> </td> </tr> <tr> <td><span translate="clients.client.users">Gebruikers</span></td> <td> <div class="input-group" ng-show="($root.Principal.hasClientRead() && ! $root.Principal.hasAllDocumentsAccess()) || $root.Principal.hasSystemAccess() || $root.Principal.hasTemplateAccess()"> <input class="form-control form-control-width-auto" id="clientUsers" type="text" autocomplete="off" minlength="3" ng-model-options="{debounce:400}" ng-model="vm.data.user" uib-typeahead="user for user in vm.user.getByEmail($viewValue)" typeahead-editable="true"> <span class="input-group-btn"> <button class="btn" ng-click="vm.user.add() "> <i class="fa fa-plus-square"></i> </button> <button class="btn" ng-click="vm.user.delete() " ng-disabled="vm.data.client.users.length==0 "> <i class="fa fa-minus-square"></i> </button> </span> </div> <div> <select class="form-control col-xs-12" multiple="multiple" ng-model="vm.selection " ng-options="user.email for user in vm.data.client.users | orderBy:email " ng-show="vm.data.client.users.length> 0"></select> </div> </td> </tr> <tr> <td><span translate="clients.client.eInvoice">Factuur</span></td> <td> <input ng-if="$root.Principal.hasClientWrite()" id="clientEInvoiceAgreement" type="checkbox" ng-model="vm.data.client.eInvoiceAgreement"> <label for="clientEInvoiceAgreement" ng-show="vm.data.client.eInvoiceAgreement" translate="clients.client.yes">Ja</label> <label for="clientEInvoiceAgreement" ng-show="!vm.data.client.eInvoiceAgreement" translate="clients.client.no">Nee</label> </td> </tr> <tr ng-if="vm.onHoldCheckboxShow"> <td><span translate="clients.client.onHold">Debtor on hold</span></td> <td> <input ng-disabled="!vm.onHoldCheckboxEditable" id="clientOnHoldCheckbox" type="checkbox" ng-model="vm.data.client.debtorOnHold"> <label for="clientOnHoldCheckbox" ng-show="vm.data.client.debtorOnHold" translate="clients.client.yes">Ja</label> <label for="clientOnHoldCheckbox" ng-show="!vm.data.client.debtorOnHold" translate="clients.client.no">Nee</label> </td> </tr> <tr> <td><span>Tradeshift exchange</span></td> <td> <input ng-if="$root.Principal.hasClientWrite()" id="tradeshiftExchangeCheckbox" type="checkbox" ng-model="vm.data.client.tradeshiftExchange"> <label for="tradeshiftExchangeCheckbox" ng-show="vm.data.client.tradeshiftExchange" translate="clients.client.yes">Ja</label> <label for="tradeshiftExchangeCheckbox" ng-show="!vm.data.client.tradeshiftExchange" translate="clients.client.no">Nee</label> </td> </tr> <tr> <td><span translate="clients.client.documentSendingMethod">Document verzendmethode</span></td> <td> <select id="clientDocSending" class="form-control" ng-if="$root.Principal.hasClientWrite()" ng-model="vm.data.client.docSending"> <option value="LINK">Link</option> <option value="CSV">CSV</option> <option value="PDF">PDF</option> <option value="LINK_XLSX" translate="clients.client.linkXlsx">Link en XLSX</option> <option value="PDF_XLSX" translate="clients.client.pdfXlsx">PDF en XLSX</option> <option value="PDF_CSV" translate="clients.client.pdfCsv">PDF en XLSX</option> <option value="CUSTOMIZED_CSV" translate="clients.client.custCsv">aangepaste CSV</option> <option value="CUSTOMIZED_PDF_CSV" translate="clients.client.custCsvPdf">aangepaste CSV + PDF</option> </select> <span ng-if="!$root.Principal.hasClientWrite()">{{vm.data.client.docSending}}</span> </td> </tr> <tr ng-show="vm.data.client.docSending === \'CUSTOMIZED_CSV\' || vm.data.client.docSending === \'CUSTOMIZED_PDF_CSV\'"> <td><span translate="clients.client.templateSelection">Kies een sjabloon</span></td> <td> <select class="form-control" ng-model="vm.data.client.csvTemplateName" ng-options="config for config in vm.data.savedConfigs track by config"></select> </td> </tr> <!-- <tr>\n                            <td><span translate="clients.client.correctionSendingMethod">Metoda wysy\u0142ki dokument\xF3w koryguj\u0105cych</span></td>\n                            <td>\n                                <!- -\n                                <select id="clientCorrectingDocSending" class="form-control"\n                                        ng-if="$root.Principal.hasClientWrite()"\n                                        ng-model="vm.data.client.correctingDocSending">\n                                    <option value="LINK">Link</option>\n                                    <option value="PDF">PDF</option>\n                                    <option value="LINK_XLSX"><span translate="clients.client.linkXlsx">Link oraz XLSX</span></option>\n                                    <option value="PDF_XLSX"><span translate="clients.client.pdfXlsx">PDF oraz XLSX</span></option>\n                                </select> <span ng-if="! $root.Principal.hasClientWrite()">{{vm.data.client.correctingDocSending}}</span>- ->\n                                <select id="clientCorrectingDocSending" class="form-control" ng-if="$root.Principal.hasClientWrite()">\n                                    <option value="LINK">Link</option>\n                                </select><span ng-if="! $root.Principal.hasClientWrite()">Link</span>\n                            </td>\n                        </tr> --> <tr> <td><span translate="clients.client.contactPerson">Contact persoon </span></td> <td> <div click-to-edit ng-model="vm.data.client.contactPerson" data-maxlength="50"></div> </td> </tr> <tr> <td> <span translate="clients.client.contactNumber">Contact nummer </span> </td> <td> <div click-to-edit ng-model="vm.data.client.phoneNumber" id="newClientPhoneNumber"> </td> </tr> <tr ng-if="$root.Principal.hasClientWrite()"> <td><span translate="clients.client.remarks">Opmerkingen</span></td> <td> <div click-to-edit ng-model="vm.data.client.notes" data-maxlength="100" textarea></div> </td> </tr> </tbody> <tfoot> <tr> <td colspan="2"></td> </tr> </tfoot> </table> <div ng-show="($root.Principal.hasClientRead() && ! $root.Principal.hasAllDocumentsAccess()) || $root.Principal.hasSystemAccess() || $root.Principal.hasTemplateAccess()" class="btn-enclose text-center"> <button class="btn" ng-click="vm.client.update()" ng-disabled="clientForm.$invalid || clientForm.$pending"> <span translate="clients.client.save">Opslaan </span><i class="fa fa-save"></i> </button> <button class="btn" ng-click="vm.client.cancel()"> <span translate="clients.client.cancel">Annuleer </span><i class="fa fa-times"></i> </button> </div> </form> </div> <div class="col-md-5 col-md-push-2" style="padding-left:0px;padding-bottom: 10px" ng-if="$root.Principal.hasSystemAccess()"> <h1 class="title text-left">SFTP Connection</h1> <form id="clientFtpForm" name="clientFtpForm" novalidate> <table class="tablesorter latest"> <thead> <tr> <th></th> <th></th> </tr> </thead> <tbody> <tr> <td><span translate="clients.client.username">Username</span></td> <td><div click-to-edit ng-model="vm.data.client.ftpConfiguration.username" data-maxlength="50"></div></td> </tr> <tr> <td><span translate="clients.client.password">Password</span></td> <td><div click-to-edit ng-model="vm.data.client.ftpConfiguration.password" data-maxlength="50">*****</div></td> </tr> <tr> <td><span translate="clients.client.deliveryMethod">Delivery method</span></td> <td> <select id="clientDeliveryMethod" class="form-control" ng-model="vm.data.client.ftpConfiguration.deliveryMethod"> <option value="FTP">FTP</option> <option value="SFTP">SFTP</option> </select> </td> </tr> <tr> <td><span>Hostname</span></td> <td><div click-to-edit ng-model="vm.data.client.ftpConfiguration.hostname"></div></td> </tr> <tr> <td><span>Port</span></td> <td><div click-to-edit ng-model="vm.data.client.ftpConfiguration.portNumber" data-ng-pattern="/^[0-9]{8}$/" data-required="required"></div></td> </tr> <tr> <td><span translate="clients.client.directory">Directory</span></td> <td><div click-to-edit ng-model="vm.data.client.ftpConfiguration.directory"></div></td> </tr> <tr> <td><span translate="clients.client.fileTypes">File types</span></td> <td> <input id="clientFileCsv" type="checkbox" ng-model="vm.data.client.ftpConfiguration.fileTypesArray.CSV"> <label for="clientFileCsv">CSV</label> <br> <input id="clientFileXml" type="checkbox" ng-model="vm.data.client.ftpConfiguration.fileTypesArray.XML"> <label for="clientFileXml">XML</label> <br> <input id="clientFilePdf" type="checkbox" ng-model="vm.data.client.ftpConfiguration.fileTypesArray.PDF"> <label for="clientFilePdf">PDF</label> </td> </tr> <tr> <td><span translate="clients.client.isActive">Is the account active?</span></td> <td> <div style="font-weight: bold" ng-class="vm.data.client.isFtpActive ? \'text-success\' : \'text-danger\'"> {{vm.data.client.isFtpActive ? (\'clients.client.yes\' | translate) : (\'clients.client.no\' | translate)}} </div> </td> </tr> </tbody> <tfoot> <tr> <td colspan="2"></td> </tr> </tfoot> </table> <div class="btn-enclose text-center"> <button class="btn" ng-click="vm.client.updateFtpConfig()"> <!-- TODO ng-disabled="clientFtpForm.$invalid" --> <span>Save </span><i class="fa fa-save"></i> </button> <button class="btn" ng-click="vm.client.cancel()"> <span>Cancel </span><i class="fa fa-times"></i> </button> <button class="btn" ng-click="vm.client.deleteFtpConfig()" ng-disabled="!vm.data.client.isFtpActive"> <span>Delete </span><i class="fa fa-trash-o"></i> </button> </div> </form> </div> </div> <hr> <div ng-show="vm.clientErrorText!=null" class="alert ng-isolate-scope alert-danger alert-dismissible" role="alert" type="danger" close="alert.close($ctrl.alerts)"> <button ng-show="true" type="button" class="close" ng-click="vm.clientErrorText=null" aria-hidden="false"> <span aria-hidden="true">\xD7</span> <span class="sr-only">Close</span> </button> <div style="text-align: center"> <span class="ng-binding ng-scope">{{vm.clientErrorText}}</span> </div> </div> <div ng-show="vm.clientSuccessText!=null" class="alert ng-isolate-scope alert-success alert-dismissible" role="alert" type="success" close="alert.close($ctrl.alerts)"> <button ng-show="true" type="button" class="close" ng-click="vm.clientSuccessText=null" aria-hidden="false"> <span aria-hidden="true">\xD7</span> <span class="sr-only">Close</span> </button> <div style="text-align: center"> <span class="ng-binding ng-scope">{{vm.clientSuccessText}}</span> </div> </div> <div class="row-fluid" ng-if="$root.Principal.hasClientWrite()"> <div class=""> <div style="width: 100%; overflow: auto" ng-show="vm.data.client.ediClientId && vm.clientTemplates.templatesNL.INVOICE_TOO_LARGE != undefined && vm.clientTemplates.templatesNL.INVOICE_TOO_LARGE != null && vm.clientTemplates.templatesNL.INVOICE_TOO_LARGE != \'\'"> <h1 class="title text-left"><span translate="clients.client.emailTemplates">E-mail sjablonen</span></h1> <table id="fixtable2" class="tablesorter latest"> <thead> <tr> <th></th> <th>{{vm.ActivityTypes[0].text()}}</th> <th>{{vm.ActivityTypes[1].text()}}</th> <th>{{vm.ActivityTypes[2].text()}}</th> <th>{{vm.ActivityTypes[3].text()}}</th> <th>{{vm.ActivityTypes[4].text()}}</th> <th>{{vm.ActivityTypes[5].text()}}</th> <th>{{vm.ActivityTypes[6].text()}}</th> <th>{{vm.ActivityTypes[7].text()}}</th> <th>{{vm.ActivityTypes[8].text()}}</th> <th>{{vm.ActivityTypes[9].text()}}</th> </tr> </thead> <tbody> <tr> <td><span translate="clients.client.titleNL">Tytu\u0142 [NL]</span></td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.titlesNL.ACCOUNT_OPENED" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'ACCOUNT_OPENED\', language:\'nl\'} : true" style="width: 100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.titlesNL.EMAIL_ADDED" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'EMAIL_ADDED\', language:\'nl\'} : true" style="width: 100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.titlesNL.REGISTRATION_FAIL" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'REGISTRATION_FAIL\', language:\'nl\'} : true" style="width: 100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.titlesNL.PASSWORD_CHANGE" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'PASSWORD_CHANGE\', language:\'nl\'} : true" style="width: 100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.titlesNL.INVOICE_WITH_LINK" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'INVOICE_WITH_LINK\', language:\'nl\'} : true" style="width: 100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.titlesNL.INVOICE_WITH_PDF" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'INVOICE_WITH_PDF\', language:\'nl\'} : true" style="width: 100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.titlesNL.INVOICE_WITH_LINK_AND_XLSX" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'INVOICE_WITH_LINK_AND_XLSX\', language:\'nl\'} : true" style="width: 100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.titlesNL.INVOICE_WITH_PDF_AND_XLSX" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'INVOICE_WITH_PDF_AND_XLSX\', language:\'nl\'} : true" style="width: 100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.titlesNL.INVOICE_WITH_PDF_AND_CSV" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'INVOICE_WITH_PDF_AND_CSV\', language:\'nl\'} : true" style="width: 100%"></select> <br> </div> </td> <!-- <td>\n                                <div uib-dropdown class="dropdown pointer" style="width: 100%;">\n                                    <select ng-model="vm.clientTemplates.titlesNL.CORRECTION_INVOICE" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'CORRECTION_INVOICE\', language:\'nl\'} : true" style="width: 100%;"></select>\n                                    <br />\n                                </div>\n                            </td> --> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.titlesNL.INVOICE_TOO_LARGE" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'INVOICE_TOO_LARGE\', language:\'nl\'} : true" style="width: 100%"></select> <br> </div> </td> </tr> <tr> <td><span translate="clients.client.contentNL">Tre\u015B\u0107 [NL]</span></td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.templatesNL.ACCOUNT_OPENED" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'ACCOUNT_OPENED\', language:\'nl\'} : true" style="width: 100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.templatesNL.EMAIL_ADDED" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'EMAIL_ADDED\', language:\'nl\'} : true" style="width: 100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.templatesNL.REGISTRATION_FAIL" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'REGISTRATION_FAIL\', language:\'nl\'} : true" style="width: 100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.templatesNL.PASSWORD_CHANGE" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'PASSWORD_CHANGE\', language:\'nl\'} : true" style="width: 100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.templatesNL.INVOICE_WITH_LINK" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'INVOICE_WITH_LINK\', language:\'nl\'} : true" style="width: 100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.templatesNL.INVOICE_WITH_PDF" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'INVOICE_WITH_PDF\', language:\'nl\'} : true" style="width: 100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.templatesNL.INVOICE_WITH_LINK_AND_XLSX" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'INVOICE_WITH_LINK_AND_XLSX\', language:\'nl\'} : true" style="width: 100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.templatesNL.INVOICE_WITH_PDF_AND_XLSX" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'INVOICE_WITH_PDF_AND_XLSX\', language:\'nl\'} : true" style="width: 100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.templatesNL.INVOICE_WITH_PDF_AND_CSV" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'INVOICE_WITH_PDF_AND_CSV\', language:\'nl\'} : true" style="width: 100%"></select> <br> </div> </td> <!-- <td>\n                                <div uib-dropdown class="dropdown pointer" style="width: 100%;">\n                                    <select ng-model="vm.clientTemplates.templatesNL.CORRECTION_INVOICE" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'CORRECTION_INVOICE\', language:\'nl\'} : true" style="width: 100%;"></select>\n                                    <br />\n                                </div>\n                            </td> --> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.templatesNL.INVOICE_TOO_LARGE" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'INVOICE_TOO_LARGE\', language:\'nl\'} : true" style="width: 100%"></select> <br> </div> </td> </tr> <tr> <td><span translate="clients.client.titleFR">Tytu\u0142 [FR]</span></td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.titlesFR.ACCOUNT_OPENED" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'ACCOUNT_OPENED\', language:\'fr\'} : true" style="width: 100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.titlesFR.EMAIL_ADDED" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'EMAIL_ADDED\', language:\'fr\'} : true" style="width: 100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.titlesFR.REGISTRATION_FAIL" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'REGISTRATION_FAIL\', language:\'fr\'} : true" style="width: 100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.titlesFR.PASSWORD_CHANGE" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'PASSWORD_CHANGE\', language:\'fr\'} : true" style="width: 100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.titlesFR.INVOICE_WITH_LINK" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'INVOICE_WITH_LINK\', language:\'fr\'} : true" style="width: 100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.titlesFR.INVOICE_WITH_PDF" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'INVOICE_WITH_PDF\', language:\'fr\'} : true" style="width: 100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.titlesFR.INVOICE_WITH_LINK_AND_XLSX" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'INVOICE_WITH_LINK_AND_XLSX\', language:\'fr\'} : true" style="width: 100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.titlesFR.INVOICE_WITH_PDF_AND_XLSX" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'INVOICE_WITH_PDF_AND_XLSX\', language:\'fr\'} : true" style="width: 100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.titlesFR.INVOICE_WITH_PDF_AND_CSV" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'INVOICE_WITH_PDF_AND_CSV\', language:\'fr\'} : true" style="width: 100%"></select> <br> </div> </td> <!-- <td>\n                                <div uib-dropdown class="dropdown pointer" style="width: 100%;">\n                                    <select ng-model="vm.clientTemplates.titlesFR.CORRECTION_INVOICE" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'CORRECTION_INVOICE\', language:\'fr\'} : true" style="width: 100%;"></select>\n                                    <br />\n                                </div>\n                            </td> --> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.titlesFR.INVOICE_TOO_LARGE" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'INVOICE_TOO_LARGE\', language:\'fr\'} : true" style="width: 100%"></select> <br> </div> </td> </tr> <tr> <td><span translate="clients.client.contentFR">Tre\u015B\u0107 [FR]</span></td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.templatesFR.ACCOUNT_OPENED" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'ACCOUNT_OPENED\', language:\'fr\'} : true" style="width: 100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.templatesFR.EMAIL_ADDED" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'EMAIL_ADDED\', language:\'fr\'} : true" style="width: 100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.templatesFR.REGISTRATION_FAIL" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'REGISTRATION_FAIL\', language:\'fr\'} : true" style="width: 100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.templatesFR.PASSWORD_CHANGE" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'PASSWORD_CHANGE\', language:\'fr\'} : true" style="width: 100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.templatesFR.INVOICE_WITH_LINK" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'INVOICE_WITH_LINK\', language:\'fr\'} : true" style="width: 100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.templatesFR.INVOICE_WITH_PDF" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'INVOICE_WITH_PDF\', language:\'fr\'} : true" style="width: 100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.templatesFR.INVOICE_WITH_LINK_AND_XLSX" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'INVOICE_WITH_LINK_AND_XLSX\', language:\'fr\'} : true" style="width: 100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.templatesFR.INVOICE_WITH_PDF_AND_XLSX" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'INVOICE_WITH_PDF_AND_XLSX\', language:\'fr\'} : true" style="width: 100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.templatesFR.INVOICE_WITH_PDF_AND_CSV" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'INVOICE_WITH_PDF_AND_CSV\', language:\'fr\'} : true" style="width: 100%"></select> <br> </div> </td> <!-- <td>\n                                <div uib-dropdown class="dropdown pointer" style="width: 100%;">\n                                    <select ng-model="vm.clientTemplates.templatesFR.CORRECTION_INVOICE" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'CORRECTION_INVOICE\', language:\'fr\'} : true" style="width: 100%;"></select>\n                                    <br />\n                                </div>\n                            </td> --> <td> <div uib-dropdown class="dropdown pointer" style="width: 100%"> <select ng-model="vm.clientTemplates.templatesFR.INVOICE_TOO_LARGE" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'INVOICE_TOO_LARGE\', language:\'fr\'} : true" style="width: 100%"></select> <br> </div> </td> </tr> <tr> <td translate="clients.client.titleEN">Tytu\u0142 [EN]</td> <td> <div uib-dropdown class="dropdown pointer" style="width:100%"> <select ng-model="vm.clientTemplates.titlesEN.ACCOUNT_OPENED" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'ACCOUNT_OPENED\', language:\'en\'} : true" style="width:100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width:100%"> <select ng-model="vm.clientTemplates.titlesEN.EMAIL_ADDED" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'EMAIL_ADDED\', language:\'en\'} : true" style="width:100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width:100%"> <select ng-model="vm.clientTemplates.titlesEN.REGISTRATION_FAIL" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'REGISTRATION_FAIL\', language:\'en\'} : true" style="width:100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width:100%"> <select ng-model="vm.clientTemplates.titlesEN.PASSWORD_CHANGE" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'PASSWORD_CHANGE\', language:\'en\'} : true" style="width:100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width:100%"> <select ng-model="vm.clientTemplates.titlesEN.INVOICE_WITH_LINK" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'INVOICE_WITH_LINK\', language:\'en\'} : true" style="width:100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width:100%"> <select ng-model="vm.clientTemplates.titlesEN.INVOICE_WITH_PDF" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'INVOICE_WITH_PDF\', language:\'en\'} : true" style="width:100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width:100%"> <select ng-model="vm.clientTemplates.titlesEN.INVOICE_WITH_LINK_AND_XLSX" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'INVOICE_WITH_LINK_AND_XLSX\', language:\'en\'} : true" style="width:100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width:100%"> <select ng-model="vm.clientTemplates.titlesEN.INVOICE_WITH_PDF_AND_XLSX" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'INVOICE_WITH_PDF_AND_XLSX\', language:\'en\'} : true" style="width:100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width:100%"> <select ng-model="vm.clientTemplates.titlesEN.INVOICE_WITH_PDF_AND_CSV" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'INVOICE_WITH_PDF_AND_CSV\', language:\'en\'} : true" style="width:100%"></select> <br> </div> </td> <!-- <td>\n                                <div uib-dropdown class="dropdown pointer" style="width:100%;">\n                                    <select ng-model="vm.clientTemplates.titlesEN.CORRECTION_INVOICE" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'CORRECTION_INVOICE\', language:\'en\'} : true" style="width:100%;"></select>\n                                    <br/>\n                                </div>\n                            </td> --> <td> <div uib-dropdown class="dropdown pointer" style="width:100%"> <select ng-model="vm.clientTemplates.titlesEN.INVOICE_TOO_LARGE" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'INVOICE_TOO_LARGE\', language:\'en\'} : true" style="width:100%"></select> <br> </div> </td> </tr> <tr> <td translate="clients.client.contentEN">Tre\u015B\u0107 [EN]</td> <td> <div uib-dropdown class="dropdown pointer" style="width:100%"> <select ng-model="vm.clientTemplates.templatesEN.ACCOUNT_OPENED" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'ACCOUNT_OPENED\', language:\'en\'} : true" style="width:100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width:100%"> <select ng-model="vm.clientTemplates.templatesEN.EMAIL_ADDED" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'EMAIL_ADDED\', language:\'en\'} : true" style="width:100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width:100%"> <select ng-model="vm.clientTemplates.templatesEN.REGISTRATION_FAIL" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'REGISTRATION_FAIL\', language:\'en\'} : true" style="width:100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width:100%"> <select ng-model="vm.clientTemplates.templatesEN.PASSWORD_CHANGE" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'PASSWORD_CHANGE\', language:\'en\'} : true" style="width:100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width:100%"> <select ng-model="vm.clientTemplates.templatesEN.INVOICE_WITH_LINK" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'INVOICE_WITH_LINK\', language:\'en\'} : true" style="width:100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width:100%"> <select ng-model="vm.clientTemplates.templatesEN.INVOICE_WITH_PDF" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'INVOICE_WITH_PDF\', language:\'en\'} : true" style="width:100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width:100%"> <select ng-model="vm.clientTemplates.templatesEN.INVOICE_WITH_LINK_AND_XLSX" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'INVOICE_WITH_LINK_AND_XLSX\', language:\'en\'} : true" style="width:100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width:100%"> <select ng-model="vm.clientTemplates.templatesEN.INVOICE_WITH_PDF_AND_XLSX" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'INVOICE_WITH_PDF_AND_XLSX\', language:\'en\'} : true" style="width:100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width:100%"> <select ng-model="vm.clientTemplates.templatesEN.INVOICE_WITH_PDF_AND_CSV" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'INVOICE_WITH_PDF_AND_CSV\', language:\'en\'} : true" style="width:100%"></select> <br> </div> </td> <!-- <td>\n                                <div uib-dropdown class="dropdown pointer" style="width:100%;">\n                                    <select ng-model="vm.clientTemplates.templatesEN.CORRECTION_INVOICE" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'CORRECTION_INVOICE\', language:\'en\'} : true" style="width:100%;"></select>\n                                    <br/>\n                                </div>\n                            </td> --> <td> <div uib-dropdown class="dropdown pointer" style="width:100%"> <select ng-model="vm.clientTemplates.templatesEN.INVOICE_TOO_LARGE" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'INVOICE_TOO_LARGE\', language:\'en\'} : true" style="width:100%"></select> <br> </div> </td> </tr> <tr> <td translate="clients.client.titleDE">Tytu\u0142 [DE]</td> <td> <div uib-dropdown class="dropdown pointer" style="width:100%"> <select ng-model="vm.clientTemplates.titlesDE.ACCOUNT_OPENED" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'ACCOUNT_OPENED\', language:\'de\'} : true" style="width:100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width:100%"> <select ng-model="vm.clientTemplates.titlesDE.EMAIL_ADDED" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'EMAIL_ADDED\', language:\'de\'} : true" style="width:100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width:100%"> <select ng-model="vm.clientTemplates.titlesDE.REGISTRATION_FAIL" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'REGISTRATION_FAIL\', language:\'de\'} : true" style="width:100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width:100%"> <select ng-model="vm.clientTemplates.titlesDE.PASSWORD_CHANGE" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'PASSWORD_CHANGE\', language:\'de\'} : true" style="width:100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width:100%"> <select ng-model="vm.clientTemplates.titlesDE.INVOICE_WITH_LINK" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'INVOICE_WITH_LINK\', language:\'de\'} : true" style="width:100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width:100%"> <select ng-model="vm.clientTemplates.titlesDE.INVOICE_WITH_PDF" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'INVOICE_WITH_PDF\', language:\'de\'} : true" style="width:100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width:100%"> <select ng-model="vm.clientTemplates.titlesDE.INVOICE_WITH_LINK_AND_XLSX" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'INVOICE_WITH_LINK_AND_XLSX\', language:\'de\'} : true" style="width:100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width:100%"> <select ng-model="vm.clientTemplates.titlesDE.INVOICE_WITH_PDF_AND_XLSX" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'INVOICE_WITH_PDF_AND_XLSX\', language:\'de\'} : true" style="width:100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width:100%"> <select ng-model="vm.clientTemplates.titlesDE.INVOICE_WITH_PDF_AND_CSV" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'INVOICE_WITH_PDF_AND_CSV\', language:\'de\'} : true" style="width:100%"></select> <br> </div> </td> <!-- <td>\n                                <div uib-dropdown class="dropdown pointer" style="width:100%;">\n                                    <select ng-model="vm.clientTemplates.titlesDE.CORRECTION_INVOICE" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'CORRECTION_INVOICE\', language:\'de\'} : true" style="width:100%;"></select>\n                                    <br/>\n                                </div>\n                            </td> --> <td> <div uib-dropdown class="dropdown pointer" style="width:100%"> <select ng-model="vm.clientTemplates.titlesDE.INVOICE_TOO_LARGE" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_TITLE\', actionType:\'INVOICE_TOO_LARGE\', language:\'de\'} : true" style="width:100%"></select> <br> </div> </td> </tr> <tr> <td translate="clients.client.contentDE">Tre\u015B\u0107 [DE]</td> <td> <div uib-dropdown class="dropdown pointer" style="width:100%"> <select ng-model="vm.clientTemplates.templatesDE.ACCOUNT_OPENED" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'ACCOUNT_OPENED\', language:\'de\'} : true" style="width:100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width:100%"> <select ng-model="vm.clientTemplates.templatesDE.EMAIL_ADDED" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'EMAIL_ADDED\', language:\'de\'} : true" style="width:100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width:100%"> <select ng-model="vm.clientTemplates.templatesDE.REGISTRATION_FAIL" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'REGISTRATION_FAIL\', language:\'de\'} : true" style="width:100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width:100%"> <select ng-model="vm.clientTemplates.templatesDE.PASSWORD_CHANGE" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'PASSWORD_CHANGE\', language:\'de\'} : true" style="width:100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width:100%"> <select ng-model="vm.clientTemplates.templatesDE.INVOICE_WITH_LINK" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'INVOICE_WITH_LINK\', language:\'de\'} : true" style="width:100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width:100%"> <select ng-model="vm.clientTemplates.templatesDE.INVOICE_WITH_PDF" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'INVOICE_WITH_PDF\', language:\'de\'} : true" style="width:100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width:100%"> <select ng-model="vm.clientTemplates.templatesDE.INVOICE_WITH_LINK_AND_XLSX" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'INVOICE_WITH_LINK_AND_XLSX\', language:\'de\'} : true" style="width:100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width:100%"> <select ng-model="vm.clientTemplates.templatesDE.INVOICE_WITH_PDF_AND_XLSX" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'INVOICE_WITH_PDF_AND_XLSX\', language:\'de\'} : true" style="width:100%"></select> <br> </div> </td> <td> <div uib-dropdown class="dropdown pointer" style="width:100%"> <select ng-model="vm.clientTemplates.templatesDE.INVOICE_WITH_PDF_AND_CSV" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'INVOICE_WITH_PDF_AND_CSV\', language:\'de\'} : true" style="width:100%"></select> <br> </div> </td> <!-- <td>\n                                <div uib-dropdown class="dropdown pointer" style="width:100%;">\n                                    <select ng-model="vm.clientTemplates.templatesDE.CORRECTION_INVOICE" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'CORRECTION_INVOICE\', language:\'de\'} : true" style="width:100%;"></select>\n                                    <br/>\n                                </div>\n                            </td> --> <td> <div uib-dropdown class="dropdown pointer" style="width:100%"> <select ng-model="vm.clientTemplates.templatesDE.INVOICE_TOO_LARGE" ng-options="title.name for title in vm.dhlEmailTempaltes | filter:{type:\'EMAIL_CONTENT\', actionType:\'INVOICE_TOO_LARGE\', language:\'de\'} : true" style="width:100%"></select> <br> </div> </td> </tr> </tbody> <tfoot> <tr> <td colspan="11"></td> </tr> </tfoot> </table> </div> <br> <button class="btn pull-right" ng-click="vm.sendNewUserTemplates()" ng-show="vm.data.client.ediClientId && vm.clientTemplates.templatesNL.INVOICE_TOO_LARGE != undefined &&\n                    vm.clientTemplates.templatesNL.INVOICE_TOO_LARGE != null && vm.clientTemplates.templatesNL.INVOICE_TOO_LARGE != \'\'"> <span translate="clients.client.save">Zapisz </span> <i class="fa fa-save"></i> </button> </div> </div> </div> ');
$templateCache.put('app/views/clients/clients/clients.html','<div id="fixed" class="container container-fluid embedded-page-padding"> <portal-alert></portal-alert> <form id="filter" class="form-inline" accept-charset="UTF-8"> <fieldset> <div class="form-group"> <label class="control-label" for="searchSAPId"><span translate="clients.clients.sapNumber">Debiteuren nummer</span>:</label> <input class="form-control margin-bottom" type="text" id="searchSAPId" ng-model="vm.filter.data.clientNumber"> </div> <div class="form-group"> <label class="control-label" for="searchClientName"><span translate="clients.clients.name">Naam</span>:</label> <input class="form-control margin-bottom" type="text" id="searchClientName" ng-model="vm.filter.data.clientName"> </div> <div class="form-group"> <label class="control-label" for="searchClientUserLogin"><span translate="clients.clients.userEmail">Gebruiker e-mail</span>:</label> <input class="form-control margin-bottom" type="text" id="searchClientUserLogin" ng-model="vm.filter.data.email"> </div> <div class="form-group"> <label class="">&nbsp;</label> <div> <button type="submit" data-role="search" class="btn margin-bottom" value="search" ng-click="vm.client.current()"> <span translate="clients.clients.search">Zoek</span> <i class="fa fa-search"></i> </button> </div> </div> <div class="form-group"> <label class="">&nbsp;</label> <div> <button id="delete" class="btn margin-bottom" ng-click="vm.filter.clear()"> <span translate="clients.clients.clean">Maak schoon</span> <i class="fa fa-eraser"></i> </button> </div> </div> </fieldset> </form> <div class="actionButtons row" ng-if="$root.Principal.hasSystemAccess() || $root.Principal.hasTemplateAccess()"> <div class="col-xs-12"> <button type="submit" class="btn btn-add btn-add-use" ng-click="vm.client.new()"><span translate="clients.clients.add">Voeg toe</span> <i class="fa fa-plus-square"></i> </button> </div> </div> </div> <div id="under-fixed"> <div class="row text-center" ng-show="vm.data._embedded != null && vm.clientsList.length == 0"> <h2><strong><span translate="clients.clients.noResults">Geen resultaten gevonden voor huidige zoekopdracht</span></strong></h2> </div> <div ng-show="vm.clientsList.length > 0"> <table id="fixtable" class="tablesorter latest" fix-table> <thead> <tr> <th><span translate="clients.clients.ordinal">Volgorde</span></th> <th><span translate="clients.clients.name">Naam</span></th> <th><span translate="clients.clients.clientNumber">Debiteuren nummer</span></th> <th><span translate="clients.clients.payerNumber">Debiteuren nummer</span></th> <th><span translate="clients.clients.userEmails">Gebruikers e-mails</span></th> <th><span translate="clients.clients.eInvoiceAcceptance">Factuur?</span></th> </tr> </thead> <tbody ng-repeat="entry in vm.clientsList" ng-dblclick="vm.nav.client(entry.client)"> <tr> <td>{{$index+1+vm.data.page.size*vm.data.page.number}}</td> <td>{{entry.client.clientName}}</td> <td>{{entry.client.clientNumber}}</td> <td>{{entry.client.payerNumber}}</td> <td> <span ng-if="entry.user == null" translate="clients.clients.none"> Brak </span> <span ng-if="entry.user != null"> {{entry.user.email}} </span> </td> <td>{{entry.client.eInvoiceAgreement != null ? vm.yesOrNo(entry.client.eInvoiceAgreement) : ""}}</td> </tr> </tbody> <tfoot> <tr> <td colspan="6"></td> </tr> </tfoot> </table> </div> <div class="row actionButtons" ng-if="vm.clientsList.length > 0"> <div class="col-sm-6 text-left"> <button class="btn" ng-disabled="!vm.data._links.first || (vm.data.page.number == 0)" ng-click="vm.client.first()"> <i class="fa fa-step-backward"></i><span translate="clients.clients.first">Eerste</span></button> <button class="btn" ng-disabled="!vm.data._links.prev" ng-click="vm.client.previous()"> <i class="fa fa-chevron-left"></i><span translate="clients.clients.previous">Vorige</span></button> </div> <div class="col-sm-6 text-right"> <button class="btn" ng-disabled="!vm.data._links.next" ng-click="vm.client.next()"> <span translate="clients.clients.next">Volgende</span> <i class="fa fa-chevron-right"></i> </button> <button class="btn" ng-disabled="!vm.data._links.last || (vm.data.page.number >= vm.data.page.totalPages-1)" ng-click="vm.client.last()"> <span translate="clients.clients.last">Laatste</span> <i class="fa fa-step-forward"></i> </button> </div> </div> <div ng-show=" $root.Principal.hasSystemAccess() || $root.Principal.hasTemplateAccess() " class="voffset3"> <h1 class="title"><span translate="clients.clients.groupClientManagement">Groep client management</span></h1> <div ng-show="vm.management.status===\'failed\'" class="alert ng-isolate-scope alert-danger alert-dismissible" role="alert " type="danger " close="alert.close($ctrl.alerts) "> <button ng-show="true " type="button " class="close" ng-click="vm.addingEmailTemplateErrorText=null " aria-hidden="false "> <span aria-hidden="true ">\xD7</span> <span class="sr-only">Close</span> </button> <div style="text-align: center"><span class="ng-binding ng-scope" translate="clients.clients.actionFailed">Actie is mislukt. Probeer het opnieuw of neem contact op met de systeembeheerder </span></div> </div> <div ng-show="vm.management.status===\'succeeded\'" class="alert ng-isolate-scope alert-success alert-dismissible" role="alert " type="success " close="alert.close($ctrl.alerts) "> <button ng-show="true " type="button " class="close" ng-click="vm.addingEmailTemplateSuccessText=null " aria-hidden="false "> <span aria-hidden="true ">\xD7</span> <span class="sr-only">Close</span> </button> <div style="text-align: center"><span class="ng-binding ng-scope" translate="clients.clients.actionSuccess">Actie geslaagd</span></div> </div> <div> <div ngf-drop ngf-select ng-model="vm.management.file " class="drop-box" ngf-drag-over-class=" \'dragover\' " ngf-multiple="false " ngf-allow-dir="false " accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet "><span translate="clients.clients.dropXlsx">Upu\u015B\u0107 skoroszyt Excel (*.XLSX) z danymi</span></div> <div ngf-no-file-drop> <div class="button" ngf-select ng-model="vm.management.file " ngf-multiple="false " ngf-allow-dir="false " accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet "> Wybierz skoroszyt Excel (*.XLSX) z danymi</div> </div> <uib-progressbar ng-class="{active : !vm.management.done, \'progress-striped\' : !vm.management.done} " value="vm.management.progress " type="{{vm.management.status}} " ng-show="vm.management.progress !=0 "><span style="color:white; white-space:nowrap">{{vm.management.message}}</span></uib-progressbar> <div width="100%" style="overflow-x: auto; text-align: center" ng-show="vm.management.errors.length> 0"> <h2><strong><span translate="clients.clients.fixFile">Herstel het bestand handmatig en upload het opnieuw.</span></strong></h2> <table class="tablesorter latest" fix-table> <thead> <tr> <th></th> <th><span translate="clients.clients.cell">Cel</span></th> <th><span translate="clients.clients.error">Fout</span></th> </tr> </thead> <tbody> <tr ng-repeat="error in vm.management.errors"> <td>{{$index+1}}</td> <td>{{error.field}}</td> <td> {{error.message.endsWith(\'wrong_file_format\') ? vm.wrongFile() : ""}} <!--  --> {{error.message.endsWith(\'required\') ? vm.required() : ""}} <!--  --> {{error.message.endsWith(\'not_found\') ? vm.notFound() : ""}} <!--  --> {{error.message.endsWith(\'not_found_client\') ? vm.notFoundClient() : ""}} <!--  --> {{error.message.endsWith(\'wrong\') ? vm.wrong() : ""}} <!--  --> {{error.message.endsWith(\'multiple_add\') ? vm.multipleAdd() : ""}} <!--  --> {{error.message.endsWith(\'client_exists\') ? vm.clientExists() : ""}} <!--  --> {{error.message.endsWith(\'multiple\') ? vm.multiple() : ""}} </td> </tr> </tbody> <tfoot> <tr> <td colspan="16"></td> </tr> </tfoot> </table> </div> <div width="100%" style="overflow-x: auto" ng-show="vm.actions.length > 0"> <table class="tablesorter latest" fix-table> <thead> <tr> <th></th> <th><span translate="clients.clients.action">Actie</span></th> <th><span translate="clients.clients.clientNumber">Debiteuren nummer</span></th> <th><span translate="clients.clients.payerNumber">Debiteuren nummer</span></th> <th><span translate="clients.clients.clientName">Debiteuren nummer</span></th> <th><span translate="clients.clients.contactPerson">Contact persoon </span></th> <th><span translate="clients.clients.contactNumber">Contact nummer </span></th> <th><span translate="clients.clients.addLogin">Toevoegen / bijwerken login</span></th> <th><span translate="clients.clients.deleteLogin">Verwijderen login</span></th> <th><span translate="clients.clients.portalLanguage">Taal</span></th> <th><span translate="clients.clients.templateType">Type sjabloon</span></th> <th><span translate="clients.clients.emailTemplate">E-mail sjabloon</span></th> <th><span translate="clients.clients.subjectTemplate">onderwerp sjabloon</span></th> <th><span translate="clients.clients.eInvoice">Factuur</span></th> <th><span translate="clients.clients.documentSendingMethod">Document verzendmethode</span></th> <!-- <th><span translate="clients.clients.correctionSendingMethod">Metoda wysy\u0142ki korekt</span></th> --> <th><span translate="clients.clients.remarks">Opmerkingen</span></th> </tr> </thead> <tbody> <tr ng-repeat="action in vm.actions"> <td>{{$index+1}}</td> <td>{{action.actionType}}</td> <td>{{action.clientNumber}}</td> <td>{{action.payerNumber}}</td> <td>{{action.clientName}}</td> <td>{{action.contactPerson}}</td> <td>{{action.phoneNumber}}</td> <td>{{action.loginAddUpdate}}</td> <td>{{action.loginDelete}}</td> <td>{{action.accountLanguage}}</td> <td>{{action.templateType}}</td> <td>{{action.emailTemplate}}</td> <td>{{action.subjectTemplate}}</td> <td>{{action.eBilling != null ? vm.yesOrNo(action.eBilling) : ""}}</td> <td>{{action.documentDeliveryMethod}}</td> <!-- <td>{{action.correctingDocumentDeliveryMethod}}</td> --> <td>{{action.notes}}</td> </tr> </tbody> <tfoot> <tr> <td colspan="16"></td> </tr> </tfoot> </table> </div> <div class="btn-enclose text-left" ng-show="vm.actions.length > 0"> <button class="btn" ng-disabled="!(vm.actions.length > 0)" ng-click="vm.management.manage()"> <span translate="clients.clients.accept">Accepteer</span> <i class="fa fa-check"></i> </button> <button class="btn" ng-disabled="!(vm.actions.length > 0)" ng-click="vm.management.cancel()"> <span translate="clients.clients.cancel">Annuleer</span> <i class="fa fa-times"></i> </button> </div> </div> </div> </div> ');
$templateCache.put('app/views/clients/newClient/newClient.html','<div class="modal-header"> <h3 class="modal-title"><span translate="clients.newClient.title">Nieuwe klant toevoegen</span></h3> </div> <div ng-show="vm.data.duplicateEmailError!=null"> <br> <div class="alert ng-isolate-scope alert-danger alert-dismissible" role="alert" type="danger" close="alert.close($ctrl.alerts)"> <button ng-show="true" type="button" class="close" ng-click="vm.data.duplicateEmailError=null" aria-hidden="false"> <span aria-hidden="true">\xD7</span> <span class="sr-only">Close</span> </button> <div style="text-align: center"> <span class="ng-binding ng-scope" translate="clients.client.duplicateEmail">{{vm.data.duplicateEmailError}}</span> </div> </div> </div> <form class="" id="newClient" name="newClient" class="form" accept-charset="UTF-8" novalidate> <div class="modal-body"> <div class="container-fluid"> <div class="row"> <table class="property-table"> <tr> <td> <label for="newClientNumber"><span translate="clients.newClient.clientNumber">Debiteuren nummer:</span></label> </td> <td> <input class="form-control form-control-width-auto input-sm input-smallest" type="text" id="newClientNumber" required="required" ng-model="vm.data.clientNumber" maxlength="8" ng-change="vm.modal.clientCheck()" ng-pattern="/[0-9]{8}/" ng-model-options="{allowInvalid:true}"> <span ng-show="vm.data.clients.length != 0" style="color: #d40511" translate="clients.newClient.clientExists">Debiteur bestaat als</span> </td> </tr> <tr> <td> <label for="newClientPayerNumber"><span translate="clients.newClient.payerNumber">Payer number:</span></label> </td> <td> <input class="form-control form-control-width-auto input-sm input-smallest" type="text" id="newClientPayerNumber" ng-model="vm.data.payerNumber" maxlength="8" ng-pattern="/[0-9]{8}/" ng-model-options="{allowInvalid:true}"> </td> </tr> <tr> <td> <label for="newClientName"><span translate="clients.newClient.clientName">Debiteuren naam:</span></label> </td> <td> <input class="form-control form-control-width-auto input-sm input-smallest" type="text" id="newClientName" required="required" maxlength="50" ng-model="vm.data.clientName"> </td> </tr> <tr> <td> <label for="newClientUsers"><span translate="clients.newClient.userEmails">Gebruiker e-mails:</span></label> </td> <td> <div class="input-group form-control-width-auto"> <input class="form-control form-control-width-auto input-sm input-smallest" id="newClientUsers" type="text" autocomplete="off" minlength="3" ng-model="vm.data.user" ng-model-options="{debounce: 300}" uib-typeahead="user for user in vm.user.getByEmail($viewValue)" typeahead-editable="true" ng-pattern="/^[^\\s@]+@[^\\s@]+\\.[^\\s@]{2,}$/" ng-model-options="{allowInvalid:true}"> <span class="input-group-btn"> <button class="btn btn-smallest" ng-click="vm.user.add()"> <i class="fa fa-plus-square"></i> </button> <button class="btn btn-smallest" ng-click="vm.user.delete() " ng-disabled="vm.data.users.length==0 "> <i class="fa fa-minus-square"></i> </button> </span> </div> <div> <select class="col-xs-12 input-sm" style="height: 54px" multiple="multiple" ng-model="vm.selection " ng-options="user.email for user in vm.data.users | orderBy:email " ng-show="vm.data.users.length> 0"></select> </div> </td> </tr> <tr> <td> <label for="newClientEInvoice"><span translate="clients.newClient.eInvoiceAcceptance">Factuur acceptatie:</span></label> </td> <td> <select class="form-control form-control-width-auto input-sm input-smallest" id="newClientEInvoice" required="required" ng-model="vm.data.eInvoiceAgreement"> <option value="true" selected="selected">{{vm.newClientEInvoiceYes}}</option> <option value="false">{{vm.newClientEInvoiceNo}}</option> </select> </td> </tr> <tr> <td> <label for="newClientLanguage"><span translate="clients.newClient.portalLanguage">Portaal taal:</span></label> </td> <td> <select class="form-control form-control-width-auto input-sm input-smallest" id="newClientLanguage" required="required" ng-model="vm.data.portalLang"> <option value="EN" selected="selected">English</option> <option value="NL">Nederlands</option> <option value="FR">Fran\xE7ais</option> <option value="DE">Deutsch</option> </select> </td> </tr> <tr> <td> <label for="newClientDocSending"><span translate="clients.newClient.documentSendingMethod">Verzendmethode document: </span></label> </td> <td> <select class="form-control form-control-width-auto input-sm input-smallest" id="newClientDocSending" required="required" ng-model="vm.data.docSending"> <option value="LINK" selected="selected">Link</option> <option value="CSV">CSV</option> <option value="PDF">PDF</option> <option value="LINK_XLSX">{{vm.linkXlsx}}</option> <option value="PDF_XLSX">{{vm.pdfXlsx}}</option> <option value="PDF_CSV">{{vm.pdfCsv}}</option> </select> </td> </tr> <!-- <tr>\n                        <td>\n                            <label for="newClientCorrectingDocSending"><span translate="clients.newClient.correctionSendingMethod">Metoda wysy\u0142ki dokument\xF3w koryguj\u0105cych:</span></label>\n                        </td>\n                        <td>\n                            <select class="form-control form-control-width-auto input-sm input-smallest" id="newClientCorrectingDocSending" required="required" ng-model="vm.data.correctingDocSending">\n                                <option value="LINK" selected="selected">Link</option>\n                                <!- - waiting for DHL templates\n                                <option value="PDF">PDF</option>\n                                <option value="LINK_XLSX">{{vm.linkXlsx}}</option>\n                                <option value="PDF_XLSX">{{vm.pdfXlsx}}</option> - ->\n                            </select>\n                        </td>\n                    </tr> --> <tr> <td> <label for="newClientNIP"><span translate="clients.newClient.clientNip">BTW codenummer debiteur:</span></label> </td> <td> <input class="form-control form-control-width-auto input-sm input-smallest" type="text" id="newClientNIP" minlength="{{vm.patternMinLength}}" maxlength="{{vm.patternMaxLength}}" ng-model="vm.data.nip" ng-pattern="vm.pattern" ng-model-options="{allowInvalid:true}"> </td> </tr> <tr> <td> <label for="newClientContactPerson "><span translate="clients.newClient.contactPerson">Contact persoon:</span></label> </td> <td> <input class="form-control form-control-width-auto input-sm input-smallest" type="text" id="newClientContactPerson" ng-model="vm.data.contactPerson"> </td> </tr> <tr> <td> <label for="newClientPhoneNumber"><span translate="clients.newClient.contactNumber">Contact nummer:</span></label> </td> <td> <input class="form-control form-control-width-auto input-sm input-smallest" type="text" id="newClientPhoneNumber" ng-model="vm.data.phoneNumber"> </td> </tr> <tr> <td> <label for="newClientNotes"><span translate="clients.newClient.remarks">Opmerkingen</span></label> </td> <td> <textarea class="form-control form-control-width-auto" id="newClientNotes" rows="2" cols="70" ng-model="vm.data.notes" maxlength="100"></textarea> </td> </tr> </table> </div> </div> </div> <div class="modal-footer"> <button class="btn btn-primary btn-sm" type="submit" ng-click="vm.modal.add()" ng-disabled="newClient.$invalid || newClient.$pending || vm.data.users.length == 0 || vm.data.clients.length != 0"> <span translate="clients.newClient.add">Toevoegen</span> <i class="fa fa-plus-square"></i> </button> <button class="btn btn-warning btn-sm" type="button" ng-click="vm.modal.cancel()"> <span translate="clients.newClient.cancel">Annuleer</span> <i class="fa fa-times"></i> </button> </div> </form> ');
$templateCache.put('app/views/login/mfa/mfa.html','<div id="shell" ui-view="shell" ng-cloak></div> <div class="container container-logout mfa-panel-padding" ng-controller="MfaController as vm"> <portal-alert></portal-alert> <table class="mfa" style="padding-top: 150px"> <tbody> <tr> <td> <section> <h1> <strong translate="mfa.title">Two-Factor Authentication</strong> </h1> <form class="form mfa-form" novalidate id="mfaForm" name="mfaForm"> <div class="form-group"> <label class="control-label" for="mfa"><span translate="mfa.mfa">Token</span></label> <br> <input ng-model="vm.token" class="mfa-input form-control" type="text" id="mfa" name="token" required> </div> <p class="mfa-margin text-align-left"> <span translate="mfa.info">Check your e-mail for your authentication token.</span> </p> <div class="text-align-left"> <button class="btn" type="submit" ng-click="mfaForm.$valid ? vm.mfa($event) : null"> <span translate="mfa.mfa-btn">Verify</span> <i class="fa fa-sign-in"></i> </button> <button class="btn btn-right" type="button" ng-click="vm.resendCode()" ng-disabled="vm.isResendDisabled"> <span translate="mfa.mfa-resend">Resend</span> <i class="fa fa-repeat"></i> </button> </div> </form> </section> </td> </tr> </tbody> </table> </div> ');
$templateCache.put('app/views/login/passwordExpired/passwordExpired.html','<div class="modal-header"> <h3 class="modal-title">Wyga\u015Bni\u0119cie has\u0142a</h3> </div> <form id="newClient" name="newClient" class="" accept-charset="UTF-8"> <div class="modal-body"> <div class="container-fluid"> Twoje has\u0142o wyga\u015Bnie za {{vm.data.days}} dni. </div> </div> <div class="modal-footer"> <!--         <button class="btn btn-primary" type="submit" ng-click="vm.modal.add()" ng-disabled="newClient.$invalid || newClient.$pending"> Dodaj\n            <i class="fa fa-plus-square"></i>\n        </button> --> <button class="btn btn-warning" type="button" ng-click="vm.modal.ok()"> OK <!-- <i class="fa fa-times"></i> --> </button> </div> </form> ');
$templateCache.put('app/views/pdfView/disputeForm/disputeForm.html','<section class="container container-fluid"> <form id="disputeForm" class="block form dispute-form" ng-submit="vm.submit()" accept-charset="UTF-8" enctype="multipart/form-data"> <h1 class="part-title dispute-title embedded-page-padding" translate="pdfView.submitDispute.detailsTitle">Your details</h1> <fieldset> <div class="form-group"> <label for="userName" class="control-label"> <span translate="pdfView.submitDispute.name">Your name</span> <strong class="red">*</strong> </label> <input id="userName" class="form-control" ng-model="vm.data.name" required="required"> </div> <div class="horizontal"> <div> <label for="email" class="control-label"> <span translate="pdfView.submitDispute.email">Your email address</span> <strong class="red">*</strong> </label> <demail required="required"></demail> </div> <div ng-show="vm.emailChanged"> <label for="retypeEmail" class="control-label"> <span translate="pdfView.submitDispute.retypeEmail">Retype your email address</span> <strong class="red">*</strong> </label> <input id="retypeEmail" class="form-control" ng-model="vm.data.retypeEmail" ng-required="vm.emailChanged"> </div> </div> <div class="form-group"> <label for="clientNumber" class="control-label"> <span translate="pdfView.submitDispute.accountNumber">Your Customer / Account Number</span> <strong class="red"> *</strong> </label> <input id="clientNumber" class="form-control" ng-model="vm.data.accountNumber" disabled="disabled"> </div> <div class="form-group"> <label for="invoiceNumber" class="control-label" translate="pdfView.submitDispute.invoiceNumber">Invoice Number</label> <input id="invoiceNumber" class="form-control" ng-model="vm.data.invoiceNumber" disabled="disabled"> </div> </fieldset> <h1 class="part-title dispute-title embedded-page-padding" translate="pdfView.submitDispute.commentTitle">Comment details</h1> <div class="horizontal" ng-repeat="commentEntry in vm.data.commentEntries" style="margin-bottom:10px"> <div style="line-height: 50px; font-family: \'delivery\'"> <span>{{$index + 1}}.</span> </div> <div> <label for="shipmentNumber" class="control-label"> <span translate="pdfView.submitDispute.shipmentNumber">Shipment Number</span> <strong class="red">*</strong> </label> <input id="shipmentNumber" class="form-control" ng-model="commentEntry.shipmentNumber" required="required"> </div> <div> <label for="comment" class="control-label"> <span translate="pdfView.submitDispute.comment">Comments</span> <strong class="red"> *</strong> </label> <textarea id="comment" class="form-control form-control-width-auto" rows="4" cols="50" type="text" ng-model="commentEntry.comment" required="required">\n                </textarea> <a class="form-help-link normal-form" style="line-height: 40px" tooltip-placement="right" uib-tooltip="{{vm.translate(\'pdfView.submitDispute.commentTipContent\')}}" tabindex="-1" tooltip><span translate="pdfView.submitDispute.commentTip">Comments tip?</span> </a> </div> <div> <h1 class="part-title dispute-title" translate="pdfView.submitDispute.attachmentTitle">Attach</h1> <label id="custom-file-input" for="inputFile{{$index}}" translate="pdfView.submitDispute.chooseFile">Choose File</label> <p style="display:inline-block" translate="pdfView.submitDispute.noFile">No file chosen</p> <input style="visibility: hidden" type="file" id="inputFile{{$index}}" ng-click="vm.addFileText($event)" file-upload ng-model="vm.data.commentEntries[$index].attachment"> </div> </div> <div class="btn-enclose text-left" style="margin-bottom:20px"> <button class="btn" type="button" ng-click="vm.addCommentField()"> <span translate="pdfView.submitDispute.add">Add </span><i class="fa fa-plus-square"></i> </button> </div> <div class="btn-enclose text-right"> <button id="button" class="btn" type="submit"> <span translate="pdfView.submitDispute.submit">Submit </span><i class="fa fa-envelope"></i> </button> </div> </form> <section class="container container-fluid"> <div ng-show="vm.disputeFormErrorText!=null" class="alert ng-isolate-scope alert-danger alert-dismissible" role="alert" type="danger" close="alert.close($ctrl.alerts)"> <button ng-show="true" type="button" class="close" ng-click="vm.disputeFormErrorText=null" aria-hidden="false"> <span aria-hidden="true">\xD7</span> <span class="sr-only" translate="entity.action.close"> Close</span> </button> <div style="text-align: center"><span class="ng-binding ng-scope">{{vm.disputeFormErrorText}}</span></div> </div> <div ng-show="vm.disputeFormSuccessText!=null" class="alert ng-isolate-scope alert-success alert-dismissible" role="alert" type="success" close="alert.close($ctrl.alerts)"> <button ng-show="true" type="button" class="close" ng-click="vm.disputeFormSuccessText=null" aria-hidden="false"> <span aria-hidden="true">\xD7</span><span class="sr-only"> Close</span> </button> <div style="text-align: center"><span class="ng-binding ng-scope">{{vm.disputeFormSuccessText}}</span></div> </div> </section> </section> ');
$templateCache.put('app/views/pending-cases/rejection-modal/rejection.modal.html','<div class="modal-header"> <h1 class="modal-title title" id="modal-title"> <span translate="pendingCases.rejectionModal.title"> Registratie weigering </span> </h1> </div> <div class="modal-body" id="modal-body"> <p> <span translate="pendingCases.rejectionModal.reason"> Reden voor weigering: </span> </p> <br> <textarea style="width:100%; min-height: 54px; resize: none" type="text" ng-model="vm.reason"></textarea> </div> <div class="modal-footer"> <button class="btn" type="button" ng-click="vm.modal.go(vm.reason)" ng-disabled="vm.reason == null || vm.reason.length == 0"> <span translate="pendingCases.rejectionModal.continue">Daargaan</span> </button> <button class="btn" type="button" ng-click="vm.modal.cancel()"> <span translate="pendingCases.rejectionModal.cancel">Annuleren</span> </button> </div> ');
$templateCache.put('app/views/system-settings/template-upload-modal/system-settings.modal.html','<div class="modal-header"> <h1 class="modal-title title" id="modal-title" translate="systemSettings.addEmailTemplate.attention">Uwaga!</h1> </div> <div class="modal-body" id="modal-body" translate="systemSettings.addEmailTemplate.msg"> Szablon o podanym oznaczeniu i typie akcji znajduje si\u0119 ju\u017C w portalu. Aby nadpisa\u0107 plik znajduj\u0105cy si\u0119 w portalu wybierz "Kontynuuj". Aby zachowa\u0107 oba szablony wybierz "Anuluj", zmie\u0144 oznaczenie Twojego szablonu w formularzu i ponownie wci\u015Bnij przycisk "Dodaj". </div> <div class="modal-footer"> <button class="btn btn-primary" type="button" ng-click="vm.modal.go()" translate="systemSettings.addEmailTemplate.continue">Kontynuuj</button> <button class="btn btn-warning" type="button" ng-click="vm.modal.cancel()" translate="systemSettings.addEmailTemplate.cancel">Anuluj</button> </div> ');
$templateCache.put('app/views/users/newUser/newUser.html','<div class="modal-header"> <h3 class="modal-title"> <span translate="users.newUser.title">Toevoegen nieuwe gebruiker</span> </h3> </div> <div class="user"> <form id="newUserForm" name="newUserForm" class="user form-inline inline-search form-padding" accept-charset="UTF-8"> <div class="modal-body"> <portal-alert></portal-alert> <div class="container-fluid"> <form class="form-inline"> <fieldset> <div class="form-group"> <label for="newUserLogin" class="control-label"><span translate="users.newUser.email">E-mail:</span></label> <email id="newUserLogin" ng-change="vm.modal.lookup()"> </div> <div class="form-group"> <label class="control-label" for="newUserPassword"> <span translate="users.newUser.password">Wachtwoord</span> </label> <input ng-disabled="vm.exists" class="form-control" type="password" id="newUserPassword" autocomplete="off" ng-required="!vm.exists" ng-model="vm.data.password"> </div> </fieldset> </form> </div> </div> <div class="modal-footer"> <button class="btn btn-primary" type="submit" ng-click="vm.modal.add()" ng-disabled="newUserForm.$invalid || newUserForm.$pending || vm.existst === null"> <span translate="users.newUser.add">Voeg toe</span> <i class="fa fa-plus-square"></i> </button> <button class="btn btn-warning" type="button" ng-click="vm.modal.cancel()"> <span translate="users.newUser.cancel">Annuleer</span> <i class="fa fa-times"></i> </button> </div> </form> </div> ');
$templateCache.put('app/views/users/report/userReport.html','<div class="modal-header"> <h3 class="modal-title"><span translate="users.report.title">Aanmaken rapport</span></h3> </div> <form id="userReport" class="voffset4" accept-charset="UTF-8"> <div class="modal-body"> <uib-tabset active="vm.active"> <uib-tab index="0" heading="{{ vm.translate(\'users.report.listHeader\') }}"> <div class="container-fluid"> <div class="form-inline row"> <fieldset class="col-xs-12" style="margin-top:15px"> <div class="form-group"> <label class="control-label" for="reportUserLogin"><span translate="users.report.email">E-mail:</span></label> <input class="form-control margin-bottom" type="text" id="reportUserLogin" ng-model="vm.filter.email"> </div> <div class="form-group"> <label class="control-label" for="reportUserSAPId"><span translate="users.report.clientSapNumber">Debiteuren nummer</span></label> <input class="form-control margin-bottom" type="text" id="reportUserSAPId" ng-model="vm.filter.clientNumber"> </div> <div class="form-group"> <label class="control-label" for="reportUserClientName"><span translate="users.report.clientName">Naam debiteur:</span></label> <input class="form-control margin-bottom" type="text" id="reportUserClientName" ng-model="vm.filter.clientName"> </div> </fieldset> </div> </div> </uib-tab> <uib-tab index="1" heading="{{ vm.translate(\'users.report.activitiesHeader\') }}"> <div class="container-fluid"> <div class="row form form-small"> <fieldset class="col-xs-12" style="margin-top:15px"> <div class="form-group clear-margin-bottom"> <label class="control-label"><span translate="users.report.changeDate">Activiteitsdatum</span>:</label> <md-datepicker class="datepicker" id="reportUserActivityDateFrom" name="date_end" ng-model="vm.filter.activityDateFrom" md-placeholder="{{ vm.translate(\'from\') }}"></md-datepicker> <md-datepicker class="datepicker" id="reportUserActivityDateTo" ng-model="vm.filter.activityDateTo" md-placeholder="{{ vm.translate(\'to\') }}"></md-datepicker> </div> <br> <div class="form-group"> <label class="control-label"><span translate="users.report.userType">Soort gebruiker: </span></label> <select class="form-control margin-bottom input-sm" id="reportUserActivityUserType" ng-model="vm.filter.activityUserTypes"> <option value="" selected="selected"></option> <option value="SYSTEM" translate="users.report.system"></option> <option value="DHL_USER" translate="users.report.dhl_user"></option> <option value="CLIENT_USER" translate="users.report.client_user"></option> </select> </div> <div class="form-group"> <label class="control-label" for="reportUserClientName"><span translate="users.report.changeOperator">Wijzig operator: </span></label> <input class="form-control margin-bottom input-sm" type="text" id="reportUserActivityOperator" ng-model="vm.filter.activityOperators"> </div> <div class="form-group"> <label class="control-label"><span translate="users.report.userLogin">Gebruikers login: </span></label> <input class="form-control margin-bottom input-sm" type="text" id="reportUserActivityAction" ng-model="vm.filter.activityUserEmails"> </div> <br> <div class="form-group"> <label class="control-label"><span translate="users.report.activityType">Soort activiteit: </span></label> <select class="form-control margin-bottom input-sm" id="actionTypeMultiselect" ng-model="vm.filter.activityActionTypes" multiple="multiple"> <option value="LOGIN_ADDED">{{ vm.translate(\'users.report.addLogin\') }}</option> <option value="DHL_USER_ADDED">{{ vm.translate(\'users.report.addNewUser\') }}</option> <option value="HTML_DOCUMENT_SEEN">{{ vm.translate(\'users.report.htmlDocumentSeen\') }}</option> <option value="PDF_DOCUMENT_SEEN">{{ vm.translate(\'users.report.pdfDocumentSeen\') }}</option> <option value="XLSX_DOCUMENT_SEEN">{{ vm.translate(\'users.report.xlsxDocumetSeen\') }}</option> <option value="DOCUMENT_DELETED">{{ vm.translate(\'users.report.documentDeleted\') }}</option> <option value="DOCUMENT_CREATED">{{ vm.translate(\'users.report.documentCreated\') }}</option> <option value="DOCUMENT_SENT">{{ vm.translate(\'users.report.documentSent\') }}</option> <option value="DOCUMENT_SENT_AGAIN">{{ vm.translate(\'users.report.documentSentAgain\') }}</option> <option value="DOCUMENT_APPROVED">{{ vm.translate(\'users.report.documentApproved\') }}</option> <option value="CLIENT_ACCOUNT_REJECTED">{{ vm.translate(\'users.report.clientAcountRejected\') }}</option> <option value="CLIENT_ACCOUNT_CONFIRMED">{{ vm.translate(\'users.report.clientAccountConfirmed\') }}</option> <option value="LP_SCAN_DOWNLOADED">{{ vm.translate(\'users.report.lpScanDownloaded\') }}</option> <option value="LOGIN_DELETED">{{ vm.translate(\'users.report.loginDeleted\') }}</option> <option value="DHL_USER_DELETED">{{ vm.translate(\'users.report.userDeleted\') }}</option> <option value="SAP_PROFILE_CREATED">{{ vm.translate(\'users.report.sapProfileCreated\') }}</option> <option value="REGISTRATION_APPROVAL_SENT">{{ vm.translate(\'users.report.registrationApprovalSent\') }}</option> <option value="REGISTRATION_REJECTION_SENT">{{ vm.translate(\'users.report.registrationRejectionSent\') }}</option> <option value="E_BILLING_CHANGE">{{ vm.translate(\'users.report.eBillingChange\') }}</option> <option value="PASSWORD_CHANGE">{{ vm.translate(\'users.report.passwordChange\') }}</option> <option value="LANGUAGE_CHANGE">{{ vm.translate(\'users.report.languageChange\') }}</option> <option value="CORRECTIVE_DOCUMENT_DELIVERY_METHOD_CHANGE">{{ vm.translate(\'users.report.correctiveDocumentDeliveryMethodChange\') }}</option> <option value="DOCUMENT_DELIVERY_METHOD_CHANGE">{{ vm.translate(\'users.report.documentDeliveryMethodChange\') }}</option> <option value="MAIL_TEMPLATE_CHANGE">{{ vm.translate(\'users.report.mailTemplateChange\') }}</option> <option value="MAIL_SUBJECT_CHANGE">{{ vm.translate(\'users.report.mailSubjectChange\') }}</option> <option value="DHL_USER_AUTHORITIES_CHANGE">{{ vm.translate(\'users.report.dhlUserAuthoritiesChange\') }}</option> <option value="NOTES_CHANGE">{{ vm.translate(\'users.report.notesChange\') }}</option> <option value="CONTACT_PERSON_CHANGE">{{ vm.translate(\'users.report.contactPersonChange\') }}</option> <option value="PAYER_NUMBER_CHANGE">{{ vm.translate(\'users.report.payerNumberChange\') }}</option> <option value="NIP_CHANGE">{{ vm.translate(\'users.report.NIPChange\') }}</option> <option value="CLIENT_NAME_CHANGE">{{ vm.translate(\'users.report.clientNameChange\') }}</option> <option value="PHONE_NUMBER_CHANGE">{{ vm.translate(\'users.report.phoneNumberChange\') }}</option> <option value="PASSWORD_CHANGE_INTERVAL_CHANGE">{{ vm.translate(\'users.report.passwordChangeIntervalChange\') }}</option> <option value="PASSWORD_SHOW_CHANGE_INTERVAL_CHANGE">{{ vm.translate(\'users.report.passwordShowChangeIntervalChange\') }}</option> <option value="EMAIL_SUBJECT_TEMPLATE_ADDED">{{ vm.translate(\'users.report.emailSubjectTemplateAdded\') }}</option> <option value="EMAIL_TEMPLATE_ADDED">{{ vm.translate(\'users.report.emailTemplateAdded\') }}</option> </select> </div> <div class="form-group"> <label class="control-label"><span translate="users.report.clientName">Naam debiteur:</span></label> <input class="form-control margin-bottom input-sm" type="text" id="reportUserActivityClientNames" ng-model="vm.filter.activityClientNames"> </div> <div class="form-group"> <label class="control-label"><span translate="users.report.clientSapNumber">Debiteuren nummer</span></label> <input class="form-control margin-bottom input-sm" type="text" id="reportUserActivityClientNumbers" ng-model="vm.filter.activityClientNumbers" smart-float> </div> <br> <div class="form-group"> <label class="control-label"><span translate="users.report.documentNumber">Document number: </span></label> <input class="form-control margin-bottom input-sm" type="text" id="reportUserActivityDocumentNumbers" ng-model="vm.filter.activityDocumentNumbers" smart-float> </div> <div class="form-group"> <label class="control-label"><span translate="users.report.documentType">Soort document :</span></label> <select class="form-control margin-bottom input-sm" name="doc_type" id="doc_type" ng-model="vm.filter.activityDocumentTypes"> <option default value="">-- {{ vm.translate(\'documents.document.choose\') }} --</option> <option value="invoice">{{ vm.translate(\'documents.document.invoice\') }}</option> <!-- <option value="correction">{{ vm.translate(\'documents.document.correctingInvoice\') }}</option> --> </select> </div> <div class="form-group"> <label class="control-label"><span translate="users.report.oldUsers">Sla archiefgebruikers niet over: </span></label> <input type="checkbox" class="form-check-input" id="useArchiveUsers" ng-model="vm.filter.useArchiveUsers"> </div> <!--1.       Wg daty zmiany \u2013 zakresu dat (zawsze nale\u017Cy poda\u0107 przedzia\u0142 dat)\n                                2.       Wg rodzaju u\u017Cytkownika.\n                                3.       Wg operatora zmiany \u2013 z mo\u017Cliwo\u015Bci\u0105 wyboru jednego lub wielu operator\xF3w zmiany.\n                                4.       Wg loginu u\u017Cytkownika - z mo\u017Cliwo\u015Bci\u0105 wyboru jednego lub wielu u\u017Cytkownik\xF3w.\n                                5.       Wg rodzaju akcji / aktywno\u015Bci - z mo\u017Cliwo\u015Bci\u0105 wyboru jednej lub wielu aktywno\u015Bci.\n                                6.       Wg nazwy klienta.\n                                7.       Wg nr klienta (SAP) \u2013 z mo\u017Cliwo\u015Bci\u0105 wyboru jednego lub wielu nr klient\xF3w\n                                8.       Wg nr dokumentu \u2013 z mo\u017Cliwo\u015Bci\u0105 wyboru jednego lub wielu nr dokument\xF3w lub wg zakresu dokument\xF3w.\n                                9.       Wg rodzaju dokumentu. --> </fieldset> </div> </div> </uib-tab> </uib-tabset> </div> <div class="modal-footer"> <a target="_blank" ng-click="vm.modal.generate()" ng-href="{{vm.modal.getGenerateURL()}}" class="btn"> <span translate="users.report.generateRaport">Aanmaken rapport</span> <i class="fa fa-table"></i> </a> <button class="btn" type="button" ng-click="vm.modal.cancel()"> <span translate="users.report.cancel">Annuleer</span> <i class="fa fa-times"></i> </button> </div> </form> ');
$templateCache.put('app/views/users/user/user.html','<div class="row-fluid embedded-page-padding" ng-if="($root.Principal.hasUserRead() || $root.Principal.hasSystemAccess() || $root.Principal.hasTemplateAccess())"> <div class="btn-enclose"> <button id="back" class="btn" ng-click="vm.nav.users()"> <i class="fa fa-chevron-left"></i> <span translate="users.user.back">Terug</span> </button> </div> </div> <br> <div ng-show="vm.rolesChangeError!=null" class="alert ng-isolate-scope alert-danger alert-dismissible" role="alert" type="danger" close="alert.close($ctrl.alerts)"> <button ng-show="true" type="button" class="close" ng-click="vm.rolesChangeError=null" aria-hidden="false"> <span aria-hidden="true">\xD7</span> <span class="sr-only">Close</span> </button> <div style="text-align: center"><span class="ng-binding ng-scope" translate="users.user.rolesUpdateError">Er is een fout opgetreden bij het bijwerken van rollen. Probeer het later opnieuw.</span> </div> </div> <div ng-show="vm.rolesChangeSuccess!=null" class="alert ng-isolate-scope alert-success alert-dismissible" role="alert" type="success" close="alert.close($ctrl.alerts)"> <button ng-show="true" type="button" class="close" ng-click="vm.rolesChangeSuccess=null" aria-hidden="false"> <span aria-hidden="true">\xD7</span> <span class="sr-only">Close</span> </button> <div style="text-align: center"><span class="ng-binding ng-scope" translate="users.user.rolesUpdateSuccess">Rollen update succesvol.</span> </div> </div> <portal-alert></portal-alert> <h1 class="row-fluid title text-left"> <span translate="users.user.title">Gebruiker</span> </h1> <div class="row"> <div class="col-md-5 container"> <table id="fixtable" class="tablesorter latest row-fluid"> <thead> <tr> <th></th> <th></th> </tr> </thead> <tbody> <tr> <td><span translate="users.user.emailAdres">E-mail adres</span></td> <td>{{vm.data .user.email}} </td> </tr> <tr> <td><span translate="users.user.activationDate">Activatie datum</span></td> <td>{{vm.data.user.firstActivationDate.activityTime | date:\'yyyy-MM-dd HH:mm:ss\'}}</td> </tr> <tr> <td><span translate="users.user.lastChangeDate">Datum laatste wijziging</span></td> <td>{{vm.data.user.lastActivityDate.activityTime | date:\'yyyy-MM-dd HH:mm:ss\'}}</td> </tr> <tr> <td><span translate="users.user.isLocked">Is het account vergrendeld? </span></td> <td>{{vm.data.user.locked ? vm.translate(\'yes\') : vm.translate(\'no\')}}</td> </tr> <tr> <td><span translate="users.user.isActive">Is het account actief? </span></td> <td>{{vm.data.user.activated ? vm.translate(\'yes\') : vm.translate(\'no\')}}</td> </tr> <tr> <td><span translate="users.user.passwordExpirationDate">Datum waarop wachtwoord is verlopen</span></td> <td>{{vm.data.user.passwordExpireDate | date:\'yyyy-MM-dd HH:mm:ss\'}}</td> </tr> <tr> <td><span translate="users.user.lastSuccessfulLogin">Laatste succesvolle aanmelding </span></td> <td>{{vm.data.user.lastSuccessfulLoginDate.activityTime | date:\'yyyy-MM-dd HH:mm:ss\'}}</td> </tr> <tr> <td><span translate="users.user.lastFailedLogin">Laatste mislukte loginpoging </span></td> <td> <span ng-repeat="fail in vm.data.user.lastFailedLoginDate">{{fail.activityTime | date:\'yyyy-MM-dd HH:mm:ss\'}}<br></span> </td> </tr> <tr> <td><span translate="users.user.clients_">Debiteuren</span></td> <td> <div ng-if="vm.data.user.clients.length == 0">{{vm.translate(\'users.users.none\')}}</div> <div ng-if="vm.data.user.clients.length > 0" ng-repeat="client in vm.data.user.clients" ng-click="vm.nav.client(client)"><a>{{client.clientNumber}}</a></div> </td> </tr> </tbody> <tfoot> <tr> <td colspan="2"></td> </tr> </tfoot> </table> <div class="btn-enclose text-center row-fluid"> <button class="btn col-xs-12 col-lg-5" ng-click="vm.user.clients()" ng-if="$root.Principal.hasSystemAccess() || $root.Principal.hasTemplateAccess()"> <span translate="users.user.manageClients">Onderhouden debiteuren</span> <i class="fa fa-users"></i> </button> <button class="btn col-xs-12 col-lg-5" confirm="vm.user.resetPassword()" ng-if="$root.Principal.hasSystemAccess() || $root.Principal.hasTemplateAccess()"> <span translate="users.user.resetPassword">Reset wachtwoord </span> <i class="fa fa-key"></i> </button> <button class="btn col-xs-12 col-lg-5" confirm="vm.user.unlock()" ng-if="$root.Principal.hasSystemAccess() || $root.Principal.hasTemplateAccess()" ng-disabled="!vm.data.user.locked"> <span translate="users.user.unlockAccount">Account ongrendelen </span> <i class="fa fa-unlock"></i> </button> <button class="btn col-xs-12 col-lg-5" confirm="vm.user.lock()" ng-if="$root.Principal.hasSystemAccess()" ng-disabled="vm.data.user.locked"> <span translate="users.user.lockAccount">Account vergrendelen </span> <i class="fa fa-ban"></i> </button> <button class="btn col-xs-12 col-lg-5" confirm="vm.user.delete()" ng-if="$root.Principal.hasSystemAccess() || $root.Principal.hasTemplateAccess()"> <span translate="users.user.deleteAccount">Verwijderen account </span> <i class="fa fa-trash-o"></i> </button> </div> </div> <div class="col-md-5 col-md-push-2" ng-if="$root.Principal.hasSystemAccess()"> <table class="tablesorter latest"> <thead> <tr> <th><span translate="users.user.roleName">Rol naam</span></th> <th><span translate="users.user.active">Actief</span></th> </tr> </thead> <tbody> <tr ng-repeat="role in vm.data.roles" ng-click="role.active = !role.active"> <td>{{role.roleName}}</td> <td> <input type="checkbox" ng-model="role.active" ng-click="role.active = !role.active"> </td> </tr> </tbody> <tfoot> <tr> <td colspan="2"></td> </tr> </tfoot> </table> <div class="voffset1"> <button class="btn col-xs-12 col-lg-5" ng-click="vm.roles.change()"> <span translate="users.user.updateRoles">Update rollen </span> <i class="fa fa-pencil"></i> </button> </div> </div> </div> <div class="row-fluid"> </div> ');
$templateCache.put('app/views/users/users/users.html','<div id="fixed" class="container container-fluid embedded-page-padding"> <portal-alert></portal-alert> <form id="filter" class="form-inline" accept-charset="UTF-8"> <fieldset> <div class="form-group"> <label class="control-label" for="searchUserLogin"><span translate="users.search.email">E-mail:</span></label> <input class="form-control" type="text" id="searchUserLogin" ng-model="vm.filter.data.email"> </div> <div class="form-group"> <label for="searchUserSAPId"><span translate="users.search.clientSapNumber">Debiteuren nummer:</span></label> <input class="form-control" type="text" id="searchUserSAPId" ng-model="vm.filter.data.clientNumber"> </div> <div class="form-group"> <label for="searchUserClientName"><span translate="users.search.clientName">Naam debiteur:</span></label> <input class="form-control" type="text" id="searchUserClientName" ng-model="vm.filter.data.clientName"> </div> <div class="form-group"> <label class="">&nbsp;</label> <div> <button type="submit" data-role="search" class="btn" value="search" ng-click="vm.list.current()"> <span translate="users.search.search">Zoek</span> <i class="fa fa-search"></i> </button> </div> </div> <div class="form-group"> <label class="">&nbsp;</label> <div> <button id="delete" class="btn" ng-click="vm.filter.clear()"> <span translate="users.search.clean">Maak schoon</span> <i class="fa fa-eraser"></i> </button> </div> </div> </fieldset> </form> <div class="actionButtons row"> <div class="col-xs-6"> <button type="submit" class="btn btn-add btn-add-use" ng-click="vm.user.form()" ng-if="$root.Principal.hasUserRead() && ($root.Principal.hasSystemAccess() || $root.Principal.hasTemplateAccess())"> <span translate="users.table.add">Voeg toe</span> <i class="fa fa-plus-square"></i> </button> </div> <div class="col-xs-6 text-right"> <button class="btn" ng-click="vm.report.form()"> <span translate="users.table.generateReport">Maak rapport aan</span> <i class="fa fa-table"></i> </button> </div> </div> </div> <div id="under-fixed"> <div class="row text-center" ng-show="vm.data._embedded != null && vm.data._embedded.beneluxUserPortalEntryResources.length == 0"> <h2><strong translate="users.errors.noUsersFound">Geen gebruikers gevonden met de gekozen criteria</strong></h2> </div> <div ng-show="vm.data._embedded.beneluxUserPortalEntryResources.length > 0" style="width: 100%; overflow-x : auto"> <table id="fixtable" class="tablesorter latest users-table" fix-table> <thead> <tr> <th><span translate="users.table.ordinal">Volgorde</span></th> <th><span translate="users.table.email">E-mail</span></th> <th><span translate="users.table.clients">Debiteuren</span></th> <th><span translate="users.table.lastCorretLogin">Laaste successvolle login</span></th> <th><span translate="users.table.lastIncorrectLogin">Laatste mislukte login</span></th> </tr> </thead> <tbody ng-repeat="entry in vm.data._embedded.beneluxUserPortalEntryResources" ng-dblclick="vm.nav.user(entry.user)"> <tr> <td>{{$index+1+vm.data.page.size*vm.data.page.number}}</td> <td>{{entry.user.email}}</td> <td>{{entry.client ? entry.client.clientNumber : vm.translate(\'users.users.none\')}}</td> <td>{{entry.lastSuccessfulLogin ? entry.lastSuccessfulLogin : vm.translate(\'users.users.none\') | date:\'yyyy-MM-dd HH:mm:ss\'}}</td> <td> <span ng-show="entry.lastFailedLogins.length > 0" ng-repeat="fail in entry.lastFailedLogins">{{fail | date:\'yyyy-MM-dd HH:mm:ss\'}}<br> </span> <span ng-show="entry.lastFailedLogins.length == 0">{{ vm.translate(\'users.users.none\') }}</span></td> </tr> </tbody> <tfoot> <tr> <td colspan="5"></td> </tr> </tfoot> </table> </div> <div class="row actionButtons" ng-if="vm.data._embedded.beneluxUserPortalEntryResources.length > 0"> <div class="col-sm-6 text-left"> <button class="btn" ng-disabled="!vm.data._links.first || (vm.data.page.number == 0)" ng-click="vm.list.first()"> <i class="fa fa-step-backward"></i> <span translate="users.table.first">Eerste</span> </button> <button class="btn" ng-disabled="!vm.data._links.prev" ng-click="vm.list.previous()"> <i class="fa fa-chevron-left"></i> <span translate="users.table.previous">Voorafgaande</span> </button> </div> <div class="col-sm-6 text-right"> <button class="btn" ng-disabled="!vm.data._links.next" ng-click="vm.list.next()"> <span translate="users.table.next">Volgende</span> <i class="fa fa-chevron-right"></i> </button> <button class="btn" ng-disabled="!vm.data._links.last || (vm.data.page.number >= vm.data.page.totalPages-1)" ng-click="vm.list.last()"> <span translate="users.table.last">Laatste</span> <i class="fa fa-step-forward"></i> </button> </div> </div> </div> ');
$templateCache.put('app/views/users/user/clients/userClients.html','<div class="modal-header"> <h3 class="modal-title"> <span translate="users.user.clients.assignToListTitle">Przypisanie u\u017Cytkownika do klient\xF3w</span> </h3> </div> <uib-tabset active="active" class="modal-body"> <uib-tab index="0" heading="{{vm.translate(\'users.user.clients.heading1\')}}"> <form class="container" style="width: 100%"> <div class="row"> <fieldset class="col-xs-12" style="margin:15px 0"> <div style="display: table-cell"> <label for="usersClientNumberAdd"> <strong><span translate="users.user.clients.clientNumber">Numer klienta:</span></strong></label> <br> <input class="form-control" type="text" id="usersClientNumberAdd" ng-model="vm.data.clientNumber" ng-change="vm.clients.lookup()"> </div> <div style="display: table-cell; padding-left: 10px"> <strong><span translate="users.user.clients.client">Klient:</span></strong> <div style="margin-top:8px">{{vm.data.clientName == null ? vm.translate(\'users.user.notFound\') : vm.data.clientName}}</div> </div> </fieldset> </div> <div class="row modal-footer"> <button class="btn btn-primary" type="submit" ng-click="vm.clients.addClient()" ng-disabled="vm.data.clientName == null || vm.data.clientName == \'\'"> <span translate="users.user.clients.assignToClient">Przypisz do klienta</span> <i class="fa fa-plus"></i> </button> <button class="btn btn-warning" type="button" ng-click="vm.modal.cancel()"> <span translate="users.user.clients.cancel">Anuluj</span> <i class="fa fa-times"></i> </button> </div> </form> </uib-tab> <uib-tab index="1" heading="{{vm.translate(\'users.user.clients.heading2\')}}"> <form class="container" style="width: 100%"> <div class="row"> <fieldset class="col-xs-12" style="margin:15px 0"> <div style="display: table-cell"> <label for="usersClientNumberDel"> <strong><span translate="users.user.clients.clientNumber">Numer klienta:</span></strong></label> <br> <input class="form-control" type="text" id="usersClientNumberDel" ng-model="vm.data.clientNumber" ng-change="vm.clients.lookup()"> </div> <div style="display: table-cell; padding-left: 10px"> <strong><span translate="users.user.clients.client">Klient:</span></strong> <div style="margin-top:8px">{{vm.data.clientName == null ? vm.translate(\'users.user.notFound\') : vm.data.clientName}}</div> </div> </fieldset> </div> <div class="row modal-footer"> <button class="btn btn-primary" type="submit" ng-click="vm.clients.removeClient()" ng-disabled="vm.data.clientName == null || vm.data.clientName == \'\'"> <span translate="users.user.clients.deleteFromlistButton">Usu\u0144 z listy</span> <i class="fa fa-trash"></i> </button> <button class="btn btn-warning" type="button" ng-click="vm.modal.cancel()"> <span translate="users.user.clients.cancel"> Anuluj</span> <i class="fa fa-times"></i> </button> </div> </form> </uib-tab> <uib-tab index="2" heading="{{vm.translate(\'users.user.clients.heading3\')}}"> <form class="container" style="width: 100%"> <div class="row"> <fieldset class="col-xs-12" style="margin:15px 0"> <label> <span translate="users.user.clients.confirmation"> Czy jeste\u015B pewien, \u017Ce chcesz usun\u0105\u0107 tego U\u017Cytkownika z wszystkich list klient\xF3w? </span> </label> </fieldset> </div> <div class="row modal-footer"> <button class="btn btn-primary" type="submit" ng-click="vm.clients.removeAllClients()"> <span translate="users.user.clients.deleteFromAllListsButton">Usu\u0144 z wszystkich list</span> <i class="fa fa-trash"></i> </button> <button class="btn btn-warning" type="button" ng-click="vm.modal.cancel()"> <span translate="users.user.clients.cancel">Anuluj</span> <i class="fa fa-times"></i> </button> </div> </form> </uib-tab> </uib-tabset> ');}]);})();